var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
import Vue$1 from "vue";
import axios from "axios";
import moment from "moment";
import { mixin } from "vue-clickaway";
import { VEmojiPicker } from "v-emoji-picker";
import mime from "mime";
import { Robin } from "robin.io-js";
import VueToast from "vue-toast-notification";
/**
  * vue-class-component v7.2.6
  * (c) 2015-present Evan You
  * @license MIT
  */
function _typeof$1(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof$1 = function(obj2) {
      return typeof obj2;
    };
  } else {
    _typeof$1 = function(obj2) {
      return obj2 && typeof Symbol === "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
    };
  }
  return _typeof$1(obj);
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++)
      arr2[i] = arr[i];
    return arr2;
  }
}
function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]")
    return Array.from(iter);
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}
function reflectionIsSupported() {
  return typeof Reflect !== "undefined" && Reflect.defineMetadata && Reflect.getOwnMetadataKeys;
}
function copyReflectionMetadata(to, from) {
  forwardMetadata(to, from);
  Object.getOwnPropertyNames(from.prototype).forEach(function(key) {
    forwardMetadata(to.prototype, from.prototype, key);
  });
  Object.getOwnPropertyNames(from).forEach(function(key) {
    forwardMetadata(to, from, key);
  });
}
function forwardMetadata(to, from, propertyKey) {
  var metaKeys = propertyKey ? Reflect.getOwnMetadataKeys(from, propertyKey) : Reflect.getOwnMetadataKeys(from);
  metaKeys.forEach(function(metaKey) {
    var metadata = propertyKey ? Reflect.getOwnMetadata(metaKey, from, propertyKey) : Reflect.getOwnMetadata(metaKey, from);
    if (propertyKey) {
      Reflect.defineMetadata(metaKey, metadata, to, propertyKey);
    } else {
      Reflect.defineMetadata(metaKey, metadata, to);
    }
  });
}
var fakeArray = {
  __proto__: []
};
var hasProto = fakeArray instanceof Array;
function isPrimitive(value) {
  var type = _typeof$1(value);
  return value == null || type !== "object" && type !== "function";
}
function collectDataFromConstructor(vm, Component2) {
  var originalInit = Component2.prototype._init;
  Component2.prototype._init = function() {
    var _this = this;
    var keys = Object.getOwnPropertyNames(vm);
    if (vm.$options.props) {
      for (var key in vm.$options.props) {
        if (!vm.hasOwnProperty(key)) {
          keys.push(key);
        }
      }
    }
    keys.forEach(function(key2) {
      Object.defineProperty(_this, key2, {
        get: function get() {
          return vm[key2];
        },
        set: function set(value) {
          vm[key2] = value;
        },
        configurable: true
      });
    });
  };
  var data = new Component2();
  Component2.prototype._init = originalInit;
  var plainData = {};
  Object.keys(data).forEach(function(key) {
    if (data[key] !== void 0) {
      plainData[key] = data[key];
    }
  });
  return plainData;
}
var $internalHooks = [
  "data",
  "beforeCreate",
  "created",
  "beforeMount",
  "mounted",
  "beforeDestroy",
  "destroyed",
  "beforeUpdate",
  "updated",
  "activated",
  "deactivated",
  "render",
  "errorCaptured",
  "serverPrefetch"
];
function componentFactory(Component2) {
  var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  options.name = options.name || Component2._componentTag || Component2.name;
  var proto = Component2.prototype;
  Object.getOwnPropertyNames(proto).forEach(function(key) {
    if (key === "constructor") {
      return;
    }
    if ($internalHooks.indexOf(key) > -1) {
      options[key] = proto[key];
      return;
    }
    var descriptor = Object.getOwnPropertyDescriptor(proto, key);
    if (descriptor.value !== void 0) {
      if (typeof descriptor.value === "function") {
        (options.methods || (options.methods = {}))[key] = descriptor.value;
      } else {
        (options.mixins || (options.mixins = [])).push({
          data: function data() {
            return _defineProperty({}, key, descriptor.value);
          }
        });
      }
    } else if (descriptor.get || descriptor.set) {
      (options.computed || (options.computed = {}))[key] = {
        get: descriptor.get,
        set: descriptor.set
      };
    }
  });
  (options.mixins || (options.mixins = [])).push({
    data: function data() {
      return collectDataFromConstructor(this, Component2);
    }
  });
  var decorators = Component2.__decorators__;
  if (decorators) {
    decorators.forEach(function(fn) {
      return fn(options);
    });
    delete Component2.__decorators__;
  }
  var superProto = Object.getPrototypeOf(Component2.prototype);
  var Super = superProto instanceof Vue$1 ? superProto.constructor : Vue$1;
  var Extended = Super.extend(options);
  forwardStaticMembers(Extended, Component2, Super);
  if (reflectionIsSupported()) {
    copyReflectionMetadata(Extended, Component2);
  }
  return Extended;
}
var shouldIgnore = {
  prototype: true,
  arguments: true,
  callee: true,
  caller: true
};
function forwardStaticMembers(Extended, Original, Super) {
  Object.getOwnPropertyNames(Original).forEach(function(key) {
    if (shouldIgnore[key]) {
      return;
    }
    var extendedDescriptor = Object.getOwnPropertyDescriptor(Extended, key);
    if (extendedDescriptor && !extendedDescriptor.configurable) {
      return;
    }
    var descriptor = Object.getOwnPropertyDescriptor(Original, key);
    if (!hasProto) {
      if (key === "cid") {
        return;
      }
      var superDescriptor = Object.getOwnPropertyDescriptor(Super, key);
      if (!isPrimitive(descriptor.value) && superDescriptor && superDescriptor.value === descriptor.value) {
        return;
      }
    }
    Object.defineProperty(Extended, key, descriptor);
  });
}
function Component(options) {
  if (typeof options === "function") {
    return componentFactory(options);
  }
  return function(Component2) {
    return componentFactory(Component2, options);
  };
}
Component.registerHooks = function registerHooks(keys) {
  $internalHooks.push.apply($internalHooks, _toConsumableArray(keys));
};
const state = {
  currentConversation: {},
  imagesToPreview: [],
  imageSelected: 0,
  isImageReplying: false,
  isPageLoading: true,
  isAuthenticated: false,
  selectMessagesOpen: false,
  conversationOpened: false,
  clearMessages: false,
  imagePreviewOpen: false,
  profileOpen: false,
  groupPromptOpen: false,
  currentParticipantToken: "",
  encryptionDetailsOpen: false,
  exitGroup: false,
  participantToken: "",
  removeParticipant: false,
  isParticipantModerator: false,
  currentAudioPlaying: 0,
  forwardMessagesEnabled: false,
  deleteMessagesEnabled: false,
  archiveChatEnabled: false,
  createChatEnabled: false,
  replyMessagesEnabled: false,
  voiceRecorderEnabled: false,
  messageReactionViewEnabled: false,
  messageReactionDeleteEnabled: false,
  useDefaultProfileDetails: false
};
const store = {
  state: Vue$1.observable(state),
  setState(key, val) {
    Vue$1.set(this.state, key, val);
  }
};
const EventBus = new Vue$1();
var __defProp$J = Object.defineProperty;
var __getOwnPropDesc$J = Object.getOwnPropertyDescriptor;
var __decorateClass$J = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$J(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$J(target, key, result);
  return result;
};
const ComponentProps$w = Vue$1.extend({
  props: {
    as: {
      type: String,
      default: "h1",
      validator: (value) => {
        return ["h1", "h2", "h3", "p", "span", "label"].includes(value);
      }
    },
    text: {
      type: String,
      default: "This is a text"
    },
    color: {
      type: String,
      default: "#000000"
    },
    fontSize: {
      type: Number,
      default: 16
    },
    fontWeight: {
      type: String,
      default: "normal"
    },
    lineHeight: {
      type: Number,
      default: 0
    },
    textWrap: {
      type: String,
      default: "nowrap"
    },
    wordBreak: {
      type: String,
      default: "initial"
    },
    maxWidth: {
      type: String,
      default: "max-content"
    },
    textAlign: {
      type: String,
      default: "left"
    },
    forRef: {
      type: String,
      default: "document-upload"
    }
  }
});
let Content$1 = class extends ComponentProps$w {
  constructor() {
    super(...arguments);
    this.root = null;
  }
  mounted() {
    this.root = document.documentElement;
  }
  get getStyles() {
    let rootFontSize = 16;
    let fontSize = `${this.fontSize / rootFontSize + "rem"}`;
    if (this.root && this.root.style.fontSize !== "") {
      rootFontSize = this.root.style.fontSize;
    }
    if (this.fontSize > 16) {
      fontSize = `clamp(0.3rem, 7vw, ${this.fontSize / rootFontSize + "rem"})`;
    } else if (this.fontSize === 16) {
      fontSize = `clamp(0.3rem, 5vw, ${this.fontSize / rootFontSize + "rem"})`;
    } else if (this.fontSize === 14) {
      fontSize = `clamp(0.3rem, 3.5vw, ${this.fontSize / rootFontSize + "rem"})`;
    } else {
      fontSize = `clamp(0.2rem, 3.5vw, ${this.fontSize / rootFontSize + "rem"})`;
    }
    return {
      "font-size": fontSize,
      color: this.color,
      "font-weight": this.fontWeight,
      "line-height": this.lineHeight === 0 ? "initial" : this.lineHeight / rootFontSize + "rem",
      "white-space": this.textWrap,
      "word-break": this.wordBreak,
      "text-align": this.textAlign,
      "max-width": this.maxWidth
    };
  }
};
Content$1 = __decorateClass$J([
  Component({
    name: "Content"
  })
], Content$1);
var render$J = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _vm.as == "h1" ? _c("h1", { staticClass: "robin-text", style: _vm.getStyles }, [_vm._t("default")], 2) : _vm.as == "h2" ? _c("h2", { staticClass: "robin-text", style: _vm.getStyles }, [_vm._t("default")], 2) : _vm.as == "h3" ? _c("h3", { staticClass: "robin-text", style: _vm.getStyles }, [_vm._t("default")], 2) : _vm.as == "p" ? _c("p", { staticClass: "robin-text", style: _vm.getStyles }, [_vm._t("default")], 2) : _vm.as == "span" ? _c("span", { staticClass: "robin-text", style: _vm.getStyles }, [_vm._t("default")], 2) : _vm.as == "label" ? _c("label", { staticClass: "robin-text", style: _vm.getStyles, attrs: { "data-testid": "label", "for": _vm.forRef } }, [_vm._t("default")], 2) : _vm._e();
};
var staticRenderFns$J = [];
var Content_vue_vue_type_style_index_0_scoped_true_lang = "";
function normalizeComponent(scriptExports, render2, staticRenderFns2, functionalTemplate, injectStyles2, scopeId, moduleIdentifier, shadowMode) {
  var options = typeof scriptExports === "function" ? scriptExports.options : scriptExports;
  if (render2) {
    options.render = render2;
    options.staticRenderFns = staticRenderFns2;
    options._compiled = true;
  }
  if (functionalTemplate) {
    options.functional = true;
  }
  if (scopeId) {
    options._scopeId = "data-v-" + scopeId;
  }
  var hook;
  if (moduleIdentifier) {
    hook = function(context2) {
      context2 = context2 || this.$vnode && this.$vnode.ssrContext || this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext;
      if (!context2 && typeof __VUE_SSR_CONTEXT__ !== "undefined") {
        context2 = __VUE_SSR_CONTEXT__;
      }
      if (injectStyles2) {
        injectStyles2.call(this, context2);
      }
      if (context2 && context2._registeredComponents) {
        context2._registeredComponents.add(moduleIdentifier);
      }
    };
    options._ssrRegister = hook;
  } else if (injectStyles2) {
    hook = shadowMode ? function() {
      injectStyles2.call(this, (options.functional ? this.parent : this).$root.$options.shadowRoot);
    } : injectStyles2;
  }
  if (hook) {
    if (options.functional) {
      options._injectStyles = hook;
      var originalRender = options.render;
      options.render = function renderWithStyleInjection(h, context2) {
        hook.call(context2);
        return originalRender(h, context2);
      };
    } else {
      var existing = options.beforeCreate;
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
    }
  }
  return {
    exports: scriptExports,
    options
  };
}
const __cssModules$J = {};
var __component__$J = /* @__PURE__ */ normalizeComponent(Content$1, render$J, staticRenderFns$J, false, injectStyles$J, "26cad293", null, null);
function injectStyles$J(context2) {
  for (let o in __cssModules$J) {
    this[o] = __cssModules$J[o];
  }
}
var Content = /* @__PURE__ */ function() {
  return __component__$J.exports;
}();
var __defProp$I = Object.defineProperty;
var __getOwnPropDesc$I = Object.getOwnPropertyDescriptor;
var __decorateClass$I = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$I(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$I(target, key, result);
  return result;
};
const ComponentProps$v = Vue$1.extend({
  props: {
    name: {
      type: String,
      default: "attachFileOpen"
    },
    emit: {
      type: String,
      default: "clicked"
    },
    toEmit: {
      type: Boolean,
      default: true
    },
    toClickAway: {
      type: Boolean,
      default: true
    },
    color: {
      type: String,
      default: "#535F89"
    },
    primaryColor: {
      type: String,
      default: "rgba(21, 174, 115, 1)"
    },
    hasFocus: {
      type: Boolean,
      default: false
    },
    focusColor: {
      type: String,
      default: "rgba(83, 95, 137, 0.1)"
    },
    styleStroke: {
      type: Boolean,
      default: false
    },
    active: {
      type: Boolean,
      default: false
    }
  }
});
let IconButton$1 = class extends ComponentProps$v {
  constructor() {
    super(...arguments);
    this.root = null;
    this.focused = false;
    this.iconItem = {
      attachFileOpen: {
        innerHTML: '<svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M21.9498 12.0503L12.0503 21.9498" stroke="#51545C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M12.0503 12.0503L21.9498 21.9498" stroke="#51545C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
        buttonStyle: {
          width: "44px",
          height: "44px",
          "border-radius": "50%",
          background: "#F5F7FC",
          display: "flex",
          "justify-content": "center",
          "align-items": "center",
          border: "none",
          cursor: "pointer"
        }
      },
      attachFileClose: {
        innerHTML: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 5V19" stroke="#15AE73" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M5 12H19" stroke="#15AE73" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
        buttonStyle: {
          width: "44px",
          height: "44px",
          "border-radius": "50%",
          background: "#F5F7FC",
          display: "flex",
          "justify-content": "center",
          "align-items": "center",
          border: "none",
          cursor: "pointer"
        }
      },
      option: {
        innerHTML: `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.99968 5.83333C10.3293 5.83333 10.6515 5.73559 10.9256 5.55245C11.1997 5.36931 11.4133 5.10902 11.5395 4.80447C11.6656 4.49993 11.6986 4.16482 11.6343 3.84152C11.57 3.51822 11.4113 3.22124 11.1782 2.98816C10.9451 2.75507 10.6481 2.59633 10.3248 2.53203C10.0015 2.46772 9.66641 2.50072 9.36187 2.62687C9.05733 2.75301 8.79703 2.96664 8.61389 3.24072C8.43076 3.5148 8.33301 3.83703 8.33301 4.16667C8.33301 4.60869 8.5086 5.03262 8.82116 5.34518C9.13373 5.65774 9.55765 5.83333 9.99968 5.83333ZM9.99968 14.1667C9.67004 14.1667 9.34781 14.2644 9.07373 14.4476C8.79964 14.6307 8.58602 14.891 8.45988 15.1955C8.33373 15.5001 8.30072 15.8352 8.36503 16.1585C8.42934 16.4818 8.58808 16.7788 8.82116 17.0118C9.05425 17.2449 9.35122 17.4037 9.67453 17.468C9.99783 17.5323 10.3329 17.4993 10.6375 17.3731C10.942 17.247 11.2023 17.0334 11.3855 16.7593C11.5686 16.4852 11.6663 16.163 11.6663 15.8333C11.6663 15.3913 11.4907 14.9674 11.1782 14.6548C10.8656 14.3423 10.4417 14.1667 9.99968 14.1667ZM9.99968 8.33333C9.67004 8.33333 9.34781 8.43108 9.07373 8.61422C8.79964 8.79735 8.58602 9.05765 8.45988 9.3622C8.33373 9.66674 8.30072 10.0018 8.36503 10.3252C8.42934 10.6485 8.58808 10.9454 8.82116 11.1785C9.05425 11.4116 9.35122 11.5703 9.67453 11.6346C9.99783 11.699 10.3329 11.6659 10.6375 11.5398C10.942 11.4137 11.2023 11.2 11.3855 10.926C11.5686 10.6519 11.6663 10.3296 11.6663 10C11.6663 9.55797 11.4907 9.13405 11.1782 8.82149C10.8656 8.50893 10.4417 8.33333 9.99968 8.33333Z" fill="${this.color}" /></svg>`,
        buttonStyle: {
          width: "30px",
          display: "flex",
          "align-items": "center",
          "justify-content": "center",
          border: "none",
          "border-radius": "50%",
          height: "30px",
          "background-color": "transparent",
          transition: "background-color 0.1s"
        }
      },
      back: {
        innerHTML: '<svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.08334 6.66667L5.83334 11.3333C6.16668 11.6667 6.66668 11.6667 7.00001 11.3333C7.33334 11 7.33334 10.5 7.00001 10.1667L2.91668 6L7.00001 1.83334C7.33334 1.5 7.33334 1 7.00001 0.666671C6.83334 0.500005 6.66668 0.416672 6.41668 0.416672C6.16668 0.416672 6.00001 0.500005 5.83334 0.666671L1.08334 5.33334C0.75001 5.75 0.75001 6.25 1.08334 6.66667C1.08334 6.58334 1.08334 6.58334 1.08334 6.66667Z" fill="#535F89" /></svg>',
        buttonStyle: {
          border: "none",
          "background-color": "transparent",
          width: "max-content"
        }
      },
      send: {
        innerHTML: '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15.7501 0.250995C15.6333 0.134162 15.4851 0.0535967 15.3236 0.0189988C15.162 -0.0155991 14.9938 -0.00275461 14.8394 0.0559859L0.552315 5.46375H0.549458C0.384726 5.52711 0.243569 5.63978 0.145265 5.78637C0.0469607 5.93296 -0.00369711 6.10632 0.000210162 6.28278C0.00411744 6.45924 0.0623993 6.63019 0.167096 6.77228C0.271792 6.91437 0.417798 7.02068 0.585173 7.07669L0.599816 7.08133L5.50349 9.17536C5.59913 9.2044 5.70072 9.20784 5.79811 9.18534C5.8955 9.16284 5.98528 9.11519 6.0585 9.04714L13.9287 1.71357C13.9521 1.69012 13.98 1.67151 14.0106 1.65882C14.0412 1.64613 14.0741 1.6396 14.1072 1.6396C14.1404 1.6396 14.1732 1.64613 14.2039 1.65882C14.2345 1.67151 14.2624 1.69012 14.2858 1.71357C14.3093 1.73702 14.3279 1.76486 14.3406 1.7955C14.3532 1.82614 14.3598 1.85898 14.3598 1.89215C14.3598 1.92531 14.3532 1.95815 14.3406 1.98879C14.3279 2.01944 14.3093 2.04728 14.2858 2.07073L6.95209 9.93754C6.88404 10.0108 6.83639 10.1006 6.8139 10.1979C6.7914 10.2953 6.79484 10.3969 6.82387 10.4926L8.91856 15.3992C8.9207 15.4064 8.92284 15.4128 8.92534 15.4196C9.03963 15.7507 9.32892 15.9843 9.67857 16H9.71429C9.8908 16.001 10.0635 15.9489 10.21 15.8504C10.3565 15.7519 10.47 15.6116 10.5357 15.4478L15.9426 1.16425C16.0022 1.0097 16.0157 0.841202 15.9816 0.679127C15.9474 0.517052 15.867 0.368347 15.7501 0.250995V0.250995Z" fill="white"/></svg>',
        buttonStyle: {
          width: "44px",
          height: "44px",
          "border-radius": "50%",
          background: "#15ae73",
          display: "flex",
          "justify-content": "center",
          "align-items": "center",
          border: "none",
          cursor: "pointer"
        }
      },
      downloadImage: {
        innerHTML: '<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.5 7.5V9.5C10.5 9.76522 10.3946 10.0196 10.2071 10.2071C10.0196 10.3946 9.76522 10.5 9.5 10.5H2.5C2.23478 10.5 1.98043 10.3946 1.79289 10.2071C1.60536 10.0196 1.5 9.76522 1.5 9.5V7.5" stroke="white" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/><path d="M3.5 5L6 7.5L8.5 5" stroke="white" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/><path d="M6 7.5V1.5" stroke="white" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/></svg>',
        buttonStyle: {
          width: "44px",
          height: "44px",
          "border-radius": "50%",
          background: "#15ae73",
          display: "flex",
          "justify-content": "center",
          "align-items": "center",
          border: "none",
          cursor: "pointer"
        }
      },
      edit: {
        innerHTML: `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.16699 3.33337H3.33366C2.89163 3.33337 2.46771 3.50897 2.15515 3.82153C1.84259 4.13409 1.66699 4.55801 1.66699 5.00004V16.6667C1.66699 17.1087 1.84259 17.5327 2.15515 17.8452C2.46771 18.1578 2.89163 18.3334 3.33366 18.3334H15.0003C15.4424 18.3334 15.8663 18.1578 16.1788 17.8452C16.4914 17.5327 16.667 17.1087 16.667 16.6667V10.8334" stroke="${this.color}" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" /><path d="M15.417 2.08332C15.7485 1.7518 16.1981 1.56555 16.667 1.56555C17.1358 1.56555 17.5855 1.7518 17.917 2.08332C18.2485 2.41484 18.4348 2.86448 18.4348 3.33332C18.4348 3.80216 18.2485 4.2518 17.917 4.58332L10.0003 12.5L6.66699 13.3333L7.50033 9.99998L15.417 2.08332Z" stroke="${this.color}" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" /></svg>`,
        buttonStyle: {
          "background-color": this.primaryColor,
          border: "1px solid #15AE73",
          width: "39px",
          height: "39px",
          "border-radius": "50%"
        }
      },
      settings: {
        innerHTML: `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.00001 10.6666C9.47277 10.6666 10.6667 9.47274 10.6667 7.99998C10.6667 6.52722 9.47277 5.33331 8.00001 5.33331C6.52725 5.33331 5.33334 6.52722 5.33334 7.99998C5.33334 9.47274 6.52725 10.6666 8.00001 10.6666Z" stroke="${this.color}" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/><path d="M12.7342 5.21746L13.3404 4.86732L13.3404 4.86732L12.7342 5.21746ZM12.7781 5.29336L12.1719 5.64349L12.1719 5.6435L12.7781 5.29336ZM13.2844 5.79161L13.6247 5.17989L13.6247 5.17989L13.2844 5.79161ZM14.3185 6.36688L13.9782 6.9786L13.9782 6.9786L14.3185 6.36688ZM14.6611 6.94795L13.9611 6.94954V6.94954L14.6611 6.94795ZM14.6659 9.04917L13.9659 9.05076V9.05076L14.6659 9.04917ZM14.3223 9.6338L13.983 9.02153L13.983 9.02153L14.3223 9.6338ZM13.2858 10.2082L13.6251 10.8205L13.2858 10.2082ZM12.7775 10.7076L12.1713 10.3574L12.1713 10.3574L12.7775 10.7076ZM12.7342 10.7824L13.3404 11.1326L13.3404 11.1326L12.7342 10.7824ZM12.5556 11.4718L11.8557 11.4836V11.4836L12.5556 11.4718ZM12.5756 12.6591L11.8757 12.6708L12.5756 12.6591ZM12.2437 13.2469L11.8923 12.6414L11.8923 12.6414L12.2437 13.2469ZM10.425 14.3024L10.7764 14.9078V14.9078L10.425 14.3024ZM9.74724 14.2974L10.1075 13.6972V13.6972L9.74724 14.2974ZM8.72987 13.6866L8.36956 14.2868L8.72987 13.6866ZM7.27082 13.6858L7.63042 14.2864H7.63042L7.27082 13.6858ZM6.2581 14.2922L5.89849 13.6916L6.2581 14.2922ZM5.58276 14.2978L5.93226 13.6913H5.93226L5.58276 14.2978ZM3.75834 13.2465L4.10784 12.64L3.75834 13.2465ZM3.42462 12.6576L4.12452 12.6695V12.6695L3.42462 12.6576ZM3.44458 11.4756L2.74468 11.4637L3.44458 11.4756ZM3.26861 10.7907L3.87612 10.443L3.26861 10.7907ZM3.22226 10.7097L2.61474 11.0575L2.61474 11.0575L3.22226 10.7097ZM2.71328 10.2069L2.37298 10.8186L2.71328 10.2069ZM1.68166 9.63301L1.34136 10.2447H1.34136L1.68166 9.63301ZM1.33909 9.05194L0.639096 9.05353L1.33909 9.05194ZM1.33432 6.95073L2.03432 6.94914L1.33432 6.95073ZM1.67784 6.3661L2.01714 6.97837L2.01714 6.97837L1.67784 6.3661ZM2.71443 5.79165L2.37513 5.17938L2.37513 5.17938L2.71443 5.79165ZM3.2227 5.29235L2.61656 4.94221L2.61656 4.94221L3.2227 5.29235ZM3.26596 5.21746L3.8721 5.56759L3.8721 5.56759L3.26596 5.21746ZM3.44455 4.5281L4.14445 4.51633V4.51633L3.44455 4.5281ZM3.42457 3.34083L2.72467 3.35261L3.42457 3.34083ZM3.7565 2.75303L4.10788 3.35845L3.7565 2.75303ZM5.57516 1.6975L5.92654 2.30292L5.92654 2.30292L5.57516 1.6975ZM6.25295 1.70251L5.89265 2.30267V2.30267L6.25295 1.70251ZM7.27032 2.31329L6.91002 2.91345L7.27032 2.31329ZM8.72937 2.31409L8.36977 1.71352V1.71352L8.72937 2.31409ZM9.74209 1.7077L9.38249 1.10713L9.38249 1.10713L9.74209 1.7077ZM10.4174 1.70205L10.7669 1.09554V1.09554L10.4174 1.70205ZM12.2419 2.75338L12.5914 2.14688L12.2419 2.75338ZM12.5756 3.34222L11.8757 3.33045V3.33045L12.5756 3.34222ZM12.5556 4.5281L11.8557 4.51633V4.51633L12.5556 4.5281ZM12.1281 5.56759L12.1719 5.64349L13.3842 4.94323L13.3404 4.86732L12.1281 5.56759ZM12.9441 6.40332L13.9782 6.9786L14.6588 5.75517L13.6247 5.17989L12.9441 6.40332ZM13.9611 6.94954L13.9659 9.05076L15.3659 9.04758L15.3611 6.94636L13.9611 6.94954ZM13.983 9.02153L12.9465 9.59597L13.6251 10.8205L14.6616 10.2461L13.983 9.02153ZM12.1713 10.3574L12.1281 10.4323L13.3404 11.1326L13.3836 11.0577L12.1713 10.3574ZM11.8557 11.4836L11.8757 12.6708L13.2755 12.6473L13.2555 11.46L11.8557 11.4836ZM11.8923 12.6414L10.0737 13.697L10.7764 14.9078L12.5951 13.8523L11.8923 12.6414ZM10.1075 13.6972L9.09017 13.0864L8.36956 14.2868L9.38694 14.8975L10.1075 13.6972ZM8.04358 12.7964H7.95578V14.1964H8.04358V12.7964ZM6.91121 13.0852L5.89849 13.6916L6.6177 14.8928L7.63042 14.2864L6.91121 13.0852ZM5.93226 13.6913L4.10784 12.64L3.40884 13.853L5.23326 14.9044L5.93226 13.6913ZM4.12452 12.6695L4.14448 11.4874L2.74468 11.4637L2.72472 12.6458L4.12452 12.6695ZM3.87612 10.443L3.82978 10.362L2.61474 11.0575L2.66109 11.1384L3.87612 10.443ZM3.05358 9.59519L2.02196 9.0213L1.34136 10.2447L2.37298 10.8186L3.05358 9.59519ZM2.03909 9.05035L2.03432 6.94914L0.634324 6.95232L0.639096 9.05353L2.03909 9.05035ZM2.01714 6.97837L3.05373 6.40392L2.37513 5.17938L1.33854 5.75383L2.01714 6.97837ZM3.82884 5.64248L3.8721 5.56759L2.65982 4.86732L2.61656 4.94221L3.82884 5.64248ZM4.14445 4.51633L4.12448 3.32906L2.72467 3.35261L2.74465 4.53988L4.14445 4.51633ZM4.10788 3.35845L5.92654 2.30292L5.22378 1.09208L3.40512 2.14761L4.10788 3.35845ZM5.89265 2.30267L6.91002 2.91345L7.63062 1.71314L6.61325 1.10236L5.89265 2.30267ZM7.95661 3.20348H8.04441V1.80348H7.95661V3.20348ZM9.08898 2.91466L10.1017 2.30827L9.38249 1.10713L8.36977 1.71352L9.08898 2.91466ZM10.0679 2.30855L11.8924 3.35989L12.5914 2.14688L10.7669 1.09554L10.0679 2.30855ZM11.8757 3.33045L11.8557 4.51633L13.2555 4.53988L13.2755 3.354L11.8757 3.33045ZM11.8924 3.35989C11.8819 3.35384 11.8755 3.34256 11.8757 3.33045L13.2755 3.354C13.2839 2.85718 13.0219 2.39497 12.5914 2.14688L11.8924 3.35989ZM10.1017 2.30827C10.0913 2.31448 10.0784 2.31459 10.0679 2.30855L10.7669 1.09554C10.3375 0.848074 9.80773 0.852509 9.38249 1.10713L10.1017 2.30827ZM8.04441 3.20348C8.41232 3.20348 8.77333 3.10366 9.08898 2.91466L8.36977 1.71352C8.27145 1.77239 8.159 1.80348 8.04441 1.80348V3.20348ZM6.91002 2.91345C7.22614 3.10323 7.5879 3.20348 7.95661 3.20348V1.80348C7.84177 1.80348 7.72909 1.77225 7.63062 1.71314L6.91002 2.91345ZM5.92654 2.30292C5.91604 2.30901 5.90305 2.30892 5.89265 2.30267L6.61325 1.10236C6.18652 0.846175 5.65425 0.842236 5.22378 1.09208L5.92654 2.30292ZM4.12448 3.32906C4.12468 3.34114 4.11833 3.35238 4.10788 3.35845L3.40512 2.14761C2.97668 2.39627 2.71634 2.8573 2.72467 3.35261L4.12448 3.32906ZM3.8721 5.56759C4.05651 5.24834 4.15065 4.88496 4.14445 4.51633L2.74465 4.53988C2.74658 4.6547 2.71726 4.76788 2.65982 4.86732L3.8721 5.56759ZM3.05373 6.40392C3.37639 6.22512 3.64433 5.96191 3.82884 5.64248L2.61656 4.94221C2.55909 5.0417 2.47563 5.12369 2.37513 5.17938L3.05373 6.40392ZM2.03432 6.94914C2.03435 6.96128 2.02777 6.97248 2.01714 6.97837L1.33854 5.75383C0.90299 5.99519 0.633193 6.45436 0.634324 6.95232L2.03432 6.94914ZM2.02197 9.0213C2.03251 9.02717 2.03907 9.03828 2.03909 9.05035L0.639096 9.05353C0.640221 9.54847 0.908849 10.0041 1.34136 10.2447L2.02197 9.0213ZM3.82978 10.362C3.64573 10.0404 3.37734 9.7753 3.05358 9.59519L2.37298 10.8186C2.47382 10.8747 2.55742 10.9573 2.61474 11.0575L3.82978 10.362ZM4.14448 11.4874C4.15066 11.1214 4.05794 10.7606 3.87612 10.443L2.66109 11.1384C2.71772 11.2374 2.7466 11.3498 2.74468 11.4637L4.14448 11.4874ZM4.10784 12.64C4.11834 12.6461 4.12473 12.6573 4.12452 12.6695L2.72472 12.6458C2.71633 13.1427 2.97829 13.6049 3.40884 13.853L4.10784 12.64ZM5.89849 13.6916C5.90886 13.6854 5.92178 13.6853 5.93226 13.6913L5.23326 14.9044C5.6627 15.1518 6.19246 15.1474 6.6177 14.8928L5.89849 13.6916ZM7.95578 12.7964C7.58787 12.7964 7.22686 12.8962 6.91121 13.0852L7.63042 14.2864C7.72874 14.2275 7.84119 14.1964 7.95578 14.1964V12.7964ZM9.09017 13.0864C8.77405 12.8967 8.41228 12.7964 8.04358 12.7964V14.1964C8.15842 14.1964 8.2711 14.2276 8.36956 14.2868L9.09017 13.0864ZM10.0737 13.697C10.0842 13.6909 10.0971 13.691 10.1075 13.6972L9.38694 14.8975C9.81367 15.1537 10.3459 15.1577 10.7764 14.9078L10.0737 13.697ZM11.8757 12.6708C11.8755 12.6588 11.8819 12.6475 11.8923 12.6414L12.5951 13.8523C13.0235 13.6036 13.2838 13.1426 13.2755 12.6473L11.8757 12.6708ZM12.1281 10.4323C11.9437 10.7516 11.8495 11.1149 11.8557 11.4836L13.2555 11.46C13.2536 11.3452 13.2829 11.232 13.3404 11.1326L12.1281 10.4323ZM12.9465 9.59597C12.6238 9.77478 12.3559 10.038 12.1713 10.3574L13.3836 11.0577C13.4411 10.9582 13.5246 10.8762 13.6251 10.8205L12.9465 9.59597ZM13.9659 9.05076C13.9658 9.03861 13.9724 9.02741 13.983 9.02153L14.6616 10.2461C15.0972 10.0047 15.367 9.54554 15.3659 9.04758L13.9659 9.05076ZM13.9782 6.9786C13.9677 6.97273 13.9611 6.96161 13.9611 6.94954L15.3611 6.94636C15.36 6.45143 15.0913 5.99578 14.6588 5.75517L13.9782 6.9786ZM12.1719 5.6435C12.3559 5.96194 12.6228 6.22454 12.9441 6.40332L13.6247 5.17989C13.5246 5.12421 13.4415 5.04242 13.3842 4.94323L12.1719 5.6435ZM13.3404 4.86732C13.2829 4.76789 13.2536 4.6547 13.2555 4.53988L11.8557 4.51633C11.8495 4.88496 11.9437 5.24834 12.1281 5.56759L13.3404 4.86732Z" fill="${this.color}"/></svg>`,
        buttonStyle: {
          "background-color": this.primaryColor,
          border: "1px solid #15AE73",
          width: "39px",
          height: "39px",
          "border-radius": "50%"
        }
      },
      photo: {
        innerHTML: '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_6391_26454)"><path d="M15.3333 12.6667C15.3333 13.0203 15.1929 13.3594 14.9428 13.6095C14.6928 13.8595 14.3536 14 14 14H2C1.64638 14 1.30724 13.8595 1.05719 13.6095C0.80714 13.3594 0.666664 13.0203 0.666664 12.6667V5.33333C0.666664 4.97971 0.80714 4.64057 1.05719 4.39052C1.30724 4.14048 1.64638 4 2 4H4.66666L6 2H10L11.3333 4H14C14.3536 4 14.6928 4.14048 14.9428 4.39052C15.1929 4.64057 15.3333 4.97971 15.3333 5.33333V12.6667Z" stroke="#EA8D51" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/><path d="M8 11.3333C9.47276 11.3333 10.6667 10.1394 10.6667 8.66667C10.6667 7.19391 9.47276 6 8 6C6.52724 6 5.33334 7.19391 5.33334 8.66667C5.33334 10.1394 6.52724 11.3333 8 11.3333Z" stroke="#EA8D51" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></g><defs><clipPath id="clip0_6391_26454"><rect width="16" height="16" fill="white"/></clipPath></defs></svg>',
        buttonStyle: {
          border: "none",
          "background-color": "transparent",
          width: "max-content"
        }
      },
      gallery: {
        innerHTML: '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.6667 2.6665H3.33334C2.8029 2.6665 2.2942 2.87722 1.91912 3.25229C1.54405 3.62736 1.33334 4.13607 1.33334 4.6665V11.3332C1.33334 11.8636 1.54405 12.3723 1.91912 12.7474C2.2942 13.1225 2.8029 13.3332 3.33334 13.3332H12.6667C13.1971 13.3332 13.7058 13.1225 14.0809 12.7474C14.456 12.3723 14.6667 11.8636 14.6667 11.3332V4.6665C14.6667 4.13607 14.456 3.62736 14.0809 3.25229C13.7058 2.87722 13.1971 2.6665 12.6667 2.6665ZM3.33334 11.9998C3.15652 11.9998 2.98696 11.9296 2.86193 11.8046C2.73691 11.6796 2.66667 11.51 2.66667 11.3332V9.71984L4.86667 7.5265C4.99129 7.40435 5.15883 7.33593 5.33334 7.33593C5.50784 7.33593 5.67538 7.40435 5.8 7.5265L10.2733 11.9998H3.33334ZM13.3333 11.3332C13.3333 11.51 13.2631 11.6796 13.1381 11.8046C13.0131 11.9296 12.8435 11.9998 12.6667 11.9998H12.1533L9.61334 9.4465L10.2 8.85984C10.3246 8.73769 10.4922 8.66927 10.6667 8.66927C10.8412 8.66927 11.0087 8.73769 11.1333 8.85984L13.3333 11.0532V11.3332ZM13.3333 9.17317L12.08 7.9265C11.7 7.56146 11.1936 7.35759 10.6667 7.35759C10.1398 7.35759 9.6333 7.56146 9.25334 7.9265L8.66667 8.51317L6.74667 6.59317C6.36671 6.22813 5.86024 6.02425 5.33334 6.02425C4.80643 6.02425 4.29996 6.22813 3.92 6.59317L2.66667 7.83984V4.6665C2.66667 4.48969 2.73691 4.32012 2.86193 4.1951C2.98696 4.07008 3.15652 3.99984 3.33334 3.99984H12.6667C12.8435 3.99984 13.0131 4.07008 13.1381 4.1951C13.2631 4.32012 13.3333 4.48969 13.3333 4.6665V9.17317Z" fill="#EA8D51"/></svg>',
        buttonStyle: {
          border: "none",
          "background-color": "transparent",
          width: "max-content"
        }
      },
      document: {
        innerHTML: '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 6.66683H6.66666C6.84347 6.66683 7.01304 6.59659 7.13807 6.47157C7.26309 6.34654 7.33333 6.17697 7.33333 6.00016C7.33333 5.82335 7.26309 5.65378 7.13807 5.52876C7.01304 5.40373 6.84347 5.3335 6.66666 5.3335H6C5.82319 5.3335 5.65362 5.40373 5.52859 5.52876C5.40357 5.65378 5.33333 5.82335 5.33333 6.00016C5.33333 6.17697 5.40357 6.34654 5.52859 6.47157C5.65362 6.59659 5.82319 6.66683 6 6.66683ZM6 8.00016C5.82319 8.00016 5.65362 8.0704 5.52859 8.19543C5.40357 8.32045 5.33333 8.49002 5.33333 8.66683C5.33333 8.84364 5.40357 9.01321 5.52859 9.13823C5.65362 9.26326 5.82319 9.3335 6 9.3335H10C10.1768 9.3335 10.3464 9.26326 10.4714 9.13823C10.5964 9.01321 10.6667 8.84364 10.6667 8.66683C10.6667 8.49002 10.5964 8.32045 10.4714 8.19543C10.3464 8.0704 10.1768 8.00016 10 8.00016H6ZM13.3333 5.96016C13.3264 5.89892 13.313 5.83858 13.2933 5.78016V5.72016C13.2613 5.65162 13.2185 5.58861 13.1667 5.5335L9.16666 1.5335C9.11155 1.48164 9.04854 1.43888 8.98 1.40683C8.9601 1.404 8.9399 1.404 8.92 1.40683C8.85227 1.36799 8.77748 1.34306 8.7 1.3335H4.66666C4.13623 1.3335 3.62752 1.54421 3.25245 1.91928C2.87738 2.29436 2.66666 2.80306 2.66666 3.3335V12.6668C2.66666 13.1973 2.87738 13.706 3.25245 14.081C3.62752 14.4561 4.13623 14.6668 4.66666 14.6668H11.3333C11.8638 14.6668 12.3725 14.4561 12.7475 14.081C13.1226 13.706 13.3333 13.1973 13.3333 12.6668V6.00016C13.3333 6.00016 13.3333 6.00016 13.3333 5.96016ZM9.33333 3.60683L11.06 5.3335H10C9.82319 5.3335 9.65362 5.26326 9.52859 5.13823C9.40357 5.01321 9.33333 4.84364 9.33333 4.66683V3.60683ZM12 12.6668C12 12.8436 11.9298 13.0132 11.8047 13.1382C11.6797 13.2633 11.5101 13.3335 11.3333 13.3335H4.66666C4.48985 13.3335 4.32028 13.2633 4.19526 13.1382C4.07024 13.0132 4 12.8436 4 12.6668V3.3335C4 3.15669 4.07024 2.98712 4.19526 2.86209C4.32028 2.73707 4.48985 2.66683 4.66666 2.66683H8V4.66683C8 5.19726 8.21071 5.70597 8.58578 6.08104C8.96086 6.45612 9.46956 6.66683 10 6.66683H12V12.6668ZM10 10.6668H6C5.82319 10.6668 5.65362 10.7371 5.52859 10.8621C5.40357 10.9871 5.33333 11.1567 5.33333 11.3335C5.33333 11.5103 5.40357 11.6799 5.52859 11.8049C5.65362 11.9299 5.82319 12.0002 6 12.0002H10C10.1768 12.0002 10.3464 11.9299 10.4714 11.8049C10.5964 11.6799 10.6667 11.5103 10.6667 11.3335C10.6667 11.1567 10.5964 10.9871 10.4714 10.8621C10.3464 10.7371 10.1768 10.6668 10 10.6668Z" fill="#EA8D51"/></svg>',
        buttonStyle: {
          border: "none",
          "background-color": "transparent",
          width: "max-content"
        }
      },
      close: {
        innerHTML: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="12" cy="12" r="12" fill="#6B7491" /><path d="M12.9403 12.0001L17.1403 7.80679C17.2658 7.68125 17.3363 7.51099 17.3363 7.33346C17.3363 7.15592 17.2658 6.98566 17.1403 6.86012C17.0148 6.73459 16.8445 6.66406 16.667 6.66406C16.4894 6.66406 16.3192 6.73459 16.1936 6.86012L12.0003 11.0601L7.80695 6.86012C7.68142 6.73459 7.51115 6.66406 7.33362 6.66406C7.15608 6.66406 6.98582 6.73459 6.86028 6.86012C6.73475 6.98566 6.66422 7.15592 6.66422 7.33346C6.66422 7.51099 6.73475 7.68125 6.86028 7.80679L11.0603 12.0001L6.86028 16.1935C6.7978 16.2554 6.7482 16.3292 6.71436 16.4104C6.68051 16.4916 6.66309 16.5788 6.66309 16.6668C6.66309 16.7548 6.68051 16.8419 6.71436 16.9232C6.7482 17.0044 6.7978 17.0781 6.86028 17.1401C6.92226 17.2026 6.99599 17.2522 7.07723 17.2861C7.15847 17.3199 7.24561 17.3373 7.33362 17.3373C7.42163 17.3373 7.50876 17.3199 7.59 17.2861C7.67124 17.2522 7.74498 17.2026 7.80695 17.1401L12.0003 12.9401L16.1936 17.1401C16.2556 17.2026 16.3293 17.2522 16.4106 17.2861C16.4918 17.3199 16.5789 17.3373 16.667 17.3373C16.755 17.3373 16.8421 17.3199 16.9233 17.2861C17.0046 17.2522 17.0783 17.2026 17.1403 17.1401C17.2028 17.0781 17.2524 17.0044 17.2862 16.9232C17.3201 16.8419 17.3375 16.7548 17.3375 16.6668C17.3375 16.5788 17.3201 16.4916 17.2862 16.4104C17.2524 16.3292 17.2028 16.2554 17.1403 16.1935L12.9403 12.0001Z" fill="white" /></svg>',
        buttonStyle: {
          border: "none",
          "background-color": "transparent",
          width: "max-content"
        }
      },
      imageDownload: {
        innerHTML: '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15.833 16.6666H4.16634C3.94533 16.6666 3.73337 16.7544 3.57709 16.9107C3.42081 17.067 3.33301 17.2789 3.33301 17.5C3.33301 17.721 3.42081 17.9329 3.57709 18.0892C3.73337 18.2455 3.94533 18.3333 4.16634 18.3333H15.833C16.054 18.3333 16.266 18.2455 16.4223 18.0892C16.5785 17.9329 16.6663 17.721 16.6663 17.5C16.6663 17.2789 16.5785 17.067 16.4223 16.9107C16.266 16.7544 16.054 16.6666 15.833 16.6666ZM9.40801 14.7583C9.48726 14.8342 9.58071 14.8936 9.68301 14.9333C9.78276 14.9774 9.89061 15.0002 9.99967 15.0002C10.1087 15.0002 10.2166 14.9774 10.3163 14.9333C10.4186 14.8936 10.5121 14.8342 10.5913 14.7583L13.9247 11.425C14.0816 11.268 14.1697 11.0552 14.1697 10.8333C14.1697 10.6114 14.0816 10.3985 13.9247 10.2416C13.7678 10.0847 13.5549 9.99655 13.333 9.99655C13.1111 9.99655 12.8983 10.0847 12.7413 10.2416L10.833 12.1583V2.49996C10.833 2.27895 10.7452 2.06698 10.5889 1.9107C10.4326 1.75442 10.2207 1.66663 9.99967 1.66663C9.77866 1.66663 9.5667 1.75442 9.41042 1.9107C9.25414 2.06698 9.16634 2.27895 9.16634 2.49996V12.1583L7.25801 10.2416C7.18031 10.1639 7.08807 10.1023 6.98655 10.0602C6.88503 10.0182 6.77622 9.99655 6.66634 9.99655C6.55646 9.99655 6.44765 10.0182 6.34613 10.0602C6.24461 10.1023 6.15237 10.1639 6.07467 10.2416C5.99698 10.3193 5.93534 10.4116 5.89329 10.5131C5.85124 10.6146 5.8296 10.7234 5.8296 10.8333C5.8296 10.9432 5.85124 11.052 5.89329 11.1535C5.93534 11.255 5.99698 11.3473 6.07467 11.425L9.40801 14.7583Z" fill="#6B7491" /></svg>',
        buttonStyle: {
          border: "none",
          "background-color": "transparent",
          width: "max-content"
        }
      },
      openModalDot: {
        innerHTML: '<svg width="18" height="4" viewBox="0 0 18 4" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4 2C4 1.60444 3.8827 1.21776 3.66294 0.888858C3.44318 0.55996 3.13082 0.303614 2.76537 0.152239C2.39992 0.000863686 1.99778 -0.0387431 1.60982 0.0384275C1.22186 0.115598 0.865492 0.30608 0.585787 0.585785C0.306082 0.86549 0.115601 1.22186 0.0384302 1.60982C-0.0387402 1.99778 0.000866492 2.39991 0.152242 2.76537C0.303617 3.13082 0.559962 3.44318 0.88886 3.66294C1.21776 3.8827 1.60444 4 2 4C2.53043 4 3.03914 3.78928 3.41421 3.41421C3.78929 3.03914 4 2.53043 4 2ZM14 2C14 2.39556 14.1173 2.78224 14.3371 3.11114C14.5568 3.44004 14.8692 3.69638 15.2346 3.84776C15.6001 3.99913 16.0022 4.03874 16.3902 3.96157C16.7781 3.8844 17.1345 3.69392 17.4142 3.41421C17.6939 3.13451 17.8844 2.77814 17.9616 2.39018C18.0387 2.00222 17.9991 1.60008 17.8478 1.23463C17.6964 0.869179 17.44 0.556821 17.1111 0.337059C16.7822 0.117296 16.3956 -2.14718e-06 16 -2.12989e-06C15.4696 -2.10671e-06 14.9609 0.210712 14.5858 0.585785C14.2107 0.960857 14 1.46956 14 2ZM7 2C7 2.39556 7.1173 2.78224 7.33706 3.11114C7.55682 3.44004 7.86918 3.69638 8.23463 3.84776C8.60009 3.99913 9.00222 4.03874 9.39018 3.96157C9.77814 3.8844 10.1345 3.69392 10.4142 3.41421C10.6939 3.13451 10.8844 2.77814 10.9616 2.39018C11.0387 2.00222 10.9991 1.60008 10.8478 1.23463C10.6964 0.869179 10.44 0.556822 10.1111 0.337059C9.78224 0.117296 9.39556 -1.8412e-06 9 -1.82391e-06C8.46957 -1.80073e-06 7.96086 0.210712 7.58579 0.585785C7.21071 0.960858 7 1.46957 7 2Z" fill="#51545C"/></svg>',
        buttonStyle: {
          border: "none",
          "background-color": "transparent",
          width: "max-content"
        }
      },
      star: {
        innerHTML: '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.0003 1.66669L12.5753 6.88335L18.3337 7.72502L14.167 11.7834L15.1503 17.5167L10.0003 14.8084L4.85033 17.5167L5.83366 11.7834L1.66699 7.72502L7.42533 6.88335L10.0003 1.66669Z" stroke="#6B7491" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" /></svg>',
        buttonStyle: {
          border: "none",
          "background-color": "transparent",
          width: "max-content"
        }
      },
      emoji: {
        innerHTML: `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.967 11.8582C11.4099 12.3073 10.7159 12.5522 10.0003 12.5522C9.28475 12.5522 8.59073 12.3073 8.03366 11.8582C7.86348 11.7167 7.64408 11.6487 7.42373 11.669C7.20337 11.6893 7.00011 11.7963 6.85866 11.9665C6.71721 12.1367 6.64916 12.3561 6.66948 12.5764C6.6898 12.7968 6.79681 13.0001 6.967 13.1415C7.81811 13.852 8.89163 14.2412 10.0003 14.2412C11.109 14.2412 12.1825 13.852 13.0337 13.1415C13.2038 13.0001 13.3109 12.7968 13.3312 12.5764C13.3515 12.3561 13.2834 12.1367 13.142 11.9665C13.072 11.8822 12.986 11.8126 12.8891 11.7615C12.7921 11.7105 12.686 11.679 12.5769 11.669C12.3566 11.6487 12.1372 11.7167 11.967 11.8582ZM7.50033 9.1665C7.66515 9.1665 7.82626 9.11763 7.9633 9.02606C8.10035 8.93449 8.20716 8.80435 8.27023 8.65207C8.3333 8.4998 8.3498 8.33225 8.31765 8.1706C8.2855 8.00894 8.20613 7.86046 8.08958 7.74392C7.97304 7.62737 7.82455 7.548 7.6629 7.51585C7.50125 7.4837 7.3337 7.5002 7.18143 7.56327C7.02915 7.62634 6.89901 7.73315 6.80744 7.8702C6.71587 8.00724 6.667 8.16835 6.667 8.33317C6.667 8.55418 6.75479 8.76615 6.91107 8.92243C7.06735 9.07871 7.27931 9.1665 7.50033 9.1665ZM12.5003 7.49984C12.3355 7.49984 12.1744 7.54871 12.0374 7.64028C11.9003 7.73185 11.7935 7.862 11.7304 8.01427C11.6674 8.16654 11.6509 8.3341 11.683 8.49575C11.7152 8.6574 11.7945 8.80588 11.9111 8.92243C12.0276 9.03897 12.1761 9.11834 12.3378 9.15049C12.4994 9.18265 12.667 9.16614 12.8192 9.10307C12.9715 9.04 13.1017 8.93319 13.1932 8.79615C13.2848 8.65911 13.3337 8.49799 13.3337 8.33317C13.3337 8.11216 13.2459 7.9002 13.0896 7.74392C12.9333 7.58764 12.7213 7.49984 12.5003 7.49984ZM10.0003 1.6665C8.35215 1.6665 6.74099 2.15525 5.37058 3.07092C4.00017 3.9866 2.93206 5.28809 2.30133 6.81081C1.6706 8.33353 1.50558 10.0091 1.82712 11.6256C2.14866 13.2421 2.94234 14.727 4.10777 15.8924C5.27321 17.0578 6.75807 17.8515 8.37458 18.173C9.99109 18.4946 11.6666 18.3296 13.1894 17.6988C14.7121 17.0681 16.0136 16 16.9292 14.6296C17.8449 13.2592 18.3337 11.648 18.3337 9.99984C18.3337 8.90549 18.1181 7.82186 17.6993 6.81081C17.2805 5.79976 16.6667 4.8811 15.8929 4.10728C15.1191 3.33346 14.2004 2.71963 13.1894 2.30084C12.1783 1.88205 11.0947 1.6665 10.0003 1.6665ZM10.0003 16.6665C8.68179 16.6665 7.39286 16.2755 6.29653 15.543C5.2002 14.8104 4.34572 13.7692 3.84113 12.5511C3.33655 11.3329 3.20453 9.99244 3.46176 8.69924C3.719 7.40603 4.35393 6.21814 5.28628 5.28579C6.21863 4.35344 7.40652 3.7185 8.69973 3.46127C9.99293 3.20403 11.3334 3.33606 12.5516 3.84064C13.7697 4.34522 14.8109 5.19971 15.5435 6.29604C16.276 7.39236 16.667 8.6813 16.667 9.99984C16.667 11.7679 15.9646 13.4636 14.7144 14.7139C13.4641 15.9641 11.7684 16.6665 10.0003 16.6665Z" fill="${!this.active ? this.color : this.getActiveColor()}" /></svg>`,
        buttonStyle: {
          border: "none",
          "background-color": "transparent",
          width: "max-content"
        }
      },
      voice: {
        innerHTML: '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.0002 12.4999C10.8842 12.4999 11.7321 12.1487 12.3572 11.5236C12.9823 10.8985 13.3335 10.0506 13.3335 9.16658V4.16658C13.3335 3.28253 12.9823 2.43468 12.3572 1.80956C11.7321 1.18444 10.8842 0.833252 10.0002 0.833252C9.11611 0.833252 8.26826 1.18444 7.64314 1.80956C7.01802 2.43468 6.66683 3.28253 6.66683 4.16658V9.16658C6.66683 10.0506 7.01802 10.8985 7.64314 11.5236C8.26826 12.1487 9.11611 12.4999 10.0002 12.4999ZM8.3335 4.16658C8.3335 3.72456 8.50909 3.30063 8.82165 2.98807C9.13421 2.67551 9.55814 2.49992 10.0002 2.49992C10.4422 2.49992 10.8661 2.67551 11.1787 2.98807C11.4912 3.30063 11.6668 3.72456 11.6668 4.16658V9.16658C11.6668 9.60861 11.4912 10.0325 11.1787 10.3451C10.8661 10.6577 10.4422 10.8333 10.0002 10.8333C9.55814 10.8333 9.13421 10.6577 8.82165 10.3451C8.50909 10.0325 8.3335 9.60861 8.3335 9.16658V4.16658ZM16.6668 9.16658C16.6668 8.94557 16.579 8.73361 16.4228 8.57733C16.2665 8.42105 16.0545 8.33325 15.8335 8.33325C15.6125 8.33325 15.4005 8.42105 15.2442 8.57733C15.088 8.73361 15.0002 8.94557 15.0002 9.16658C15.0002 10.4927 14.4734 11.7644 13.5357 12.7021C12.598 13.6398 11.3262 14.1666 10.0002 14.1666C8.67408 14.1666 7.40231 13.6398 6.46463 12.7021C5.52695 11.7644 5.00016 10.4927 5.00016 9.16658C5.00016 8.94557 4.91237 8.73361 4.75608 8.57733C4.5998 8.42105 4.38784 8.33325 4.16683 8.33325C3.94582 8.33325 3.73385 8.42105 3.57757 8.57733C3.42129 8.73361 3.3335 8.94557 3.3335 9.16658C3.33497 10.7893 3.92826 12.3558 5.00216 13.5724C6.07606 14.789 7.55681 15.5721 9.16683 15.7749V17.4999H7.50016C7.27915 17.4999 7.06719 17.5877 6.91091 17.744C6.75463 17.9003 6.66683 18.1122 6.66683 18.3333C6.66683 18.5543 6.75463 18.7662 6.91091 18.9225C7.06719 19.0788 7.27915 19.1666 7.50016 19.1666H12.5002C12.7212 19.1666 12.9331 19.0788 13.0894 18.9225C13.2457 18.7662 13.3335 18.5543 13.3335 18.3333C13.3335 18.1122 13.2457 17.9003 13.0894 17.744C12.9331 17.5877 12.7212 17.4999 12.5002 17.4999H10.8335V15.7749C12.4435 15.5721 13.9243 14.789 14.9982 13.5724C16.0721 12.3558 16.6654 10.7893 16.6668 9.16658Z" fill="#15AE73"/></svg>',
        buttonStyle: {
          border: "none",
          "background-color": "transparent",
          width: "max-content"
        }
      },
      play: {
        innerHTML: '<svg width="18" height="22" viewBox="0 0 18 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M18 11L-9.78799e-07 21.3923L-7.02746e-08 0.607695L18 11Z" fill="#9999BC"/></svg>',
        buttonStyle: {
          border: "none",
          "background-color": "transparent",
          width: "max-content"
        }
      },
      reply: {
        innerHTML: '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.7402 11.7934C13.158 11.2333 13.4447 10.5866 13.5792 9.90098C13.7137 9.21533 13.6925 8.50824 13.5171 7.83189C13.3418 7.15553 13.0168 6.52718 12.5662 5.9932C12.1156 5.45922 11.5508 5.03324 10.9136 4.7467C10.7748 3.9481 10.4558 3.19165 9.98079 2.53482C9.50582 1.87798 8.88738 1.33805 8.17246 0.956056C7.45755 0.574057 6.66497 0.360038 5.85494 0.33026C5.04492 0.300483 4.23876 0.455732 3.49773 0.784209C2.7567 1.11269 2.10028 1.60575 1.57837 2.22594C1.05645 2.84612 0.682765 3.57711 0.485701 4.36337C0.288636 5.14962 0.273379 5.97045 0.441089 6.76348C0.608799 7.55651 0.955063 8.30088 1.45357 8.94004L0.526905 9.86004C0.4344 9.95379 0.371735 10.0728 0.346819 10.2022C0.321903 10.3315 0.335852 10.4653 0.386905 10.5867C0.436918 10.7084 0.52185 10.8127 0.630997 10.8862C0.740144 10.9598 0.868621 10.9994 1.00024 11H4.79357C5.17134 11.7964 5.76693 12.4696 6.5114 12.9415C7.25588 13.4134 8.11879 13.6649 9.00024 13.6667H13.0002C13.1319 13.666 13.2603 13.6264 13.3695 13.5529C13.4786 13.4793 13.5636 13.3751 13.6136 13.2534C13.6646 13.132 13.6786 12.9982 13.6537 12.8688C13.6287 12.7395 13.5661 12.6205 13.4736 12.5267L12.7402 11.7934ZM4.33357 9.00004C4.33449 9.22329 4.35232 9.44615 4.3869 9.6667H2.6069L2.84024 9.44004C2.90272 9.37806 2.95232 9.30433 2.98617 9.22309C3.02001 9.14185 3.03744 9.05471 3.03744 8.9667C3.03744 8.87869 3.02001 8.79156 2.98617 8.71032C2.95232 8.62908 2.90272 8.55534 2.84024 8.49337C2.46661 8.12384 2.1704 7.68353 1.96894 7.19818C1.76748 6.71284 1.6648 6.1922 1.6669 5.6667C1.6669 4.60584 2.08833 3.58842 2.83848 2.83827C3.58862 2.08813 4.60604 1.6667 5.6669 1.6667C6.49469 1.66173 7.30323 1.91629 7.97886 2.39461C8.65448 2.87293 9.16323 3.55095 9.43357 4.33337C9.2869 4.33337 9.1469 4.33337 9.00024 4.33337C7.76256 4.33337 6.57558 4.82503 5.70041 5.7002C4.82524 6.57537 4.33357 7.76236 4.33357 9.00004ZM11.3602 12.3334L11.3936 12.3667H9.00024C8.22913 12.3653 7.48235 12.0966 6.88712 11.6064C6.29188 11.1162 5.88502 10.4348 5.73584 9.67826C5.58665 8.92172 5.70438 8.13686 6.06895 7.45738C6.43353 6.7779 7.02241 6.24584 7.73527 5.95184C8.44814 5.65783 9.24088 5.62007 9.97846 5.84499C10.716 6.06991 11.3528 6.54359 11.7803 7.18534C12.2078 7.82709 12.3996 8.59721 12.323 9.3645C12.2464 10.1318 11.9062 10.8488 11.3602 11.3934C11.2346 11.5165 11.1627 11.6842 11.1602 11.86C11.1606 11.9482 11.1785 12.0355 11.2128 12.1167C11.2471 12.198 11.2972 12.2716 11.3602 12.3334Z" fill="#51545C"/></svg>',
        buttonStyle: {
          border: "none",
          "background-color": "transparent",
          width: "max-content"
        }
      },
      trash: {
        innerHTML: '<svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7 16C7.26522 16 7.51957 15.8946 7.70711 15.7071C7.89464 15.5196 8 15.2652 8 15V9C8 8.73478 7.89464 8.48043 7.70711 8.29289C7.51957 8.10536 7.26522 8 7 8C6.73478 8 6.48043 8.10536 6.29289 8.29289C6.10536 8.48043 6 8.73478 6 9V15C6 15.2652 6.10536 15.5196 6.29289 15.7071C6.48043 15.8946 6.73478 16 7 16ZM17 4H13V3C13 2.20435 12.6839 1.44129 12.1213 0.87868C11.5587 0.316071 10.7956 0 10 0H8C7.20435 0 6.44129 0.316071 5.87868 0.87868C5.31607 1.44129 5 2.20435 5 3V4H1C0.734784 4 0.48043 4.10536 0.292893 4.29289C0.105357 4.48043 0 4.73478 0 5C0 5.26522 0.105357 5.51957 0.292893 5.70711C0.48043 5.89464 0.734784 6 1 6H2V17C2 17.7956 2.31607 18.5587 2.87868 19.1213C3.44129 19.6839 4.20435 20 5 20H13C13.7956 20 14.5587 19.6839 15.1213 19.1213C15.6839 18.5587 16 17.7956 16 17V6H17C17.2652 6 17.5196 5.89464 17.7071 5.70711C17.8946 5.51957 18 5.26522 18 5C18 4.73478 17.8946 4.48043 17.7071 4.29289C17.5196 4.10536 17.2652 4 17 4ZM7 3C7 2.73478 7.10536 2.48043 7.29289 2.29289C7.48043 2.10536 7.73478 2 8 2H10C10.2652 2 10.5196 2.10536 10.7071 2.29289C10.8946 2.48043 11 2.73478 11 3V4H7V3ZM14 17C14 17.2652 13.8946 17.5196 13.7071 17.7071C13.5196 17.8946 13.2652 18 13 18H5C4.73478 18 4.48043 17.8946 4.29289 17.7071C4.10536 17.5196 4 17.2652 4 17V6H14V17ZM11 16C11.2652 16 11.5196 15.8946 11.7071 15.7071C11.8946 15.5196 12 15.2652 12 15V9C12 8.73478 11.8946 8.48043 11.7071 8.29289C11.5196 8.10536 11.2652 8 11 8C10.7348 8 10.4804 8.10536 10.2929 8.29289C10.1054 8.48043 10 8.73478 10 9V15C10 15.2652 10.1054 15.5196 10.2929 15.7071C10.4804 15.8946 10.7348 16 11 16Z" fill="#D53120"/></svg>',
        buttonStyle: {
          border: "none",
          "background-color": "transparent",
          width: "max-content"
        }
      },
      delete: {
        innerHTML: '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2.5 5H4.16667H17.5" stroke="#E80000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" /><path d="M6.66699 5.00002V3.33335C6.66699 2.89133 6.84259 2.4674 7.15515 2.15484C7.46771 1.84228 7.89163 1.66669 8.33366 1.66669H11.667C12.109 1.66669 12.5329 1.84228 12.8455 2.15484C13.1581 2.4674 13.3337 2.89133 13.3337 3.33335V5.00002M15.8337 5.00002V16.6667C15.8337 17.1087 15.6581 17.5326 15.3455 17.8452C15.0329 18.1578 14.609 18.3334 14.167 18.3334H5.83366C5.39163 18.3334 4.96771 18.1578 4.65515 17.8452C4.34259 17.5326 4.16699 17.1087 4.16699 16.6667V5.00002H15.8337Z" stroke="#E80000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" /><path d="M11.667 9.16669V14.1667" stroke="#E80000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" /><path d="M8.33301 9.16669V14.1667" stroke="#E80000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" /></svg>',
        buttonStyle: {
          border: "none",
          "background-color": "transparent",
          width: "max-content"
        }
      },
      remove: {
        innerHTML: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.4099 12.0002L19.7099 5.71019C19.8982 5.52188 20.004 5.26649 20.004 5.00019C20.004 4.73388 19.8982 4.47849 19.7099 4.29019C19.5216 4.10188 19.2662 3.99609 18.9999 3.99609C18.7336 3.99609 18.4782 4.10188 18.2899 4.29019L11.9999 10.5902L5.70994 4.29019C5.52164 4.10188 5.26624 3.99609 4.99994 3.99609C4.73364 3.99609 4.47824 4.10188 4.28994 4.29019C4.10164 4.47849 3.99585 4.73388 3.99585 5.00019C3.99585 5.26649 4.10164 5.52188 4.28994 5.71019L10.5899 12.0002L4.28994 18.2902C4.19621 18.3831 4.12182 18.4937 4.07105 18.6156C4.02028 18.7375 3.99414 18.8682 3.99414 19.0002C3.99414 19.1322 4.02028 19.2629 4.07105 19.3848C4.12182 19.5066 4.19621 19.6172 4.28994 19.7102C4.3829 19.8039 4.4935 19.8783 4.61536 19.9291C4.73722 19.9798 4.86793 20.006 4.99994 20.006C5.13195 20.006 5.26266 19.9798 5.38452 19.9291C5.50638 19.8783 5.61698 19.8039 5.70994 19.7102L11.9999 13.4102L18.2899 19.7102C18.3829 19.8039 18.4935 19.8783 18.6154 19.9291C18.7372 19.9798 18.8679 20.006 18.9999 20.006C19.132 20.006 19.2627 19.9798 19.3845 19.9291C19.5064 19.8783 19.617 19.8039 19.7099 19.7102C19.8037 19.6172 19.8781 19.5066 19.9288 19.3848C19.9796 19.2629 20.0057 19.1322 20.0057 19.0002C20.0057 18.8682 19.9796 18.7375 19.9288 18.6156C19.8781 18.4937 19.8037 18.3831 19.7099 18.2902L13.4099 12.0002Z" fill="${this.color}"/></svg>`,
        buttonStyle: {
          border: "none",
          "background-color": "transparent",
          width: "max-content",
          display: "flex",
          "align-items": "center"
        }
      },
      remove2: {
        innerHTML: '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.9398 8.00012L13.1398 3.80679C13.2653 3.68125 13.3359 3.51099 13.3359 3.33346C13.3359 3.15592 13.2653 2.98566 13.1398 2.86012C13.0143 2.73459 12.844 2.66406 12.6665 2.66406C12.4889 2.66406 12.3187 2.73459 12.1931 2.86012L7.9998 7.06012L3.80646 2.86012C3.68093 2.73459 3.51066 2.66406 3.33313 2.66406C3.1556 2.66406 2.98533 2.73459 2.8598 2.86012C2.73426 2.98566 2.66374 3.15592 2.66374 3.33346C2.66374 3.51099 2.73426 3.68125 2.8598 3.80679L7.0598 8.00012L2.8598 12.1935C2.79731 12.2554 2.74771 12.3292 2.71387 12.4104C2.68002 12.4916 2.6626 12.5788 2.6626 12.6668C2.6626 12.7548 2.68002 12.8419 2.71387 12.9232C2.74771 13.0044 2.79731 13.0781 2.8598 13.1401C2.92177 13.2026 2.99551 13.2522 3.07675 13.2861C3.15798 13.3199 3.24512 13.3373 3.33313 13.3373C3.42114 13.3373 3.50827 13.3199 3.58951 13.2861C3.67075 13.2522 3.74449 13.2026 3.80646 13.1401L7.9998 8.94012L12.1931 13.1401C12.2551 13.2026 12.3288 13.2522 12.4101 13.2861C12.4913 13.3199 12.5785 13.3373 12.6665 13.3373C12.7545 13.3373 12.8416 13.3199 12.9228 13.2861C13.0041 13.2522 13.0778 13.2026 13.1398 13.1401C13.2023 13.0781 13.2519 13.0044 13.2857 12.9232C13.3196 12.8419 13.337 12.7548 13.337 12.6668C13.337 12.5788 13.3196 12.4916 13.2857 12.4104C13.2519 12.3292 13.2023 12.2554 13.1398 12.1935L8.9398 8.00012Z" fill="#D53120"/></svg>',
        buttonStyle: {
          border: "none",
          "background-color": "transparent",
          width: "max-content"
        }
      },
      remove3: {
        innerHTML: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.4099 12.0002L19.7099 5.71019C19.8982 5.52188 20.004 5.26649 20.004 5.00019C20.004 4.73388 19.8982 4.47849 19.7099 4.29019C19.5216 4.10188 19.2662 3.99609 18.9999 3.99609C18.7336 3.99609 18.4782 4.10188 18.2899 4.29019L11.9999 10.5902L5.70994 4.29019C5.52164 4.10188 5.26624 3.99609 4.99994 3.99609C4.73364 3.99609 4.47824 4.10188 4.28994 4.29019C4.10164 4.47849 3.99585 4.73388 3.99585 5.00019C3.99585 5.26649 4.10164 5.52188 4.28994 5.71019L10.5899 12.0002L4.28994 18.2902C4.19621 18.3831 4.12182 18.4937 4.07105 18.6156C4.02028 18.7375 3.99414 18.8682 3.99414 19.0002C3.99414 19.1322 4.02028 19.2629 4.07105 19.3848C4.12182 19.5066 4.19621 19.6172 4.28994 19.7102C4.3829 19.8039 4.4935 19.8783 4.61536 19.9291C4.73722 19.9798 4.86793 20.006 4.99994 20.006C5.13195 20.006 5.26266 19.9798 5.38452 19.9291C5.50638 19.8783 5.61698 19.8039 5.70994 19.7102L11.9999 13.4102L18.2899 19.7102C18.3829 19.8039 18.4935 19.8783 18.6154 19.9291C18.7372 19.9798 18.8679 20.006 18.9999 20.006C19.132 20.006 19.2627 19.9798 19.3845 19.9291C19.5064 19.8783 19.617 19.8039 19.7099 19.7102C19.8037 19.6172 19.8781 19.5066 19.9288 19.3848C19.9796 19.2629 20.0057 19.1322 20.0057 19.0002C20.0057 18.8682 19.9796 18.7375 19.9288 18.6156C19.8781 18.4937 19.8037 18.3831 19.7099 18.2902L13.4099 12.0002Z" fill="#D53120"/></svg>',
        buttonStyle: {
          border: "none",
          "background-color": "transparent",
          width: "max-content",
          display: "flex",
          "align-items": "center"
        }
      },
      forward: {
        innerHTML: '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.6666 8.33333C11.5817 8.31128 11.4932 8.30622 11.4063 8.31843C11.3195 8.33064 11.2358 8.35988 11.1603 8.40447C11.0847 8.44907 11.0187 8.50814 10.966 8.5783C10.9133 8.64846 10.875 8.72833 10.8533 8.81333C10.5983 9.81902 10.0155 10.7111 9.19698 11.3485C8.37841 11.986 7.37076 12.3325 6.33326 12.3333H2.6066L3.03326 11.9133C3.15743 11.7884 3.22713 11.6195 3.22713 11.4433C3.22713 11.2672 3.15743 11.0982 3.03326 10.9733C2.37826 10.321 1.93173 9.4889 1.75032 8.58248C1.56891 7.67605 1.66078 6.73616 2.01429 5.88203C2.3678 5.02789 2.96702 4.29798 3.73595 3.78488C4.50487 3.27178 5.40886 2.9986 6.33326 2.99999C6.51007 2.99999 6.67964 2.92975 6.80467 2.80473C6.92969 2.67971 6.99993 2.51014 6.99993 2.33333C6.99993 2.15652 6.92969 1.98695 6.80467 1.86192C6.67964 1.7369 6.51007 1.66666 6.33326 1.66666C5.20491 1.67037 4.10047 1.99218 3.14672 2.59515C2.19298 3.19812 1.42859 4.05781 0.941309 5.07554C0.454028 6.09326 0.263602 7.22776 0.391893 8.34881C0.520184 9.46985 0.961991 10.532 1.6666 11.4133L0.526597 12.5267C0.434092 12.6204 0.371428 12.7395 0.346512 12.8688C0.321595 12.9981 0.335544 13.1319 0.386597 13.2533C0.43661 13.3751 0.521542 13.4793 0.630689 13.5528C0.739836 13.6264 0.868313 13.666 0.99993 13.6667H6.33326C7.6641 13.6675 8.95745 13.2259 10.0098 12.4113C11.0622 11.5966 11.8139 10.4552 12.1466 9.16666C12.1717 9.08042 12.1791 8.98999 12.1683 8.90082C12.1576 8.81164 12.129 8.72556 12.0841 8.64773C12.0393 8.5699 11.9792 8.50193 11.9075 8.4479C11.8357 8.39387 11.7538 8.3549 11.6666 8.33333ZM13.4733 2.50666L11.4733 0.506659C11.4099 0.445966 11.3351 0.398389 11.2533 0.366659C11.091 0.299981 10.9089 0.299981 10.7466 0.366659C10.6648 0.398389 10.59 0.445966 10.5266 0.506659L8.5266 2.50666C8.40106 2.6322 8.33054 2.80246 8.33054 2.97999C8.33054 3.15753 8.40106 3.32779 8.5266 3.45333C8.65213 3.57886 8.8224 3.64939 8.99993 3.64939C9.17746 3.64939 9.34773 3.57886 9.47326 3.45333L10.3333 2.60666V6.33333C10.3333 6.51014 10.4035 6.67971 10.5285 6.80473C10.6535 6.92976 10.8231 6.99999 10.9999 6.99999C11.1767 6.99999 11.3463 6.92976 11.4713 6.80473C11.5964 6.67971 11.6666 6.51014 11.6666 6.33333V2.60666L12.5266 3.47333C12.5886 3.53581 12.6623 3.58541 12.7435 3.61925C12.8248 3.6531 12.9119 3.67053 12.9999 3.67053C13.0879 3.67053 13.1751 3.6531 13.2563 3.61925C13.3376 3.58541 13.4113 3.53581 13.4733 3.47333C13.5357 3.41135 13.5853 3.33762 13.6192 3.25638C13.653 3.17514 13.6705 3.088 13.6705 2.99999C13.6705 2.91198 13.653 2.82485 13.6192 2.74361C13.5853 2.66237 13.5357 2.58863 13.4733 2.52666V2.50666Z" fill="#51545C"/></svg>',
        buttonStyle: {
          border: "none",
          "background-color": "transparent",
          width: "max-content"
        }
      },
      select: {
        innerHTML: '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.8135 4.85992L5.9535 7.72659L4.8535 6.62659C4.79373 6.5568 4.72019 6.50012 4.63748 6.4601C4.55477 6.42009 4.46468 6.3976 4.37287 6.39405C4.28105 6.39051 4.1895 6.40598 4.10395 6.43949C4.0184 6.47301 3.9407 6.52385 3.87573 6.58882C3.81076 6.65379 3.75992 6.73149 3.72641 6.81704C3.69289 6.90259 3.67742 6.99414 3.68097 7.08595C3.68451 7.17777 3.707 7.26786 3.74701 7.35057C3.78703 7.43328 3.84371 7.50682 3.9135 7.56659L5.48017 9.13992C5.54246 9.20171 5.61634 9.25059 5.69756 9.28377C5.77879 9.31694 5.86576 9.33376 5.9535 9.33325C6.12839 9.33252 6.29599 9.26308 6.42017 9.13992L9.7535 5.80659C9.81598 5.74461 9.86558 5.67088 9.89943 5.58964C9.93327 5.5084 9.9507 5.42126 9.9507 5.33325C9.9507 5.24524 9.93327 5.15811 9.89943 5.07687C9.86558 4.99563 9.81598 4.92189 9.7535 4.85992C9.62859 4.73575 9.45962 4.66606 9.2835 4.66606C9.10738 4.66606 8.93841 4.73575 8.8135 4.85992ZM7.00017 0.333252C5.68162 0.333252 4.39269 0.724245 3.29636 1.45679C2.20004 2.18933 1.34555 3.23052 0.840969 4.4487C0.336385 5.66687 0.204362 7.00731 0.461597 8.30052C0.718832 9.59373 1.35377 10.7816 2.28612 11.714C3.21847 12.6463 4.40636 13.2813 5.69956 13.5385C6.99277 13.7957 8.33321 13.6637 9.55139 13.1591C10.7696 12.6545 11.8108 11.8 12.5433 10.7037C13.2758 9.60739 13.6668 8.31846 13.6668 6.99992C13.6668 6.12444 13.4944 5.25753 13.1594 4.4487C12.8243 3.63986 12.3333 2.90493 11.7142 2.28587C11.0952 1.66682 10.3602 1.17575 9.55139 0.840722C8.74255 0.50569 7.87564 0.333252 7.00017 0.333252ZM7.00017 12.3333C5.94533 12.3333 4.91419 12.0205 4.03712 11.4344C3.16006 10.8484 2.47648 10.0154 2.07281 9.0409C1.66914 8.06636 1.56352 6.994 1.76931 5.95944C1.9751 4.92487 2.48305 3.97456 3.22893 3.22868C3.97481 2.4828 4.92512 1.97485 5.95968 1.76906C6.99425 1.56328 8.0666 1.66889 9.04114 2.07256C10.0157 2.47623 10.8486 3.15982 11.4347 4.03688C12.0207 4.91394 12.3335 5.94509 12.3335 6.99992C12.3335 8.41441 11.7716 9.77096 10.7714 10.7712C9.77121 11.7713 8.41465 12.3333 7.00017 12.3333Z" fill="#51545C"/></svg>',
        buttonStyle: {
          border: "none",
          "background-color": "transparent",
          width: "max-content"
        }
      },
      download: {
        innerHTML: '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.52667 8.86016C5.46418 8.92214 5.41459 8.99587 5.38074 9.07711C5.34689 9.15835 5.32947 9.24549 5.32947 9.3335C5.32947 9.4215 5.34689 9.50864 5.38074 9.58988C5.41459 9.67112 5.46418 9.74485 5.52667 9.80683L7.52667 11.8068C7.58864 11.8693 7.66238 11.9189 7.74362 11.9528C7.82486 11.9866 7.91199 12.004 8 12.004C8.08801 12.004 8.17515 11.9866 8.25638 11.9528C8.33762 11.9189 8.41136 11.8693 8.47333 11.8068L10.4733 9.80683C10.5989 9.68129 10.6694 9.51103 10.6694 9.3335C10.6694 9.15596 10.5989 8.9857 10.4733 8.86016C10.3478 8.73463 10.1775 8.6641 10 8.6641C9.82247 8.6641 9.6522 8.73463 9.52667 8.86016L8.66667 9.72683V2.00016C8.66667 1.82335 8.59643 1.65378 8.4714 1.52876C8.34638 1.40373 8.17681 1.3335 8 1.3335C7.82319 1.3335 7.65362 1.40373 7.5286 1.52876C7.40357 1.65378 7.33333 1.82335 7.33333 2.00016V9.72683L6.47333 8.86016C6.41136 8.79768 6.33762 8.74808 6.25638 8.71424C6.17515 8.68039 6.08801 8.66296 6 8.66296C5.91199 8.66296 5.82486 8.68039 5.74362 8.71424C5.66238 8.74808 5.58864 8.79768 5.52667 8.86016ZM12 6.00016H10.6667C10.4899 6.00016 10.3203 6.0704 10.1953 6.19543C10.0702 6.32045 10 6.49002 10 6.66683C10 6.84364 10.0702 7.01321 10.1953 7.13823C10.3203 7.26326 10.4899 7.3335 10.6667 7.3335H12C12.1768 7.3335 12.3464 7.40373 12.4714 7.52876C12.5964 7.65378 12.6667 7.82335 12.6667 8.00016V12.6668C12.6667 12.8436 12.5964 13.0132 12.4714 13.1382C12.3464 13.2633 12.1768 13.3335 12 13.3335H4C3.82319 13.3335 3.65362 13.2633 3.5286 13.1382C3.40357 13.0132 3.33333 12.8436 3.33333 12.6668V8.00016C3.33333 7.82335 3.40357 7.65378 3.5286 7.52876C3.65362 7.40373 3.82319 7.3335 4 7.3335H5.33333C5.51014 7.3335 5.67971 7.26326 5.80474 7.13823C5.92976 7.01321 6 6.84364 6 6.66683C6 6.49002 5.92976 6.32045 5.80474 6.19543C5.67971 6.0704 5.51014 6.00016 5.33333 6.00016H4C3.46957 6.00016 2.96086 6.21088 2.58579 6.58595C2.21071 6.96102 2 7.46973 2 8.00016V12.6668C2 13.1973 2.21071 13.706 2.58579 14.081C2.96086 14.4561 3.46957 14.6668 4 14.6668H12C12.5304 14.6668 13.0391 14.4561 13.4142 14.081C13.7893 13.706 14 13.1973 14 12.6668V8.00016C14 7.46973 13.7893 6.96102 13.4142 6.58595C13.0391 6.21088 12.5304 6.00016 12 6.00016Z" fill="#15AE73"/></svg>',
        buttonStyle: {
          border: "none",
          "background-color": "transparent",
          width: "max-content"
        }
      },
      thumbsUp: {
        innerHTML: '<svg width="14" height="18" viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M0 13.3185C0 12.0769 0.0872402 10.2867 0.393569 9.78921C0.699899 9.2917 3.37046 6.82769 4.23394 4.8211C5.09743 2.81451 5.24635 -2.64843e-08 6.66448 0C8.08261 2.64843e-08 8.54711 1.07299 8.39665 3.27715C8.24619 5.48132 7.19249 6.8417 7.93351 7.37855C8.43701 7.74333 9.32516 7.14674 11.4795 7.14674C12.418 7.14674 14 7.14674 14 8.40487C14 9.66301 13.7229 9.51859 13.5964 10.3727C13.47 11.2267 13.8508 11.6408 13.4302 12.6044C13.0095 13.568 12.4917 13.6862 12.2509 14.3763C12.0102 15.0664 12.0945 15.8083 10.9684 16.8194C9.8422 17.8305 8.04477 18 6.66448 18C5.28419 18 1.18342 17.5376 0.618626 16.2318C0.0538331 14.9261 0 14.4502 0 13.3185Z" fill="#7A7A7A"/></svg>',
        buttonStyle: {
          border: "none",
          "background-color": "transparent",
          width: "max-content"
        }
      },
      like: {
        innerHTML: '<svg width="20" height="17" viewBox="0 0 20 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M10.0001 16.9998C10.9077 17.0335 17.2333 12.9488 19.1353 8.85454C20.2893 6.37012 20.2882 4.06058 19.132 2.3507C18.1364 0.878608 16.3962 0 14.4777 0C11.7118 0 10.575 2.68418 10.0001 2.68418C9.42509 2.68418 8.42213 0 5.52265 0C3.6035 0 1.86348 0.878822 0.867904 2.3507C-0.288337 4.06036 -0.289226 6.37012 0.864793 8.85475C2.76705 12.9484 9.09241 16.9661 10.0001 16.9998Z" fill="#7A7A7A"/></svg>',
        buttonStyle: {
          border: "none",
          "background-color": "transparent",
          width: "max-content"
        }
      },
      thumbsDown: {
        innerHTML: '<svg width="14" height="18" viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M0 4.68147C0 5.9231 0.0872402 7.71329 0.393569 8.21079C0.699899 8.7083 3.37046 11.1723 4.23394 13.1789C5.09743 15.1855 5.24635 18 6.66448 18C8.0826 18 8.54711 16.927 8.39665 14.7228C8.24619 12.5187 7.19249 11.1583 7.93351 10.6215C8.43701 10.2567 9.32516 10.8533 11.4795 10.8533C12.418 10.8533 14 10.8533 14 9.59513C14 8.33699 13.7229 8.48141 13.5964 7.62735C13.47 6.77329 13.8508 6.35923 13.4302 5.39561C13.0095 4.432 12.4917 4.31375 12.2509 3.62367C12.0102 2.93359 12.0945 2.19169 10.9684 1.1806C9.8422 0.169497 8.04477 7.26842e-08 6.66448 0C5.28419 -7.26842e-08 1.18342 0.462433 0.618626 1.76815C0.0538331 3.07387 0 3.54983 0 4.68147Z" fill="#7A7A7A"/></svg>',
        buttonStyle: {
          border: "none",
          "background-color": "transparent",
          width: "max-content"
        }
      },
      lol: {
        innerHTML: '<svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M17.2208 13.4974L18.0008 13.1448C18.424 12.9407 18.8882 12.7053 19.3936 12.4385L19.9169 12.1827C20.4329 11.9111 20.6497 11.4041 20.5674 10.6617C20.5445 10.4547 20.4687 10.2238 20.3401 9.96872C20.2116 9.71372 20.008 9.63643 19.7294 9.73682L16.888 11.098C16.8845 10.6649 16.8877 10.1906 16.8974 9.67502C16.9622 5.03162 16.9325 2.15012 16.8084 1.03032C16.7773 0.750325 16.7365 0.583525 16.686 0.529625C16.5039 0.394725 16.0785 0.478325 15.4099 0.780525C14.7307 1.08762 14.3681 1.38572 14.3222 1.67492C14.2982 3.87132 14.2809 6.07762 14.2702 8.29362C14.2615 11.6334 14.2862 13.565 14.3442 14.0884C14.3941 14.5387 15.353 14.3417 17.2208 13.4974ZM10.127 16.7617C8.86799 17.2669 8.01959 17.0784 7.58189 16.1963C7.14419 15.3141 6.86329 14.3132 6.73919 13.1934C6.68249 12.6822 6.64829 12.1225 6.63659 11.5143C6.58149 9.60918 6.78759 7.89918 7.25489 6.38428C7.72219 4.86928 8.58189 3.82878 9.83419 3.26268L9.86609 3.24828C11.1278 2.76738 11.9792 2.95768 12.4201 3.81918C12.8611 4.68068 13.1417 5.65308 13.2617 6.73638C13.3211 7.27188 13.352 7.85228 13.3544 8.47748C13.4818 12.9445 12.406 15.7059 10.127 16.7617ZM10.0506 14.1121C10.6608 13.7852 10.9355 12.2422 10.8749 9.48328C10.8643 8.78508 10.828 8.15608 10.766 7.59618C10.7295 7.26758 10.6601 6.84198 10.5576 6.31958C10.4551 5.79708 10.23 5.57618 9.88229 5.65668C9.54269 5.81018 9.31099 6.33348 9.18709 7.22668C9.06319 8.11988 9.01289 9.12358 9.03609 10.2379C9.04799 10.9482 9.08489 11.5834 9.14699 12.1433C9.18479 12.4841 9.25789 12.9175 9.36639 13.4437C9.47489 13.9698 9.70289 14.1926 10.0506 14.1121ZM4.67671 19.168L3.89671 19.5206C2.02881 20.365 1.07001 20.562 1.02001 20.1116C0.962006 19.5883 0.937406 17.6566 0.946006 14.3168C0.956706 12.1008 0.974006 9.89458 0.998006 7.69808C1.04401 7.40888 1.40661 7.11078 2.08581 6.80378C2.75441 6.50148 3.17971 6.41788 3.36181 6.55288C3.41241 6.60668 3.45321 6.77358 3.48421 7.05348C3.60831 8.17328 3.63801 11.0549 3.57321 15.6982C3.56351 16.2138 3.56041 16.6882 3.56381 17.1212L6.40521 15.76C6.68381 15.6597 6.88741 15.737 7.01601 15.992C7.14461 16.247 7.22031 16.478 7.24331 16.6849C7.32561 17.4273 7.10871 17.9344 6.59281 18.206L6.06951 18.4617C5.56411 18.7285 5.09981 18.9639 4.67671 19.168Z" fill="#7A7A7A"/></svg>',
        buttonStyle: {
          border: "none",
          "background-color": "transparent",
          width: "max-content"
        }
      },
      exclamation: {
        innerHTML: '<svg width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M14.1245 13.8091C14.2779 13.7951 14.4082 13.7392 14.5156 13.6414C14.6229 13.5437 14.6766 13.4179 14.6766 13.2643C14.7533 12.4261 14.9373 11.1444 15.2287 9.41909C15.5201 7.69383 15.8345 6.01397 16.1719 4.37951C16.5092 2.74505 16.7776 1.63446 16.977 1.04773C16.9923 0.991851 17 0.935972 17 0.880093C17 0.754366 16.9463 0.628638 16.839 0.50291C16.5322 0.195576 16.2524 0.0349243 15.9993 0.0209546C15.7463 0.00698487 15.5814 0 15.5047 0C15.1673 0 14.8376 0.0419092 14.5156 0.125728C14.1168 0.237485 13.8024 0.349243 13.5724 0.461001C13.3577 0.54482 13.235 0.691502 13.2043 0.901048C13.097 1.59953 12.9091 2.85681 12.6407 4.67288C12.3723 6.48894 12.1615 8.078 12.0081 9.44005C11.8548 10.8021 11.7781 11.7555 11.7781 12.3003C11.7781 12.6636 11.8011 12.922 11.8471 13.0757C12.0311 13.369 12.3455 13.5646 12.7903 13.6624C13.235 13.7602 13.6031 13.8091 13.8945 13.8091H14.1245ZM5.16441 13.369C5.01872 13.5367 4.83852 13.6275 4.62382 13.6414C4.3171 13.6414 4.00654 13.603 3.69215 13.5262C3.37776 13.4494 3.1899 13.2922 3.12855 13.0547C3.08254 12.8452 3.05954 12.5448 3.05954 12.1537C3.05954 11.9721 3.07104 11.6473 3.09405 11.1793C3.11705 10.7113 3.20523 10.135 3.35859 9.45052C3.51195 8.76601 3.74966 8.27707 4.07172 7.9837C4.3171 7.8021 4.59314 7.60652 4.89986 7.39697C5.66667 6.922 6.34145 6.3702 6.92422 5.74156C7.30762 5.33644 7.49932 4.89639 7.49932 4.42142C7.49932 4.156 7.43798 3.88359 7.31529 3.60419C7.20794 3.33877 7.04691 3.15017 6.83221 3.03842C6.63284 2.92666 6.34145 2.87078 5.95805 2.87078H5.84303C4.46279 2.94063 3.61931 3.34575 3.31258 4.08615C3.20523 4.35157 3.15156 4.60303 3.15156 4.84051C3.15156 5.30151 3.32792 5.73458 3.68065 6.1397C3.788 6.26543 3.84168 6.39115 3.84168 6.51688C3.84168 6.55879 3.82251 6.63911 3.78417 6.75786C3.74583 6.8766 3.62697 6.97788 3.4276 7.0617C3.05954 7.18743 2.69914 7.25029 2.34641 7.25029C1.90167 7.25029 1.41475 7.10361 0.885656 6.81024C0.356563 6.51688 0.0613442 5.86729 0 4.86147V4.77765C0 4.07916 0.203203 3.35972 0.609608 2.61932C1.01601 1.87893 1.69463 1.25728 2.64547 0.754366C3.50429 0.307334 4.61615 0.0838184 5.98106 0.0838184H6.34912C7.59134 0.125728 8.64569 0.520373 9.51218 1.26775C10.3787 2.01513 10.8656 2.94761 10.9729 4.06519V4.19092C10.9729 5.05704 10.6662 5.7695 10.0528 6.32829C9.43933 6.88708 8.74921 7.36903 7.98241 7.77416C7.09292 8.23516 6.47948 8.7241 6.14208 9.24098C5.86604 9.77183 5.65133 10.3586 5.49797 11.0012C5.39062 11.4342 5.33694 11.8463 5.33694 12.2375C5.33694 12.4331 5.35228 12.6286 5.38295 12.8242V12.8661C5.38295 13.0338 5.3101 13.2014 5.16441 13.369ZM5.60149 17.4657C5.21042 17.8219 4.7465 18 4.20974 18C3.65765 18 3.18606 17.8219 2.79499 17.4657C2.40392 17.1094 2.20839 16.6868 2.20839 16.1979C2.20839 15.695 2.40392 15.2654 2.79499 14.9092C3.18606 14.553 3.65765 14.3749 4.20974 14.3749C4.7465 14.3749 5.21042 14.553 5.60149 14.9092C5.99256 15.2654 6.18809 15.695 6.18809 16.1979C6.18809 16.6868 5.99256 17.1094 5.60149 17.4657ZM14.32 17.4657C13.929 17.8219 13.4574 18 12.9053 18C12.3685 18 11.9046 17.8219 11.5135 17.4657C11.1225 17.1094 10.9269 16.6868 10.9269 16.1979C10.9269 15.695 11.1225 15.2654 11.5135 14.9092C11.9046 14.553 12.3685 14.3749 12.9053 14.3749C13.4574 14.3749 13.929 14.553 14.32 14.9092C14.7111 15.2654 14.9066 15.695 14.9066 16.1979C14.9066 16.6868 14.7111 17.1094 14.32 17.4657Z" fill="#7A7A7A"/></svg>',
        buttonStyle: {
          border: "none",
          "background-color": "transparent",
          width: "max-content"
        }
      },
      messagePopupCaret: {
        innerHTML: '<svg width="11" height="7" viewBox="0 0 11 7" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.2458 0.290792C10.0584 0.104542 9.80498 0 9.5408 0C9.27661 0 9.02316 0.104542 8.8358 0.290792L5.2458 3.83079L1.7058 0.290792C1.51844 0.104542 1.26498 0 1.0008 0C0.736612 0 0.483161 0.104542 0.295798 0.290792C0.20207 0.383755 0.127675 0.494356 0.0769067 0.616216C0.026138 0.738075 0 0.868781 0 1.00079C0 1.1328 0.026138 1.26351 0.0769067 1.38537C0.127675 1.50723 0.20207 1.61783 0.295798 1.71079L4.5358 5.95079C4.62876 6.04452 4.73936 6.11891 4.86122 6.16968C4.98308 6.22045 5.11379 6.24659 5.2458 6.24659C5.37781 6.24659 5.50852 6.22045 5.63037 6.16968C5.75223 6.11891 5.86283 6.04452 5.9558 5.95079L10.2458 1.71079C10.3395 1.61783 10.4139 1.50723 10.4647 1.38537C10.5155 1.26351 10.5416 1.1328 10.5416 1.00079C10.5416 0.868781 10.5155 0.738075 10.4647 0.616216C10.4139 0.494356 10.3395 0.383755 10.2458 0.290792Z" fill="#071439"/></svg>',
        buttonStyle: {
          border: "none",
          "background-color": "transparent",
          width: "max-content"
        }
      },
      closeModal: {
        innerHTML: '<svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="13" cy="13" r="13" fill="#F5F7FC"/><path d="M20 7.41L18.59 6L13 11.59L7.41 6L6 7.41L11.59 13L6 18.59L7.41 20L13 14.41L18.59 20L20 18.59L14.41 13L20 7.41Z" fill="#9999BC"/></svg>',
        buttonStyle: {
          border: "none",
          "background-color": "transparent",
          width: "max-content"
        }
      },
      caretRight: {
        innerHTML: '<svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.70706 5.33822L1.55674 0.265572C1.47214 0.181421 1.3715 0.114629 1.26062 0.0690483C1.14973 0.0234675 1.0308 0 0.910672 0C0.790547 0 0.671612 0.0234675 0.560726 0.0690483C0.44984 0.114629 0.349199 0.181421 0.264607 0.265572C0.0951276 0.433789 0 0.661341 0 0.898531C0 1.13572 0.0951276 1.36327 0.264607 1.53149L4.76886 6.02056L0.264607 10.4647C0.0951276 10.633 0 10.8605 0 11.0977C0 11.3349 0.0951276 11.5624 0.264607 11.7307C0.348882 11.8155 0.449381 11.883 0.560282 11.9292C0.671182 11.9754 0.790279 11.9995 0.910672 12C1.03106 11.9995 1.15016 11.9754 1.26106 11.9292C1.37196 11.883 1.47246 11.8155 1.55674 11.7307L6.70706 6.65801C6.79942 6.57393 6.87314 6.4719 6.92355 6.35832C6.97397 6.24475 7 6.1221 7 5.99811C7 5.87412 6.97397 5.75148 6.92355 5.63791C6.87314 5.52433 6.79942 5.42229 6.70706 5.33822Z" fill="#C9C9C9"/></svg>',
        buttonStyle: {
          border: "none",
          "background-color": "transparent",
          width: "max-content"
        }
      },
      caretLeft: {
        innerHTML: '<svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.292943 5.33822L5.44326 0.265572C5.52786 0.181421 5.6285 0.114629 5.73938 0.0690483C5.85027 0.0234675 5.9692 0 6.08933 0C6.20945 0 6.32839 0.0234675 6.43927 0.0690483C6.55016 0.114629 6.6508 0.181421 6.73539 0.265572C6.90487 0.433789 7 0.661341 7 0.898531C7 1.13572 6.90487 1.36327 6.73539 1.53149L2.23114 6.02056L6.73539 10.4647C6.90487 10.633 7 10.8605 7 11.0977C7 11.3349 6.90487 11.5624 6.73539 11.7307C6.65112 11.8155 6.55062 11.883 6.43972 11.9292C6.32882 11.9754 6.20972 11.9995 6.08933 12C5.96894 11.9995 5.84984 11.9754 5.73894 11.9292C5.62804 11.883 5.52754 11.8155 5.44326 11.7307L0.292943 6.65801C0.200579 6.57393 0.126865 6.4719 0.076447 6.35832C0.0260291 6.24475 0 6.1221 0 5.99811C0 5.87412 0.0260291 5.75148 0.076447 5.63791C0.126865 5.52433 0.200579 5.42229 0.292943 5.33822Z" fill="#70767D"/></svg>',
        buttonStyle: {
          border: "none",
          "background-color": "transparent",
          width: "max-content"
        }
      }
    };
  }
  get focusType() {
    if (this.focused && this.styleStroke && this.hasFocus) {
      return "stroke-focused";
    }
    if (this.focused && !this.styleStroke && this.hasFocus) {
      return "fill-focused";
    }
    return "";
  }
  mounted() {
    this.root = document.documentElement;
    this.setRootVariables();
    this.getActiveColor();
  }
  setRootVariables() {
    this.root.style.setProperty("--primary-focus-color", this.focusColor);
    this.root.style.setProperty("--primary-color", this.primaryColor);
  }
  getActiveColor() {
    return this.root.style.getPropertyValue("--primary-color");
  }
  emitClickAway() {
    this.$emit("clickoutside");
  }
};
IconButton$1 = __decorateClass$I([
  Component({
    name: "IconButton",
    mixins: [mixin],
    watch: {
      focusColor() {
        this.setRootVariables();
      }
    }
  })
], IconButton$1);
var render$I = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _vm.toEmit && _vm.toClickAway ? _c("button", { directives: [{ name: "on-clickaway", rawName: "v-on-clickaway", value: _vm.emitClickAway, expression: "emitClickAway" }], ref: "button", staticClass: "robin-button", class: _vm.focusType, style: _vm.iconItem[_vm.name].buttonStyle, attrs: { "type": "button", "data-testid": "button" }, domProps: { "innerHTML": _vm._s(_vm.iconItem[_vm.name].innerHTML) }, on: { "click": function($event) {
    return _vm.$emit(_vm.emit);
  }, "focus": function($event) {
    _vm.focused = true;
  }, "blur": function($event) {
    _vm.focused = false;
  } } }) : _vm.toEmit && !_vm.toClickAway ? _c("button", { ref: "button", staticClass: "robin-button", class: _vm.focusType, style: _vm.iconItem[_vm.name].buttonStyle, attrs: { "type": "button", "data-testid": "button" }, domProps: { "innerHTML": _vm._s(_vm.iconItem[_vm.name].innerHTML) }, on: { "click": function($event) {
    return _vm.$emit(_vm.emit);
  }, "focus": function($event) {
    _vm.focused = true;
  }, "blur": function($event) {
    _vm.focused = false;
  } } }) : !_vm.toEmit && !_vm.toClickAway ? _c("button", { ref: "button", staticClass: "robin-button", class: _vm.focusType, style: _vm.iconItem[_vm.name].buttonStyle, attrs: { "type": "button", "data-testid": "button" }, domProps: { "innerHTML": _vm._s(_vm.iconItem[_vm.name].innerHTML) }, on: { "focus": function($event) {
    _vm.focused = true;
  }, "blur": function($event) {
    _vm.focused = false;
  } } }) : _c("button", { directives: [{ name: "on-clickaway", rawName: "v-on-clickaway", value: _vm.emitClickAway, expression: "emitClickAway" }], ref: "button", staticClass: "robin-button", class: _vm.focusType, style: _vm.iconItem[_vm.name].buttonStyle, attrs: { "type": "button", "data-testid": "button" }, domProps: { "innerHTML": _vm._s(_vm.iconItem[_vm.name].innerHTML) }, on: { "focus": function($event) {
    _vm.focused = true;
  }, "blur": function($event) {
    _vm.focused = false;
  } } });
};
var staticRenderFns$I = [];
var IconButton_vue_vue_type_style_index_0_scoped_true_lang = "";
const __cssModules$I = {};
var __component__$I = /* @__PURE__ */ normalizeComponent(IconButton$1, render$I, staticRenderFns$I, false, injectStyles$I, "8361411e", null, null);
function injectStyles$I(context2) {
  for (let o in __cssModules$I) {
    this[o] = __cssModules$I[o];
  }
}
var IconButton = /* @__PURE__ */ function() {
  return __component__$I.exports;
}();
var __defProp$H = Object.defineProperty;
var __getOwnPropDesc$H = Object.getOwnPropertyDescriptor;
var __decorateClass$H = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$H(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$H(target, key, result);
  return result;
};
const ComponentProps$u = Vue$1.extend({
  props: {
    placeholder: {
      type: String,
      default: "Search Messages..."
    },
    loading: {
      type: Boolean,
      default: false
    }
  }
});
let RSeachBar = class extends ComponentProps$u {
  constructor() {
    super(...arguments);
    this.text = "";
  }
  userTyping() {
    this.$emit("user-typing", this.text);
  }
  created() {
    this.resetSearchText();
  }
  resetSearchText() {
    EventBus.$on("search-text.reset", () => {
      if (this.text !== "") {
        this.text = "";
        this.userTyping();
      }
    });
  }
};
RSeachBar = __decorateClass$H([
  Component({
    name: "SearchBar"
  })
], RSeachBar);
var render$H = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "robin-box-search" }, [_c("svg", { attrs: { "width": "20", "height": "20", "viewBox": "0 0 20 20", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, [_c("path", { attrs: { "d": "M9.16667 15.8333C12.8486 15.8333 15.8333 12.8486 15.8333 9.16667C15.8333 5.48477 12.8486 2.5 9.16667 2.5C5.48477 2.5 2.5 5.48477 2.5 9.16667C2.5 12.8486 5.48477 15.8333 9.16667 15.8333Z", "stroke": "#9999BC", "stroke-width": "2", "stroke-linecap": "round", "stroke-linejoin": "round" } }), _c("path", { attrs: { "d": "M17.5 17.5L13.875 13.875", "stroke": "#9999BC", "stroke-width": "2", "stroke-linecap": "round", "stroke-linejoin": "round" } })]), _c("input", { directives: [{ name: "model", rawName: "v-model", value: _vm.text, expression: "text" }], staticClass: "robin-input", attrs: { "type": "search", "placeholder": _vm.placeholder, "autocomplete": "off" }, domProps: { "value": _vm.text }, on: { "input": [function($event) {
    if ($event.target.composing) {
      return;
    }
    _vm.text = $event.target.value;
  }, function($event) {
    return _vm.userTyping();
  }], "keyup": function($event) {
    if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) {
      return null;
    }
    return _vm.userTyping();
  } } }), _c("div", { directives: [{ name: "show", rawName: "v-show", value: _vm.loading, expression: "loading" }], staticClass: "robin-spinner" })]);
};
var staticRenderFns$H = [];
var SearchBar_vue_vue_type_style_index_0_scoped_true_lang = "";
const __cssModules$H = {};
var __component__$H = /* @__PURE__ */ normalizeComponent(RSeachBar, render$H, staticRenderFns$H, false, injectStyles$H, "27514174", null, null);
function injectStyles$H(context2) {
  for (let o in __cssModules$H) {
    this[o] = __cssModules$H[o];
  }
}
var SearchBar = /* @__PURE__ */ function() {
  return __component__$H.exports;
}();
var __defProp$G = Object.defineProperty;
var __getOwnPropDesc$G = Object.getOwnPropertyDescriptor;
var __decorateClass$G = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$G(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$G(target, key, result);
  return result;
};
const ComponentProps$t = Vue$1.extend({
  props: {
    name: {
      type: String,
      default: "comment"
    },
    color: {
      type: String,
      default: "#15AE73"
    }
  }
});
let SvgIcon$1 = class extends ComponentProps$t {
  constructor() {
    super(...arguments);
    this.iconItem = {
      comment: {
        innerHTML: `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.4733 4.19337L6.93992 7.72671L5.52659 6.31337C5.46682 6.24359 5.39328 6.18691 5.31057 6.14689C5.22786 6.10687 5.13777 6.08439 5.04595 6.08084C4.95414 6.0773 4.86259 6.09277 4.77704 6.12628C4.69149 6.1598 4.61379 6.21064 4.54882 6.27561C4.48385 6.34058 4.43301 6.41828 4.39949 6.50383C4.36598 6.58938 4.35051 6.68093 4.35405 6.77274C4.3576 6.86456 4.38009 6.95464 4.4201 7.03735C4.46012 7.12006 4.5168 7.19361 4.58659 7.25337L6.47325 9.14004C6.59743 9.2632 6.76503 9.33264 6.93992 9.33337C7.02766 9.33388 7.11463 9.31706 7.19586 9.28389C7.27708 9.25071 7.35096 9.20183 7.41325 9.14004L11.4133 5.14004C11.4757 5.07807 11.5253 5.00433 11.5592 4.92309C11.593 4.84185 11.6105 4.75472 11.6105 4.66671C11.6105 4.5787 11.593 4.49156 11.5592 4.41032C11.5253 4.32908 11.4757 4.25535 11.4133 4.19337C11.2883 4.06921 11.1194 3.99951 10.9433 3.99951C10.7671 3.99951 10.5982 4.06921 10.4733 4.19337ZM12.6666 1.33337H3.33325C2.80282 1.33337 2.29411 1.54409 1.91904 1.91916C1.54397 2.29423 1.33325 2.80294 1.33325 3.33337V10C1.33325 10.5305 1.54397 11.0392 1.91904 11.4143C2.29411 11.7893 2.80282 12 3.33325 12H11.0599L13.5266 14.4734C13.5889 14.5352 13.6628 14.584 13.744 14.6172C13.8252 14.6504 13.9122 14.6672 13.9999 14.6667C14.0874 14.669 14.1741 14.6507 14.2533 14.6134C14.375 14.5634 14.4792 14.4784 14.5528 14.3693C14.6263 14.2601 14.6659 14.1317 14.6666 14V3.33337C14.6666 2.80294 14.4559 2.29423 14.0808 1.91916C13.7057 1.54409 13.197 1.33337 12.6666 1.33337ZM13.3333 12.3934L11.8066 10.86C11.7443 10.7983 11.6704 10.7494 11.5892 10.7162C11.508 10.683 11.421 10.6662 11.3333 10.6667H3.33325C3.15644 10.6667 2.98687 10.5965 2.86185 10.4714C2.73682 10.3464 2.66659 10.1769 2.66659 10V3.33337C2.66659 3.15656 2.73682 2.98699 2.86185 2.86197C2.98687 2.73695 3.15644 2.66671 3.33325 2.66671H12.6666C12.8434 2.66671 13.013 2.73695 13.138 2.86197C13.263 2.98699 13.3333 3.15656 13.3333 3.33337V12.3934Z" fill="${this.color}" /></svg>`
      },
      trash: {
        innerHTML: '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.66667 12C6.84348 12 7.01305 11.9298 7.13807 11.8048C7.2631 11.6798 7.33333 11.5102 7.33333 11.3334V7.33337C7.33333 7.15656 7.2631 6.98699 7.13807 6.86197C7.01305 6.73695 6.84348 6.66671 6.66667 6.66671C6.48986 6.66671 6.32029 6.73695 6.19526 6.86197C6.07024 6.98699 6 7.15656 6 7.33337V11.3334C6 11.5102 6.07024 11.6798 6.19526 11.8048C6.32029 11.9298 6.48986 12 6.66667 12ZM13.3333 4.00004H10.6667V3.33337C10.6667 2.80294 10.456 2.29423 10.0809 1.91916C9.70581 1.54409 9.1971 1.33337 8.66667 1.33337H7.33333C6.8029 1.33337 6.29419 1.54409 5.91912 1.91916C5.54405 2.29423 5.33333 2.80294 5.33333 3.33337V4.00004H2.66667C2.48986 4.00004 2.32029 4.07028 2.19526 4.1953C2.07024 4.32033 2 4.4899 2 4.66671C2 4.84352 2.07024 5.01309 2.19526 5.13811C2.32029 5.26314 2.48986 5.33337 2.66667 5.33337H3.33333V12.6667C3.33333 13.1971 3.54405 13.7058 3.91912 14.0809C4.29419 14.456 4.8029 14.6667 5.33333 14.6667H10.6667C11.1971 14.6667 11.7058 14.456 12.0809 14.0809C12.456 13.7058 12.6667 13.1971 12.6667 12.6667V5.33337H13.3333C13.5101 5.33337 13.6797 5.26314 13.8047 5.13811C13.9298 5.01309 14 4.84352 14 4.66671C14 4.4899 13.9298 4.32033 13.8047 4.1953C13.6797 4.07028 13.5101 4.00004 13.3333 4.00004ZM6.66667 3.33337C6.66667 3.15656 6.7369 2.98699 6.86193 2.86197C6.98695 2.73695 7.15652 2.66671 7.33333 2.66671H8.66667C8.84348 2.66671 9.01305 2.73695 9.13807 2.86197C9.2631 2.98699 9.33333 3.15656 9.33333 3.33337V4.00004H6.66667V3.33337ZM11.3333 12.6667C11.3333 12.8435 11.2631 13.0131 11.1381 13.1381C11.013 13.2631 10.8435 13.3334 10.6667 13.3334H5.33333C5.15652 13.3334 4.98695 13.2631 4.86193 13.1381C4.7369 13.0131 4.66667 12.8435 4.66667 12.6667V5.33337H11.3333V12.6667ZM9.33333 12C9.51014 12 9.67971 11.9298 9.80474 11.8048C9.92976 11.6798 10 11.5102 10 11.3334V7.33337C10 7.15656 9.92976 6.98699 9.80474 6.86197C9.67971 6.73695 9.51014 6.66671 9.33333 6.66671C9.15652 6.66671 8.98695 6.73695 8.86193 6.86197C8.73691 6.98699 8.66667 7.15656 8.66667 7.33337V11.3334C8.66667 11.5102 8.73691 11.6798 8.86193 11.8048C8.98695 11.9298 9.15652 12 9.33333 12Z" fill="#D53120" /></svg>'
      },
      "not-read": {
        innerHTML: '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M3.08687 6.58736C3.31468 6.35955 3.68402 6.35955 3.91183 6.58736L6.24516 8.92069C6.47297 9.1485 6.47297 9.51784 6.24516 9.74565C6.01736 9.97345 5.64801 9.97345 5.4202 9.74565L3.08687 7.41232C2.85906 7.18451 2.85906 6.81516 3.08687 6.58736Z" fill="#8D9091"/><path fill-rule="evenodd" clip-rule="evenodd" d="M10.9125 4.25435C11.1403 4.48216 11.1403 4.8515 10.9125 5.07931L6.24581 9.74597C6.01801 9.97378 5.64866 9.97378 5.42085 9.74597C5.19305 9.51817 5.19305 9.14882 5.42085 8.92102L10.0875 4.25435C10.3153 4.02654 10.6847 4.02654 10.9125 4.25435Z" fill="#8D9091"/></svg>'
      },
      read: {
        innerHTML: '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M1.34125 6.58736C1.56969 6.35955 1.94007 6.35955 2.16851 6.58736L4.50834 8.92069C4.73678 9.1485 4.73678 9.51784 4.50834 9.74565C4.2799 9.97345 3.90952 9.97345 3.68108 9.74565L1.34125 7.41232C1.11281 7.18451 1.11281 6.81516 1.34125 6.58736Z" fill="#15AE73"/><path fill-rule="evenodd" clip-rule="evenodd" d="M5.43598 7.17085C5.66442 6.94305 6.03479 6.94305 6.26323 7.17085L8.01811 8.92085C8.24655 9.14866 8.24655 9.51801 8.01811 9.74581C7.78967 9.97362 7.41929 9.97362 7.19085 9.74581L5.43598 7.99581C5.20754 7.76801 5.20754 7.39866 5.43598 7.17085Z" fill="#15AE73"/><path fill-rule="evenodd" clip-rule="evenodd" d="M9.18801 4.25435C9.41645 4.48216 9.41645 4.8515 9.18801 5.07931L4.50835 9.74597C4.27991 9.97378 3.90954 9.97378 3.6811 9.74597C3.45266 9.51817 3.45266 9.14882 3.6811 8.92102L8.36076 4.25435C8.5892 4.02654 8.95957 4.02654 9.18801 4.25435Z" fill="#15AE73"/><path fill-rule="evenodd" clip-rule="evenodd" d="M12.6978 4.25435C12.9262 4.48216 12.9262 4.8515 12.6978 5.07931L8.01812 9.74597C7.78968 9.97378 7.4193 9.97378 7.19086 9.74597C6.96242 9.51817 6.96242 9.14882 7.19086 8.92102L11.8705 4.25435C12.099 4.02654 12.4693 4.02654 12.6978 4.25435Z" fill="#15AE73"/></svg>'
      },
      "3users": {
        innerHTML: '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4.66669 13.3334C4.66669 12.2288 6.15907 11.3334 8.00002 11.3334C9.84097 11.3334 11.3334 12.2288 11.3334 13.3334" stroke="#15AE73" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" /><path d="M12 9.49963C13.1773 9.80826 14 10.5131 14 11.3332" stroke="#15AE73" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" /><path d="M4 9.49963C2.82273 9.80826 2 10.5131 2 11.3332" stroke="#15AE73" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" /><path d="M8 9.33337C9.10457 9.33337 10 8.43794 10 7.33337C10 6.2288 9.10457 5.33337 8 5.33337C6.89543 5.33337 6 6.2288 6 7.33337C6 8.43794 6.89543 9.33337 8 9.33337Z" stroke="#15AE73" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" /><path d="M12 6.82411C12.4091 6.4579 12.6666 5.92571 12.6666 5.33337C12.6666 4.2288 11.7712 3.33337 10.6666 3.33337C10.1544 3.33337 9.68715 3.52594 9.33331 3.84264" stroke="#15AE73" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" /><path d="M3.99998 6.82411C3.59081 6.4579 3.33331 5.92571 3.33331 5.33337C3.33331 4.2288 4.22874 3.33337 5.33331 3.33337C5.84555 3.33337 6.31281 3.52594 6.66665 3.84264" stroke="#15AE73" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" /></svg>'
      },
      nochat: {
        innerHTML: '<svg width="228" height="178" viewBox="0 0 687 534" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="No Chat History"><path id="Fill 1" fill-rule="evenodd" clip-rule="evenodd" d="M371.601 0C308.835 0 251.146 21.7573 205.594 58.159H131.974C122.409 58.159 114.584 66.0105 114.584 75.6067C114.584 85.203 122.409 93.0545 131.974 93.0545H169.442H180.421C189.986 93.0545 197.812 100.906 197.812 110.502C197.812 115.294 195.852 119.668 192.699 122.82C189.557 125.984 185.198 127.95 180.421 127.95H156.997H144.063H80.9619C71.3971 127.95 63.5713 135.801 63.5713 145.398C63.5713 154.994 71.3971 162.845 80.9619 162.845H126.136C112.499 194.998 104.946 230.376 104.946 267.532C104.946 281.013 105.943 294.261 107.856 307.208C108.656 312.616 109.618 317.979 110.743 323.283C143.553 318.246 178.357 314.198 214.692 311.244L217.428 313.745L220.002 310.825C263.652 307.417 309.471 305.602 356.727 305.602C457.128 305.602 551.084 313.791 631.417 328.029C634.512 314.559 636.599 300.705 637.585 286.538C638.037 280.257 638.257 273.917 638.257 267.532C638.257 119.773 518.876 0 371.601 0Z" fill="#F1F2F7"/><path id="Fill 3" fill-rule="evenodd" clip-rule="evenodd" d="M28.1553 127.143H17.6161C7.92726 127.143 0 135.153 0 144.943C0 154.733 7.92726 162.743 17.6161 162.743H28.1553C37.8442 162.743 45.7714 154.733 45.7714 144.943C45.7714 135.153 37.8442 127.143 28.1553 127.143Z" fill="#F1F2F7"/><g id="Group 7"><mask id="mask0_804_1701" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="110" y="305" width="577" height="229"><path id="Clip 6" fill-rule="evenodd" clip-rule="evenodd" d="M686.393 305.987V534H398.388H110.382V305.987H686.393Z" fill="white"/></mask><g mask="url(#mask0_804_1701)"><path id="Fill 5" fill-rule="evenodd" clip-rule="evenodd" d="M686.393 394.143C686.393 403.679 678.57 411.481 669.007 411.481H557.953C553.178 411.481 548.821 413.434 545.679 416.578C542.527 419.71 540.567 424.056 540.567 428.818C540.567 438.354 548.391 446.156 557.953 446.156H578.586C583.36 446.156 587.72 448.109 590.861 451.253C594.014 454.386 595.973 458.732 595.973 463.494C595.973 473.029 588.149 480.831 578.586 480.831H531.144C486.576 514.212 431.196 534 371.178 534C242.994 534 135.94 443.787 110.382 323.556C143.184 318.551 177.98 314.529 214.306 311.593L217.04 314.078L219.615 311.177C263.254 307.79 309.062 305.987 356.307 305.987C456.683 305.987 550.616 314.124 630.93 328.271C627.025 345.124 621.507 361.352 614.553 376.805H669.007C673.794 376.805 678.129 378.759 681.282 381.903C684.434 385.035 686.393 389.381 686.393 394.143Z" fill="#E8EBF2"/></g></g><path id="Fill 8" fill-rule="evenodd" clip-rule="evenodd" d="M635.714 285.747C634.729 300.185 632.645 314.303 629.554 328.029C549.328 313.52 455.497 305.177 355.228 305.177C308.035 305.177 262.278 307.025 218.685 310.498L248.916 275.471L295.944 306.159L359.605 288.582L469.121 305.177L516.665 288.582L528.707 305.177L557.436 283.852L584.283 308.459L626.625 274.629L635.714 285.747Z" fill="#E0E2EE"/><path id="Fill 10" fill-rule="evenodd" clip-rule="evenodd" d="M479.634 301.074C491.676 283.569 498.574 262.81 498.396 240.595C497.904 178.804 442.858 129.152 375.449 129.69C308.039 130.229 253.795 180.758 254.288 242.548C254.782 304.337 309.828 353.991 377.236 353.453C401.32 353.26 423.722 346.683 442.549 335.492L492.912 347.351L479.634 301.074Z" fill="#D8DBEA"/><path id="Fill 12" fill-rule="evenodd" clip-rule="evenodd" d="M340.743 238.927C340.799 245.948 335.152 251.686 328.131 251.742C321.108 251.799 315.37 246.151 315.315 239.13C315.259 232.108 320.905 226.371 327.927 226.314C334.948 226.258 340.686 231.905 340.743 238.927Z" fill="#BEC0D6"/><path id="Fill 14" fill-rule="evenodd" clip-rule="evenodd" d="M386.514 238.926C386.57 245.948 380.923 251.686 373.901 251.742C366.878 251.798 361.141 246.151 361.086 239.13C361.029 232.108 366.676 226.37 373.698 226.314C380.719 226.258 386.457 231.905 386.514 238.926Z" fill="#BEC0D6"/><path id="Fill 16" fill-rule="evenodd" clip-rule="evenodd" d="M432.286 238.926C432.342 245.947 426.695 251.685 419.673 251.742C412.65 251.798 406.913 246.151 406.858 239.129C406.801 232.107 412.448 226.37 419.47 226.314C426.491 226.257 432.228 231.905 432.286 238.926Z" fill="#BEC0D6"/><path id="Fill 18" fill-rule="evenodd" clip-rule="evenodd" d="M218.686 310.229L216.22 312.772L213.601 310.594C215.287 310.462 216.987 310.34 218.686 310.229Z" fill="#F1F2F7"/><path id="Fill 20" fill-rule="evenodd" clip-rule="evenodd" d="M241.572 328.029C241.572 336.104 244.154 343.621 248.593 349.949L243.882 366.831L262.222 362.369C269.118 366.38 277.294 368.714 286.072 368.714C310.649 368.714 330.572 350.498 330.572 328.029C330.572 305.558 310.649 287.342 286.072 287.342C261.495 287.342 241.572 305.558 241.572 328.029Z" fill="url(#paint0_linear_804_1701)"/><path id="Fill 22" fill-rule="evenodd" clip-rule="evenodd" d="M297.514 328.029C297.514 330.837 299.79 333.114 302.599 333.114C305.407 333.114 307.686 330.837 307.686 328.029C307.686 325.221 305.407 322.942 302.599 322.942C299.79 322.942 297.514 325.221 297.514 328.029Z" fill="white"/><path id="Fill 24" fill-rule="evenodd" clip-rule="evenodd" d="M282.258 328.029C282.258 330.837 284.534 333.114 287.344 333.114C290.151 333.114 292.429 330.837 292.429 328.029C292.429 325.221 290.151 322.942 287.344 322.942C284.534 322.942 282.258 325.221 282.258 328.029Z" fill="white"/><path id="Fill 26" fill-rule="evenodd" clip-rule="evenodd" d="M264.457 328.029C264.457 330.837 266.734 333.114 269.543 333.114C272.351 333.114 274.628 330.837 274.628 328.029C274.628 325.221 272.351 322.942 269.543 322.942C266.734 322.942 264.457 325.221 264.457 328.029Z" fill="white"/><path id="Fill 28" fill-rule="evenodd" clip-rule="evenodd" d="M213.6 310.884C177.278 313.844 142.485 317.898 109.686 322.943C108.562 317.63 107.6 312.259 106.8 306.842L163.021 264.457L213.6 310.884Z" fill="#E0E2EE"/><path id="Fill 30" fill-rule="evenodd" clip-rule="evenodd" d="M467.886 397.957C467.886 402.872 423.485 406.857 368.714 406.857C313.943 406.857 269.543 402.872 269.543 397.957C269.543 393.043 313.943 389.057 368.714 389.057C423.485 389.057 467.886 393.043 467.886 397.957Z" fill="#D8DBEA"/><path id="Fill 32" fill-rule="evenodd" clip-rule="evenodd" d="M630.629 480.6C620.839 480.6 612.829 472.59 612.829 462.8C612.829 453.01 620.839 445 630.629 445C640.419 445 648.429 453.01 648.429 462.8C648.429 472.59 640.419 480.6 630.629 480.6Z" fill="#E1E3EF"/></g><defs><linearGradient id="paint0_linear_804_1701" x1="286.072" y1="246.657" x2="205.026" y2="335.3" gradientUnits="userSpaceOnUse"><stop stop-color="#15AE73"/><stop offset="1" stop-color="#1794CF"/></linearGradient></defs></svg>'
      },
      file: {
        innerHTML: '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.00033 6.66659H6.66699C6.8438 6.66659 7.01337 6.59635 7.1384 6.47132C7.26342 6.3463 7.33366 6.17673 7.33366 5.99992C7.33366 5.82311 7.26342 5.65354 7.1384 5.52851C7.01337 5.40349 6.8438 5.33325 6.66699 5.33325H6.00033C5.82351 5.33325 5.65395 5.40349 5.52892 5.52851C5.4039 5.65354 5.33366 5.82311 5.33366 5.99992C5.33366 6.17673 5.4039 6.3463 5.52892 6.47132C5.65395 6.59635 5.82351 6.66659 6.00033 6.66659ZM6.00033 7.99992C5.82351 7.99992 5.65395 8.07016 5.52892 8.19518C5.4039 8.32021 5.33366 8.48977 5.33366 8.66659C5.33366 8.8434 5.4039 9.01297 5.52892 9.13799C5.65395 9.26301 5.82351 9.33325 6.00033 9.33325H10.0003C10.1771 9.33325 10.3467 9.26301 10.4717 9.13799C10.5968 9.01297 10.667 8.8434 10.667 8.66659C10.667 8.48977 10.5968 8.32021 10.4717 8.19518C10.3467 8.07016 10.1771 7.99992 10.0003 7.99992H6.00033ZM13.3337 5.95992C13.3267 5.89867 13.3133 5.83834 13.2937 5.77992V5.71992C13.2616 5.65137 13.2188 5.58836 13.167 5.53325L9.16699 1.53325C9.11188 1.4814 9.04887 1.43864 8.98033 1.40659C8.96043 1.40376 8.94023 1.40376 8.92033 1.40659C8.8526 1.36775 8.77781 1.34281 8.70033 1.33325H4.66699C4.13656 1.33325 3.62785 1.54397 3.25278 1.91904C2.87771 2.29411 2.66699 2.80282 2.66699 3.33325V12.6666C2.66699 13.197 2.87771 13.7057 3.25278 14.0808C3.62785 14.4559 4.13656 14.6666 4.66699 14.6666H11.3337C11.8641 14.6666 12.3728 14.4559 12.7479 14.0808C13.1229 13.7057 13.3337 13.197 13.3337 12.6666V5.99992C13.3337 5.99992 13.3337 5.99992 13.3337 5.95992ZM9.33366 3.60659L11.0603 5.33325H10.0003C9.82351 5.33325 9.65394 5.26301 9.52892 5.13799C9.4039 5.01297 9.33366 4.8434 9.33366 4.66659V3.60659ZM12.0003 12.6666C12.0003 12.8434 11.9301 13.013 11.8051 13.138C11.68 13.263 11.5105 13.3333 11.3337 13.3333H4.66699C4.49018 13.3333 4.32061 13.263 4.19559 13.138C4.07056 13.013 4.00033 12.8434 4.00033 12.6666V3.33325C4.00033 3.15644 4.07056 2.98687 4.19559 2.86185C4.32061 2.73682 4.49018 2.66659 4.66699 2.66659H8.00033V4.66659C8.00033 5.19702 8.21104 5.70573 8.58611 6.0808C8.96118 6.45587 9.46989 6.66659 10.0003 6.66659H12.0003V12.6666ZM10.0003 10.6666H6.00033C5.82351 10.6666 5.65395 10.7368 5.52892 10.8618C5.4039 10.9869 5.33366 11.1564 5.33366 11.3333C5.33366 11.5101 5.4039 11.6796 5.52892 11.8047C5.65395 11.9297 5.82351 11.9999 6.00033 11.9999H10.0003C10.1771 11.9999 10.3467 11.9297 10.4717 11.8047C10.5968 11.6796 10.667 11.5101 10.667 11.3333C10.667 11.1564 10.5968 10.9869 10.4717 10.8618C10.3467 10.7368 10.1771 10.6666 10.0003 10.6666Z" fill="#566BA0" /></svg>'
      },
      mailbox: {
        innerHTML: `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.66659 9.33333H9.33325C9.51006 9.33333 9.67963 9.2631 9.80466 9.13807C9.92968 9.01305 9.99992 8.84348 9.99992 8.66667C9.99992 8.48986 9.92968 8.32029 9.80466 8.19526C9.67963 8.07024 9.51006 8 9.33325 8H6.66659C6.48977 8 6.32021 8.07024 6.19518 8.19526C6.07016 8.32029 5.99992 8.48986 5.99992 8.66667C5.99992 8.84348 6.07016 9.01305 6.19518 9.13807C6.32021 9.2631 6.48977 9.33333 6.66659 9.33333ZM12.6666 2H3.33325C2.80282 2 2.29411 2.21071 1.91904 2.58579C1.54397 2.96086 1.33325 3.46957 1.33325 4V6C1.33325 6.17681 1.40349 6.34638 1.52851 6.4714C1.65354 6.59643 1.82311 6.66667 1.99992 6.66667H2.66659V12C2.66659 12.5304 2.8773 13.0391 3.25237 13.4142C3.62744 13.7893 4.13615 14 4.66659 14H11.3333C11.8637 14 12.3724 13.7893 12.7475 13.4142C13.1225 13.0391 13.3333 12.5304 13.3333 12V6.66667H13.9999C14.1767 6.66667 14.3463 6.59643 14.4713 6.4714C14.5963 6.34638 14.6666 6.17681 14.6666 6V4C14.6666 3.46957 14.4559 2.96086 14.0808 2.58579C13.7057 2.21071 13.197 2 12.6666 2ZM11.9999 12C11.9999 12.1768 11.9297 12.3464 11.8047 12.4714C11.6796 12.5964 11.5101 12.6667 11.3333 12.6667H4.66659C4.48977 12.6667 4.32021 12.5964 4.19518 12.4714C4.07016 12.3464 3.99992 12.1768 3.99992 12V6.66667H11.9999V12ZM13.3333 5.33333H2.66659V4C2.66659 3.82319 2.73682 3.65362 2.86185 3.5286C2.98687 3.40357 3.15644 3.33333 3.33325 3.33333H12.6666C12.8434 3.33333 13.013 3.40357 13.138 3.5286C13.263 3.65362 13.3333 3.82319 13.3333 4V5.33333Z" fill="${this.color}" /></svg>`
      },
      "user-circle": {
        innerHTML: '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.99995 1.3335C6.70694 1.33595 5.44254 1.71437 4.36077 2.42266C3.279 3.13094 2.42655 4.13852 1.90725 5.32268C1.38794 6.50683 1.2242 7.81644 1.43597 9.092C1.64774 10.3676 2.22587 11.554 3.09995 12.5068C3.72423 13.1835 4.48191 13.7236 5.32524 14.093C6.16857 14.4623 7.07927 14.653 7.99995 14.653C8.92063 14.653 9.83133 14.4623 10.6747 14.093C11.518 13.7236 12.2757 13.1835 12.9 12.5068C13.774 11.554 14.3522 10.3676 14.5639 9.092C14.7757 7.81644 14.612 6.50683 14.0927 5.32268C13.5734 4.13852 12.7209 3.13094 11.6391 2.42266C10.5574 1.71437 9.29297 1.33595 7.99995 1.3335ZM7.99995 13.3335C6.61893 13.3314 5.29256 12.7937 4.29995 11.8335C4.60131 11.0999 5.11397 10.4724 5.77279 10.0308C6.4316 9.58915 7.20682 9.35336 7.99995 9.35336C8.79308 9.35336 9.5683 9.58915 10.2271 10.0308C10.8859 10.4724 11.3986 11.0999 11.7 11.8335C10.7073 12.7937 9.38097 13.3314 7.99995 13.3335ZM6.66662 6.66683C6.66662 6.40312 6.74482 6.14533 6.89132 5.92607C7.03783 5.7068 7.24607 5.53591 7.48971 5.43499C7.73334 5.33407 8.00143 5.30767 8.26007 5.35912C8.51871 5.41056 8.75629 5.53755 8.94276 5.72402C9.12923 5.91049 9.25622 6.14807 9.30766 6.40671C9.35911 6.66535 9.33271 6.93344 9.23179 7.17707C9.13087 7.42071 8.95998 7.62895 8.74071 7.77546C8.52145 7.92196 8.26366 8.00016 7.99995 8.00016C7.64633 8.00016 7.30719 7.85969 7.05714 7.60964C6.80709 7.35959 6.66662 7.02045 6.66662 6.66683ZM12.6066 10.6668C12.011 9.648 11.0942 8.85552 9.99995 8.4135C10.3394 8.0286 10.5606 7.55393 10.6369 7.04645C10.7133 6.53897 10.6416 6.02024 10.4305 5.55249C10.2193 5.08475 9.87768 4.68787 9.44656 4.40947C9.01544 4.13108 8.51314 3.983 7.99995 3.983C7.48676 3.983 6.98447 4.13108 6.55335 4.40947C6.12223 4.68787 5.7806 5.08475 5.56945 5.55249C5.3583 6.02024 5.28661 6.53897 5.36297 7.04645C5.43933 7.55393 5.66051 8.0286 5.99995 8.4135C4.90568 8.85552 3.98893 9.648 3.39328 10.6668C2.91858 9.85823 2.66776 8.93781 2.66662 8.00016C2.66662 6.58567 3.22852 5.22912 4.22872 4.22893C5.22891 3.22873 6.58546 2.66683 7.99995 2.66683C9.41444 2.66683 10.771 3.22873 11.7712 4.22893C12.7714 5.22912 13.3333 6.58567 13.3333 8.00016C13.3321 8.93781 13.0813 9.85823 12.6066 10.6668Z" fill="#51545C"/></svg>'
      },
      "check-circle": {
        innerHTML: '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.81325 5.86016L6.95326 8.72683L5.85325 7.62683C5.79349 7.55704 5.71994 7.50036 5.63723 7.46035C5.55452 7.42033 5.46444 7.39784 5.37262 7.3943C5.28081 7.39075 5.18926 7.40622 5.10371 7.43974C5.01816 7.47325 4.94046 7.52409 4.87549 7.58906C4.81052 7.65403 4.75968 7.73173 4.72616 7.81728C4.69265 7.90283 4.67718 7.99439 4.68072 8.0862C4.68427 8.17801 4.70676 8.2681 4.74677 8.35081C4.78679 8.43352 4.84347 8.50707 4.91325 8.56683L6.47992 10.1402C6.54221 10.202 6.61609 10.2508 6.69732 10.284C6.77854 10.3172 6.86552 10.334 6.95326 10.3335C7.12815 10.3328 7.29575 10.2633 7.41992 10.1402L10.7533 6.80683C10.8157 6.74485 10.8653 6.67112 10.8992 6.58988C10.933 6.50864 10.9505 6.4215 10.9505 6.3335C10.9505 6.24549 10.933 6.15835 10.8992 6.07711C10.8653 5.99587 10.8157 5.92214 10.7533 5.86016C10.6283 5.736 10.4594 5.6663 10.2833 5.6663C10.1071 5.6663 9.93816 5.736 9.81325 5.86016ZM7.99992 1.3335C6.68138 1.3335 5.39245 1.72449 4.29612 2.45703C3.19979 3.18957 2.34531 4.23077 1.84072 5.44894C1.33614 6.66711 1.20412 8.00756 1.46135 9.30077C1.71859 10.594 2.35353 11.7819 3.28588 12.7142C4.21823 13.6466 5.40611 14.2815 6.69932 14.5387C7.99253 14.796 9.33297 14.6639 10.5511 14.1594C11.7693 13.6548 12.8105 12.8003 13.5431 11.704C14.2756 10.6076 14.6666 9.31871 14.6666 8.00016C14.6666 7.12468 14.4941 6.25778 14.1591 5.44894C13.8241 4.6401 13.333 3.90517 12.714 3.28612C12.0949 2.66706 11.36 2.176 10.5511 1.84097C9.74231 1.50593 8.8754 1.3335 7.99992 1.3335ZM7.99992 13.3335C6.94509 13.3335 5.91394 13.0207 5.03688 12.4347C4.15982 11.8486 3.47623 11.0157 3.07256 10.0411C2.6689 9.0666 2.56328 7.99425 2.76907 6.95968C2.97485 5.92512 3.48281 4.97481 4.22869 4.22893C4.97457 3.48305 5.92487 2.9751 6.95944 2.76931C7.99401 2.56352 9.06636 2.66914 10.0409 3.07281C11.0154 3.47647 11.8484 4.16006 12.4344 5.03712C13.0205 5.91418 13.3333 6.94533 13.3333 8.00016C13.3333 9.41465 12.7714 10.7712 11.7712 11.7714C10.771 12.7716 9.41441 13.3335 7.99992 13.3335Z" fill="#51545C"/></svg>'
      },
      "times-square": {
        innerHTML: '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.4733 5.52683C10.4113 5.46434 10.3376 5.41475 10.2564 5.3809C10.1751 5.34706 10.088 5.32963 9.99998 5.32963C9.91197 5.32963 9.82483 5.34706 9.7436 5.3809C9.66236 5.41475 9.58862 5.46434 9.52665 5.52683L7.99998 7.06016L6.47331 5.52683C6.34778 5.40129 6.17751 5.33077 5.99998 5.33077C5.82245 5.33077 5.65218 5.40129 5.52665 5.52683C5.40111 5.65237 5.33059 5.82263 5.33059 6.00016C5.33059 6.1777 5.40111 6.34796 5.52665 6.4735L7.05998 8.00016L5.52665 9.52683C5.46416 9.58881 5.41456 9.66254 5.38072 9.74378C5.34687 9.82502 5.32945 9.91216 5.32945 10.0002C5.32945 10.0882 5.34687 10.1753 5.38072 10.2565C5.41456 10.3378 5.46416 10.4115 5.52665 10.4735C5.58862 10.536 5.66236 10.5856 5.7436 10.6194C5.82483 10.6533 5.91197 10.6707 5.99998 10.6707C6.08799 10.6707 6.17512 10.6533 6.25636 10.6194C6.3376 10.5856 6.41134 10.536 6.47331 10.4735L7.99998 8.94016L9.52665 10.4735C9.58862 10.536 9.66236 10.5856 9.7436 10.6194C9.82483 10.6533 9.91197 10.6707 9.99998 10.6707C10.088 10.6707 10.1751 10.6533 10.2564 10.6194C10.3376 10.5856 10.4113 10.536 10.4733 10.4735C10.5358 10.4115 10.5854 10.3378 10.6192 10.2565C10.6531 10.1753 10.6705 10.0882 10.6705 10.0002C10.6705 9.91216 10.6531 9.82502 10.6192 9.74378C10.5854 9.66254 10.5358 9.58881 10.4733 9.52683L8.93998 8.00016L10.4733 6.4735C10.5358 6.41152 10.5854 6.33779 10.6192 6.25655C10.6531 6.17531 10.6705 6.08817 10.6705 6.00016C10.6705 5.91216 10.6531 5.82502 10.6192 5.74378C10.5854 5.66254 10.5358 5.5888 10.4733 5.52683ZM12.6666 1.3335H3.33331C2.80288 1.3335 2.29417 1.54421 1.9191 1.91928C1.54403 2.29436 1.33331 2.80306 1.33331 3.3335V12.6668C1.33331 13.1973 1.54403 13.706 1.9191 14.081C2.29417 14.4561 2.80288 14.6668 3.33331 14.6668H12.6666C13.1971 14.6668 13.7058 14.4561 14.0809 14.081C14.4559 13.706 14.6666 13.1973 14.6666 12.6668V3.3335C14.6666 2.80306 14.4559 2.29436 14.0809 1.91928C13.7058 1.54421 13.1971 1.3335 12.6666 1.3335ZM13.3333 12.6668C13.3333 12.8436 13.2631 13.0132 13.1381 13.1382C13.013 13.2633 12.8435 13.3335 12.6666 13.3335H3.33331C3.1565 13.3335 2.98693 13.2633 2.86191 13.1382C2.73688 13.0132 2.66665 12.8436 2.66665 12.6668V3.3335C2.66665 3.15669 2.73688 2.98712 2.86191 2.86209C2.98693 2.73707 3.1565 2.66683 3.33331 2.66683H12.6666C12.8435 2.66683 13.013 2.73707 13.1381 2.86209C13.2631 2.98712 13.3333 3.15669 13.3333 3.3335V12.6668Z" fill="#D53120"/></svg>'
      },
      encryption: {
        innerHTML: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.2902 20.8968L12.6452 21.8317L12.6452 21.8317L12.2902 20.8968ZM11.7098 20.8968L11.3548 21.8317L11.3548 21.8317L11.7098 20.8968ZM5 4H19V2H5V4ZM19 4V10.1649H21V4H19ZM5 10.1649V4H3V10.1649H5ZM19 10.1649C19 16.8586 13.3228 19.435 11.9351 19.962L12.6452 21.8317C14.1289 21.2682 21 18.2341 21 10.1649H19ZM3 10.1649C3 18.2341 9.87108 21.2682 11.3548 21.8317L12.0649 19.962C10.6772 19.435 5 16.8586 5 10.1649H3ZM11.9351 19.962C11.95 19.9564 11.9725 19.951 12 19.951C12.0275 19.951 12.05 19.9564 12.0649 19.962L11.3548 21.8317C11.7737 21.9908 12.2263 21.9908 12.6452 21.8317L11.9351 19.962ZM19 4V4H21C21 2.89543 20.1046 2 19 2V4ZM5 2C3.89543 2 3 2.89543 3 4H5V4V2Z" fill="#15AE73"/><path d="M15.7071 9.70711C16.0976 9.31658 16.0976 8.68342 15.7071 8.29289C15.3166 7.90237 14.6834 7.90237 14.2929 8.29289L15.7071 9.70711ZM11 13L10.2929 13.7071C10.6834 14.0976 11.3166 14.0976 11.7071 13.7071L11 13ZM9.70711 10.2929C9.31658 9.90237 8.68342 9.90237 8.29289 10.2929C7.90237 10.6834 7.90237 11.3166 8.29289 11.7071L9.70711 10.2929ZM14.2929 8.29289L10.2929 12.2929L11.7071 13.7071L15.7071 9.70711L14.2929 8.29289ZM11.7071 12.2929L9.70711 10.2929L8.29289 11.7071L10.2929 13.7071L11.7071 12.2929Z" fill="#15AE73"/></svg>'
      },
      largeEncryption: {
        innerHTML: '<svg width="65" height="65" viewBox="0 0 65 65" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M33.2856 56.5956L33.9957 58.4653L33.9957 58.4653L33.2856 56.5956ZM31.7137 56.5956L31.0036 58.4653L31.0036 58.4653L31.7137 56.5956ZM13.5413 10.125H51.458V6.125H13.5413V10.125ZM52.1663 10.8333V27.5298H56.1663V10.8333H52.1663ZM12.833 27.5298V10.8333H8.83301V27.5298H12.833ZM52.1663 27.5298C52.1663 46.1459 36.3677 53.2856 32.5755 54.7259L33.9957 58.4653C37.98 56.952 56.1663 48.8969 56.1663 27.5298H52.1663ZM8.83301 27.5298C8.83301 48.8969 27.0194 56.952 31.0036 58.4653L32.4239 54.7259C28.6317 53.2856 12.833 46.1459 12.833 27.5298H8.83301ZM32.5755 54.7259C32.5378 54.7402 32.5138 54.7423 32.4997 54.7423C32.4855 54.7423 32.4616 54.7402 32.4238 54.7259L31.0036 58.4653C31.9763 58.8347 33.0231 58.8347 33.9957 58.4653L32.5755 54.7259ZM51.458 10.125C51.8492 10.125 52.1663 10.4421 52.1663 10.8333H56.1663C56.1663 8.23299 54.0583 6.125 51.458 6.125V10.125ZM13.5413 6.125C10.941 6.125 8.83301 8.23299 8.83301 10.8333H12.833C12.833 10.4421 13.1501 10.125 13.5413 10.125V6.125Z" fill="#15AE73"/><path d="M42.0392 25.7892C42.8203 25.0082 42.8203 23.7418 42.0392 22.9608C41.2582 22.1797 39.9918 22.1797 39.2108 22.9608L42.0392 25.7892ZM29.7917 35.2083L28.3775 36.6225C28.7525 36.9976 29.2612 37.2083 29.7917 37.2083C30.3221 37.2083 30.8308 36.9976 31.2059 36.6225L29.7917 35.2083ZM25.7892 28.3775C25.0082 27.5964 23.7418 27.5964 22.9608 28.3775C22.1797 29.1585 22.1797 30.4248 22.9608 31.2059L25.7892 28.3775ZM39.2108 22.9608L28.3775 33.7941L31.2059 36.6225L42.0392 25.7892L39.2108 22.9608ZM31.2059 33.7941L25.7892 28.3775L22.9608 31.2059L28.3775 36.6225L31.2059 33.7941Z" fill="#15AE73"/></svg>'
      },
      addParticipant: {
        innerHTML: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3 19C3 16.7909 5.68629 15 9 15C12.3137 15 15 16.7909 15 19" stroke="#EA8D51" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M18 16C18 16.5523 18.4477 17 19 17C19.5523 17 20 16.5523 20 16H18ZM20 10C20 9.44772 19.5523 9 19 9C18.4477 9 18 9.44772 18 10H20ZM20 16V10H18V16H20Z" fill="#EA8D51"/><path d="M16 12C15.4477 12 15 12.4477 15 13C15 13.5523 15.4477 14 16 14L16 12ZM22 14C22.5523 14 23 13.5523 23 13C23 12.4477 22.5523 12 22 12V14ZM16 14L22 14V12L16 12L16 14Z" fill="#EA8D51"/><path d="M9 12C11.2091 12 13 10.2091 13 8C13 5.79086 11.2091 4 9 4C6.79086 4 5 5.79086 5 8C5 10.2091 6.79086 12 9 12Z" stroke="#EA8D51" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>'
      },
      forwarded: {
        innerHTML: '<svg width="61" height="12" viewBox="0 0 61 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14.44 10H15.25L15.91 6.92H19.14L19.3 6.18H16.07L16.56 3.83H20.23L20.38 3.1H15.91L14.44 10ZM21.7645 10.1C23.0245 10.1 24.1245 9.25 24.4645 7.66C24.8245 5.98 24.0345 5.06 22.7245 5.06C21.4545 5.06 20.3845 5.91 20.0445 7.5C19.6945 9.18 20.4445 10.1 21.7645 10.1ZM21.8145 9.41C20.9545 9.41 20.5245 8.86 20.7745 7.66C21.0545 6.37 21.7945 5.74 22.6945 5.74C23.5545 5.74 23.9845 6.3 23.7345 7.5C23.4545 8.79 22.7145 9.41 21.8145 9.41ZM25.1489 10H25.9189L26.4189 7.64C26.6889 6.35 27.4889 5.79 28.1989 5.79C28.3389 5.79 28.5089 5.81 28.6689 5.88L28.7789 5.14C28.6389 5.09 28.4589 5.05 28.2689 5.05C27.6489 5.05 27.1389 5.39 26.8089 5.97H26.7789L26.9689 5.12H26.1889L25.1489 10ZM34.7936 5.12L33.0436 9.47L32.7036 5.12H32.0036L29.8336 9.47L29.9536 5.12H29.1336L29.1736 10H30.2536L32.1636 6.11L32.4336 10H33.5036L35.6236 5.12H34.7936ZM39.5619 5.12L39.4419 5.75H39.3619C39.1319 5.35 38.7319 5.02 38.0219 5.02C36.7019 5.02 35.8719 6.11 35.5719 7.48C35.2619 8.94 35.6819 10.1 37.0419 10.1C37.6919 10.1 38.2119 9.86 38.6219 9.44H38.6419L38.5319 10H39.2919L40.3319 5.12H39.5619ZM37.2919 9.39C36.3819 9.39 36.1019 8.73 36.3319 7.63C36.5819 6.47 37.2119 5.74 38.1719 5.74C38.9819 5.74 39.3319 6.42 39.1019 7.48C38.8619 8.65 38.1419 9.39 37.2919 9.39ZM40.8716 10H41.6416L42.1416 7.64C42.4116 6.35 43.2116 5.79 43.9216 5.79C44.0616 5.79 44.2316 5.81 44.3916 5.88L44.5016 5.14C44.3616 5.09 44.1816 5.05 43.9916 5.05C43.3716 5.05 42.8616 5.39 42.5316 5.97H42.5016L42.6916 5.12H41.9116L40.8716 10ZM48.8102 3.1L48.2602 5.75H48.1802C47.9502 5.35 47.5502 5.02 46.8402 5.02C45.5202 5.02 44.6902 6.11 44.3902 7.48C44.0802 8.94 44.5002 10.1 45.8602 10.1C46.5102 10.1 47.0302 9.86 47.4402 9.44H47.4602L47.3502 10H48.1102L49.5802 3.1H48.8102ZM46.1102 9.39C45.2002 9.39 44.9202 8.73 45.1502 7.63C45.4002 6.47 46.0302 5.74 46.9902 5.74C47.8002 5.74 48.1502 6.42 47.9202 7.48C47.6802 8.65 46.9602 9.39 46.1102 9.39ZM52.4799 5.06C50.9699 5.06 50.0899 6.25 49.8199 7.5C49.5299 8.87 50.0099 10.06 51.6199 10.06C52.2499 10.06 52.8999 9.89 53.5299 9.35L53.0899 8.86C52.6699 9.21 52.1699 9.37 51.6699 9.37C50.6499 9.37 50.4099 8.67 50.5399 7.83L53.9699 7.86C53.9799 7.83 53.9899 7.76 54.0299 7.62C54.2899 6.38 54.0599 5.06 52.4799 5.06ZM52.3999 5.74C53.2799 5.74 53.5299 6.37 53.3599 7.23H50.6599C50.8799 6.49 51.4199 5.74 52.3999 5.74ZM59.3376 3.1L58.7876 5.75H58.7076C58.4776 5.35 58.0776 5.02 57.3676 5.02C56.0476 5.02 55.2176 6.11 54.9176 7.48C54.6076 8.94 55.0276 10.1 56.3876 10.1C57.0376 10.1 57.5576 9.86 57.9676 9.44H57.9876L57.8776 10H58.6376L60.1076 3.1H59.3376ZM56.6376 9.39C55.7276 9.39 55.4476 8.73 55.6776 7.63C55.9276 6.47 56.5576 5.74 57.5176 5.74C58.3276 5.74 58.6776 6.42 58.4476 7.48C58.2076 8.65 57.4876 9.39 56.6376 9.39Z" fill="#9999BC"/><path d="M7.5 7L10 4.5L7.5 2" stroke="#9999BC" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/><path d="M2 10V6.5C2 5.96957 2.21071 5.46086 2.58579 5.08579C2.96086 4.71071 3.46957 4.5 4 4.5H10" stroke="#9999BC" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/></svg>'
      },
      camera: {
        innerHTML: '<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16 21.3335C18.2091 21.3335 20 19.5426 20 17.3335C20 15.1244 18.2091 13.3335 16 13.3335C13.7909 13.3335 12 15.1244 12 17.3335C12 19.5426 13.7909 21.3335 16 21.3335Z" stroke="#FFFFFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M26.6667 9.3335H5.33333C4.59695 9.3335 4 9.93045 4 10.6668V24.0002C4 24.7365 4.59695 25.3335 5.33333 25.3335H26.6667C27.403 25.3335 28 24.7365 28 24.0002V10.6668C28 9.93045 27.403 9.3335 26.6667 9.3335Z" stroke="#FFFFFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M19.0389 5.3335H12.9609C12.387 5.3335 11.8775 5.70074 11.696 6.24519L11.2516 7.57853C10.9638 8.4419 11.6064 9.3335 12.5165 9.3335H19.4833C20.3934 9.3335 21.0361 8.4419 20.7483 7.57853L20.3038 6.24519C20.1223 5.70074 19.6128 5.3335 19.0389 5.3335Z" stroke="#FFFFFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>'
      },
      clear: {
        innerHTML: '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z" fill="#9999BC"/></svg>'
      },
      camera2: {
        innerHTML: '<svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_6_6572)"><path d="M12.4582 10.2917C12.4582 10.579 12.344 10.8545 12.1409 11.0577C11.9377 11.2609 11.6622 11.375 11.3748 11.375H1.62484C1.33752 11.375 1.06197 11.2609 0.858805 11.0577C0.655641 10.8545 0.541504 10.579 0.541504 10.2917V4.33333C0.541504 4.04602 0.655641 3.77047 0.858805 3.5673C1.06197 3.36414 1.33752 3.25 1.62484 3.25H3.7915L4.87484 1.625H8.12484L9.20817 3.25H11.3748C11.6622 3.25 11.9377 3.36414 12.1409 3.5673C12.344 3.77047 12.4582 4.04602 12.4582 4.33333V10.2917Z" stroke="white" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/><path d="M6.50016 9.20833C7.69678 9.20833 8.66683 8.23828 8.66683 7.04167C8.66683 5.84505 7.69678 4.875 6.50016 4.875C5.30355 4.875 4.3335 5.84505 4.3335 7.04167C4.3335 8.23828 5.30355 9.20833 6.50016 9.20833Z" stroke="white" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/></g><defs><clipPath id="clip0_6_6572"><rect width="13" height="13" fill="white"/></clipPath></defs></svg>'
      }
    };
  }
};
SvgIcon$1 = __decorateClass$G([
  Component({
    name: "SvgIcon"
  })
], SvgIcon$1);
var render$G = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _vm.iconItem[_vm.name] ? _c("div", { staticClass: "robin-svg", attrs: { "data-testid": "icon" }, domProps: { "innerHTML": _vm._s(_vm.iconItem[_vm.name].innerHTML) } }) : _vm._e();
};
var staticRenderFns$G = [];
var SvgIcon_vue_vue_type_style_index_0_scoped_true_lang = "";
const __cssModules$G = {};
var __component__$G = /* @__PURE__ */ normalizeComponent(SvgIcon$1, render$G, staticRenderFns$G, false, injectStyles$G, "51f95f92", null, null);
function injectStyles$G(context2) {
  for (let o in __cssModules$G) {
    this[o] = __cssModules$G[o];
  }
}
var SvgIcon = /* @__PURE__ */ function() {
  return __component__$G.exports;
}();
var __defProp$F = Object.defineProperty;
var __getOwnPropDesc$F = Object.getOwnPropertyDescriptor;
var __decorateClass$F = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$F(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$F(target, key, result);
  return result;
};
const ComponentProps$s = Vue$1.extend({
  props: {
    color: {
      type: String,
      default: "#15AE73"
    },
    fontSize: {
      type: Number,
      default: 16
    },
    fontWeight: {
      type: String,
      default: "normal"
    },
    emit: {
      type: String,
      default: "archived"
    }
  }
});
let Button$1 = class extends ComponentProps$s {
  constructor() {
    super(...arguments);
    this.root = null;
  }
  mounted() {
    this.root = document.documentElement;
  }
  get getStyles() {
    let rootFontSize = 16;
    let fontSize = `${this.fontSize / rootFontSize + "rem"}`;
    if (this.root && this.root.style.fontSize !== "") {
      rootFontSize = this.root.style.fontSize;
    }
    if (this.fontSize === 16) {
      fontSize = `clamp(0.3rem, 5vw, ${this.fontSize / rootFontSize + "rem"})`;
    } else if (this.fontSize === 14) {
      fontSize = `clamp(0.3rem, 3.5vw, ${this.fontSize / rootFontSize + "rem"})`;
    } else if (this.fontSize === 17) {
      fontSize = `clamp(0.3rem, 7vw, ${this.fontSize / rootFontSize + "rem"})`;
    }
    return {
      "font-size": fontSize,
      color: this.color,
      "font-weight": this.fontWeight
    };
  }
};
Button$1 = __decorateClass$F([
  Component({
    name: "Button"
  })
], Button$1);
var render$F = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("button", { staticClass: "robin-button", style: _vm.getStyles, attrs: { "type": "button", "data-testid": "button" }, on: { "click": function($event) {
    return _vm.$emit(_vm.emit);
  } } }, [_vm._t("default", function() {
    return [_vm._v("Archived")];
  })], 2);
};
var staticRenderFns$F = [];
var Button_vue_vue_type_style_index_0_scoped_true_lang = "";
const __cssModules$F = {};
var __component__$F = /* @__PURE__ */ normalizeComponent(Button$1, render$F, staticRenderFns$F, false, injectStyles$F, "9df49c4e", null, null);
function injectStyles$F(context2) {
  for (let o in __cssModules$F) {
    this[o] = __cssModules$F[o];
  }
}
var Button = /* @__PURE__ */ function() {
  return __component__$F.exports;
}();
var __defProp$E = Object.defineProperty;
var __getOwnPropDesc$E = Object.getOwnPropertyDescriptor;
var __decorateClass$E = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$E(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$E(target, key, result);
  return result;
};
const ComponentProps$r = Vue$1.extend({
  props: {
    imgUrl: {
      type: String,
      default: ""
    },
    senderToken: {
      type: String,
      default: ""
    },
    robinUsers: {
      type: Array,
      default: () => []
    }
  }
});
let Avatar$1 = class extends ComponentProps$r {
  get getContactName() {
    const index = this.robinUsers.findIndex((user2) => user2.userToken === this.senderToken);
    const user = this.robinUsers[index];
    if (user) {
      return user.userName && user.userName !== "" ? user.userName.trim().split(" ") : "";
    }
    return "";
  }
  renderContactName() {
    let name = "";
    if (this.getContactName.length > 1) {
      name = this.getContactName[0][0] + (this.getContactName[1].trim() !== "" ? this.getContactName[1][0] : "");
    }
    if (this.getContactName.length < 2) {
      name = this.getContactName[0][0];
    }
    return name;
  }
};
Avatar$1 = __decorateClass$E([
  Component({
    name: "Avatar",
    components: {
      Content
    }
  })
], Avatar$1);
var render$E = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "robin-image" }, [_vm.imgUrl == "" && _vm.getContactName == "" ? _c("svg", { attrs: { "width": "50", "height": "50", "viewBox": "0 0 50 50", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, [_c("circle", { attrs: { "cx": "25", "cy": "25", "r": "24", "fill": "#F4F6F8", "stroke": "#236BF8", "stroke-opacity": "0.2" } }), _c("path", { attrs: { "d": "M28.1903 25.1128C29.1958 24.3217 29.9297 23.2368 30.29 22.0092C30.6503 20.7815 30.6189 19.4721 30.2003 18.263C29.7817 17.054 28.9967 16.0055 27.9544 15.2634C26.9122 14.5213 25.6646 14.1226 24.3851 14.1226C23.1057 14.1226 21.8581 14.5213 20.8158 15.2634C19.7736 16.0055 18.9886 17.054 18.57 18.263C18.1514 19.4721 18.12 20.7815 18.4803 22.0092C18.8405 23.2368 19.5745 24.3217 20.58 25.1128C18.857 25.8031 17.3536 26.948 16.2302 28.4255C15.1067 29.9031 14.4052 31.6577 14.2005 33.5026C14.1857 33.6372 14.1976 33.7735 14.2354 33.9036C14.2733 34.0337 14.3364 34.1551 14.4211 34.2608C14.5923 34.4743 14.8413 34.6111 15.1133 34.641C15.3854 34.6709 15.6581 34.5916 15.8716 34.4204C16.0851 34.2492 16.2219 34.0002 16.2518 33.7282C16.477 31.7233 17.433 29.8716 18.9372 28.527C20.4413 27.1823 22.3881 26.439 24.4057 26.439C26.4232 26.439 28.37 27.1823 29.8741 28.527C31.3783 29.8716 32.3343 31.7233 32.5595 33.7282C32.5874 33.9802 32.7076 34.213 32.897 34.3815C33.0864 34.5501 33.3316 34.6426 33.5851 34.641H33.698C33.9668 34.6101 34.2125 34.4741 34.3816 34.2628C34.5507 34.0515 34.6294 33.7819 34.6005 33.5128C34.3949 31.6628 33.6896 29.9036 32.5604 28.4238C31.4311 26.944 29.9204 25.7995 28.1903 25.1128ZM24.3851 24.3846C23.5737 24.3846 22.7805 24.144 22.1059 23.6932C21.4312 23.2424 20.9054 22.6017 20.5949 21.852C20.2843 21.1024 20.2031 20.2775 20.3614 19.4817C20.5197 18.6859 20.9104 17.9548 21.4842 17.3811C22.0579 16.8073 22.7889 16.4166 23.5848 16.2583C24.3806 16.1 25.2055 16.1813 25.9551 16.4918C26.7048 16.8023 27.3455 17.3281 27.7963 18.0028C28.2471 18.6774 28.4877 19.4706 28.4877 20.282C28.4877 21.3701 28.0555 22.4136 27.2861 23.183C26.5167 23.9524 25.4732 24.3846 24.3851 24.3846Z", "fill": "#566BA0" } })]) : _vm._e(), _vm.imgUrl == "" && _vm.getContactName != "" ? _c("div", { staticClass: "robin-default-profile" }, [_c("Content", { attrs: { "as": "span", "font-size": 16 } }, [_vm._v(" " + _vm._s(_vm.renderContactName()) + " ")])], 1) : _vm._e(), _vm.imgUrl != "" ? _c("img", { staticClass: "robin-image", attrs: { "src": _vm.imgUrl, "alt": "profile", "data-testid": "profile-picture" } }) : _vm._e()]);
};
var staticRenderFns$E = [];
var Avatar_vue_vue_type_style_index_0_scoped_true_lang = "";
const __cssModules$E = {};
var __component__$E = /* @__PURE__ */ normalizeComponent(Avatar$1, render$E, staticRenderFns$E, false, injectStyles$E, "6c8f2065", null, null);
function injectStyles$E(context2) {
  for (let o in __cssModules$E) {
    this[o] = __cssModules$E[o];
  }
}
var Avatar = /* @__PURE__ */ function() {
  return __component__$E.exports;
}();
var __defProp$D = Object.defineProperty;
var __getOwnPropDesc$D = Object.getOwnPropertyDescriptor;
var __decorateClass$D = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$D(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$D(target, key, result);
  return result;
};
const ComponentProps$q = Vue$1.extend({
  props: {
    color: {
      type: String,
      default: "#15AE73"
    }
  }
});
let Mention$1 = class extends ComponentProps$q {
  constructor() {
    super(...arguments);
    this.root = null;
  }
  mounted() {
    this.root = document.documentElement;
    this.setRootVariables();
  }
  setRootVariables() {
    this.root.style.setProperty("--color", this.color);
  }
};
Mention$1 = __decorateClass$D([
  Component({
    name: "Mention",
    watch: {
      color() {
        this.setRootVariables();
      }
    }
  })
], Mention$1);
var render$D = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", { attrs: { "width": "18", "height": "18", "viewBox": "0 0 18 18", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, [_c("path", { attrs: { "d": "M8.99972 0.666626C7.72145 0.66657 6.46031 0.960577 5.31385 1.5259C4.16739 2.09123 3.16635 2.91271 2.38817 3.92681C1.61 4.94091 1.07554 6.12044 0.826152 7.37414C0.576765 8.62784 0.619131 9.92211 0.949975 11.1568C1.28082 12.3915 1.89127 13.5336 2.7341 14.4946C3.57693 15.4556 4.62955 16.2099 5.81053 16.699C6.9915 17.1882 8.26918 17.3991 9.5447 17.3154C10.8202 17.2318 12.0594 16.8558 13.1664 16.2166C13.266 16.1645 13.354 16.0928 13.4251 16.0058C13.4963 15.9188 13.5491 15.8183 13.5804 15.7104C13.6118 15.6025 13.6209 15.4893 13.6074 15.3777C13.5938 15.2662 13.5578 15.1585 13.5016 15.0612C13.4453 14.9639 13.37 14.879 13.2801 14.8115C13.1902 14.7441 13.0875 14.6956 12.9784 14.6688C12.8692 14.6421 12.7558 14.6377 12.6449 14.6559C12.534 14.6742 12.4279 14.7147 12.333 14.775C11.0622 15.5087 9.58467 15.8026 8.12973 15.6111C6.67478 15.4196 5.32367 14.7534 4.28594 13.7158C3.2482 12.6781 2.58183 11.3271 2.39016 9.87219C2.19849 8.41726 2.49223 6.93974 3.22584 5.66877C3.95944 4.3978 5.09192 3.4044 6.44763 2.84262C7.80334 2.28084 9.30653 2.18208 10.7241 2.56166C12.1416 2.94124 13.3944 3.77794 14.2879 4.94201C15.1815 6.10608 15.6661 7.53246 15.6664 8.99996V9.62496C15.6664 10.0117 15.5127 10.3827 15.2392 10.6562C14.9658 10.9296 14.5948 11.0833 14.208 11.0833C13.8213 11.0833 13.4503 10.9296 13.1769 10.6562C12.9034 10.3827 12.7497 10.0117 12.7497 9.62496V6.08329C12.7497 5.86228 12.6619 5.65032 12.5056 5.49404C12.3494 5.33776 12.1374 5.24996 11.9164 5.24996C11.7226 5.24565 11.5334 5.30903 11.3813 5.42919C11.2292 5.54935 11.1237 5.71877 11.083 5.90829C10.4705 5.48461 9.74452 5.25521 8.99972 5.24996C8.37235 5.24246 7.75314 5.39248 7.19878 5.68629C6.64442 5.9801 6.17263 6.4083 5.82664 6.93168C5.48064 7.45506 5.27149 8.05689 5.21835 8.68204C5.1652 9.30719 5.26976 9.93569 5.52244 10.51C5.77512 11.0842 6.16785 11.5859 6.66466 11.9691C7.16147 12.3523 7.74647 12.6047 8.3661 12.7032C8.98572 12.8017 9.62016 12.7432 10.2113 12.5329C10.8024 12.3227 11.3314 11.9676 11.7497 11.5C12.1457 12.0127 12.6916 12.3894 13.3115 12.5775C13.9314 12.7656 14.5946 12.7559 15.2087 12.5496C15.8229 12.3434 16.3575 11.9509 16.7382 11.4267C17.1189 10.9026 17.3268 10.2728 17.333 9.62496V8.99996C17.333 7.90561 17.1175 6.82198 16.6987 5.81093C16.2799 4.79988 15.6661 3.88122 14.8923 3.1074C14.1185 2.33358 13.1998 1.71975 12.1887 1.30096C11.1777 0.882174 10.0941 0.666626 8.99972 0.666626ZM8.99972 11.0833C8.58767 11.0833 8.18488 10.9611 7.84228 10.7322C7.49968 10.5033 7.23265 10.1779 7.07497 9.79722C6.91728 9.41654 6.87603 8.99765 6.95641 8.59352C7.0368 8.18939 7.23522 7.81818 7.52658 7.52682C7.81794 7.23546 8.18915 7.03704 8.59328 6.95666C8.9974 6.87627 9.41629 6.91753 9.79697 7.07521C10.1777 7.23289 10.503 7.49992 10.7319 7.84252C10.9609 8.18512 11.083 8.58792 11.083 8.99996C11.083 9.5525 10.8636 10.0824 10.4729 10.4731C10.0822 10.8638 9.55225 11.0833 8.99972 11.0833Z", "fill": _vm.color } })]);
};
var staticRenderFns$D = [];
const __cssModules$D = {};
var __component__$D = /* @__PURE__ */ normalizeComponent(Mention$1, render$D, staticRenderFns$D, false, injectStyles$D, null, null, null);
function injectStyles$D(context2) {
  for (let o in __cssModules$D) {
    this[o] = __cssModules$D[o];
  }
}
var Mention = /* @__PURE__ */ function() {
  return __component__$D.exports;
}();
var __defProp$C = Object.defineProperty;
var __getOwnPropDesc$C = Object.getOwnPropertyDescriptor;
var __decorateClass$C = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$C(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$C(target, key, result);
  return result;
};
const ComponentProps$p = Vue$1.extend({
  props: {
    conversation: {
      type: Object,
      default: () => {
      }
    }
  }
});
let ChatListPopOver$1 = class extends ComponentProps$p {
  get isDeleteMessagesEnabled() {
    return store.state.deleteMessagesEnabled;
  }
  get isArchiveChatEnabled() {
    return store.state.archiveChatEnabled;
  }
};
ChatListPopOver$1 = __decorateClass$C([
  Component({
    name: "ChatListPopOver",
    components: {
      Content,
      SvgIcon
    }
  })
], ChatListPopOver$1);
var render$C = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { ref: "popup-body", staticClass: "robin-popup robin-zoomIn" }, [_c("div", { staticClass: "robin-wrapper robin-w-100", on: { "click": function($event) {
    _vm.conversation.unread_messages > 0 || _vm.conversation.unread_messages == "marked" ? _vm.$emit("mark-as-read") : _vm.$emit("mark-as-unread");
  } } }, [_c("Content", { attrs: { "font-size": 14, "color": "#101010" } }, [_vm._v(_vm._s(_vm.conversation.unread_messages > 0 || _vm.conversation.unread_messages == "marked" ? "Mark As Read" : "Mark As Unread"))]), _c("SvgIcon", { attrs: { "name": "comment", "color": "#51545C" } })], 1), _vm.isArchiveChatEnabled ? _c("div", { staticClass: "robin-wrapper robin-w-100", on: { "click": function($event) {
    return _vm.$emit("archive-chat");
  } } }, [_c("Content", { attrs: { "font-size": 14, "color": "#101010" } }, [_vm._v("Archive Chat")]), _c("SvgIcon", { attrs: { "name": "mailbox", "color": "#51545C" } })], 1) : _vm._e(), _vm.isDeleteMessagesEnabled ? _c("div", { staticClass: "robin-wrapper robin-w-100", on: { "click": function($event) {
    return _vm.$emit("delete-conversation");
  } } }, [_c("Content", { attrs: { "font-size": 14, "color": "#D53120" } }, [_vm._v("Delete Chat")]), _c("SvgIcon", { attrs: { "name": "trash" } })], 1) : _vm._e()]);
};
var staticRenderFns$C = [];
var ChatListPopOver_vue_vue_type_style_index_0_scoped_true_lang = "";
const __cssModules$C = {};
var __component__$C = /* @__PURE__ */ normalizeComponent(ChatListPopOver$1, render$C, staticRenderFns$C, false, injectStyles$C, "275d118e", null, null);
function injectStyles$C(context2) {
  for (let o in __cssModules$C) {
    this[o] = __cssModules$C[o];
  }
}
var ChatListPopOver = /* @__PURE__ */ function() {
  return __component__$C.exports;
}();
var __defProp$B = Object.defineProperty;
var __getOwnPropDesc$B = Object.getOwnPropertyDescriptor;
var __decorateClass$B = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$B(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$B(target, key, result);
  return result;
};
const ComponentProps$o = Vue$1.extend({
  props: {
    imgUrl: {
      type: String,
      default: ""
    }
  }
});
let GroupAvatar$1 = class extends ComponentProps$o {
};
GroupAvatar$1 = __decorateClass$B([
  Component({
    name: "GroupAvatar"
  })
], GroupAvatar$1);
var render$B = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "robin-image" }, [_c("svg", { directives: [{ name: "show", rawName: "v-show", value: _vm.imgUrl == "", expression: "imgUrl == ''" }], attrs: { "width": "50", "height": "50", "viewBox": "0 0 50 50", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, [_c("circle", { attrs: { "cx": "25", "cy": "25", "r": "24", "fill": "#F4F6F8", "stroke": "#236BF8", "stroke-opacity": "0.2" } }), _c("path", { attrs: { "d": "M24.6923 24.6102C25.2395 24.1365 25.6785 23.5506 25.9793 22.8923C26.2802 22.234 26.4359 21.5186 26.4359 20.7948C26.4359 19.4347 25.8956 18.1304 24.9339 17.1686C23.9721 16.2069 22.6678 15.6666 21.3077 15.6666C19.9476 15.6666 18.6432 16.2069 17.6815 17.1686C16.7198 18.1304 16.1795 19.4347 16.1795 20.7948C16.1795 21.5186 16.3352 22.234 16.636 22.8923C16.9368 23.5506 17.3758 24.1365 17.9231 24.6102C16.4873 25.2604 15.2692 26.3102 14.4143 27.6344C13.5595 28.9585 13.104 30.5008 13.1025 32.0769C13.1025 32.3489 13.2106 32.6098 13.4029 32.8021C13.5953 32.9945 13.8562 33.1025 14.1282 33.1025C14.4002 33.1025 14.6611 32.9945 14.8534 32.8021C15.0458 32.6098 15.1538 32.3489 15.1538 32.0769C15.1538 30.4448 15.8022 28.8795 16.9562 27.7255C18.1103 26.5714 19.6756 25.923 21.3077 25.923C22.9398 25.923 24.505 26.5714 25.6591 27.7255C26.8132 28.8795 27.4615 30.4448 27.4615 32.0769C27.4615 32.3489 27.5696 32.6098 27.7619 32.8021C27.9543 32.9945 28.2151 33.1025 28.4872 33.1025C28.7592 33.1025 29.0201 32.9945 29.2124 32.8021C29.4047 32.6098 29.5128 32.3489 29.5128 32.0769C29.5113 30.5008 29.0559 28.9585 28.201 27.6344C27.3462 26.3102 26.128 25.2604 24.6923 24.6102ZM21.3077 23.8718C20.6991 23.8718 20.1042 23.6913 19.5982 23.3532C19.0922 23.0151 18.6978 22.5346 18.465 21.9723C18.2321 21.4101 18.1711 20.7914 18.2899 20.1946C18.4086 19.5977 18.7016 19.0494 19.132 18.6191C19.5623 18.1888 20.1105 17.8958 20.7074 17.777C21.3043 17.6583 21.9229 17.7192 22.4852 17.9521C23.0474 18.185 23.5279 18.5794 23.866 19.0854C24.2041 19.5914 24.3846 20.1863 24.3846 20.7948C24.3846 21.6109 24.0604 22.3935 23.4834 22.9705C22.9063 23.5476 22.1237 23.8718 21.3077 23.8718ZM31.2974 24.2C31.9538 23.4608 32.3826 22.5477 32.5321 21.5706C32.6816 20.5934 32.5455 19.5939 32.1403 18.6923C31.735 17.7907 31.0777 17.0254 30.2476 16.4886C29.4176 15.9518 28.45 15.6664 27.4615 15.6666C27.1895 15.6666 26.9286 15.7747 26.7363 15.967C26.5439 16.1594 26.4359 16.4203 26.4359 16.6923C26.4359 16.9643 26.5439 17.2252 26.7363 17.4175C26.9286 17.6098 27.1895 17.7179 27.4615 17.7179C28.2776 17.7179 29.0602 18.0421 29.6372 18.6191C30.2143 19.1962 30.5384 19.9788 30.5384 20.7948C30.537 21.3335 30.3941 21.8624 30.1241 22.3286C29.8542 22.7948 29.4665 23.1819 29 23.4512C28.8479 23.539 28.7209 23.6642 28.6311 23.8151C28.5413 23.9659 28.4918 24.1373 28.4872 24.3128C28.4829 24.4869 28.523 24.6592 28.6037 24.8136C28.6845 24.9679 28.8032 25.0991 28.9487 25.1948L29.3487 25.4615L29.482 25.5333C30.7183 26.1197 31.7613 27.0471 32.4882 28.2064C33.215 29.3657 33.5954 30.7086 33.5846 32.0769C33.5846 32.3489 33.6927 32.6098 33.885 32.8021C34.0773 32.9945 34.3382 33.1025 34.6102 33.1025C34.8823 33.1025 35.1431 32.9945 35.3355 32.8021C35.5278 32.6098 35.6359 32.3489 35.6359 32.0769C35.6443 30.503 35.2501 28.953 34.4907 27.5744C33.7314 26.1957 32.6321 25.0341 31.2974 24.2Z", "fill": "#566BA0" } })]), _vm.imgUrl != "" ? _c("img", { staticClass: "robin-image", attrs: { "src": _vm.imgUrl, "alt": "profile", "data-testid": "profile-picture" } }) : _vm._e()]);
};
var staticRenderFns$B = [];
var GroupAvatar_vue_vue_type_style_index_0_scoped_true_lang = "";
const __cssModules$B = {};
var __component__$B = /* @__PURE__ */ normalizeComponent(GroupAvatar$1, render$B, staticRenderFns$B, false, injectStyles$B, "5211326e", null, null);
function injectStyles$B(context2) {
  for (let o in __cssModules$B) {
    this[o] = __cssModules$B[o];
  }
}
var GroupAvatar = /* @__PURE__ */ function() {
  return __component__$B.exports;
}();
var __defProp$A = Object.defineProperty;
var __getOwnPropDesc$A = Object.getOwnPropertyDescriptor;
var __decorateClass$A = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$A(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$A(target, key, result);
  return result;
};
const ComponentProps$n = Vue$1.extend({
  props: {
    unread: {
      type: [Number, String],
      default: 0
    },
    backgroundColor: {
      type: String,
      default: "#15AE73"
    }
  }
});
let UnreadMessageCount$1 = class extends ComponentProps$n {
};
UnreadMessageCount$1 = __decorateClass$A([
  Component({
    name: "UnreadMessageCount"
  })
], UnreadMessageCount$1);
var render$A = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _vm.unread > 0 && _vm.unread <= 9 ? _c("div", { staticClass: "robin-unread-messages", style: { "background-color": _vm.backgroundColor }, attrs: { "data-testid": "unread-count" } }, [_vm._v(" " + _vm._s(_vm.unread) + " ")]) : _vm.unread > 9 ? _c("div", { staticClass: "robin-unread-messages", style: { "background-color": _vm.backgroundColor }, attrs: { "data-testid": "unread-count" } }, [_vm._v("9+")]) : _c("div", { staticClass: "robin-unread-messages", style: { "background-color": _vm.backgroundColor }, attrs: { "data-testid": "unread-count" } });
};
var staticRenderFns$A = [];
var UnreadMessageCount_vue_vue_type_style_index_0_scoped_true_lang = "";
const __cssModules$A = {};
var __component__$A = /* @__PURE__ */ normalizeComponent(UnreadMessageCount$1, render$A, staticRenderFns$A, false, injectStyles$A, "cd71de8c", null, null);
function injectStyles$A(context2) {
  for (let o in __cssModules$A) {
    this[o] = __cssModules$A[o];
  }
}
var UnreadMessageCount = /* @__PURE__ */ function() {
  return __component__$A.exports;
}();
const pdf = "https://s3.us-east-2.amazonaws.com/robin.io-vue-assets/pdf.svg";
const doc = "https://s3.us-east-2.amazonaws.com/robin.io-vue-assets/doc.svg";
const csv = "https://s3.us-east-2.amazonaws.com/robin.io-vue-assets/csv.svg";
const ppt = "https://s3.us-east-2.amazonaws.com/robin.io-vue-assets/ppt.svg";
const xls = "https://s3.us-east-2.amazonaws.com/robin.io-vue-assets/xls.svg";
const txt = "https://s3.us-east-2.amazonaws.com/robin.io-vue-assets/txt.svg";
const zip = "https://s3.us-east-2.amazonaws.com/robin.io-vue-assets/zip.svg";
const avi = "https://s3.us-east-2.amazonaws.com/robin.io-vue-assets/avi.svg";
const psd = "https://s3.us-east-2.amazonaws.com/robin.io-vue-assets/psd.svg";
const svg = "https://s3.us-east-2.amazonaws.com/robin.io-vue-assets/svg.svg";
const ai = "https://s3.us-east-2.amazonaws.com/robin.io-vue-assets/ai.svg";
const mp3 = "https://s3.us-east-2.amazonaws.com/robin.io-vue-assets/mp3.svg";
const mkv = "https://s3.us-east-2.amazonaws.com/robin.io-vue-assets/mkv.svg";
const gif = "https://s3.us-east-2.amazonaws.com/robin.io-vue-assets/gif.svg";
const notification = "https://s3.us-east-2.amazonaws.com/robin.io-vue-assets/notification.wav";
const logo = "https://s3.us-east-2.amazonaws.com/robin.io-vue-assets/logo.svg";
const robin_icon = "https://s3.us-east-2.amazonaws.com/robin.io-vue-assets/robin_icon.png";
var assets = {
  pdf,
  doc,
  csv,
  ppt,
  xls,
  txt,
  zip,
  avi,
  psd,
  svg,
  ai,
  mp3,
  mkv,
  gif,
  "default": "https://s3.us-east-2.amazonaws.com/robin.io-vue-assets/default.png",
  notification,
  logo,
  robin_icon
};
var __defProp$z = Object.defineProperty;
var __getOwnPropDesc$z = Object.getOwnPropertyDescriptor;
var __decorateClass$z = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$z(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$z(target, key, result);
  return result;
};
const ComponentProps$m = Vue$1.extend({
  props: {
    regularConversations: {
      type: Array,
      default: () => []
    },
    archivedConversations: {
      type: Array,
      default: () => []
    }
  }
});
let PrimaryChatList$1 = class extends ComponentProps$m {
  constructor() {
    super(...arguments);
    this.popUpStates = [];
    this.activeConversation = {};
    this.avatarKey = 0;
    this.scroll = false;
    this.isLoading = false;
    this.conversations = [];
    this.key = 0;
    this.screenWidth = 0;
  }
  created() {
    this.onGroupIconUpdate();
  }
  mounted() {
    this.$nextTick(function() {
      this.onResize();
    });
    window.addEventListener("resize", this.onResize);
  }
  get isPageLoading() {
    return store.state.isPageLoading;
  }
  get currentConversation() {
    return store.state.currentConversation;
  }
  get isCreateChatEnabled() {
    return store.state.createChatEnabled;
  }
  get isArchiveChatEnabled() {
    return store.state.archiveChatEnabled;
  }
  get assets() {
    return assets;
  }
  onGroupIconUpdate() {
    EventBus.$on("group.icon.update", (conversation) => {
      const index = this.conversations.findIndex((item) => item._id === conversation._id);
      this.conversations[index] = conversation;
      this.$forceUpdate();
    });
  }
  openConversation(conversation) {
    store.setState("imagePreviewOpen", false);
    EventBus.$emit("conversation-opened", conversation);
    EventBus.$emit("open-conversation");
  }
  formatRecentMessageTime(time) {
    const datetime = moment(time);
    return datetime.calendar(null, {
      sameDay: function() {
        return "[" + datetime.fromNow() + "]";
      },
      lastDay: function() {
        return "[" + datetime.fromNow() + "]";
      },
      lastWeek: function() {
        return "[" + datetime.fromNow() + "]";
      },
      sameElse: "DD/MM/YYYY"
    });
  }
  getProfileImage(conversation) {
    const index = this.$robin_users.findIndex((user) => user.userToken === conversation.sender_token);
    return this.$robin_users[index] ? this.$robin_users[index].profileImage : null;
  }
  onScroll() {
    this.scroll = true;
  }
  handleOpenPopUp(event, _id, refContainerKey, refKey, id) {
    const popupContainer = this.$refs[refContainerKey];
    const popup = this.$refs[refKey];
    popup[0].$refs["popup-body"].classList.remove("robin-zoomOut");
    if (!this.scroll && this.conversations.length - 2 !== parseInt(id) || this.conversations.length - 1 !== parseInt(id)) {
      popupContainer[0].style.top = event.clientY - 12 + "px";
      if (this.screenWidth > 1024) {
        popupContainer[0].style.left = event.clientX - 90 + "px";
      } else {
        popupContainer[0].style.left = event.clientX - 145 + "px";
      }
    } else {
      popupContainer[0].style.top = event.clientY - 60 + "px";
      if (this.screenWidth > 1024) {
        popupContainer[0].style.left = event.clientX - 90 + "px";
      } else {
        popupContainer[0].style.left = event.clientX - 145 + "px";
      }
    }
    const index = this.popUpStates.findIndex((val) => val._id === _id);
    this.popUpStates[index].opened = true;
    this.popUpStates.forEach((val, i) => {
      if (val._id !== _id) {
        this.popUpStates[i].opened = false;
      }
    });
  }
  handleClosePopUp(_id, refKey) {
    const popup = this.$refs[refKey];
    popup[0].$refs["popup-body"].classList.add("robin-zoomOut");
    window.setTimeout(() => {
      const index = this.popUpStates.findIndex((val) => val._id === _id);
      if (this.popUpStates[index] ? this.popUpStates[index].opened : false) {
        const popup2 = this.$refs[refKey];
        popup2[0].$refs["popup-body"].classList.remove("robin-zoomOut");
        this.popUpStates[index].opened = false;
      }
    }, 300);
  }
  async handleArchiveChat(conversation) {
    const res = await this.$robin.archiveConversation(conversation._id, this.$user_token);
    if (!res.error) {
      EventBus.$emit("regular-conversation.delete", conversation);
      EventBus.$emit("archived-conversation.add", conversation);
      this.$toast.open({
        message: "Conversation archived.",
        type: "success",
        position: "bottom-left"
      });
      this.$emit("refresh");
    }
  }
  searchConversation(searchText) {
    let searchData = [];
    this.isLoading = true;
    const data = this.$regularConversations.filter((obj) => {
      let stopSearch = false;
      Object.values(obj).forEach((val) => {
        const filter = String(val).toLowerCase().includes(searchText.toLowerCase());
        if (filter) {
          stopSearch = true;
        }
      });
      if (stopSearch) {
        return obj;
      }
    });
    searchData = [...data];
    this.$emit("search", {
      text: searchText,
      data: searchData
    });
    setTimeout(() => {
      this.isLoading = false;
    }, 300);
  }
  openEdit() {
    this.$emit("opennewchatmodal", "newchat");
    setTimeout(() => {
      this.refresh();
    }, 300);
  }
  openArchivedChat() {
    this.$emit("openarchivedchatmodal", "archivedchat");
    setTimeout(() => {
      this.refresh();
    }, 300);
  }
  refresh() {
    this.key += 1;
  }
  handleMarkAsRead(conversation) {
    EventBus.$emit("mark-as-read", conversation);
  }
  handleMarkAsUnread(conversation) {
    EventBus.$emit("mark-as-unread.modified", conversation);
  }
  async handleDeleteConversation(conversation) {
    const res = await this.$robin.deleteConversation(this.$user_token, conversation._id);
    if (res && !res.error) {
      EventBus.$emit("regular-conversation.delete", conversation);
      EventBus.$emit("close-conversation", conversation);
      this.$toast.open({
        message: "Conversation deleted.",
        type: "success",
        position: "bottom-left"
      });
    } else {
      this.$toast.open({
        message: "Check your connection.",
        type: "error",
        position: "bottom-left"
      });
    }
  }
  onResize() {
    this.screenWidth = window.innerWidth;
  }
};
PrimaryChatList$1 = __decorateClass$z([
  Component({
    name: "PrimaryChatList",
    components: {
      Content,
      IconButton,
      SvgIcon,
      SearchBar,
      Button,
      Avatar,
      Mention,
      GroupAvatar,
      UnreadMessageCount,
      ChatListPopOver
    },
    watch: {
      regularConversations: {
        handler(val) {
          this.conversations = [...val].sort((a, b) => {
            const dateA = moment(a.last_message ? a.last_message.timestamp : a.updated_at).valueOf();
            const dateB = moment(b.last_message ? b.last_message.timestamp : b.updated_at).valueOf();
            if (dateA > dateB) {
              return -1;
            }
            if (dateB < dateA) {
              return 1;
            }
            return 0;
          });
          this.popUpStates = [];
          this.conversations.forEach((val2) => {
            this.popUpStates.push({
              opened: false,
              _id: val2._id
            });
          });
        },
        immediate: true
      },
      $robin_users: {
        handler(val) {
          this.avatarKey += 1;
        }
      }
    }
  })
], PrimaryChatList$1);
var render$z = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "robin-side-container" }, [_c("header", { staticClass: "robin-header" }, [_vm.$logo === "" ? _c("img", { attrs: { "src": _vm.assets["logo"], "alt": "logo" } }) : _c("img", { staticClass: "custom", attrs: { "src": _vm.$logo, "alt": "logo" } }), _c("div", { staticClass: "robin-wrapper" }, [_vm.isCreateChatEnabled ? _c("IconButton", { attrs: { "name": "edit", "emit": "edit", "to-emit": true, "to-click-away": false, "color": "#fff" }, on: { "edit": function($event) {
    return _vm.openEdit();
  } } }) : _vm._e(), _vm._t("chat-list-header")], 2)]), _c("div", { staticClass: "robin-wrapper robin-w-100 robin-pl-16 robin-pr-16 robin-pb-16" }, [_c("SearchBar", { key: _vm.key, attrs: { "loading": _vm.isLoading }, on: { "user-typing": function($event) {
    return _vm.searchConversation($event);
  } } })], 1), _vm.isArchiveChatEnabled ? _c("Button", { staticClass: "robin-wrapper robin-pl-16 robin-pr-16 robin-flex robin-flex-space-between robin-w-100 robin-pt-16 robin-pb-12", on: { "archived": function($event) {
    return _vm.openArchivedChat();
  } } }, [_c("div", { directives: [{ name: "show", rawName: "v-show", value: _vm.archivedConversations.length > 0, expression: "archivedConversations.length > 0" }], staticClass: "robin-flex robin-flex-align-center", attrs: { "font-weight": "400" } }, [_c("SvgIcon", { attrs: { "name": "mailbox", "color": "#15AE73" } }), _c("Content", { staticClass: "robin-ml-6", attrs: { "font-weight": "400", "color": "#15AE73" } }, [_vm._v(" Archived Chats ")])], 1), _c("Content", { directives: [{ name: "show", rawName: "v-show", value: _vm.archivedConversations.length > 0, expression: "archivedConversations.length > 0" }], attrs: { "font-weight": "400", "color": "#15AE73", "data-testid": "archived-conversation-count" } }, [_vm._v(" " + _vm._s(_vm.archivedConversations.length) + " ")])], 1) : _vm._e(), _c("div", { directives: [{ name: "show", rawName: "v-show", value: _vm.isPageLoading, expression: "isPageLoading" }], staticClass: "robin-spinner" }), _c("div", { directives: [{ name: "show", rawName: "v-show", value: !_vm.isPageLoading, expression: "!isPageLoading" }], staticClass: "robin-wrapper robin-card-container robin-pb-16 robin-flex robin-flex-column", class: { "robin-come-down": _vm.screenWidth > 1200 }, on: { "scroll": function($event) {
    return _vm.onScroll();
  } } }, _vm._l(_vm.conversations, function(conversation, index) {
    return _c("div", { key: "conversation-" + index, staticClass: "robin-card robin-flex robin-flex-align-center", class: { "robin-card-active": _vm.currentConversation._id == conversation._id && _vm.screenWidth > 1200 }, attrs: { "data-testid": "conversation-" + index }, on: { "click": function($event) {
      if ($event.target !== $event.currentTarget) {
        return null;
      }
      return _vm.openConversation(conversation);
    } } }, [_c("div", { staticClass: "robin-card-info robin-mr-12", on: { "click": function($event) {
      return _vm.openConversation(conversation);
    } } }, [!conversation.is_group ? _c("Avatar", { key: _vm.avatarKey, attrs: { "robin-users": _vm.$robin_users, "img-url": _vm.getProfileImage(conversation) || conversation.display_photo, "sender-token": conversation.sender_token === _vm.$user_token ? conversation.receiver_token : conversation.sender_token, "data-testid": "regular-avatar" } }) : _c("GroupAvatar", { attrs: { "img-url": conversation.group_icon, "data-testid": "group-avatar" } })], 1), _c("div", { staticClass: "robin-card-info robin-h-100 robin-flex robin-flex-column robin-flex-space-between robin-pt-4 robin-pb-41 robin-flex-1", on: { "click": function($event) {
      if ($event.target !== $event.currentTarget) {
        return null;
      }
      return _vm.openConversation(conversation);
    } } }, [_c("div", { staticClass: "robin-flex robin-flex-space-between", on: { "click": function($event) {
      return _vm.openConversation(conversation);
    } } }, [!conversation.is_group ? _c("Content", { attrs: { "font-weight": "normal", "color": "#000000", "font-size": 16, "line-height": 20 } }, [_vm._v(" " + _vm._s(conversation.sender_token != _vm.$user_token ? conversation.sender_name : conversation.receiver_name) + " ")]) : _c("Content", { attrs: { "font-weight": "normal", "color": "#000000", "font-size": 16, "line-height": 20 } }, [_vm._v(" " + _vm._s(conversation.name) + " ")]), _c("Content", { attrs: { "as": "p", "fontWeight": "normal", "color": "#51545C", "fontSize": 14, "lineHeight": 18 } }, [_vm._v(" " + _vm._s(_vm.formatRecentMessageTime(conversation.last_message ? conversation.last_message.timestamp : conversation.updated_at)) + " ")])], 1), _c("div", { staticClass: "robin-flex robin-flex-space-between", on: { "click": function($event) {
      if ($event.target !== $event.currentTarget) {
        return null;
      }
      return _vm.openConversation(conversation);
    } } }, [_c("div", { staticClass: "robin-mini-info-container robin-flex-1", on: { "click": function($event) {
      return _vm.openConversation(conversation);
    } } }, [conversation.last_message && !conversation.last_message.is_attachment ? _c("Content", { attrs: { "as": "p", "font-weight": "normal", "color": "#8D9091", "font-size": 14, "line-height": 18 } }, [_vm._v(" " + _vm._s(conversation.last_message && conversation.last_message.msg.length < 20 ? conversation.last_message.msg : conversation.last_message ? conversation.last_message.msg.substring(0, 20) + " ..." : "") + " ")]) : _vm._e(), _c("Content", { directives: [{ name: "show", rawName: "v-show", value: conversation.last_message && conversation.last_message.is_attachment, expression: "conversation.last_message && conversation.last_message.is_attachment" }], attrs: { "as": "p", "font-weight": "normal", "color": "#8D9091", "font-size": 14, "line-height": 18 } }, [_c("b", [_c("i", [_vm._v("Attachment")])])])], 1), _c("div", { staticClass: "robin-mini-info-container robin-flex robin-flex-align-center" }, [conversation.unread_messages > 0 || conversation.unread_messages == "marked" ? _c("div", { staticClass: "mini-info robin-ml-10", on: { "click": function($event) {
      return _vm.openConversation(conversation);
    } } }, [_c("UnreadMessageCount", { attrs: { "unread": conversation.unread_messages, "background-color": "#EA8D51" } })], 1) : _vm._e(), _c("div", { staticClass: "robin-hidden robin-ml-10", on: { "click": function($event) {
      _vm.handleOpenPopUp($event, conversation._id, "popup-container-" + index, "popup-" + index, index.toString());
    } } }, [_c("IconButton", { attrs: { "name": "openModalDot", "to-click-away": true, "to-emit": false }, on: { "clickoutside": function($event) {
      return _vm.handleClosePopUp(conversation._id, "popup-" + index);
    } } })], 1)])])]), _c("div", { directives: [{ name: "show", rawName: "v-show", value: _vm.popUpStates[index] ? _vm.popUpStates[index].opened : false, expression: "popUpStates[index] ? popUpStates[index].opened : false" }], ref: "popup-container-" + index, refInFor: true, staticClass: "robin-popup-container" }, [_c("ChatListPopOver", { ref: "popup-" + index, refInFor: true, attrs: { "conversation": conversation }, on: { "archive-chat": function($event) {
      return _vm.handleArchiveChat(conversation);
    }, "delete-conversation": function($event) {
      return _vm.handleDeleteConversation(conversation);
    }, "mark-as-read": function($event) {
      return _vm.handleMarkAsRead(conversation);
    }, "mark-as-unread": function($event) {
      return _vm.handleMarkAsUnread(conversation);
    } } })], 1)]);
  }), 0)], 1);
};
var staticRenderFns$z = [];
var PrimaryChatList_vue_vue_type_style_index_0_scoped_true_lang = "";
const __cssModules$z = {};
var __component__$z = /* @__PURE__ */ normalizeComponent(PrimaryChatList$1, render$z, staticRenderFns$z, false, injectStyles$z, "f6cde966", null, null);
function injectStyles$z(context2) {
  for (let o in __cssModules$z) {
    this[o] = __cssModules$z[o];
  }
}
var PrimaryChatList = /* @__PURE__ */ function() {
  return __component__$z.exports;
}();
var __defProp$y = Object.defineProperty;
var __getOwnPropDesc$y = Object.getOwnPropertyDescriptor;
var __decorateClass$y = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$y(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$y(target, key, result);
  return result;
};
const ComponentProps$l = Vue$1.extend({
  props: {
    text: {
      type: String,
      default: "A"
    }
  }
});
let AlphabetBlock$1 = class extends ComponentProps$l {
};
AlphabetBlock$1 = __decorateClass$y([
  Component({
    name: "AlphabetBlock"
  })
], AlphabetBlock$1);
var render$y = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "robin-alphabet-block robin-flex robin-flex-align-center" }, [_vm._v(" " + _vm._s(_vm.text) + " ")]);
};
var staticRenderFns$y = [];
var AlphabetBlock_vue_vue_type_style_index_0_scoped_true_lang = "";
const __cssModules$y = {};
var __component__$y = /* @__PURE__ */ normalizeComponent(AlphabetBlock$1, render$y, staticRenderFns$y, false, injectStyles$y, "1aeb80c8", null, null);
function injectStyles$y(context2) {
  for (let o in __cssModules$y) {
    this[o] = __cssModules$y[o];
  }
}
var AlphabetBlock = /* @__PURE__ */ function() {
  return __component__$y.exports;
}();
var __defProp$x = Object.defineProperty;
var __getOwnPropDesc$x = Object.getOwnPropertyDescriptor;
var __decorateClass$x = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$x(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$x(target, key, result);
  return result;
};
const ComponentProps$k = Vue$1.extend({
  props: {
    robinUsers: {
      type: Array,
      default: () => []
    }
  }
});
let NewChatList$1 = class extends ComponentProps$k {
  constructor() {
    super(...arguments);
    this.contacts = {};
    this.isLoading = false;
    this.searchData = [];
    this.key = 0;
  }
  created() {
    this.getContacts("");
  }
  async createConversation(user) {
    const res = await this.$robin.createConversation({
      sender_name: this.$senderName,
      sender_token: this.$user_token,
      receiver_token: user.userToken,
      receiver_name: user.userName
    });
    if (res && !res.error) {
      if (!this.checkConversations(res.data)) {
        this.$conversations.push(res.data);
      }
      EventBus.$emit("conversation-opened", res.data);
      EventBus.$emit("open-conversation");
      this.openPreviousModal();
    } else {
      this.$toast.open({
        message: "Check your connection.",
        type: "error",
        position: "bottom-left"
      });
    }
  }
  checkConversations(convo) {
    let res = false;
    this.$conversations.forEach((conversation) => {
      if (conversation._id === convo._id) {
        res = true;
      }
    });
    return res;
  }
  getContacts(searchText) {
    this.contacts = {};
    if (searchText.trim() === "") {
      this.robinUsers.forEach((user) => {
        this.contacts[this.getContactKey(user.userName)] = this.robinUsers.filter((item) => item.userToken !== this.$user_token && this.validateContact(item.userName, user.userName));
      });
      for (const key in this.contacts) {
        if (this.contacts[key].length === 0) {
          delete this.contacts[key];
        }
      }
      this.sortContacts();
    } else {
      this.searchData.forEach((user) => {
        this.contacts[this.getContactKey(user.userName)] = this.searchData.filter((item) => item.userToken !== this.$user_token && this.validateContact(item.userName, user.userName));
      });
    }
  }
  searchContacts(searchText) {
    this.isLoading = true;
    const data = this.robinUsers.filter((obj) => {
      let stopSearch = false;
      Object.values(obj).forEach((val) => {
        const filter = String(val).toLowerCase().includes(searchText.toLowerCase());
        if (filter) {
          stopSearch = true;
        }
      });
      if (stopSearch) {
        return obj;
      }
    });
    this.searchData = [...data];
    this.getContacts(searchText);
    setTimeout(() => {
      this.isLoading = false;
    }, 300);
  }
  sortContacts() {
    this.contacts = Object.keys(this.contacts).sort().reduce((result, key) => {
      result[key] = this.contacts[key];
      return result;
    }, {});
  }
  openPreviousModal() {
    this.$emit("closemodal", "primary");
    setTimeout(() => {
      this.refresh();
    }, 300);
  }
  openGroupChat() {
    this.$emit("openmodal", "newgroup");
    setTimeout(() => {
      this.refresh();
    }, 300);
  }
  getContactKey(username) {
    if (username && username.trim() !== "" && isNaN(parseInt(username[0]))) {
      return username[0].toUpperCase();
    }
    return "*";
  }
  validateContact(usernameVal, username) {
    if (!usernameVal[0] && !username[0]) {
      return usernameVal.trim() === username.trim();
    }
    if (usernameVal[0] && username[0]) {
      return usernameVal[0].toUpperCase() === username[0].toUpperCase();
    }
    return false;
  }
  refresh() {
    this.key += 1;
  }
};
NewChatList$1 = __decorateClass$x([
  Component({
    name: "NewChatList",
    components: {
      Content,
      SearchBar,
      Button,
      SvgIcon,
      IconButton,
      Avatar,
      AlphabetBlock
    },
    watch: {
      robinUsers: {
        handler(val) {
          this.getContacts("");
        }
      }
    }
  })
], NewChatList$1);
var render$x = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { ref: "popup-body", staticClass: "robin-side-container" }, [_c("header", { staticClass: "robin-header" }, [_c("IconButton", { attrs: { "name": "remove", "emit": "close", "to-emit": true, "to-click-away": false }, on: { "close": function($event) {
    return _vm.openPreviousModal();
  } } }), _c("Content", { staticClass: "robin-ml-12", attrs: { "font-weight": "400", "font-size": 16 } }, [_vm._v(" New Chat ")])], 1), _c("div", { staticClass: "robin-w-100 robin-pl-16 robin-pr-16" }, [_c("SearchBar", { key: _vm.key, attrs: { "loading": _vm.isLoading, "placeholder": "Search or start new chat" }, on: { "user-typing": function($event) {
    return _vm.searchContacts($event);
  } } })], 1), _c("div", { staticClass: "robin-w-100 robin-create-group robin-h-100 robin-h-100 robin-flex robin-flex-align-center robin-pl-16 robin-pr-16 robin-flex-1 robin-mt-31 robin-pb-16" }, [_c("Button", { staticClass: "robin-flex robin-flex-align-center", attrs: { "color": "#15AE73", "font-size": 14, "line-height": 18, "emit": "newgroupchat" }, on: { "newgroupchat": function($event) {
    return _vm.openGroupChat();
  } } }, [_c("SvgIcon", { attrs: { "name": "3users" } }), _c("Content", { staticClass: "robin-ml-5", attrs: { "color": "#15AE73" } }, [_vm._v("Create Group Chat")])], 1)], 1), _c("div", { staticClass: "robin-contact-container robin-overflow-y-auto" }, _vm._l(_vm.contacts, function(contact, key, index) {
    return _c("div", { key: "contact-" + index }, [_c("AlphabetBlock", { directives: [{ name: "show", rawName: "v-show", value: key.toString() != "*", expression: "key.toString() != '*'" }], attrs: { "text": key } }), _c("div", { staticClass: "robin-wrapper robin-card-container robin-flex robin-flex-column robin-grey-200" }, _vm._l(contact, function(user) {
      return _c("div", { key: user.userToken, staticClass: "robin-card robin-flex robin-flex-align-center robin-clickable", on: { "click": function($event) {
        return _vm.createConversation(user);
      } } }, [_c("div", { staticClass: "robin-card-info robin-mr-12" }, [_c("Avatar", { attrs: { "robin-users": _vm.$robin_users, "img-url": user.profileImage, "sender-token": user.userToken } })], 1), _c("div", { staticClass: "robin-card-info robin-h-100 robin-h-100 robin-flex robin-flex-align-center robin-pt-4 robin-pb-4\u02DD robin-flex-1" }, [_c("div", { staticClass: "robin-flex" }, [_c("Content", { attrs: { "font-size": 14, "line-height": 18 } }, [_vm._v(_vm._s(user.userName))])], 1)])]);
    }), 0)], 1);
  }), 0)]);
};
var staticRenderFns$x = [];
var NewChatList_vue_vue_type_style_index_0_scoped_true_lang = "";
const __cssModules$x = {};
var __component__$x = /* @__PURE__ */ normalizeComponent(NewChatList$1, render$x, staticRenderFns$x, false, injectStyles$x, "58fdb2fa", null, null);
function injectStyles$x(context2) {
  for (let o in __cssModules$x) {
    this[o] = __cssModules$x[o];
  }
}
var NewChatList = /* @__PURE__ */ function() {
  return __component__$x.exports;
}();
var __defProp$w = Object.defineProperty;
var __getOwnPropDesc$w = Object.getOwnPropertyDescriptor;
var __decorateClass$w = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$w(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$w(target, key, result);
  return result;
};
let NoChatList$1 = class extends Vue$1 {
  constructor() {
    super(...arguments);
    this.key = 0;
  }
  get assets() {
    return assets;
  }
  get isCreateChatEnabled() {
    return store.state.createChatEnabled;
  }
  openEdit() {
    this.$emit("opennewchatmodal", "newchat");
    setTimeout(() => {
      this.refresh();
    }, 300);
  }
  refresh() {
    this.key += 1;
  }
};
NoChatList$1 = __decorateClass$w([
  Component({
    name: "NoChatList",
    components: {
      Content,
      IconButton,
      SearchBar,
      Button,
      SvgIcon
    }
  })
], NoChatList$1);
var render$w = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "robin-side-container" }, [_c("header", { staticClass: "robin-header robin-flex robin-flex-align-center" }, [_vm.$logo === "" ? _c("img", { attrs: { "src": _vm.assets["logo"], "alt": "logo" } }) : _c("img", { staticClass: "custom", attrs: { "src": _vm.$logo, "alt": "logo" } }), _c("div", { staticClass: "robin-buttons robin-flex robin-flex-align-center" }, [_vm.isCreateChatEnabled ? _c("IconButton", { attrs: { "name": "edit", "emit": "edit", "to-emit": true, "to-click-away": false, "color": "#fff", "data-testid": "edit" }, on: { "edit": function($event) {
    return _vm.openEdit();
  } } }) : _vm._e(), _vm._t("chat-list-header")], 2)]), _c("div", { staticClass: "robin-wrapper robin-pl-16 robin-pr-16 robin-w-100" }, [_c("SearchBar", { key: _vm.key })], 1), _c("div", { staticClass: "robin-wrapper robin-pl-16 robin-pr-16 robin-flex robin-flex-column robin-flex-align-center robin-h-100 robin-w-100 robin-flex-1 robin-pt-100" }, [_c("SvgIcon", { attrs: { "name": "nochat" } }), _c("div", { staticClass: "robin-mb-13 robin-mt-33" }, [_c("Content", { attrs: { "fontWeight": "normal", "color": "#535F89" } }, [_vm._v("No Messages Yet")])], 1), _vm.isCreateChatEnabled ? _c("Button", { attrs: { "emit": "newchat" }, on: { "newchat": function($event) {
    return _vm.openEdit();
  } } }, [_vm._v("Start a chat")]) : _vm._e()], 1)]);
};
var staticRenderFns$w = [];
var NoChatList_vue_vue_type_style_index_0_scoped_true_lang = "";
const __cssModules$w = {};
var __component__$w = /* @__PURE__ */ normalizeComponent(NoChatList$1, render$w, staticRenderFns$w, false, injectStyles$w, "6b362cbc", null, null);
function injectStyles$w(context2) {
  for (let o in __cssModules$w) {
    this[o] = __cssModules$w[o];
  }
}
var NoChatList = /* @__PURE__ */ function() {
  return __component__$w.exports;
}();
var __defProp$v = Object.defineProperty;
var __getOwnPropDesc$v = Object.getOwnPropertyDescriptor;
var __decorateClass$v = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$v(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$v(target, key, result);
  return result;
};
const ComponentProps$j = Vue$1.extend({
  props: {
    placeholder: {
      type: String,
      default: "Choose a group chat name"
    },
    borderRadius: {
      type: Number,
      default: 4
    },
    height: {
      type: Number,
      default: 44
    },
    width: {
      type: [String, Number],
      default: "fullWidth",
      validator: (value) => {
        const regex = /^\d+$/;
        return regex.test(value) || value.includes("fullWidth");
      }
    },
    text: {
      type: String,
      default: ""
    },
    reset: {
      type: Boolean,
      default: false
    }
  }
});
let Input$1 = class extends ComponentProps$j {
  get getStyles() {
    return {
      "border-radius": this.borderRadius + "px",
      "min-height": this.height + "px",
      width: this.width === "fullWidth" ? "100%" : this.width + "px"
    };
  }
  userTyping(val) {
    this.$emit("user-typing", val);
  }
  resetTyping() {
    const input = this.$refs.input;
    input.value = "";
  }
};
Input$1 = __decorateClass$v([
  Component({
    name: "Input",
    watch: {
      text(val) {
        if (val === "") {
          this.resetTyping();
        }
      },
      reset(val) {
        if (val) {
          this.resetTyping();
        }
      }
    }
  })
], Input$1);
var render$v = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("input", { ref: "input", staticClass: "robin-input", style: _vm.getStyles, attrs: { "type": "text", "placeholder": _vm.placeholder, "autocomplete": "off", "data-testid": "input" }, on: { "input": function($event) {
    return _vm.userTyping($event.target.value);
  } } });
};
var staticRenderFns$v = [];
var Input_vue_vue_type_style_index_0_scoped_true_lang = "";
const __cssModules$v = {};
var __component__$v = /* @__PURE__ */ normalizeComponent(Input$1, render$v, staticRenderFns$v, false, injectStyles$v, "9b28f3d8", null, null);
function injectStyles$v(context2) {
  for (let o in __cssModules$v) {
    this[o] = __cssModules$v[o];
  }
}
var Input = /* @__PURE__ */ function() {
  return __component__$v.exports;
}();
var __defProp$u = Object.defineProperty;
var __getOwnPropDesc$u = Object.getOwnPropertyDescriptor;
var __decorateClass$u = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$u(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$u(target, key, result);
  return result;
};
const ComponentProps$i = Vue$1.extend({
  props: {
    groupName: {
      type: String,
      default: ""
    }
  }
});
let NewGroupChatList$2 = class extends ComponentProps$i {
  constructor() {
    super(...arguments);
    this.name = "";
    this.icon = {};
    this.resetInput = false;
    this.acceptedVisualFiles = "image/png, image/jpg, image/jpeg";
  }
  userTyping(val) {
    this.name = val;
  }
  openPreviousModal() {
    this.$emit("closemodal", "newchat");
    this.icon = {};
    this.name = "";
    this.resetInput = true;
  }
  openGroupChatList() {
    this.$emit("openmodal", "newgroupchat");
    this.$emit("set-groupicon", this.icon);
    this.$emit("set-groupname", this.name);
  }
  resetFileTarget(event) {
    event.target.value = "";
  }
  toBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        var _a;
        return resolve(((_a = reader.result) == null ? void 0 : _a.toString()) || "");
      };
      reader.onerror = (error2) => reject(error2);
    });
  }
  async handleFileChange(file) {
    let fileURL;
    try {
      fileURL = await this.toBase64(file[0]);
    } catch (e2) {
      console.warn(e2);
    }
    const typeIndex = file[0].name.lastIndexOf(".");
    if (file[0].size < 5000001) {
      this.icon = {
        name: file[0].name.substring(0, typeIndex),
        size: file[0].size,
        type: file[0].type,
        extension: file[0].name.substring(typeIndex + 1),
        localUrl: fileURL,
        file: file[0]
      };
    } else {
      this.$toast.open({
        message: "Image upload cannot be more than 5mb",
        type: "error",
        position: "bottom-left"
      });
    }
  }
};
NewGroupChatList$2 = __decorateClass$u([
  Component({
    name: "NewGroupChat",
    components: {
      Content,
      Input,
      Button,
      GroupAvatar,
      IconButton
    }
  })
], NewGroupChatList$2);
var render$u = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { ref: "popup-body", staticClass: "robin-side-container" }, [_c("header", { staticClass: "robin-header robin-mb-33" }, [_c("IconButton", { attrs: { "name": "remove", "emit": "close", "to-emit": true, "to-click-away": false }, on: { "close": function($event) {
    return _vm.openPreviousModal();
  } } }), _c("Content", { staticClass: "robin-ml-12", attrs: { "font-weight": "400", "font-size": 16 } }, [_vm._v("New Group Chat")]), _c("div", { staticClass: "robin-ml-auto" }, [_c("Button", { directives: [{ name: "show", rawName: "v-show", value: _vm.name.length > 0, expression: "name.length > 0" }], staticClass: "robin-pulse-2", attrs: { "emit": "done" }, on: { "done": function($event) {
    return _vm.openGroupChatList();
  } } }, [_vm._v("Done")])], 1)], 1), _c("Content", { staticClass: "robin-clickable", attrs: { "as": "label", "for-ref": "group-icon-upload" } }, [_c("div", { directives: [{ name: "show", rawName: "v-show", value: !_vm.icon.name, expression: "!icon.name" }], staticClass: "robin-group-image robin-mb-7" }, [_c("input", { style: { display: "none" }, attrs: { "type": "file", "accept": _vm.acceptedVisualFiles, "id": "group-icon-upload", "data-testid": "group-icon-upload" }, on: { "change": function($event) {
    return _vm.handleFileChange($event.target.files);
  }, "click": function($event) {
    return _vm.resetFileTarget($event);
  } } }), _c("Content", { attrs: { "color": "#fff", "fontSize": 24 } }, [_vm._v("RG")])], 1), _c("img", { directives: [{ name: "show", rawName: "v-show", value: _vm.icon.name, expression: "icon.name" }], staticClass: "robin-group-image robin-mb-7", attrs: { "src": _vm.icon.localUrl, "alt": _vm.icon.name, "data-testid": "image" } }), _c("Content", { staticClass: "robin-mb-32", attrs: { "fontWeight": "400", "fontSize": 14 } }, [_vm._v("Tap To Add Group Image")])], 1), _c("div", { staticClass: "robin-wrapper robin-w-100" }, [_c("Content", { staticClass: "robin-mb-8", attrs: { "fontWeight": "400", "fontSize": 14 } }, [_vm._v("Group Name")]), _c("Input", { attrs: { "text": _vm.groupName, "reset": _vm.resetInput, "placeholder": "Robin Group" }, on: { "user-typing": _vm.userTyping } })], 1)], 1);
};
var staticRenderFns$u = [];
var NewGroupChat_vue_vue_type_style_index_0_scoped_true_lang = "";
const __cssModules$u = {};
var __component__$u = /* @__PURE__ */ normalizeComponent(NewGroupChatList$2, render$u, staticRenderFns$u, false, injectStyles$u, "a03b2418", null, null);
function injectStyles$u(context2) {
  for (let o in __cssModules$u) {
    this[o] = __cssModules$u[o];
  }
}
var NewGroupChat = /* @__PURE__ */ function() {
  return __component__$u.exports;
}();
var __defProp$t = Object.defineProperty;
var __getOwnPropDesc$t = Object.getOwnPropertyDescriptor;
var __decorateClass$t = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$t(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$t(target, key, result);
  return result;
};
const ComponentProps$h = Vue$1.extend({
  props: {
    color: {
      type: String,
      default: "#15AE73"
    }
  }
});
let CheckBox$1 = class extends ComponentProps$h {
  constructor() {
    super(...arguments);
    this.root = null;
    this.checked = false;
  }
  mounted() {
    this.root = document.documentElement;
    this.setRootVariables();
  }
  setRootVariables() {
    this.root.style.setProperty("--checkbox-color", this.color);
  }
};
CheckBox$1 = __decorateClass$t([
  Component({
    name: "CheckBox",
    watch: {
      color() {
        this.setRootVariables();
      }
    }
  })
], CheckBox$1);
var render$t = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("label", { staticClass: "robin-checkbox-container" }, [_c("input", { directives: [{ name: "model", rawName: "v-model", value: _vm.checked, expression: "checked" }], staticClass: "robin-checkbox-button", attrs: { "type": "checkbox", "name": "checkbox", "data-testid": "checkbox" }, domProps: { "checked": Array.isArray(_vm.checked) ? _vm._i(_vm.checked, null) > -1 : _vm.checked }, on: { "click": function($event) {
    return _vm.$emit("clicked", _vm.checked);
  }, "change": function($event) {
    var $$a = _vm.checked, $$el = $event.target, $$c = $$el.checked ? true : false;
    if (Array.isArray($$a)) {
      var $$v = null, $$i = _vm._i($$a, $$v);
      if ($$el.checked) {
        $$i < 0 && (_vm.checked = $$a.concat([$$v]));
      } else {
        $$i > -1 && (_vm.checked = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
      }
    } else {
      _vm.checked = $$c;
    }
  } } }), _c("span", { staticClass: "robin-checkbox-control" })]);
};
var staticRenderFns$t = [];
var CheckBox_vue_vue_type_style_index_0_scoped_true_lang = "";
const __cssModules$t = {};
var __component__$t = /* @__PURE__ */ normalizeComponent(CheckBox$1, render$t, staticRenderFns$t, false, injectStyles$t, "5f1e8c1e", null, null);
function injectStyles$t(context2) {
  for (let o in __cssModules$t) {
    this[o] = __cssModules$t[o];
  }
}
var CheckBox = /* @__PURE__ */ function() {
  return __component__$t.exports;
}();
var __defProp$s = Object.defineProperty;
var __getOwnPropDesc$s = Object.getOwnPropertyDescriptor;
var __decorateClass$s = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$s(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$s(target, key, result);
  return result;
};
const ComponentProps$g = Vue$1.extend({
  props: {
    groupName: {
      type: String,
      default: ""
    },
    groupIcon: {
      type: Object,
      default: () => {
      }
    },
    robinUsers: {
      type: Array,
      default: () => []
    }
  }
});
let NewGroupChatList$1 = class extends ComponentProps$g {
  constructor() {
    super(...arguments);
    this.modalOpen = false;
    this.contacts = {};
    this.checkBoxKeyState = 0;
    this.users = [];
    this.isLoading = false;
    this.isUploading = false;
    this.searchData = [];
    this.updatingParticipants = false;
    this.conversationId = "";
    this.key = 0;
  }
  created() {
    this.getContacts("");
    this.handleAddGroupParticipants();
  }
  closeModal() {
    this.modalOpen = false;
    this.users = [];
    this.checkBoxKeyState += 1;
  }
  openModal() {
    this.modalOpen = true;
    this.checkBoxKeyState += 1;
  }
  getContacts(searchText) {
    this.contacts = {};
    if (searchText.trim() === "") {
      this.robinUsers.forEach((user) => {
        this.contacts[this.getContactKey(user.userName)] = this.robinUsers.filter((item) => item.userToken !== this.$user_token && this.validateContact(item.userName, user.userName));
      });
      for (const key in this.contacts) {
        if (this.contacts[key].length === 0) {
          delete this.contacts[key];
        }
      }
      this.sortContacts();
    } else {
      this.searchData.forEach((user) => {
        this.contacts[this.getContactKey(user.userName)] = this.searchData.filter((item) => item.userToken !== this.$user_token && this.validateContact(item.userName, user.userName));
      });
    }
  }
  toggleCheckAction(val, user) {
    if (!val) {
      this.addUser(user);
    } else {
      this.removeUser(user);
    }
  }
  toggleSelectAllCheckAction(val) {
    const checkboxComponents = this.$refs["checkbox-comp"];
    if (!val) {
      this.users = [...this.robinUsers];
      for (let i = 0; i < checkboxComponents.length; i += 1) {
        checkboxComponents[i].checked = true;
      }
    } else {
      this.users = [];
      for (let i = 0; i < checkboxComponents.length; i += 1) {
        checkboxComponents[i].checked = false;
      }
    }
  }
  async createGroupConversation() {
    const moderator = {
      user_token: this.$user_token,
      meta_data: {
        display_name: this.$senderName
      }
    };
    const users = this.users.map((user) => {
      return {
        user_token: user.userToken,
        meta_data: {
          profile_image: user.profileImage,
          display_name: user.userName
        }
      };
    });
    this.isUploading = true;
    const res = await this.$robin.createGroupConversation(this.groupName, moderator, users);
    if (res && !res.error) {
      if (this.groupIcon.file) {
        this.uploadGroupIcon(res.data).then(() => {
          this.$emit("changesidebartype", "primary");
          this.$emit("closemodal");
          this.$emit("reset-groupname");
          this.toggleSelectAllCheckAction(true);
          this.isUploading = false;
        });
      } else {
        this.$emit("changesidebartype", "primary");
        this.$emit("closemodal");
        this.$emit("reset-groupname");
        this.isUploading = false;
      }
    } else {
      this.$toast.open({
        message: "Check your connection.",
        type: "error",
        position: "bottom-left"
      });
      this.isUploading = false;
    }
  }
  async addGroupParticipants() {
    const users = this.users.map((user) => {
      return {
        user_token: user.userToken,
        meta_data: {
          profile_image: user.profileImage,
          display_name: user.userName
        }
      };
    });
    this.isUploading = true;
    const res = await this.$robin.addGroupParticipants(this.conversationId, users);
    if (res && !res.error) {
      this.conversationId = "";
      this.isUploading = false;
      this.$emit("changesidebartype", "primary");
      this.$emit("closemodal");
      this.$emit("reset-groupname");
      this.toggleSelectAllCheckAction(true);
      EventBus.$emit("update.group.conversation", res.data);
    } else {
      this.$toast.open({
        message: "Check your connection.",
        type: "error",
        position: "bottom-left"
      });
      this.isUploading = false;
    }
  }
  handleAddGroupParticipants() {
    EventBus.$on("edit.participants.group", (details) => {
      this.conversationId = details.conversation_id;
      this.updatingParticipants = true;
    });
  }
  async uploadGroupIcon(conversation) {
    const robin = this.$robin;
    const res = await robin.uploadGroupIcon(conversation._id, this.groupIcon.file);
    if (res && !res.error) {
      this.$emit("reset-groupicon");
    }
  }
  addUser(user) {
    this.users.push(user);
  }
  removeUser(user) {
    const userIndex = this.users.findIndex((item) => item.userToken === user.userToken);
    this.users.splice(userIndex, 1);
    if (this.users.length < 1) {
      this.closeModal();
    }
  }
  addIndexToCheckBoxState(index, checkBoxKeyState) {
    return parseInt(index) + checkBoxKeyState;
  }
  searchContacts(searchText) {
    this.isLoading = true;
    const data = this.robinUsers.filter((obj) => {
      let stopSearch = false;
      Object.values(obj).forEach((val) => {
        const filter = String(val).toLowerCase().includes(searchText.toLowerCase());
        if (filter) {
          stopSearch = true;
        }
      });
      if (stopSearch) {
        return obj;
      }
    });
    this.searchData = [...data];
    this.getContacts(searchText);
    setTimeout(() => {
      this.isLoading = false;
    }, 300);
  }
  sortContacts() {
    this.contacts = Object.keys(this.contacts).sort().reduce((result, key) => {
      result[key] = this.contacts[key];
      return result;
    }, {});
  }
  getContactKey(username) {
    return username !== "" && isNaN(parseInt(username[0])) ? username[0].toUpperCase() : "*";
  }
  validateContact(usernameVal, username) {
    if (!usernameVal[0] && !username[0]) {
      return usernameVal.trim() === username.trim();
    }
    if (usernameVal[0] && username[0]) {
      return usernameVal[0].toUpperCase() === username[0].toUpperCase();
    }
    return false;
  }
  openPreviousModal() {
    if (!this.updatingParticipants) {
      this.$emit("closemodal", "newgroup");
    } else {
      this.$emit("changesidebartype", "primary");
      this.$emit("closemodal");
      this.toggleSelectAllCheckAction(true);
    }
    this.updatingParticipants = false;
    setTimeout(() => {
      this.refresh();
    }, 300);
  }
  refresh() {
    this.key += 1;
  }
};
NewGroupChatList$1 = __decorateClass$s([
  Component({
    name: "NewGroupChatList",
    components: {
      Content,
      SearchBar,
      Button,
      Avatar,
      IconButton,
      CheckBox,
      AlphabetBlock
    },
    watch: {
      robinUsers: {
        handler(val) {
          this.getContacts("");
        }
      }
    }
  })
], NewGroupChatList$1);
var render$s = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { ref: "popup-body", staticClass: "robin-side-container" }, [_c("header", { staticClass: "robin-header" }, [_c("IconButton", { attrs: { "name": "remove", "emit": "close", "to-emit": true, "to-click-away": false }, on: { "close": function($event) {
    return _vm.openPreviousModal();
  } } }), _c("Content", { staticClass: "robin-ml-12", attrs: { "font-weight": "400", "font-size": 16 } }, [_vm._v(_vm._s(!_vm.updatingParticipants ? "New Group Chat" : "Add Group Participants"))]), _c("div", { staticClass: "robin-ml-auto" }, [_c("Button", { directives: [{ name: "show", rawName: "v-show", value: _vm.users.length > 0 && !_vm.isUploading, expression: "users.length > 0 && !isUploading" }], staticClass: "robin-pulse-2", attrs: { "emit": "done" }, on: { "done": function($event) {
    !_vm.updatingParticipants ? _vm.createGroupConversation() : _vm.addGroupParticipants();
  } } }, [_vm._v("Done")]), _c("div", { directives: [{ name: "show", rawName: "v-show", value: _vm.isUploading, expression: "isUploading" }], staticClass: "robin-spinner" })], 1)], 1), _c("div", { staticClass: "robin-w-100 robin-pl-16 robin-pr-16" }, [_c("SearchBar", { attrs: { "loading": _vm.isLoading, "placeholder": "Search" }, on: { "user-typing": function($event) {
    return _vm.searchContacts($event);
  } } })], 1), _c("div", { staticClass: "robin-select robin-flex robin-flex-align-center robin-flex-justify-end robin-w-100 robin-pl-16 robin-pr-16 robin-pt-24 robin-pb-23" }, [_c("Content", { attrs: { "color": "#9999BC" } }, [_vm._v(" Select All ")]), _c("CheckBox", { staticClass: "robin-ml-8", attrs: { "data-testid": "select-all-button" }, on: { "clicked": function($event) {
    return _vm.toggleSelectAllCheckAction($event);
  } } })], 1), _c("div", { staticClass: "robin-contact-container robin-overflow-y-auto" }, _vm._l(_vm.contacts, function(contact, key, index) {
    return _c("div", { key: "contact-" + index }, [_c("div", { directives: [{ name: "show", rawName: "v-show", value: key.toString() != "*", expression: "key.toString() != '*'" }], staticClass: "robin-w-100" }, [_c("AlphabetBlock", { attrs: { "text": key } })], 1), _c("div", { staticClass: "robin-card-container robin-flex robin-flex-column" }, _vm._l(contact, function(user, userIndex) {
      return _c("div", { key: user.userToken, staticClass: "robin-card robin-flex robin-flex-align-center" }, [_c("div", { staticClass: "robin-card-info robin-mr-12" }, [_c("Avatar", { attrs: { "robin-users": _vm.$robin_users, "img-url": user.profileImage, "sender-token": user.userToken } })], 1), _c("div", { staticClass: "robin-card-info robin-h-100 robin-h-100 robin-flex robin-flex-align-center robin-pt-4 robin-pb-4\u02DD robin-flex-1" }, [_c("div", { staticClass: "robin-flex" }, [_c("Content", { attrs: { "font-size": 14, "line-height": 18, "data-testid": "content" } }, [_vm._v(_vm._s(user.userName))])], 1), _c("div", { staticClass: "robin-ml-auto" }, [_c("CheckBox", { key: _vm.addIndexToCheckBoxState(userIndex, _vm.checkBoxKeyState), ref: "checkbox-comp", refInFor: true, attrs: { "data-testid": "checkbox" }, on: { "clicked": function($event) {
        return _vm.toggleCheckAction($event, user);
      } } })], 1)])]);
    }), 0)]);
  }), 0)]);
};
var staticRenderFns$s = [];
var NewGroupChatList_vue_vue_type_style_index_0_scoped_true_lang = "";
const __cssModules$s = {};
var __component__$s = /* @__PURE__ */ normalizeComponent(NewGroupChatList$1, render$s, staticRenderFns$s, false, injectStyles$s, "86128258", null, null);
function injectStyles$s(context2) {
  for (let o in __cssModules$s) {
    this[o] = __cssModules$s[o];
  }
}
var NewGroupChatList = /* @__PURE__ */ function() {
  return __component__$s.exports;
}();
var __defProp$r = Object.defineProperty;
var __getOwnPropDesc$r = Object.getOwnPropertyDescriptor;
var __decorateClass$r = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$r(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$r(target, key, result);
  return result;
};
let RArchivedChatListPopOver = class extends Vue$1 {
};
RArchivedChatListPopOver = __decorateClass$r([
  Component({
    name: "RArchivedChatListPopOver",
    components: {
      Content,
      SvgIcon
    }
  })
], RArchivedChatListPopOver);
var render$r = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { ref: "popup-body", staticClass: "robin-popup robin-zoomIn" }, [_c("div", { staticClass: "robin-wrapper robin-w-100", attrs: { "data-testid": "unarchive-chat" }, on: { "click": function($event) {
    return _vm.$emit("unarchive-chat");
  } } }, [_c("Content", { attrs: { "font-size": 14, "color": "#101010" } }, [_vm._v("Unarchive Chat")]), _c("SvgIcon", { attrs: { "name": "mailbox", "color": "#51545C" } })], 1)]);
};
var staticRenderFns$r = [];
var ArchiveChatListPopOver_vue_vue_type_style_index_0_scoped_true_lang = "";
const __cssModules$r = {};
var __component__$r = /* @__PURE__ */ normalizeComponent(RArchivedChatListPopOver, render$r, staticRenderFns$r, false, injectStyles$r, "7f03a0a0", null, null);
function injectStyles$r(context2) {
  for (let o in __cssModules$r) {
    this[o] = __cssModules$r[o];
  }
}
var ArchiveChatListPopOver = /* @__PURE__ */ function() {
  return __component__$r.exports;
}();
var __defProp$q = Object.defineProperty;
var __getOwnPropDesc$q = Object.getOwnPropertyDescriptor;
var __decorateClass$q = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$q(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$q(target, key, result);
  return result;
};
const ComponentProps$f = Vue$1.extend({
  props: {
    archivedConversations: {
      type: Array,
      default: () => []
    }
  }
});
let ArchivedChatList$1 = class extends ComponentProps$f {
  constructor() {
    super(...arguments);
    this.conversations = [];
    this.popUpStates = [];
    this.activeConversation = {};
    this.scroll = false;
    this.avatarKey = 0;
    this.screenWidth = 0;
  }
  mounted() {
    this.$nextTick(function() {
      this.onResize();
    });
    window.addEventListener("resize", this.onResize);
  }
  openConversation(conversation) {
    if (!this.isConversationActive(conversation) && this.screenWidth > 1200) {
      this.activeConversation = conversation;
      store.setState("imagePreviewOpen", false);
      EventBus.$emit("conversation-opened", conversation);
      EventBus.$emit("open-conversation");
    }
    if (this.screenWidth <= 1200) {
      this.activeConversation = conversation;
      store.setState("imagePreviewOpen", false);
      EventBus.$emit("conversation-opened", conversation);
      EventBus.$emit("open-conversation");
    }
  }
  getProfileImage(conversation) {
    const index = this.$robin_users.findIndex((user) => user.userToken === conversation.sender_token);
    return this.$robin_users[index] ? this.$robin_users[index].profileImage : "";
  }
  isConversationActive(object) {
    return Object.is(this.activeConversation, object);
  }
  handleOpenPopUp(event, _id, refContainerKey, refKey, id) {
    const popupContainer = this.$refs[refContainerKey];
    const popup = this.$refs[refKey];
    popup[0].$refs["popup-body"].classList.remove("robin-zoomOut");
    if (!this.scroll && this.conversations.length - 2 !== parseInt(id) || this.conversations.length - 1 !== parseInt(id)) {
      popupContainer[0].style.top = event.clientY - 12 + "px";
      if (this.screenWidth > 1024) {
        popupContainer[0].style.left = event.clientX - 90 + "px";
      } else {
        popupContainer[0].style.left = event.clientX - 145 + "px";
      }
    } else {
      popupContainer[0].style.top = event.clientY - 60 + "px";
      if (this.screenWidth > 1024) {
        popupContainer[0].style.left = event.clientX - 90 + "px";
      } else {
        popupContainer[0].style.left = event.clientX - 145 + "px";
      }
    }
    const index = this.popUpStates.findIndex((val) => val._id === _id);
    this.popUpStates[index].opened = true;
    this.popUpStates.forEach((val, i) => {
      if (val._id !== _id) {
        this.popUpStates[i].opened = false;
      }
    });
  }
  handleClosePopUp(_id, refKey) {
    const popup = this.$refs[refKey];
    popup[0].$refs["popup-body"].classList.add("robin-zoomOut");
    window.setTimeout(() => {
      const index = this.popUpStates.findIndex((val) => val._id === _id);
      if (this.popUpStates[index].opened) {
        const popup2 = this.$refs[refKey];
        popup2[0].$refs["popup-body"].classList.remove("robin-zoomOut");
        this.popUpStates[index].opened = false;
      }
    }, 300);
  }
  formatRecentMessageTime(time) {
    const datetime = moment(time);
    return datetime.calendar(null, {
      sameDay: function() {
        return "[" + datetime.fromNow() + "]";
      },
      lastDay: function() {
        return "[" + datetime.fromNow() + "]";
      },
      lastWeek: function() {
        return "[" + datetime.fromNow() + "]";
      },
      sameElse: "DD/MM/YYYY"
    });
  }
  onScroll() {
    this.scroll = true;
  }
  async unArchiveChat(id) {
    const res = await this.$robin.unarchiveConversation(id, this.$user_token);
    if (!res.error) {
      const index = this.conversations.findIndex((conversation2) => conversation2._id === id);
      const conversation = this.conversations[index];
      conversation.archived_for = [];
      EventBus.$emit("archived-conversation.delete", conversation);
      EventBus.$emit("regular-conversation.add", conversation);
      this.$toast.open({
        message: "Conversation unarchived.",
        type: "success",
        position: "bottom-left"
      });
      this.$emit("refresh");
    }
  }
  onResize() {
    this.screenWidth = window.innerWidth;
  }
};
ArchivedChatList$1 = __decorateClass$q([
  Component({
    name: "ArchivedChatList",
    components: {
      Content,
      IconButton,
      Avatar,
      GroupAvatar,
      ArchiveChatListPopOver
    },
    watch: {
      archivedConversations: {
        handler(val) {
          this.conversations = [...val].sort((a, b) => {
            const dateA = moment(a.last_message ? a.last_message.timestamp : a.updated_at).valueOf();
            const dateB = moment(b.last_message ? b.last_message.timestamp : b.updated_at).valueOf();
            if (dateA > dateB) {
              return -1;
            }
            if (dateB < dateA) {
              return 1;
            }
            return 0;
          });
          this.popUpStates = [];
          [...val].forEach((val2) => {
            this.popUpStates.push({
              opened: false,
              _id: val2._id
            });
          });
        },
        immediate: true
      },
      $robin_users: {
        handler(val) {
          this.avatarKey += 1;
        }
      }
    }
  })
], ArchivedChatList$1);
var render$q = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { ref: "popup-body", staticClass: "robin-side-container" }, [_c("header", { staticClass: "robin-header" }, [_c("IconButton", { attrs: { "name": "remove", "color": "#000", "emit": "close", "to-emit": true, "to-click-away": false, "data-testid": "closemodal" }, on: { "close": function($event) {
    return _vm.$emit("closemodal", "primary");
  } } }), _c("Content", { staticClass: "robin-ml-12", attrs: { "fontWeight": "400", "fontSize": 16 } }, [_vm._v(" Archived Messages ")])], 1), _c("div", { staticClass: "robin-wrapper robin-card-container robin-flex robin-flex-column robin-mt-42", on: { "scroll": function($event) {
    return _vm.onScroll();
  } } }, [_vm._l(_vm.conversations, function(conversation, index) {
    return _c("div", { directives: [{ name: "show", rawName: "v-show", value: _vm.conversations.length > 0, expression: "conversations.length > 0" }], key: "conversation-" + index, staticClass: "robin-card robin-flex robin-flex-align-center", class: { "robin-card-active": _vm.isConversationActive(conversation) && _vm.screenWidth > 1200 }, attrs: { "data-testid": "card" }, on: { "click": function($event) {
      if ($event.target !== $event.currentTarget) {
        return null;
      }
      return _vm.openConversation(conversation);
    } } }, [_c("div", { staticClass: "robin-card-info robin-mr-12", on: { "click": function($event) {
      return _vm.openConversation(conversation);
    } } }, [!conversation.is_group ? _c("Avatar", { key: _vm.avatarKey, attrs: { "data-testid": "regular-avatar", "robin-users": _vm.$robin_users, "img-url": _vm.getProfileImage(conversation), "sender-token": conversation.sender_token === _vm.$user_token ? conversation.receiver_token : conversation.sender_token } }) : _c("GroupAvatar", { attrs: { "data-testid": "group-avatar", "img-url": conversation.group_icon } })], 1), _c("div", { staticClass: "robin-card-info robin-h-100 robin-h-100 robin-flex robin-flex-column robin-flex-space-between robin-pt-4 robin-pb-4\u02DD robin-flex-1" }, [_c("div", { staticClass: "robin-flex robin-flex-space-between", on: { "click": function($event) {
      return _vm.openConversation(conversation);
    } } }, [!conversation.is_group ? _c("Content", { attrs: { "fontWeight": "normal", "color": "#000000", "fontSize": 16, "lineHeight": 20 } }, [_vm._v(" " + _vm._s(conversation.sender_token != _vm.$user_token ? conversation.sender_name : conversation.receiver_name) + " ")]) : _c("Content", { attrs: { "font-weight": "normal", "color": "#000000", "font-size": 16, "line-height": 20 } }, [_vm._v(" " + _vm._s(conversation.name) + " ")]), _c("Content", { attrs: { "as": "p", "fontWeight": "normal", "color": "#51545C", "fontSize": 14, "lineHeight": 18 } }, [_vm._v(" " + _vm._s(_vm.formatRecentMessageTime(conversation.last_message ? conversation.last_message.timestamp : conversation.updated_at)) + " ")])], 1), _c("div", { staticClass: "robin-flex robin-flex-space-between", on: { "click": function($event) {
      if ($event.target !== $event.currentTarget) {
        return null;
      }
      return _vm.openConversation(conversation);
    } } }, [_c("Content", { attrs: { "as": "p", "fontWeight": "normal", "color": "#8D9091", "fontSize": 14, "lineHeight": 18 }, nativeOn: { "click": function($event) {
      return _vm.openConversation(conversation);
    } } }, [_vm._v(" " + _vm._s(conversation.last_message && conversation.last_message.msg.length < 20 ? conversation.last_message.msg : conversation.last_message ? conversation.last_message.msg.substring(0, 20) + " ..." : "") + " ")]), _c("div", { staticClass: "robin-mini-info-container robin-flex robin-flex-align-center" }, [_c("div", { staticClass: "robin-hidden robin-ml-10", attrs: { "data-testid": "chat-handler" }, on: { "click": function($event) {
      _vm.handleOpenPopUp($event, conversation._id, "popup-container-" + index, "popup-" + index, index.toString());
    } } }, [_c("IconButton", { attrs: { "name": "openModalDot", "to-emit": false, "to-click-away": true }, on: { "clickoutside": function($event) {
      return _vm.handleClosePopUp(conversation._id, "popup-" + index);
    } } })], 1)])], 1)]), _c("div", { directives: [{ name: "show", rawName: "v-show", value: _vm.popUpStates[index].opened, expression: "popUpStates[index].opened" }], ref: "popup-container-" + index, refInFor: true, staticClass: "robin-popup-container", attrs: { "data-testid": "chat-popover" } }, [_c("ArchiveChatListPopOver", { ref: "popup-" + index, refInFor: true, on: { "unarchive-chat": function($event) {
      return _vm.unArchiveChat(conversation._id);
    } } })], 1)]);
  }), _c("div", { directives: [{ name: "show", rawName: "v-show", value: _vm.conversations.length < 1, expression: "conversations.length < 1" }], staticClass: "robin-flex robin-flex-justify-center robin-pt-15" }, [_c("Content", { attrs: { "font-size": 18, "color": "#15AE73" } }, [_vm._v("No archived chat")])], 1)], 2)]);
};
var staticRenderFns$q = [];
var ArchivedChatList_vue_vue_type_style_index_0_scoped_true_lang = "";
const __cssModules$q = {};
var __component__$q = /* @__PURE__ */ normalizeComponent(ArchivedChatList$1, render$q, staticRenderFns$q, false, injectStyles$q, "b4a8546e", null, null);
function injectStyles$q(context2) {
  for (let o in __cssModules$q) {
    this[o] = __cssModules$q[o];
  }
}
var ArchivedChatList = /* @__PURE__ */ function() {
  return __component__$q.exports;
}();
var __defProp$p = Object.defineProperty;
var __getOwnPropDesc$p = Object.getOwnPropertyDescriptor;
var __decorateClass$p = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$p(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$p(target, key, result);
  return result;
};
let SideContainer$1 = class extends Vue$1 {
  constructor() {
    super(...arguments);
    this.key = 0;
    this.searchText = "";
    this.regularConversations = [];
    this.archivedConversations = [];
    this.sideBarType = "primary";
    this.conversations = [];
    this.groupName = "";
    this.groupIcon = {};
  }
  created() {
    this.getUserToken();
    this.onGroupConversationCreated();
    this.onNewConversationCreated();
    this.handleAddRegularConversation();
    this.handleRemoveRegularConversation();
    this.handleAddArchivedConversation();
    this.handleRemoveArchivedConversation();
    this.handleMarkAsRead();
    this.handleMarkAsUnread();
    this.showNewGroupModal();
    this.handleMessageForward();
  }
  get isPageLoading() {
    return store.state.isPageLoading;
  }
  setGroupName(val) {
    this.groupName = val;
  }
  resetGroupName() {
    this.groupName = "";
  }
  setGroupIcon(val) {
    this.groupIcon = val;
  }
  resetGroupIcon() {
    this.groupIcon = {};
  }
  showNewGroupModal() {
    EventBus.$on("show.new.group", () => {
      this.openModal("slide-3", "newgroupchat");
    });
  }
  openModal(refKey, type) {
    if (type === "primary") {
      this.sideBarType = type;
    } else {
      const popup = this.$refs[refKey];
      window.setTimeout(() => {
        popup.$refs["popup-body"].classList.add("robin-slideInLeft");
        this.sideBarType = type;
      }, 200);
    }
  }
  closeModal(refKey = "slide-1", type) {
    if (type === "primary" && refKey === "slide-0") {
      this.sideBarType = type;
      this.resetGroupName();
    } else {
      const popup = this.$refs[refKey];
      popup.$refs["popup-body"].classList.add("robin-slideOutLeft");
      window.setTimeout(() => {
        popup.$refs["popup-body"].classList.remove("robin-slideOutLeft");
        this.sideBarType = type;
      }, 200);
    }
  }
  onGroupConversationCreated() {
    EventBus.$on("new-group.conversation", (conversation) => {
      conversation.participants.every((participant) => {
        if (participant.user_token === this.$user_token) {
          this.$regularConversations.unshift(conversation);
          this.regularConversations.unshift(conversation);
          return false;
        }
        return true;
      });
    });
  }
  onNewConversationCreated() {
    EventBus.$on("new.conversation", (conversation) => {
      if (conversation.sender_token === this.$user_token || conversation.receiver_token === this.$user_token) {
        EventBus.$emit("regular-conversation.add", conversation);
      }
    });
  }
  handleAddRegularConversation() {
    EventBus.$on("regular-conversation.add", (conversation) => {
      const index = this.$regularConversations.findIndex((item) => item._id === conversation._id);
      if (index === -1) {
        this.$regularConversations.unshift(conversation);
        this.regularConversations.unshift(conversation);
      }
    });
  }
  handleRemoveRegularConversation() {
    EventBus.$on("regular-conversation.delete", (conversation) => {
      const index = this.$regularConversations.findIndex((item) => item._id === conversation._id);
      this.$regularConversations.splice(index, 1);
      this.regularConversations.splice(index, 1);
    });
  }
  handleRemoveArchivedConversation() {
    EventBus.$on("archived-conversation.delete", (conversation) => {
      const index = this.$archivedConversations.findIndex((item) => item._id === conversation._id);
      this.archivedConversations.splice(index, 1);
      this.$archivedConversations.splice(index, 1);
    });
  }
  handleAddArchivedConversation() {
    EventBus.$on("archived-conversation.add", (conversation) => {
      this.archivedConversations.unshift(conversation);
      this.$archivedConversations.unshift(conversation);
    });
  }
  async getUserToken() {
    const res = await this.$robin.getUserToken({
      user_token: this.$user_token
    });
    if (!res.error) {
      this.conversations = res.data.conversations == null ? [] : res.data.conversations;
      Vue$1.prototype.$conversations = res.data.conversations == null ? [] : res.data.conversations;
      Vue$1.prototype.$regularConversations = this.getRegularConversations();
      Vue$1.prototype.$archivedConversations = this.getArchivedConversations();
      this.regularConversations = this.getRegularConversations();
      this.archivedConversations = this.getArchivedConversations();
      store.setState("isPageLoading", false);
      this.$forceUpdate();
    }
  }
  getArchivedConversations() {
    return this.$conversations.filter((user) => {
      if (!user.archived_for)
        return false;
      return user.archived_for.includes(this.$user_token);
    });
  }
  getRegularConversations() {
    const regularConversations = this.$conversations.filter((user) => {
      if (!user.archived_for || user.archived_for.length === 0)
        return true;
      return !user.archived_for.includes(this.$user_token);
    });
    return this.addUnreadMessagesToConversation(regularConversations);
  }
  addUnreadMessagesToConversation(conversations) {
    let unreadMessages = 0;
    const data = conversations.map((conversation) => {
      this.getConversationMessages(conversation._id).then((messages) => {
        if (messages) {
          messages.forEach((message) => {
            if (message.sender_token !== this.$user_token && !message.is_read) {
              unreadMessages += 1;
            }
          });
        }
        conversation.unread_messages = unreadMessages;
        unreadMessages = 0;
      });
      return conversation;
    });
    return data;
  }
  async getConversationMessages(id) {
    const res = await this.$robin.getConversationMessages(id, this.$user_token);
    if (res && !res.error) {
      return res.data;
    } else {
      this.$toast.open({
        message: "Check your connection.",
        type: "error",
        position: "bottom-left"
      });
    }
    return [];
  }
  handleMarkAsRead() {
    EventBus.$on("mark-as-read", (conversation) => {
      if (conversation) {
        if (!conversation.archived_for || conversation.archived_for.length === 0) {
          const index = this.$regularConversations.findIndex((item) => item._id === conversation._id);
          if (this.regularConversations[index]) {
            this.regularConversations[index].unread_messages = 0;
            this.$regularConversations[index].unread_messages = 0;
          }
        }
      }
    });
  }
  handleMarkAsUnread() {
    EventBus.$on("mark-as-unread", (conversation) => {
      if (conversation) {
        if (!conversation.archived_for || conversation.archived_for.length === 0) {
          const index = this.$regularConversations.findIndex((item) => item._id === conversation._id);
          if (this.regularConversations[index]) {
            this.$regularConversations[index].unread_messages += 1;
          }
        }
      }
    });
    EventBus.$on("mark-as-unread.modified", (conversation) => {
      if (conversation) {
        if (!conversation.archived_for || conversation.archived_for.length === 0) {
          const index = this.$regularConversations.findIndex((item) => item._id === conversation._id);
          if (this.regularConversations[index]) {
            this.regularConversations[index].unread_messages = "marked";
            this.$regularConversations[index].unread_messages = "marked";
          }
        }
      }
    });
  }
  handleMessageForward() {
    EventBus.$on("message.forward", (messages) => {
      messages.forEach((msg) => {
        this.conversations.forEach((conversation, index) => {
          if (conversation._id === msg.conversation_id) {
            msg.content.timestamp = new Date();
            this.conversations[index].last_message = msg.content;
            EventBus.$emit("regular-conversation.delete", this.conversations[index]);
            EventBus.$emit("regular-conversation.add", this.conversations[index]);
          }
        });
      });
    });
  }
  refresh() {
    this.key += 1;
  }
  searchedData(event) {
    this.searchText = event.text.trim();
    if (event.text.trim() !== "") {
      this.regularConversations = event.data;
    } else {
      this.regularConversations = this.getRegularConversations();
      this.refresh();
    }
  }
};
SideContainer$1 = __decorateClass$p([
  Component({
    name: "SideContainer",
    components: {
      PrimaryChatList,
      NewChatList,
      NoChatList,
      NewGroupChat,
      NewGroupChatList,
      ArchivedChatList
    },
    watch: {
      $robin_users: {
        handler(val) {
          this.refresh();
        }
      }
    }
  })
], SideContainer$1);
var render$p = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "robin-chat-list-container" }, [_c("PrimaryChatList", { directives: [{ name: "show", rawName: "v-show", value: _vm.$conversations.length > 0 || _vm.isPageLoading, expression: "$conversations.length > 0 || isPageLoading" }], key: _vm.key, attrs: { "regular-conversations": _vm.regularConversations, "archived-conversations": _vm.archivedConversations }, on: { "search": function($event) {
    return _vm.searchedData($event);
  }, "opennewchatmodal": function($event) {
    return _vm.openModal("slide-1", $event);
  }, "openarchivedchatmodal": function($event) {
    return _vm.openModal("slide-3", $event);
  }, "closemodal": function($event) {
    return _vm.closeModal("slide-1", $event);
  }, "refresh": _vm.refresh }, scopedSlots: _vm._u([{ key: "chat-list-header", fn: function() {
    return [_vm._t("chat-list-header")];
  }, proxy: true }], null, true) }), _c("NewChatList", { directives: [{ name: "show", rawName: "v-show", value: _vm.sideBarType == "newchat", expression: "sideBarType == 'newchat'" }], key: _vm.key + 1, ref: "slide-1", attrs: { "robin-users": _vm.$robin_users }, on: { "openmodal": function($event) {
    return _vm.openModal("slide-2", $event);
  }, "closemodal": function($event) {
    return _vm.closeModal("slide-1", $event);
  } } }), _c("NoChatList", { directives: [{ name: "show", rawName: "v-show", value: _vm.$conversations.length < 1 && !_vm.isPageLoading, expression: "$conversations.length < 1 && !isPageLoading" }], on: { "opennewchatmodal": function($event) {
    return _vm.openModal("slide-1", $event);
  } }, scopedSlots: _vm._u([{ key: "chat-list-header", fn: function() {
    return [_vm._t("chat-list-header")];
  }, proxy: true }], null, true) }), _c("NewGroupChat", { directives: [{ name: "show", rawName: "v-show", value: _vm.sideBarType == "newgroup", expression: "sideBarType == 'newgroup'" }], key: _vm.key + 2, ref: "slide-2", attrs: { "group-name": _vm.groupName }, on: { "openmodal": function($event) {
    return _vm.openModal("slide-3", $event);
  }, "set-groupname": function($event) {
    return _vm.setGroupName($event);
  }, "set-groupicon": function($event) {
    return _vm.setGroupIcon($event);
  }, "closemodal": function($event) {
    return _vm.closeModal("slide-2", $event);
  } } }), _c("NewGroupChatList", { directives: [{ name: "show", rawName: "v-show", value: _vm.sideBarType == "newgroupchat", expression: "sideBarType == 'newgroupchat'" }], key: _vm.key + 3, ref: "slide-3", attrs: { "robin-users": _vm.$robin_users, "group-name": _vm.groupName, "group-icon": _vm.groupIcon }, on: { "openmodal": function($event) {
    return _vm.openModal("slide-0", $event);
  }, "closemodal": function($event) {
    return _vm.closeModal("slide-3", $event);
  }, "reset-groupname": function($event) {
    return _vm.resetGroupName();
  }, "reset-groupicon": function($event) {
    return _vm.resetGroupIcon();
  } } }), _c("ArchivedChatList", { directives: [{ name: "show", rawName: "v-show", value: _vm.sideBarType == "archivedchat", expression: "sideBarType == 'archivedchat'" }], key: _vm.key + 4, ref: "slide-4", attrs: { "archived-conversations": _vm.archivedConversations }, on: { "closemodal": function($event) {
    return _vm.closeModal("slide-4", $event);
  }, "refresh": _vm.refresh } })], 1);
};
var staticRenderFns$p = [];
var SideContainer_vue_vue_type_style_index_0_scoped_true_lang = "";
const __cssModules$p = {};
var __component__$p = /* @__PURE__ */ normalizeComponent(SideContainer$1, render$p, staticRenderFns$p, false, injectStyles$p, "6b196ca8", null, null);
function injectStyles$p(context2) {
  for (let o in __cssModules$p) {
    this[o] = __cssModules$p[o];
  }
}
var SideContainer = /* @__PURE__ */ function() {
  return __component__$p.exports;
}();
var __defProp$o = Object.defineProperty;
var __getOwnPropDesc$o = Object.getOwnPropertyDescriptor;
var __decorateClass$o = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$o(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$o(target, key, result);
  return result;
};
const ComponentProps$e = Vue$1.extend({
  props: {
    color: {
      type: String,
      default: "#535F89"
    },
    focusColor: {
      type: String,
      default: "rgba(21, 174, 115, 0.1)"
    }
  }
});
let OptionButton$1 = class extends ComponentProps$e {
  constructor() {
    super(...arguments);
    this.root = null;
  }
  mounted() {
    this.root = document.documentElement;
    this.setRootVariables();
  }
  setRootVariables() {
    this.root.style.setProperty("--primary-focus-color", this.focusColor);
  }
  emitClickAway() {
    this.$emit("clickoutside");
  }
};
OptionButton$1 = __decorateClass$o([
  Component({
    name: "OptionButton",
    mixins: [mixin],
    watch: {
      focusColor() {
        this.setRootVariables();
      }
    }
  })
], OptionButton$1);
var render$o = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("button", { directives: [{ name: "on-clickaway", rawName: "v-on-clickaway", value: _vm.emitClickAway, expression: "emitClickAway" }], staticClass: "robin-button", attrs: { "type": "button", "data-testid": "button" }, on: { "click": function($event) {
    return _vm.$emit("open");
  } } }, [_c("svg", { attrs: { "width": "20", "height": "20", "viewBox": "0 0 20 20", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, [_c("path", { attrs: { "d": "M9.99968 5.83333C10.3293 5.83333 10.6515 5.73559 10.9256 5.55245C11.1997 5.36931 11.4133 5.10902 11.5395 4.80447C11.6656 4.49993 11.6986 4.16482 11.6343 3.84152C11.57 3.51822 11.4113 3.22124 11.1782 2.98816C10.9451 2.75507 10.6481 2.59633 10.3248 2.53203C10.0015 2.46772 9.66641 2.50072 9.36187 2.62687C9.05733 2.75301 8.79703 2.96664 8.61389 3.24072C8.43076 3.5148 8.33301 3.83703 8.33301 4.16667C8.33301 4.60869 8.5086 5.03262 8.82116 5.34518C9.13373 5.65774 9.55765 5.83333 9.99968 5.83333ZM9.99968 14.1667C9.67004 14.1667 9.34781 14.2644 9.07373 14.4476C8.79964 14.6307 8.58602 14.891 8.45988 15.1955C8.33373 15.5001 8.30072 15.8352 8.36503 16.1585C8.42934 16.4818 8.58808 16.7788 8.82116 17.0118C9.05425 17.2449 9.35122 17.4037 9.67453 17.468C9.99783 17.5323 10.3329 17.4993 10.6375 17.3731C10.942 17.247 11.2023 17.0334 11.3855 16.7593C11.5686 16.4852 11.6663 16.163 11.6663 15.8333C11.6663 15.3913 11.4907 14.9674 11.1782 14.6548C10.8656 14.3423 10.4417 14.1667 9.99968 14.1667ZM9.99968 8.33333C9.67004 8.33333 9.34781 8.43108 9.07373 8.61422C8.79964 8.79735 8.58602 9.05765 8.45988 9.3622C8.33373 9.66674 8.30072 10.0018 8.36503 10.3252C8.42934 10.6485 8.58808 10.9454 8.82116 11.1785C9.05425 11.4116 9.35122 11.5703 9.67453 11.6346C9.99783 11.699 10.3329 11.6659 10.6375 11.5398C10.942 11.4137 11.2023 11.2 11.3855 10.926C11.5686 10.6519 11.6663 10.3296 11.6663 10C11.6663 9.55797 11.4907 9.13405 11.1782 8.82149C10.8656 8.50893 10.4417 8.33333 9.99968 8.33333Z", "fill": _vm.color } })])]);
};
var staticRenderFns$o = [];
var OptionButton_vue_vue_type_style_index_0_scoped_true_lang = "";
const __cssModules$o = {};
var __component__$o = /* @__PURE__ */ normalizeComponent(OptionButton$1, render$o, staticRenderFns$o, false, injectStyles$o, "4321f986", null, null);
function injectStyles$o(context2) {
  for (let o in __cssModules$o) {
    this[o] = __cssModules$o[o];
  }
}
var OptionButton = /* @__PURE__ */ function() {
  return __component__$o.exports;
}();
var __defProp$n = Object.defineProperty;
var __getOwnPropDesc$n = Object.getOwnPropertyDescriptor;
var __decorateClass$n = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$n(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$n(target, key, result);
  return result;
};
let GroupMessagePopOver$1 = class extends Vue$1 {
  handleSelectMessages() {
    store.setState("selectMessagesOpen", true);
  }
  async handleLeaveGroup() {
    store.setState("exitGroup", true);
  }
};
GroupMessagePopOver$1 = __decorateClass$n([
  Component({
    name: "GroupMessagePopOver",
    components: {
      Content,
      SvgIcon
    }
  })
], GroupMessagePopOver$1);
var render$n = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { ref: "popup-body", staticClass: "robin-popup robin-zoomIn" }, [_c("div", { staticClass: "robin-wrapper robin-w-100", attrs: { "data-testid": "view-group-profile" }, on: { "click": function($event) {
    return _vm.$emit("view-group-profile");
  } } }, [_c("Content", { attrs: { "font-size": 14, "as": "span", "color": "#51545C" } }, [_vm._v("Group Info")]), _c("SvgIcon", { attrs: { "name": "user-circle" } })], 1), _c("div", { staticClass: "robin-wrapper robin-w-100", on: { "click": function($event) {
    return _vm.handleSelectMessages();
  } } }, [_c("Content", { attrs: { "font-size": 14, "as": "span", "color": "#51545C" } }, [_vm._v("Select Messages")]), _c("SvgIcon", { attrs: { "name": "check-circle" } })], 1), _c("div", { staticClass: "robin-wrapper robin-w-100", on: { "click": function($event) {
    return _vm.handleLeaveGroup();
  } } }, [_c("Content", { attrs: { "font-size": 14, "as": "span", "color": "#51545C" } }, [_vm._v("Leave Group")]), _c("SvgIcon", { attrs: { "name": "times-square" } })], 1)]);
};
var staticRenderFns$n = [];
var GroupMessagePopOver_vue_vue_type_style_index_0_scoped_true_lang = "";
const __cssModules$n = {};
var __component__$n = /* @__PURE__ */ normalizeComponent(GroupMessagePopOver$1, render$n, staticRenderFns$n, false, injectStyles$n, "516aa140", null, null);
function injectStyles$n(context2) {
  for (let o in __cssModules$n) {
    this[o] = __cssModules$n[o];
  }
}
var GroupMessagePopOver = /* @__PURE__ */ function() {
  return __component__$n.exports;
}();
var __defProp$m = Object.defineProperty;
var __getOwnPropDesc$m = Object.getOwnPropertyDescriptor;
var __decorateClass$m = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$m(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$m(target, key, result);
  return result;
};
let PersonalMessagePopOver$1 = class extends Vue$1 {
  get isDeleteMessagesEnabled() {
    return store.state.deleteMessagesEnabled;
  }
  get isForwardMessagesEnabled() {
    return store.state.forwardMessagesEnabled;
  }
  handleSelectMessages() {
    store.setState("selectMessagesOpen", true);
  }
  handleClearMessages() {
    store.setState("clearMessages", true);
  }
};
PersonalMessagePopOver$1 = __decorateClass$m([
  Component({
    name: "PersonalMessagePopOverr",
    components: {
      Content,
      SvgIcon
    }
  })
], PersonalMessagePopOver$1);
var render$m = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { ref: "popup-body", staticClass: "robin-popup robin-zoomIn" }, [_c("div", { staticClass: "robin-wrapper robin-w-100", on: { "click": function($event) {
    return _vm.$emit("view-profile");
  } } }, [_c("Content", { attrs: { "font-size": 14, "color": "#51545C" } }, [_vm._v("Contact Info")]), _c("SvgIcon", { attrs: { "name": "user-circle" } })], 1), _vm.isForwardMessagesEnabled || _vm.isDeleteMessagesEnabled || _vm.isForwardMessagesEnabled && _vm.isDeleteMessagesEnabled ? _c("div", { staticClass: "robin-wrapper robin-w-100", on: { "click": function($event) {
    return _vm.handleSelectMessages();
  } } }, [_c("Content", { attrs: { "font-size": 14, "color": "#51545C" } }, [_vm._v("Select Messages")]), _c("SvgIcon", { attrs: { "name": "check-circle" } })], 1) : _vm._e(), _vm.isDeleteMessagesEnabled ? _c("div", { staticClass: "robin-wrapper robin-w-100", on: { "click": function($event) {
    return _vm.handleClearMessages();
  } } }, [_c("Content", { attrs: { "font-size": 14, "color": "#51545C" } }, [_vm._v("Delete Chat")]), _c("SvgIcon", { attrs: { "name": "trash" } })], 1) : _vm._e()]);
};
var staticRenderFns$m = [];
var PersonalMessagePopOver_vue_vue_type_style_index_0_scoped_true_lang = "";
const __cssModules$m = {};
var __component__$m = /* @__PURE__ */ normalizeComponent(PersonalMessagePopOver$1, render$m, staticRenderFns$m, false, injectStyles$m, "79816b5f", null, null);
function injectStyles$m(context2) {
  for (let o in __cssModules$m) {
    this[o] = __cssModules$m[o];
  }
}
var PersonalMessagePopOver = /* @__PURE__ */ function() {
  return __component__$m.exports;
}();
var __defProp$l = Object.defineProperty;
var __getOwnPropDesc$l = Object.getOwnPropertyDescriptor;
var __decorateClass$l = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$l(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$l(target, key, result);
  return result;
};
const ComponentProps$d = Vue$1.extend({
  props: {
    conversation: {
      type: Object,
      default: () => ({})
    },
    selectedMessages: {
      type: Array,
      default: () => []
    }
  }
});
let ChatHeader$1 = class extends ComponentProps$d {
  constructor() {
    super(...arguments);
    this.screenWidth = 0;
    this.avatarKey = 0;
    this.popUpState = {
      opened: false
    };
  }
  created() {
    this.handleUserConnect();
    this.handleUserDisconnect();
  }
  mounted() {
    this.$nextTick(function() {
      this.onResize();
    });
    window.addEventListener("resize", this.onResize);
  }
  get profileOpen() {
    return store.state.profileOpen;
  }
  get selectMessagesOpen() {
    return store.state.selectMessagesOpen;
  }
  get isDeleteMessagesEnabled() {
    return store.state.deleteMessagesEnabled;
  }
  get isForwardMessagesEnabled() {
    return store.state.forwardMessagesEnabled;
  }
  get showDefaultProfileDetails() {
    return store.state.useDefaultProfileDetails;
  }
  handleOpenPopUp(event, refKey) {
    const popupContainer = this.$refs["popup-container"];
    const popup = this.$refs[refKey];
    popup.$refs["popup-body"].classList.remove("robin-zoomOut");
    if (!this.profileOpen) {
      popupContainer.style.right = Math.floor(event.clientX / 26) + "px";
    } else {
      popupContainer.style.right = Math.floor(event.clientX / 2.47) + "px";
    }
    this.popUpState.opened = true;
  }
  handleClosePopUp(refKey) {
    const popup = this.$refs[refKey];
    popup.$refs["popup-body"].classList.remove("robin-zoomIn");
    popup.$refs["popup-body"].classList.add("robin-zoomOut");
    window.setTimeout(() => {
      if (popup.$refs["popup-body"]) {
        popup.$refs["popup-body"].classList.add("robin-zoomIn");
        popup.$refs["popup-body"].classList.remove("robin-zoomOut");
      }
      this.popUpState.opened = false;
    }, 300);
  }
  handleUserConnect() {
    EventBus.$on("user.connect", (conversation) => {
      if (conversation !== this.$user_token) {
        this.conversation.status = "online";
      }
    });
  }
  getProfileImage(conversation) {
    const index = this.$robin_users.findIndex((user) => user.userToken === conversation.sender_token);
    return this.$robin_users[index] ? this.$robin_users[index].profileImage : null;
  }
  handleUserDisconnect() {
    EventBus.$on("user.disconnect", (conversation) => {
      if (conversation !== this.$user_token) {
        this.conversation.status = "offline";
      }
    });
  }
  openProfile() {
    if (this.showDefaultProfileDetails) {
      store.setState("profileOpen", true);
    } else {
      EventBus.$emit("open-profile");
    }
  }
  cancelSelect() {
    store.setState("selectMessagesOpen", false);
  }
  deleteSelectedMessages() {
    this.$emit("delete-selected-messages");
  }
  onResize() {
    this.screenWidth = window.innerWidth;
  }
  back() {
    EventBus.$emit("left.message");
  }
};
ChatHeader$1 = __decorateClass$l([
  Component({
    name: "ChatHeader",
    components: {
      IconButton,
      GroupAvatar,
      Content,
      Button,
      OptionButton,
      Avatar,
      GroupMessagePopOver,
      PersonalMessagePopOver
    },
    watch: {
      $robin_users: {
        handler(val) {
          this.avatarKey += 1;
        }
      }
    }
  })
], ChatHeader$1);
var render$l = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("header", [_c("div", { directives: [{ name: "show", rawName: "v-show", value: !_vm.selectMessagesOpen, expression: "!selectMessagesOpen" }], staticClass: "robin-card-container robin-flex robin-flex-align-center" }, [_c("IconButton", { directives: [{ name: "show", rawName: "v-show", value: _vm.screenWidth <= 1200, expression: "screenWidth <= 1200" }], attrs: { "name": "back", "to-emit": true, "to-click-away": false, "emit": "clicked" }, on: { "clicked": function($event) {
    return _vm.back();
  } } }), _c("div", { staticClass: "robin-flex robin-flex-align-center robin-clickable", on: { "click": function($event) {
    return _vm.openProfile();
  } } }, [_c("div", { staticClass: "robin-card-info robin-mr-8" }, [_vm.conversation.is_group ? _c("GroupAvatar", { attrs: { "img-url": _vm.conversation.group_icon } }) : _c("Avatar", { key: _vm.avatarKey, attrs: { "img-url": _vm.getProfileImage(_vm.conversation) || _vm.conversation.display_photo, "robin-users": _vm.$robin_users, "sender-token": _vm.conversation.sender_token === _vm.$user_token ? _vm.conversation.receiver_token : _vm.conversation.sender_token } })], 1), _c("div", { staticClass: "robin-card-info robin-h-100 robin-flex robin-flex-column robin-flex-space-between robin-flex-1" }, [_c("div", { staticClass: "robin-mt-6" }, [!_vm.conversation.is_group ? _c("Content", { attrs: { "font-weight": "normal", "color": "#000000", "font-size": 14, "line-height": 24 } }, [_vm._v(" " + _vm._s(_vm.conversation.sender_token != _vm.$user_token ? _vm.conversation.sender_name : _vm.conversation.receiver_name) + " ")]) : _c("Content", { attrs: { "font-weight": "normal", "color": "#000000", "font-size": 14, "line-height": 24 } }, [_vm._v(" " + _vm._s(_vm.conversation.name) + " ")])], 1), _c("div", { staticClass: "robin-mt-6" })])])], 1), _c("div", { directives: [{ name: "show", rawName: "v-show", value: _vm.selectMessagesOpen && _vm.isForwardMessagesEnabled || _vm.selectMessagesOpen && _vm.isDeleteMessagesEnabled || _vm.isForwardMessagesEnabled && _vm.isDeleteMessagesEnabled && _vm.selectMessagesOpen, expression: "(selectMessagesOpen && isForwardMessagesEnabled) || (selectMessagesOpen && isDeleteMessagesEnabled) || (isForwardMessagesEnabled && isDeleteMessagesEnabled && selectMessagesOpen)" }], staticClass: "robin-flex robin-robin-flex-align-center" }, [_c("IconButton", { attrs: { "name": "remove", "to-emit": true, "to-click-away": false, "emit": "close" }, on: { "close": function($event) {
    return _vm.cancelSelect();
  } } }), _c("Button", { staticClass: "robin-ml-5", attrs: { "color": "#000", "emit": "clicked" }, on: { "clicked": function($event) {
    return _vm.cancelSelect();
  } } }, [_vm._v("Select Messages")])], 1), _vm.selectMessagesOpen && _vm.isDeleteMessagesEnabled && _vm.selectedMessages.length > 0 ? _c("IconButton", { staticClass: "robin-ml-auto", attrs: { "name": "trash", "to-emit": true, "to-click-away": false, "emit": "delete", "data-testid": "delete-button" }, on: { "delete": function($event) {
    return _vm.deleteSelectedMessages();
  } } }) : _vm._e(), _c("div", { directives: [{ name: "show", rawName: "v-show", value: !_vm.selectMessagesOpen, expression: "!selectMessagesOpen" }], staticClass: "robin-options robin-ml-auto", on: { "click": function($event) {
    return _vm.handleOpenPopUp($event, _vm.conversation.is_group ? "popup-1" : "popup-2");
  } } }, [_c("IconButton", { attrs: { "to-click-away": true, "to-emit": false, "name": "openModalDot" }, on: { "clickoutside": function($event) {
    return _vm.handleClosePopUp(_vm.conversation.is_group ? "popup-1" : "popup-2");
  } } }), _c("div", { directives: [{ name: "show", rawName: "v-show", value: _vm.popUpState.opened && !_vm.selectMessagesOpen, expression: "popUpState.opened && !selectMessagesOpen" }], ref: "popup-container", staticClass: "robin-popup-container" }, [_c("GroupMessagePopOver", { directives: [{ name: "show", rawName: "v-show", value: _vm.conversation.is_group, expression: "conversation.is_group" }], ref: "popup-1", on: { "view-group-profile": function($event) {
    return _vm.openProfile();
  } } }), _c("PersonalMessagePopOver", { directives: [{ name: "show", rawName: "v-show", value: !_vm.conversation.is_group, expression: "!conversation.is_group" }], ref: "popup-2", on: { "view-profile": function($event) {
    return _vm.openProfile();
  } } })], 1)], 1)], 1);
};
var staticRenderFns$l = [];
var ChatHeader_vue_vue_type_style_index_0_scoped_true_lang = "";
const __cssModules$l = {};
var __component__$l = /* @__PURE__ */ normalizeComponent(ChatHeader$1, render$l, staticRenderFns$l, false, injectStyles$l, "73b673b3", null, null);
function injectStyles$l(context2) {
  for (let o in __cssModules$l) {
    this[o] = __cssModules$l[o];
  }
}
var ChatHeader = /* @__PURE__ */ function() {
  return __component__$l.exports;
}();
var waveEncoder = () => {
  let BYTES_PER_SAMPLE = 2;
  let recorded = [];
  function encode(buffer) {
    let length = buffer.length;
    let data = new Uint8Array(length * BYTES_PER_SAMPLE);
    for (let i = 0; i < length; i++) {
      let index = i * BYTES_PER_SAMPLE;
      let sample = buffer[i];
      if (sample > 1) {
        sample = 1;
      } else if (sample < -1) {
        sample = -1;
      }
      sample = sample * 32768;
      data[index] = sample;
      data[index + 1] = sample >> 8;
    }
    recorded.push(data);
  }
  function dump(sampleRate) {
    let bufferLength = recorded.length ? recorded[0].length : 0;
    let length = recorded.length * bufferLength;
    let wav = new Uint8Array(44 + length);
    let view = new DataView(wav.buffer);
    view.setUint32(0, 1380533830, false);
    view.setUint32(4, 36 + length, true);
    view.setUint32(8, 1463899717, false);
    view.setUint32(12, 1718449184, false);
    view.setUint32(16, 16, true);
    view.setUint16(20, 1, true);
    view.setUint16(22, 1, true);
    view.setUint32(24, sampleRate, true);
    view.setUint32(28, sampleRate * BYTES_PER_SAMPLE, true);
    view.setUint16(32, BYTES_PER_SAMPLE, true);
    view.setUint16(34, 8 * BYTES_PER_SAMPLE, true);
    view.setUint32(36, 1684108385, false);
    view.setUint32(40, length, true);
    for (let i = 0; i < recorded.length; i++) {
      wav.set(recorded[i], i * bufferLength + 44);
    }
    recorded = [];
    postMessage(wav.buffer, [wav.buffer]);
  }
  onmessage = (e2) => {
    if (e2.data[0] === "encode") {
      encode(e2.data[1]);
    } else if (e2.data[0] === "dump") {
      dump(e2.data[1]);
    }
  };
};
let AudioContext = window.AudioContext || window.webkitAudioContext;
let createWorker = (fn) => {
  let js = fn.toString().replace(/^(\(\)\s*=>|function\s*\(\))\s*{/, "").replace(/}$/, "");
  let blob = new Blob([js]);
  return new Worker(URL.createObjectURL(blob));
};
let error = (method) => {
  let event = new Event("error");
  event.data = new Error("Wrong state for " + method);
  return event;
};
let context;
class MediaRecorder$1 {
  constructor(stream, config = null) {
    this.stream = stream;
    this.config = config;
    this.state = "inactive";
    this.em = document.createDocumentFragment();
    this.encoder = createWorker(MediaRecorder$1.encoder);
    let recorder = this;
    this.encoder.addEventListener("message", (e2) => {
      let event = new Event("dataavailable");
      event.data = new Blob([e2.data], { type: recorder.mimeType });
      recorder.em.dispatchEvent(event);
      if (recorder.state === "inactive") {
        recorder.em.dispatchEvent(new Event("stop"));
      }
    });
  }
  start(timeslice) {
    if (this.state !== "inactive") {
      return this.em.dispatchEvent(error("start"));
    }
    this.state = "recording";
    if (!context) {
      context = new AudioContext(this.config);
    }
    this.clone = this.stream.clone();
    this.input = context.createMediaStreamSource(this.clone);
    this.processor = context.createScriptProcessor(2048, 1, 1);
    this.encoder.postMessage(["init", context.sampleRate]);
    this.processor.onaudioprocess = (e2) => {
      if (this.state === "recording") {
        this.encoder.postMessage(["encode", e2.inputBuffer.getChannelData(0)]);
      }
    };
    this.input.connect(this.processor);
    this.processor.connect(context.destination);
    this.em.dispatchEvent(new Event("start"));
    if (timeslice) {
      this.slicing = setInterval(() => {
        if (this.state === "recording")
          this.requestData();
      }, timeslice);
    }
    return void 0;
  }
  stop() {
    if (this.state === "inactive") {
      return this.em.dispatchEvent(error("stop"));
    }
    this.requestData();
    this.state = "inactive";
    this.clone.getTracks().forEach((track) => {
      track.stop();
    });
    this.processor.disconnect();
    this.input.disconnect();
    return clearInterval(this.slicing);
  }
  pause() {
    if (this.state !== "recording") {
      return this.em.dispatchEvent(error("pause"));
    }
    this.state = "paused";
    return this.em.dispatchEvent(new Event("pause"));
  }
  resume() {
    if (this.state !== "paused") {
      return this.em.dispatchEvent(error("resume"));
    }
    this.state = "recording";
    return this.em.dispatchEvent(new Event("resume"));
  }
  requestData() {
    if (this.state === "inactive") {
      return this.em.dispatchEvent(error("requestData"));
    }
    return this.encoder.postMessage(["dump", context.sampleRate]);
  }
  addEventListener(...args) {
    this.em.addEventListener(...args);
  }
  removeEventListener(...args) {
    this.em.removeEventListener(...args);
  }
  dispatchEvent(...args) {
    this.em.dispatchEvent(...args);
  }
}
MediaRecorder$1.prototype.mimeType = "audio/wav";
MediaRecorder$1.isTypeSupported = (mimeType) => {
  return MediaRecorder$1.prototype.mimeType === mimeType;
};
MediaRecorder$1.notSupported = !navigator.mediaDevices || !AudioContext;
MediaRecorder$1.encoder = waveEncoder;
var mpegEncoder = () => {
  importScripts("https://cdnjs.cloudflare.com/ajax/libs/lamejs/1.2.0/lame.min.js");
  let CHANNELS = 1;
  let KBPS = 128;
  let DEFAULT_SAMPLE_RATE = 44100;
  let encoder;
  let recorded = new Int8Array();
  function concat(a, b) {
    if (b.length === 0) {
      return a;
    }
    let c = new Int8Array(a.length + b.length);
    c.set(a);
    c.set(b, a.length);
    return c;
  }
  function init(sampleRate) {
    encoder = new lamejs.Mp3Encoder(CHANNELS, sampleRate || DEFAULT_SAMPLE_RATE, KBPS);
  }
  function encode(buffer) {
    for (let i = 0; i < buffer.length; i++) {
      buffer[i] = buffer[i] * 32767.5;
    }
    let buf = encoder.encodeBuffer(buffer);
    recorded = concat(recorded, buf);
  }
  function dump() {
    let buf = encoder.flush();
    recorded = concat(recorded, buf);
    let buffer = recorded.buffer;
    recorded = new Int8Array();
    postMessage(buffer, [buffer]);
  }
  onmessage = (e2) => {
    if (e2.data[0] === "init") {
      init(e2.data[1]);
    } else if (e2.data[0] === "encode") {
      encode(e2.data[1]);
    } else {
      dump(e2.data[1]);
    }
  };
};
var __defProp$k = Object.defineProperty;
var __getOwnPropDesc$k = Object.getOwnPropertyDescriptor;
var __decorateClass$k = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$k(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$k(target, key, result);
  return result;
};
let AttachFilePopOver$1 = class extends Vue$1 {
  constructor() {
    super(...arguments);
    this.acceptedDocFiles = "application/*, text/*";
    this.acceptedVisualFiles = "image/*, video/*";
    this.screenWidth = 0;
  }
  mounted() {
    this.$nextTick(function() {
      this.onResize();
    });
    window.addEventListener("resize", this.onResize);
  }
  resetFileTarget(event) {
    event.target.value = "";
  }
  handleFileChange(files) {
    [...files].forEach((file) => {
      const fileURL = URL.createObjectURL(file);
      const typeIndex = file.name.lastIndexOf(".");
      if (file.size < 5000001) {
        this.$emit("file-upload", {
          name: file.name.substring(0, typeIndex),
          size: file.size,
          type: file.type,
          extension: file.name.substring(typeIndex + 1),
          localUrl: fileURL,
          file
        });
      } else {
        this.$toast.open({
          message: "Image upload cannot be more than 5mb",
          type: "error",
          position: "bottom-left"
        });
      }
    });
  }
  onResize() {
    this.screenWidth = window.innerWidth;
  }
};
AttachFilePopOver$1 = __decorateClass$k([
  Component({
    name: "AttachFilePopOver",
    components: {
      Content,
      IconButton
    }
  })
], AttachFilePopOver$1);
var render$k = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { ref: "popup-body", staticClass: "robin-popup robin-zoomIn" }, [_vm.screenWidth > 1024 ? _c("Content", { staticClass: "robin-wrapper robin-w-100", attrs: { "max-width": "100%", "font-size": 14, "color": "#51545C", "as": "label", "for-ref": "camera-upload" }, nativeOn: { "click": function($event) {
    return _vm.$emit("open-camera");
  } } }, [_vm._v(" Camera "), _c("IconButton", { staticClass: "robin-ml-auto", attrs: { "name": "photo", "to-emit": false, "to-click-away": false } })], 1) : _c("Content", { staticClass: "robin-wrapper robin-w-100", attrs: { "max-width": "100%", "font-size": 14, "color": "#51545C", "as": "label", "for-ref": "camera-upload" } }, [_c("input", { style: { display: "none" }, attrs: { "type": "file", "accept": "image/*", "capture": "environment", "id": "camera-upload" }, on: { "change": function($event) {
    return _vm.handleFileChange($event.target.files);
  }, "click": function($event) {
    return _vm.resetFileTarget($event);
  } } }), _vm._v(" Camera "), _c("IconButton", { staticClass: "robin-ml-auto", attrs: { "name": "photo", "to-emit": false, "to-click-away": false } })], 1), _c("Content", { ref: "photo-upload", staticClass: "robin-wrapper robin-w-100", attrs: { "max-width": "100%", "as": "label", "font-size": 14, "color": "#51545C", "for-ref": "photo-upload" } }, [_c("input", { style: { display: "none" }, attrs: { "type": "file", "multiple": "", "accept": _vm.acceptedVisualFiles, "id": "photo-upload" }, on: { "change": function($event) {
    return _vm.handleFileChange($event.target.files);
  }, "click": function($event) {
    return _vm.resetFileTarget($event);
  } } }), _vm._v(" Photos & Videos "), _c("IconButton", { staticClass: "robin-ml-auto", attrs: { "name": "gallery", "emit": "clicked", "to-emit": false, "to-click-away": false } })], 1), _c("Content", { ref: "document-upload", staticClass: "robin-wrapper robin-w-100", attrs: { "as": "label", "for-ref": "document-upload", "font-size": 14, "max-width": "100%", "color": "#51545C" } }, [_c("input", { style: { display: "none" }, attrs: { "type": "file", "multiple": "", "accept": _vm.acceptedDocFiles, "id": "document-upload" }, on: { "change": function($event) {
    return _vm.handleFileChange($event.target.files);
  }, "click": function($event) {
    return _vm.resetFileTarget($event);
  } } }), _vm._v(" Document "), _c("IconButton", { staticClass: "robin-ml-auto", attrs: { "name": "document", "emit": "clicked", "to-emit": false, "to-click-away": false } })], 1)], 1);
};
var staticRenderFns$k = [];
var AttachFilePopOver_vue_vue_type_style_index_0_scoped_true_lang = "";
const __cssModules$k = {};
var __component__$k = /* @__PURE__ */ normalizeComponent(AttachFilePopOver$1, render$k, staticRenderFns$k, false, injectStyles$k, "8bab9c92", null, null);
function injectStyles$k(context2) {
  for (let o in __cssModules$k) {
    this[o] = __cssModules$k[o];
  }
}
var AttachFilePopOver = /* @__PURE__ */ function() {
  return __component__$k.exports;
}();
var __defProp$j = Object.defineProperty;
var __getOwnPropDesc$j = Object.getOwnPropertyDescriptor;
var __decorateClass$j = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$j(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$j(target, key, result);
  return result;
};
const ComponentProps$c = Vue$1.extend({
  props: {
    conversation: {
      type: Object,
      default: () => {
      }
    },
    capturedImage: {
      type: Object,
      default: () => {
      }
    },
    messageReply: {
      type: Object,
      default: () => {
      }
    }
  }
});
let MessageInputBar$1 = class extends ComponentProps$c {
  constructor() {
    super(...arguments);
    this.text = "";
    this.files = [];
    this.acceptedDocFiles = "application/*, text/*";
    this.isUploading = false;
    this.replying = false;
    this.screenWidth = 0;
    this.currentTime = "00:00";
    this.elapsedTimer = null;
    this.recorder = null;
    this.isRecording = false;
    this.sendRecording = false;
    this.imageRegex = /^image/;
    this.emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    this.websiteRegex = /[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)/;
    this.videoRegex = /^video/;
    this.popUpState = {
      opened: false,
      emojiOpened: false
    };
  }
  mounted() {
    this.handleConversationOpen();
    this.$nextTick(function() {
      this.onResize();
    });
    window.addEventListener("resize", this.onResize);
    this.resetState();
    this.focusInput();
  }
  get isVoiceRecorderEnabled() {
    return store.state.voiceRecorderEnabled;
  }
  get checkFileFormat() {
    return this.files.some((file) => file.type.includes("image"));
  }
  get currentConversation() {
    return store.state.currentConversation;
  }
  getElapsedTime(startTime) {
    const endTime = new Date();
    let timeDiff = endTime - startTime;
    timeDiff = timeDiff / 1e3;
    let seconds = Math.floor(timeDiff % 60);
    seconds = seconds < 10 ? "0" + seconds : seconds;
    timeDiff = Math.floor(timeDiff / 60);
    let minutes = timeDiff % 60;
    minutes = minutes < 10 ? "0" + minutes : minutes;
    timeDiff = Math.floor(timeDiff / 60);
    const hours = timeDiff % 24;
    timeDiff = Math.floor(timeDiff / 24);
    const days = timeDiff;
    let totalHours = hours + days * 24;
    totalHours = totalHours < 10 ? "0" + totalHours : totalHours;
    if (totalHours === "00") {
      this.currentTime = minutes + ":" + seconds;
    } else {
      this.currentTime = totalHours + ":" + minutes + ":" + seconds;
    }
  }
  resetState() {
    const input = this.$refs.input;
    input.value = "";
    input.style.height = 0;
    this.text = "";
    this.files = [];
    this.isUploading = false;
    this.replying = false;
    this.popUpState.emojiOpened = false;
    this.recorder = null;
    this.isRecording = false;
    this.currentTime = "00:00";
    this.sendRecording = false;
  }
  send(event) {
    if (this.screenWidth <= 1024 && event && event.keyCode === 13) {
      this.newLine();
      this.calculateTextareaHeight();
      this.calculateTextareaHeight();
    } else {
      if (!this.replying && !this.isUploading) {
        this.sendMessage();
      }
      if (this.replying && !this.isUploading) {
        this.replyMessage();
      }
      if (!this.replying && !this.isUploading && this.isRecording) {
        this.sendRecording = true;
        this.stopRecorder();
      }
    }
  }
  sendMessage() {
    if (this.files.length > 0 && this.text.trim().length === 0) {
      this.sendFileMessage();
    } else if (this.text.trim().length > 0 && this.files.length < 1) {
      this.sendTextMessage();
    } else if (this.text.trim().length > 0 && this.files.length > 1) {
      Promise.all([this.sendTextMessage(), this.sendFileMessage()]);
    } else if (this.text.trim().length > 0 && this.files.length === 1) {
      this.sendMessageWithAttachment();
    }
  }
  async replyMessage() {
    if (this.files.length > 0 && this.text.trim().length === 0) {
      this.replyFileMessage();
    } else if (this.text.trim().length > 0 && this.files.length < 1) {
      this.replyTextMessage();
    } else if (this.text.trim().length > 0 && this.files.length > 1) {
      Promise.all([this.replyTextMessage(), this.replyFileMessage()]);
    } else if (this.text.trim().length > 0 && this.files.length === 1) {
      this.replyMessageWithAttachment();
    }
  }
  async sendTextMessage() {
    this.isUploading = true;
    try {
      const message = {
        msg: this.text,
        sender_token: this.$user_token,
        receiver_token: this.conversation.receiver_token === this.$user_token ? this.conversation.sender_token : this.conversation.receiver_token,
        timestamp: new Date()
      };
      await this.$robin.sendMessageToConversation(__spreadValues({}, message), this.$conn, this.$channel, this.conversation._id, this.$user_token, this.$senderName);
      this.resetState();
    } catch (e2) {
      this.isUploading = false;
      this.$toast.open({
        message: "Check your connection.",
        type: "error",
        position: "bottom-left"
      });
    }
  }
  async sendFileMessage() {
    this.isUploading = true;
    try {
      await Promise.all(this.files.map(async (file) => {
        await this.$robin.sendMessageAttachment(this.$user_token, this.conversation._id, file.file, this.$senderName, "");
      }));
      this.resetState();
    } catch (e2) {
      this.isUploading = false;
      this.$toast.open({
        message: "Check your connection.",
        type: "error",
        position: "bottom-left"
      });
    }
  }
  async sendMessageWithAttachment() {
    this.isUploading = true;
    try {
      await Promise.all(this.files.map(async (file) => {
        await this.$robin.sendMessageAttachment(this.$user_token, this.conversation._id, file.file, this.$senderName, this.text);
      }));
      this.resetState();
    } catch (e2) {
      this.isUploading = false;
      this.$toast.open({
        message: "Check your connection.",
        type: "error",
        position: "bottom-left"
      });
    }
  }
  async replyTextMessage() {
    this.isUploading = true;
    try {
      const robin = this.$robin;
      const message = {
        msg: this.text,
        sender_token: this.$user_token,
        receiver_token: this.conversation.receiver_token === this.$user_token ? this.conversation.sender_token : this.conversation.receiver_token,
        timestamp: new Date()
      };
      await robin.replyToMessage(__spreadValues({}, message), this.$conn, this.$channel, this.conversation._id, this.messageReply._id, this.$user_token, this.$senderName);
      this.resetState();
    } catch (e2) {
      this.isUploading = false;
      this.$toast.open({
        message: "Check your connection.",
        type: "error",
        position: "bottom-left"
      });
    }
  }
  async replyFileMessage() {
    this.isUploading = true;
    try {
      const robin = this.$robin;
      await Promise.all(this.files.map(async (file) => {
        await robin.replyMessageWithAttachment(this.$user_token, this.conversation._id, this.messageReply._id, file.file, this.$senderName);
      }));
      this.resetState();
    } catch (e2) {
      this.isUploading = false;
      this.$toast.open({
        message: "Check your connection.",
        type: "error",
        position: "bottom-left"
      });
    }
  }
  async replyMessageWithAttachment() {
    this.isUploading = true;
    try {
      const robin = this.$robin;
      await Promise.all(this.files.map(async (file) => {
        await robin.replyMessageWithAttachment(this.$user_token, this.conversation._id, this.messageReply._id, file.file, this.$senderName, this.text);
      }));
      this.resetState();
    } catch (e2) {
      this.isUploading = false;
      this.$toast.open({
        message: "Check your connection.",
        type: "error",
        position: "bottom-left"
      });
    }
  }
  enterText(event) {
    this.text = event.target.value;
    this.calculateTextareaHeight();
  }
  escapeText() {
    const input = this.$refs.input;
    input.value = "";
    this.text = "";
    input.style.height = 0;
  }
  selectEmoji(emoji) {
    if (this.text.length > 0)
      this.text += ` ${emoji.data}`;
    else
      this.text += `${emoji.data}`;
    this.focusInput();
  }
  focusInput() {
    const input = this.$refs.input;
    if (input) {
      input.focus();
    }
  }
  handleEmojiOpenPopUp() {
    const popup = this.$refs["popup-1"];
    popup.classList.remove("robin-squeezeIn");
    this.popUpState.emojiOpened = true;
  }
  handleEmojiClosePopUp() {
    const popup = this.$refs["popup-1"];
    popup.classList.remove("robin-squeezeOut");
    popup.classList.add("robin-squeezeIn");
    window.setTimeout(() => {
      popup.classList.remove("robin-squeezeIn");
      popup.classList.add("robin-squeezeOut");
      this.popUpState.emojiOpened = false;
    }, 100);
  }
  toggleAttachFilePopup() {
    this.popUpState.opened = !this.popUpState.opened;
  }
  handleClosePopUp() {
    const popup = this.$refs["popup-4"];
    popup.$refs["popup-body"].classList.remove("robin-zoomIn");
    popup.$refs["popup-body"].classList.add("robin-zoomOut");
    window.setTimeout(() => {
      popup.$refs["popup-body"].classList.add("robin-zoomIn");
      popup.$refs["popup-body"].classList.remove("robin-zoomOut");
      this.popUpState.opened = false;
    }, 300);
  }
  handleFileUpload(file) {
    this.files.push(file);
    this.recorder = null;
  }
  handleFileUploadClose() {
    const popup = this.$refs["popup-2"];
    popup.classList.remove("robin-squeezeOut");
    popup.classList.add("robin-squeezeIn");
    window.setTimeout(() => {
      popup.classList.remove("robin-squeezeIn");
      popup.classList.add("robin-squeezeOut");
      this.files = [];
    }, 100);
  }
  removeFile(index) {
    if (this.files.length > 1) {
      this.files.splice(index, 1);
    } else {
      const popup = this.$refs["popup-2"];
      popup.classList.remove("robin-squeezeOut");
      popup.classList.add("robin-squeezeIn");
      window.setTimeout(() => {
        popup.classList.remove("robin-squeezeIn");
        popup.classList.add("robin-squeezeOut");
        this.files = [];
      }, 100);
    }
  }
  handleReplyMessageClose() {
    const popup = this.$refs["popup-3"];
    popup.classList.remove("robin-squeezeOut");
    popup.classList.add("robin-squeezeIn");
    window.setTimeout(() => {
      popup.classList.remove("robin-squeezeIn");
      popup.classList.add("robin-squeezeOut");
      this.$emit("on-close-reply");
      store.setState("isImageReplying", false);
    }, 100);
  }
  checkAttachmentType(attachmentUrl) {
    const strArr = attachmentUrl.split(".");
    if (mime.getType(strArr[strArr.length - 1]) === "application/msword") {
      return "doc";
    }
    return `${mime.getType(strArr[strArr.length - 1])}`;
  }
  getFileDetails(attachmentUrl) {
    const fileName = attachmentUrl.substring(attachmentUrl.lastIndexOf("/") + 1);
    const strArr = fileName.split(".");
    return {
      name: strArr[strArr.length - 2],
      extension: strArr[strArr.length - 1]
    };
  }
  validateLinkInMessage() {
    const messageReply = this.messageReply.content ? this.messageReply.content.msg : "";
    const texts = messageReply.split(" ");
    return {
      containsWebsite: texts.some((text) => this.websiteRegex.test(text)),
      containsEmail: texts.some((text) => this.emailRegex.test(text))
    };
  }
  injectHtml() {
    let returnedMessage = "";
    const messageReply = this.messageReply.content ? this.messageReply.content.msg : "";
    for (const word of messageReply.split(" ")) {
      if (this.emailRegex.test(word)) {
        returnedMessage += String.raw` <a target="_blank" href="mailto:${word}" > ${word} <a/>`;
      } else if (this.websiteRegex.test(word)) {
        if (word.includes("http://") || word.includes("https://")) {
          returnedMessage += String.raw` <a target="_blank" href="${word}" > ${word} <a/>`;
        } else {
          returnedMessage += String.raw` <a target="_blank" href="http://${word}"> ${word} <a/>`;
        }
      } else {
        returnedMessage += ` ${word}`;
      }
    }
    return returnedMessage;
  }
  handleConversationOpen() {
    EventBus.$on("conversation-opened", (_) => {
      const input = this.$refs.input;
      setTimeout(() => {
        if (input) {
          input.focus();
        }
      }, 50);
    });
  }
  onResize() {
    this.screenWidth = window.innerWidth;
  }
  newLine() {
    const input = this.$refs.input;
    input.value += "\n";
  }
  calculateTextareaHeight() {
    const input = this.$refs.input;
    if (!input)
      return;
    const padding = window.getComputedStyle(input, null).getPropertyValue("padding-top").replace("px", "");
    input.style.height = 0;
    input.style.height = input.scrollHeight - padding * 2 + "px";
    input.style.lineHeight = 1.5;
    if (input.style.height === "12px" || input.style.height === "16px") {
      input.style.lineHeight = 1;
    } else {
      input.style.lineHeight = 1.5;
    }
  }
  createUuid(length) {
    let result = "";
    const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    const charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }
  toggleRecorder(record) {
    if (record) {
      this.startRecorder();
    } else {
      this.stopRecorder();
    }
  }
  startRecorder() {
    MediaRecorder$1.encoder = mpegEncoder;
    MediaRecorder$1.prototype.mimeType = "audio/mpeg";
    window.MediaRecorder = MediaRecorder$1;
    navigator.mediaDevices.getUserMedia({ audio: true }).then((stream) => {
      this.recorder = new MediaRecorder(stream);
      this.recorder.addEventListener("dataavailable", (event) => {
        const file = new File([event.data], `${this.createUuid(30)}.mp3`, {
          type: event.data.type
        });
        this.files.push({
          name: `${this.createUuid(30)}`,
          size: event.data.size,
          type: event.data.type,
          audio: true,
          extension: "mp3",
          localUrl: URL.createObjectURL(event.data),
          file
        });
        if (!this.replying && this.sendRecording)
          this.sendMessage();
        if (this.replying && this.sendRecording)
          this.replyMessage();
        if (!this.sendRecording)
          this.files = [];
      });
      this.recorder.start();
      this.isRecording = true;
      const startTime = new Date();
      this.elapsedTimer = setInterval(() => {
        this.getElapsedTime(startTime);
      }, 1e3);
    });
  }
  stopRecorder() {
    this.recorder.stop();
    clearInterval(this.elapsedTimer);
    this.isRecording = false;
    this.currentTime = "00:00";
    this.recorder.stream.getTracks().forEach((i) => i.stop());
  }
};
MessageInputBar$1 = __decorateClass$j([
  Component({
    name: "MessageInputBar",
    mixins: [mixin],
    components: {
      IconButton,
      AttachFilePopOver,
      VEmojiPicker,
      Content,
      SvgIcon
    },
    watch: {
      capturedImage: function(image) {
        this.files.push({
          name: "captured-image",
          type: "image/jpeg",
          extension: "jpeg",
          localUrl: image.localUrl,
          file: image.file
        });
      },
      messageReply: {
        handler(val) {
          if (Object.keys(this.messageReply).length > 0) {
            this.replying = true;
          } else {
            this.replying = false;
          }
        },
        deep: true
      }
    }
  })
], MessageInputBar$1);
var render$j = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { directives: [{ name: "on-clickaway", rawName: "v-on-clickaway", value: _vm.handleEmojiClosePopUp, expression: "handleEmojiClosePopUp" }], staticClass: "robin-message-box" }, [_c("div", { directives: [{ name: "show", rawName: "v-show", value: _vm.popUpState.emojiOpened, expression: "popUpState.emojiOpened" }], ref: "popup-1", staticClass: "robin-emoji-container robin-emoji-out robin-squeezeOut", attrs: { "tabindex": "1" }, on: { "keydown": function($event) {
    if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) {
      return null;
    }
    if ($event.ctrlKey || $event.shiftKey || $event.altKey || $event.metaKey) {
      return null;
    }
    $event.preventDefault();
    !_vm.replying ? _vm.sendMessage() : _vm.replyMessage();
  } } }, [_c("VEmojiPicker", { staticClass: "robin-emoji", attrs: { "emojisByRow": _vm.screenWidth > 768 ? 15 : 7, "label-search": "Search", "lang": "pt-BR" }, on: { "select": _vm.selectEmoji } })], 1), _c("div", { directives: [{ name: "show", rawName: "v-show", value: _vm.replying, expression: "replying" }], ref: "popup-3", staticClass: "robin-reply-container robin-squeezeOut" }, [_c("div", { staticClass: "robin-wrapper robin-flex robin-flex-1 robin-pt-8 robin-pb-8 robin-pl-24 robin-pr-24 robin-overflow-y-auto" }, [!_vm.messageReply.has_attachment ? _c("div", { staticClass: "robin-reply robin-w-100" }, [!_vm.validateLinkInMessage().containsEmail && !_vm.validateLinkInMessage().containsWebsite ? _c("Content", { attrs: { "font-size": 14, "textWrap": "pre-line", "wordBreak": "break-word", "as": "span" } }, [_vm._v(" " + _vm._s(_vm.messageReply.content ? _vm.messageReply.content.msg : "") + " ")]) : _vm._e(), _vm.validateLinkInMessage().containsEmail && _vm.validateLinkInMessage().containsWebsite || _vm.validateLinkInMessage().containsEmail || _vm.validateLinkInMessage().containsWebsite ? _c("div", { staticClass: "robin-link-container", domProps: { "innerHTML": _vm._s(_vm.injectHtml()) } }) : _vm._e()], 1) : _c("div", { staticClass: "robin-reply robin-w-100" }, [_c("div", { staticClass: "robin-file-upload" }, [_vm.imageRegex.test(_vm.checkAttachmentType(_vm.messageReply.content.attachment)) ? _c("img", { attrs: { "src": _vm.messageReply.content.attachment, "alt": _vm.getFileDetails(_vm.messageReply.content.attachment).name + "-image" } }) : _vm._e(), _vm.videoRegex.test(_vm.checkAttachmentType(_vm.messageReply.content.attachment)) ? _c("div", { staticClass: "robin-video" }, [_c("video", { attrs: { "width": "100%", "height": "100%", "controls": "" } }, [_c("source", { attrs: { "src": _vm.messageReply.content.attachment } }), _vm._v(" Your browser does not support the video tag. ")])]) : _vm._e(), _vm.acceptedDocFiles.includes(_vm.getFileDetails(_vm.messageReply.content.attachment).extension) ? _c("div", { staticClass: "robin-file" }, [_c("SvgIcon", { attrs: { "name": "file" } }), _c("Content", { attrs: { "as": "span" } }, [_vm._v(" " + _vm._s(_vm.getFileDetails(_vm.messageReply.content.attachment).name.length > 6 ? _vm.getFileDetails(_vm.messageReply.content.attachment).name.substring(0, 6) + ".." : _vm.getFileDetails(_vm.messageReply.content.attachment).name) + " ")]), _c("Content", { attrs: { "as": "span" } }, [_vm._v(" " + _vm._s("." + _vm.getFileDetails(_vm.messageReply.content.attachment).extension) + " ")])], 1) : _vm._e()])])]), _c("div", { staticClass: "robin-reply-close" }, [_c("IconButton", { attrs: { "name": "remove", "to-emit": true, "to-click-away": false }, on: { "clicked": _vm.handleReplyMessageClose } })], 1)]), _c("div", { directives: [{ name: "show", rawName: "v-show", value: _vm.files && _vm.files.length > 0 && !_vm.recorder, expression: "files && files.length > 0 && !recorder" }], ref: "popup-2", staticClass: "robin-file-upload-container robin-squeezeOut" }, [_c("div", { staticClass: "robin-wrapper robin-flex robin-flex-1 robin-pt-8 robin-pb-8 robin-pl-24 robin-pr-24 robin-overflow-y-auto" }, _vm._l(_vm.files, function(file, index) {
    return _c("div", { key: "image-" + index, staticClass: "robin-file-upload" }, [_c("div", { staticClass: "robin-file-upload-delete", on: { "click": function($event) {
      return _vm.removeFile(index);
    } } }, [_c("IconButton", { attrs: { "name": "close", "to-emit": false, "to-click-away": false } })], 1), file.type.includes("image") ? _c("img", { attrs: { "src": file.localUrl, "alt": file.name + "-image" } }) : _vm._e(), file.type.includes("video") ? _c("div", { staticClass: "robin-video" }, [_c("video", { attrs: { "width": "100%", "height": "100%", "controls": "" }, on: { "click": function($event) {
      return _vm.removeFile(index);
    } } }, [_c("source", { attrs: { "src": file.localUrl, "type": file.type } }), _vm._v(" Your browser does not support the video tag. ")])]) : _vm._e(), _vm.acceptedDocFiles.includes(file.extension) ? _c("div", { staticClass: "robin-file" }, [_c("SvgIcon", { attrs: { "name": "file" } }), _c("Content", { attrs: { "as": "span" } }, [_vm._v(" " + _vm._s(file.name.length > 6 ? file.name.substring(0, 6) + ".." : file.name) + " ")]), _c("Content", { attrs: { "as": "span" } }, [_vm._v(" " + _vm._s("." + file.extension) + " ")])], 1) : _vm._e()]);
  }), 0), _c("div", { staticClass: "robin-file-upload-close" }, [_c("IconButton", { attrs: { "name": "remove", "to-emit": true, "to-click-away": false }, on: { "clicked": _vm.handleFileUploadClose } })], 1)]), _c("div", { staticClass: "robin-message-box-inner", attrs: { "tabindex": "1" }, on: { "keydown": function($event) {
    if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) {
      return null;
    }
    if ($event.ctrlKey || $event.shiftKey || $event.altKey || $event.metaKey) {
      return null;
    }
    $event.preventDefault();
    return _vm.send($event);
  } } }, [!_vm.isRecording ? _c("div", { staticClass: "robin-mr-8", attrs: { "data-testid": "attach-file-button" }, on: { "click": function($event) {
    return _vm.toggleAttachFilePopup();
  } } }, [!_vm.popUpState.opened ? _c("IconButton", { attrs: { "name": "attachFileClose", "to-click-away": false, "to-emit": false } }) : _c("IconButton", { attrs: { "name": "attachFileOpen", "to-click-away": true, "to-emit": false }, on: { "clickoutside": function($event) {
    return _vm.handleClosePopUp();
  } } })], 1) : _c("div", { staticClass: "robin-ar-indicator robin-mr-8" }, [_c("IconButton", { attrs: { "name": "remove3", "to-click-away": false, "to-emit": true, "data-testid": "record-stop-button" }, on: { "clicked": function($event) {
    return _vm.toggleRecorder(false);
  } } }), _c("div", { staticClass: "robin-ar-dot" })], 1), _c("div", { directives: [{ name: "show", rawName: "v-show", value: !_vm.isRecording, expression: "!isRecording" }], staticClass: "robin-message-input" }, [_c("div", { staticClass: "robin-mt-4" }, [_c("IconButton", { attrs: { "name": "emoji", "active": _vm.popUpState.emojiOpened, "to-emit": true, "to-click-away": false }, on: { "clicked": function($event) {
    !_vm.popUpState.emojiOpened ? _vm.handleEmojiOpenPopUp() : _vm.handleEmojiClosePopUp();
  } } })], 1), _c("div", { directives: [{ name: "show", rawName: "v-show", value: !_vm.isRecording, expression: "!isRecording" }], staticClass: "robin-input-wrapper", attrs: { "tabindex": "1" } }, [_c("textarea", { ref: "input", staticClass: "robin-input", attrs: { "placeholder": "Type your message...", "data-testid": "input" }, domProps: { "value": _vm.text }, on: { "input": function($event) {
    return _vm.enterText($event);
  }, "keydown": function($event) {
    if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) {
      return null;
    }
    return _vm.escapeText();
  } } })])]), _c("div", { directives: [{ name: "show", rawName: "v-show", value: (_vm.text.trim().length > 0 || _vm.files.length > 0 || _vm.isRecording) && !_vm.isUploading, expression: "(text.trim().length > 0 || files.length > 0 || isRecording) && !isUploading" }], staticClass: "robin-flex robin-flex-align-center robin-ml-auto robin-pl-21 robin-come-up" }, [_c("div", { directives: [{ name: "show", rawName: "v-show", value: _vm.isRecording, expression: "isRecording" }], staticClass: "robin-ar-time robin-mr-8", attrs: { "data-testid": "current-time" } }, [_vm._v(" " + _vm._s(_vm.currentTime) + " ")]), _c("IconButton", { attrs: { "name": "send", "emit": "sendmessage", "to-emit": true, "to-click-away": false, "data-testid": "send-button" }, on: { "sendmessage": function($event) {
    return _vm.send(null);
  } } })], 1), _c("div", { directives: [{ name: "show", rawName: "v-show", value: _vm.isUploading, expression: "isUploading" }], staticClass: "robin-send-button-loader robin-ml-21" }, [_c("div", { staticClass: "robin-spinner2" })]), _c("div", { directives: [{ name: "show", rawName: "v-show", value: _vm.text.trim() == "" && _vm.files.length < 1 && !_vm.isUploading && !_vm.isRecording && _vm.isVoiceRecorderEnabled, expression: "text.trim() == '' && files.length < 1 && !isUploading && !isRecording && isVoiceRecorderEnabled" }], staticClass: "robin-ml-8", attrs: { "data-testid": "record-start-button" }, on: { "click": function($event) {
    return _vm.toggleRecorder(true);
  } } }, [_c("IconButton", { attrs: { "name": "voice", "to-click-away": false, "to-emit": false } })], 1), _c("div", { directives: [{ name: "show", rawName: "v-show", value: _vm.popUpState.opened, expression: "popUpState.opened" }], staticClass: "robin-popup-container" }, [_c("AttachFilePopOver", { ref: "popup-4", attrs: { "data-testid": "attach-file-popover" }, on: { "file-upload": _vm.handleFileUpload, "open-camera": function($event) {
    return _vm.$emit("open-camera");
  } } })], 1)])]);
};
var staticRenderFns$j = [];
var MessageInputBar_vue_vue_type_style_index_0_scoped_true_lang = "";
const __cssModules$j = {};
var __component__$j = /* @__PURE__ */ normalizeComponent(MessageInputBar$1, render$j, staticRenderFns$j, false, injectStyles$j, "2b8651bc", null, null);
function injectStyles$j(context2) {
  for (let o in __cssModules$j) {
    this[o] = __cssModules$j[o];
  }
}
var MessageInputBar = /* @__PURE__ */ function() {
  return __component__$j.exports;
}();
var __defProp$i = Object.defineProperty;
var __getOwnPropDesc$i = Object.getOwnPropertyDescriptor;
var __decorateClass$i = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$i(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$i(target, key, result);
  return result;
};
const ComponentProps$b = Vue$1.extend({
  props: {
    cameraOpened: {
      type: Boolean,
      default: false
    }
  }
});
let CameraButton$1 = class extends ComponentProps$b {
  created() {
    document.addEventListener("keyup", (event) => {
      if (event.keyCode === 13 && this.cameraOpened) {
        this.$emit("clicked");
      }
    });
  }
};
CameraButton$1 = __decorateClass$i([
  Component({
    name: "CameraButton",
    components: {
      SvgIcon
    }
  })
], CameraButton$1);
var render$i = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("button", { staticClass: "robin-button", attrs: { "type": "button", "data-testid": "camera-button" }, on: { "click": function($event) {
    return _vm.$emit("clicked");
  }, "keyup": function($event) {
    if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) {
      return null;
    }
    return _vm.$emit("clicked");
  } } }, [_c("SvgIcon", { attrs: { "name": "camera" } })], 1);
};
var staticRenderFns$i = [];
var CameraButton_vue_vue_type_style_index_0_scoped_true_lang = "";
const __cssModules$i = {};
var __component__$i = /* @__PURE__ */ normalizeComponent(CameraButton$1, render$i, staticRenderFns$i, false, injectStyles$i, "bfcd9f8a", null, null);
function injectStyles$i(context2) {
  for (let o in __cssModules$i) {
    this[o] = __cssModules$i[o];
  }
}
var CameraButton = /* @__PURE__ */ function() {
  return __component__$i.exports;
}();
var __defProp$h = Object.defineProperty;
var __getOwnPropDesc$h = Object.getOwnPropertyDescriptor;
var __decorateClass$h = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$h(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$h(target, key, result);
  return result;
};
const ComponentProps$a = Vue$1.extend({
  props: {
    cameraOpened: {
      type: Boolean,
      default: false
    }
  }
});
let Camera$1 = class extends ComponentProps$a {
  constructor() {
    super(...arguments);
    this.camera = null;
    this.deviceId = null;
    this.devices = [];
    this.isPhotoTaken = false;
    this.isShotPhoto = false;
    this.screenWidth = 0;
  }
  mounted() {
    this.$nextTick(function() {
      this.onResize();
    });
    window.addEventListener("resize", this.onResize);
  }
  setupMedia() {
    const navigatorExtended = navigator;
    if (navigatorExtended.mediaDevices === void 0) {
      navigatorExtended.mediaDevices = {};
    }
    if (navigatorExtended.mediaDevices.getUserMedia === void 0) {
      navigatorExtended.mediaDevices.getUserMedia = this.legacyGetUserMediaSupport();
    }
    this.createCameraElement();
  }
  legacyGetUserMediaSupport() {
    const navigatorExtended = navigator;
    return (constraints) => {
      const getUserMedia = navigatorExtended.getUserMedia || navigatorExtended.webkitGetUserMedia || navigatorExtended.mozGetUserMedia || navigatorExtended.msGetUserMedia || navigatorExtended.oGetUserMedia;
      if (!getUserMedia) {
        return Promise.reject(new Error("getUserMedia is not implemented in this browser"));
      }
      return new Promise(function(resolve, reject) {
        getUserMedia.call(navigator, constraints, resolve, reject);
      });
    };
  }
  createCameraElement() {
    const camera = this.$refs.camera;
    const windowEl = window;
    const constraints = windowEl.constraints = {
      audio: false,
      video: true
    };
    navigator.mediaDevices.getUserMedia(constraints).then((stream) => {
      camera.srcObject = stream;
    }).catch();
  }
  closeCamera() {
    const camera = this.$refs.camera;
    const tracks = camera.srcObject.getTracks();
    tracks.forEach((track) => {
      track.stop();
    });
    this.$emit("close");
  }
  async takePhoto() {
    const capture = this.getCanvas().toDataURL("image/jpeg");
    const res = await this.convertBase64ToFile(capture);
    this.$emit("captured-image", {
      file: res,
      localUrl: capture
    });
    this.closeCamera();
  }
  getCanvas() {
    const camera = this.$refs.camera;
    const canvas = document.createElement("canvas");
    canvas.height = camera.height;
    canvas.width = 500;
    const ctx = canvas.getContext("2d");
    ctx == null ? void 0 : ctx.drawImage(camera, 0, 0, canvas.width, canvas.height);
    return canvas;
  }
  createUuid(length) {
    let result = "";
    const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    const charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }
  async convertBase64ToFile(base64) {
    const res = await fetch(base64);
    const blob = await res.blob();
    return new File([blob], `${this.createUuid(30)}.jpeg`, { type: "image/jpeg" });
  }
  onResize() {
    this.screenWidth = window.innerWidth;
  }
};
Camera$1 = __decorateClass$h([
  Component({
    name: "Camera",
    components: {
      Content,
      IconButton,
      CameraButton
    },
    watch: {
      cameraOpened: {
        handler(val) {
          if (val) {
            this.setupMedia();
          }
        }
      }
    }
  })
], Camera$1);
var render$h = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { ref: "popup-body", staticClass: "robin-camera-box robin-squeezeOut" }, [_c("header", { staticClass: "robin-head" }, [_c("div", { staticClass: "robin-wrapper robin-mr-12", attrs: { "data-testid": "close-camera" }, on: { "click": function($event) {
    return _vm.closeCamera();
  } } }, [_c("IconButton", { attrs: { "name": "remove", "to-emit": false, "to-click-away": false } })], 1), _c("Content", { attrs: { "as": "h3", "font-size": 18 } }, [_vm._v(" Take photo ")])], 1), _c("div", { staticClass: "robin-body" }, [_c("video", { directives: [{ name: "show", rawName: "v-show", value: !_vm.isPhotoTaken, expression: "!isPhotoTaken" }], ref: "camera", attrs: { "width": "100%", "height": _vm.screenWidth > 480 ? "500px" : "250px", "autoplay": "true", "muted": "true" }, domProps: { "muted": true } }), _vm.cameraOpened ? _c("CameraButton", { attrs: { "camera-opened": _vm.cameraOpened, "data-testid": "camera-button" }, on: { "clicked": function($event) {
    return _vm.takePhoto();
  } } }) : _vm._e()], 1)]);
};
var staticRenderFns$h = [];
var Camera_vue_vue_type_style_index_0_scoped_true_lang = "";
const __cssModules$h = {};
var __component__$h = /* @__PURE__ */ normalizeComponent(Camera$1, render$h, staticRenderFns$h, false, injectStyles$h, "2dfbda1b", null, null);
function injectStyles$h(context2) {
  for (let o in __cssModules$h) {
    this[o] = __cssModules$h[o];
  }
}
var Camera = /* @__PURE__ */ function() {
  return __component__$h.exports;
}();
var commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};
function commonjsRequire(path) {
  throw new Error('Could not dynamically require "' + path + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var localforage = { exports: {} };
/*!
    localForage -- Offline Storage, Improved
    Version 1.10.0
    https://localforage.github.io/localForage
    (c) 2013-2017 Mozilla, Apache License 2.0
*/
(function(module2, exports2) {
  (function(f) {
    {
      module2.exports = f();
    }
  })(function() {
    return function e2(t, n, r) {
      function s(o2, u) {
        if (!n[o2]) {
          if (!t[o2]) {
            var a = typeof commonjsRequire == "function" && commonjsRequire;
            if (!u && a)
              return a(o2, true);
            if (i)
              return i(o2, true);
            var f = new Error("Cannot find module '" + o2 + "'");
            throw f.code = "MODULE_NOT_FOUND", f;
          }
          var l = n[o2] = { exports: {} };
          t[o2][0].call(l.exports, function(e3) {
            var n2 = t[o2][1][e3];
            return s(n2 ? n2 : e3);
          }, l, l.exports, e2, t, n, r);
        }
        return n[o2].exports;
      }
      var i = typeof commonjsRequire == "function" && commonjsRequire;
      for (var o = 0; o < r.length; o++)
        s(r[o]);
      return s;
    }({ 1: [function(_dereq_, module3, exports3) {
      (function(global2) {
        var Mutation = global2.MutationObserver || global2.WebKitMutationObserver;
        var scheduleDrain;
        {
          if (Mutation) {
            var called = 0;
            var observer = new Mutation(nextTick);
            var element = global2.document.createTextNode("");
            observer.observe(element, {
              characterData: true
            });
            scheduleDrain = function() {
              element.data = called = ++called % 2;
            };
          } else if (!global2.setImmediate && typeof global2.MessageChannel !== "undefined") {
            var channel = new global2.MessageChannel();
            channel.port1.onmessage = nextTick;
            scheduleDrain = function() {
              channel.port2.postMessage(0);
            };
          } else if ("document" in global2 && "onreadystatechange" in global2.document.createElement("script")) {
            scheduleDrain = function() {
              var scriptEl = global2.document.createElement("script");
              scriptEl.onreadystatechange = function() {
                nextTick();
                scriptEl.onreadystatechange = null;
                scriptEl.parentNode.removeChild(scriptEl);
                scriptEl = null;
              };
              global2.document.documentElement.appendChild(scriptEl);
            };
          } else {
            scheduleDrain = function() {
              setTimeout(nextTick, 0);
            };
          }
        }
        var draining;
        var queue = [];
        function nextTick() {
          draining = true;
          var i, oldQueue;
          var len = queue.length;
          while (len) {
            oldQueue = queue;
            queue = [];
            i = -1;
            while (++i < len) {
              oldQueue[i]();
            }
            len = queue.length;
          }
          draining = false;
        }
        module3.exports = immediate;
        function immediate(task) {
          if (queue.push(task) === 1 && !draining) {
            scheduleDrain();
          }
        }
      }).call(this, typeof commonjsGlobal !== "undefined" ? commonjsGlobal : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {});
    }, {}], 2: [function(_dereq_, module3, exports3) {
      var immediate = _dereq_(1);
      function INTERNAL() {
      }
      var handlers = {};
      var REJECTED = ["REJECTED"];
      var FULFILLED = ["FULFILLED"];
      var PENDING = ["PENDING"];
      module3.exports = Promise2;
      function Promise2(resolver) {
        if (typeof resolver !== "function") {
          throw new TypeError("resolver must be a function");
        }
        this.state = PENDING;
        this.queue = [];
        this.outcome = void 0;
        if (resolver !== INTERNAL) {
          safelyResolveThenable(this, resolver);
        }
      }
      Promise2.prototype["catch"] = function(onRejected) {
        return this.then(null, onRejected);
      };
      Promise2.prototype.then = function(onFulfilled, onRejected) {
        if (typeof onFulfilled !== "function" && this.state === FULFILLED || typeof onRejected !== "function" && this.state === REJECTED) {
          return this;
        }
        var promise = new this.constructor(INTERNAL);
        if (this.state !== PENDING) {
          var resolver = this.state === FULFILLED ? onFulfilled : onRejected;
          unwrap(promise, resolver, this.outcome);
        } else {
          this.queue.push(new QueueItem(promise, onFulfilled, onRejected));
        }
        return promise;
      };
      function QueueItem(promise, onFulfilled, onRejected) {
        this.promise = promise;
        if (typeof onFulfilled === "function") {
          this.onFulfilled = onFulfilled;
          this.callFulfilled = this.otherCallFulfilled;
        }
        if (typeof onRejected === "function") {
          this.onRejected = onRejected;
          this.callRejected = this.otherCallRejected;
        }
      }
      QueueItem.prototype.callFulfilled = function(value) {
        handlers.resolve(this.promise, value);
      };
      QueueItem.prototype.otherCallFulfilled = function(value) {
        unwrap(this.promise, this.onFulfilled, value);
      };
      QueueItem.prototype.callRejected = function(value) {
        handlers.reject(this.promise, value);
      };
      QueueItem.prototype.otherCallRejected = function(value) {
        unwrap(this.promise, this.onRejected, value);
      };
      function unwrap(promise, func, value) {
        immediate(function() {
          var returnValue;
          try {
            returnValue = func(value);
          } catch (e2) {
            return handlers.reject(promise, e2);
          }
          if (returnValue === promise) {
            handlers.reject(promise, new TypeError("Cannot resolve promise with itself"));
          } else {
            handlers.resolve(promise, returnValue);
          }
        });
      }
      handlers.resolve = function(self2, value) {
        var result = tryCatch(getThen, value);
        if (result.status === "error") {
          return handlers.reject(self2, result.value);
        }
        var thenable = result.value;
        if (thenable) {
          safelyResolveThenable(self2, thenable);
        } else {
          self2.state = FULFILLED;
          self2.outcome = value;
          var i = -1;
          var len = self2.queue.length;
          while (++i < len) {
            self2.queue[i].callFulfilled(value);
          }
        }
        return self2;
      };
      handlers.reject = function(self2, error2) {
        self2.state = REJECTED;
        self2.outcome = error2;
        var i = -1;
        var len = self2.queue.length;
        while (++i < len) {
          self2.queue[i].callRejected(error2);
        }
        return self2;
      };
      function getThen(obj) {
        var then = obj && obj.then;
        if (obj && (typeof obj === "object" || typeof obj === "function") && typeof then === "function") {
          return function appyThen() {
            then.apply(obj, arguments);
          };
        }
      }
      function safelyResolveThenable(self2, thenable) {
        var called = false;
        function onError(value) {
          if (called) {
            return;
          }
          called = true;
          handlers.reject(self2, value);
        }
        function onSuccess(value) {
          if (called) {
            return;
          }
          called = true;
          handlers.resolve(self2, value);
        }
        function tryToUnwrap() {
          thenable(onSuccess, onError);
        }
        var result = tryCatch(tryToUnwrap);
        if (result.status === "error") {
          onError(result.value);
        }
      }
      function tryCatch(func, value) {
        var out = {};
        try {
          out.value = func(value);
          out.status = "success";
        } catch (e2) {
          out.status = "error";
          out.value = e2;
        }
        return out;
      }
      Promise2.resolve = resolve;
      function resolve(value) {
        if (value instanceof this) {
          return value;
        }
        return handlers.resolve(new this(INTERNAL), value);
      }
      Promise2.reject = reject;
      function reject(reason) {
        var promise = new this(INTERNAL);
        return handlers.reject(promise, reason);
      }
      Promise2.all = all;
      function all(iterable) {
        var self2 = this;
        if (Object.prototype.toString.call(iterable) !== "[object Array]") {
          return this.reject(new TypeError("must be an array"));
        }
        var len = iterable.length;
        var called = false;
        if (!len) {
          return this.resolve([]);
        }
        var values = new Array(len);
        var resolved = 0;
        var i = -1;
        var promise = new this(INTERNAL);
        while (++i < len) {
          allResolver(iterable[i], i);
        }
        return promise;
        function allResolver(value, i2) {
          self2.resolve(value).then(resolveFromAll, function(error2) {
            if (!called) {
              called = true;
              handlers.reject(promise, error2);
            }
          });
          function resolveFromAll(outValue) {
            values[i2] = outValue;
            if (++resolved === len && !called) {
              called = true;
              handlers.resolve(promise, values);
            }
          }
        }
      }
      Promise2.race = race;
      function race(iterable) {
        var self2 = this;
        if (Object.prototype.toString.call(iterable) !== "[object Array]") {
          return this.reject(new TypeError("must be an array"));
        }
        var len = iterable.length;
        var called = false;
        if (!len) {
          return this.resolve([]);
        }
        var i = -1;
        var promise = new this(INTERNAL);
        while (++i < len) {
          resolver(iterable[i]);
        }
        return promise;
        function resolver(value) {
          self2.resolve(value).then(function(response) {
            if (!called) {
              called = true;
              handlers.resolve(promise, response);
            }
          }, function(error2) {
            if (!called) {
              called = true;
              handlers.reject(promise, error2);
            }
          });
        }
      }
    }, { "1": 1 }], 3: [function(_dereq_, module3, exports3) {
      (function(global2) {
        if (typeof global2.Promise !== "function") {
          global2.Promise = _dereq_(2);
        }
      }).call(this, typeof commonjsGlobal !== "undefined" ? commonjsGlobal : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {});
    }, { "2": 2 }], 4: [function(_dereq_, module3, exports3) {
      var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
        return typeof obj;
      } : function(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }
      function getIDB() {
        try {
          if (typeof indexedDB !== "undefined") {
            return indexedDB;
          }
          if (typeof webkitIndexedDB !== "undefined") {
            return webkitIndexedDB;
          }
          if (typeof mozIndexedDB !== "undefined") {
            return mozIndexedDB;
          }
          if (typeof OIndexedDB !== "undefined") {
            return OIndexedDB;
          }
          if (typeof msIndexedDB !== "undefined") {
            return msIndexedDB;
          }
        } catch (e2) {
          return;
        }
      }
      var idb = getIDB();
      function isIndexedDBValid() {
        try {
          if (!idb || !idb.open) {
            return false;
          }
          var isSafari = typeof openDatabase !== "undefined" && /(Safari|iPhone|iPad|iPod)/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent) && !/BlackBerry/.test(navigator.platform);
          var hasFetch = typeof fetch === "function" && fetch.toString().indexOf("[native code") !== -1;
          return (!isSafari || hasFetch) && typeof indexedDB !== "undefined" && typeof IDBKeyRange !== "undefined";
        } catch (e2) {
          return false;
        }
      }
      function createBlob(parts, properties) {
        parts = parts || [];
        properties = properties || {};
        try {
          return new Blob(parts, properties);
        } catch (e2) {
          if (e2.name !== "TypeError") {
            throw e2;
          }
          var Builder = typeof BlobBuilder !== "undefined" ? BlobBuilder : typeof MSBlobBuilder !== "undefined" ? MSBlobBuilder : typeof MozBlobBuilder !== "undefined" ? MozBlobBuilder : WebKitBlobBuilder;
          var builder = new Builder();
          for (var i = 0; i < parts.length; i += 1) {
            builder.append(parts[i]);
          }
          return builder.getBlob(properties.type);
        }
      }
      if (typeof Promise === "undefined") {
        _dereq_(3);
      }
      var Promise$1 = Promise;
      function executeCallback(promise, callback) {
        if (callback) {
          promise.then(function(result) {
            callback(null, result);
          }, function(error2) {
            callback(error2);
          });
        }
      }
      function executeTwoCallbacks(promise, callback, errorCallback) {
        if (typeof callback === "function") {
          promise.then(callback);
        }
        if (typeof errorCallback === "function") {
          promise["catch"](errorCallback);
        }
      }
      function normalizeKey(key2) {
        if (typeof key2 !== "string") {
          console.warn(key2 + " used as a key, but it is not a string.");
          key2 = String(key2);
        }
        return key2;
      }
      function getCallback() {
        if (arguments.length && typeof arguments[arguments.length - 1] === "function") {
          return arguments[arguments.length - 1];
        }
      }
      var DETECT_BLOB_SUPPORT_STORE = "local-forage-detect-blob-support";
      var supportsBlobs = void 0;
      var dbContexts = {};
      var toString = Object.prototype.toString;
      var READ_ONLY = "readonly";
      var READ_WRITE = "readwrite";
      function _binStringToArrayBuffer(bin) {
        var length2 = bin.length;
        var buf = new ArrayBuffer(length2);
        var arr = new Uint8Array(buf);
        for (var i = 0; i < length2; i++) {
          arr[i] = bin.charCodeAt(i);
        }
        return buf;
      }
      function _checkBlobSupportWithoutCaching(idb2) {
        return new Promise$1(function(resolve) {
          var txn = idb2.transaction(DETECT_BLOB_SUPPORT_STORE, READ_WRITE);
          var blob = createBlob([""]);
          txn.objectStore(DETECT_BLOB_SUPPORT_STORE).put(blob, "key");
          txn.onabort = function(e2) {
            e2.preventDefault();
            e2.stopPropagation();
            resolve(false);
          };
          txn.oncomplete = function() {
            var matchedChrome = navigator.userAgent.match(/Chrome\/(\d+)/);
            var matchedEdge = navigator.userAgent.match(/Edge\//);
            resolve(matchedEdge || !matchedChrome || parseInt(matchedChrome[1], 10) >= 43);
          };
        })["catch"](function() {
          return false;
        });
      }
      function _checkBlobSupport(idb2) {
        if (typeof supportsBlobs === "boolean") {
          return Promise$1.resolve(supportsBlobs);
        }
        return _checkBlobSupportWithoutCaching(idb2).then(function(value) {
          supportsBlobs = value;
          return supportsBlobs;
        });
      }
      function _deferReadiness(dbInfo) {
        var dbContext = dbContexts[dbInfo.name];
        var deferredOperation = {};
        deferredOperation.promise = new Promise$1(function(resolve, reject) {
          deferredOperation.resolve = resolve;
          deferredOperation.reject = reject;
        });
        dbContext.deferredOperations.push(deferredOperation);
        if (!dbContext.dbReady) {
          dbContext.dbReady = deferredOperation.promise;
        } else {
          dbContext.dbReady = dbContext.dbReady.then(function() {
            return deferredOperation.promise;
          });
        }
      }
      function _advanceReadiness(dbInfo) {
        var dbContext = dbContexts[dbInfo.name];
        var deferredOperation = dbContext.deferredOperations.pop();
        if (deferredOperation) {
          deferredOperation.resolve();
          return deferredOperation.promise;
        }
      }
      function _rejectReadiness(dbInfo, err) {
        var dbContext = dbContexts[dbInfo.name];
        var deferredOperation = dbContext.deferredOperations.pop();
        if (deferredOperation) {
          deferredOperation.reject(err);
          return deferredOperation.promise;
        }
      }
      function _getConnection(dbInfo, upgradeNeeded) {
        return new Promise$1(function(resolve, reject) {
          dbContexts[dbInfo.name] = dbContexts[dbInfo.name] || createDbContext();
          if (dbInfo.db) {
            if (upgradeNeeded) {
              _deferReadiness(dbInfo);
              dbInfo.db.close();
            } else {
              return resolve(dbInfo.db);
            }
          }
          var dbArgs = [dbInfo.name];
          if (upgradeNeeded) {
            dbArgs.push(dbInfo.version);
          }
          var openreq = idb.open.apply(idb, dbArgs);
          if (upgradeNeeded) {
            openreq.onupgradeneeded = function(e2) {
              var db = openreq.result;
              try {
                db.createObjectStore(dbInfo.storeName);
                if (e2.oldVersion <= 1) {
                  db.createObjectStore(DETECT_BLOB_SUPPORT_STORE);
                }
              } catch (ex) {
                if (ex.name === "ConstraintError") {
                  console.warn('The database "' + dbInfo.name + '" has been upgraded from version ' + e2.oldVersion + " to version " + e2.newVersion + ', but the storage "' + dbInfo.storeName + '" already exists.');
                } else {
                  throw ex;
                }
              }
            };
          }
          openreq.onerror = function(e2) {
            e2.preventDefault();
            reject(openreq.error);
          };
          openreq.onsuccess = function() {
            var db = openreq.result;
            db.onversionchange = function(e2) {
              e2.target.close();
            };
            resolve(db);
            _advanceReadiness(dbInfo);
          };
        });
      }
      function _getOriginalConnection(dbInfo) {
        return _getConnection(dbInfo, false);
      }
      function _getUpgradedConnection(dbInfo) {
        return _getConnection(dbInfo, true);
      }
      function _isUpgradeNeeded(dbInfo, defaultVersion) {
        if (!dbInfo.db) {
          return true;
        }
        var isNewStore = !dbInfo.db.objectStoreNames.contains(dbInfo.storeName);
        var isDowngrade = dbInfo.version < dbInfo.db.version;
        var isUpgrade = dbInfo.version > dbInfo.db.version;
        if (isDowngrade) {
          if (dbInfo.version !== defaultVersion) {
            console.warn('The database "' + dbInfo.name + `" can't be downgraded from version ` + dbInfo.db.version + " to version " + dbInfo.version + ".");
          }
          dbInfo.version = dbInfo.db.version;
        }
        if (isUpgrade || isNewStore) {
          if (isNewStore) {
            var incVersion = dbInfo.db.version + 1;
            if (incVersion > dbInfo.version) {
              dbInfo.version = incVersion;
            }
          }
          return true;
        }
        return false;
      }
      function _encodeBlob(blob) {
        return new Promise$1(function(resolve, reject) {
          var reader = new FileReader();
          reader.onerror = reject;
          reader.onloadend = function(e2) {
            var base64 = btoa(e2.target.result || "");
            resolve({
              __local_forage_encoded_blob: true,
              data: base64,
              type: blob.type
            });
          };
          reader.readAsBinaryString(blob);
        });
      }
      function _decodeBlob(encodedBlob) {
        var arrayBuff = _binStringToArrayBuffer(atob(encodedBlob.data));
        return createBlob([arrayBuff], { type: encodedBlob.type });
      }
      function _isEncodedBlob(value) {
        return value && value.__local_forage_encoded_blob;
      }
      function _fullyReady(callback) {
        var self2 = this;
        var promise = self2._initReady().then(function() {
          var dbContext = dbContexts[self2._dbInfo.name];
          if (dbContext && dbContext.dbReady) {
            return dbContext.dbReady;
          }
        });
        executeTwoCallbacks(promise, callback, callback);
        return promise;
      }
      function _tryReconnect(dbInfo) {
        _deferReadiness(dbInfo);
        var dbContext = dbContexts[dbInfo.name];
        var forages = dbContext.forages;
        for (var i = 0; i < forages.length; i++) {
          var forage = forages[i];
          if (forage._dbInfo.db) {
            forage._dbInfo.db.close();
            forage._dbInfo.db = null;
          }
        }
        dbInfo.db = null;
        return _getOriginalConnection(dbInfo).then(function(db) {
          dbInfo.db = db;
          if (_isUpgradeNeeded(dbInfo)) {
            return _getUpgradedConnection(dbInfo);
          }
          return db;
        }).then(function(db) {
          dbInfo.db = dbContext.db = db;
          for (var i2 = 0; i2 < forages.length; i2++) {
            forages[i2]._dbInfo.db = db;
          }
        })["catch"](function(err) {
          _rejectReadiness(dbInfo, err);
          throw err;
        });
      }
      function createTransaction(dbInfo, mode, callback, retries) {
        if (retries === void 0) {
          retries = 1;
        }
        try {
          var tx = dbInfo.db.transaction(dbInfo.storeName, mode);
          callback(null, tx);
        } catch (err) {
          if (retries > 0 && (!dbInfo.db || err.name === "InvalidStateError" || err.name === "NotFoundError")) {
            return Promise$1.resolve().then(function() {
              if (!dbInfo.db || err.name === "NotFoundError" && !dbInfo.db.objectStoreNames.contains(dbInfo.storeName) && dbInfo.version <= dbInfo.db.version) {
                if (dbInfo.db) {
                  dbInfo.version = dbInfo.db.version + 1;
                }
                return _getUpgradedConnection(dbInfo);
              }
            }).then(function() {
              return _tryReconnect(dbInfo).then(function() {
                createTransaction(dbInfo, mode, callback, retries - 1);
              });
            })["catch"](callback);
          }
          callback(err);
        }
      }
      function createDbContext() {
        return {
          forages: [],
          db: null,
          dbReady: null,
          deferredOperations: []
        };
      }
      function _initStorage(options) {
        var self2 = this;
        var dbInfo = {
          db: null
        };
        if (options) {
          for (var i in options) {
            dbInfo[i] = options[i];
          }
        }
        var dbContext = dbContexts[dbInfo.name];
        if (!dbContext) {
          dbContext = createDbContext();
          dbContexts[dbInfo.name] = dbContext;
        }
        dbContext.forages.push(self2);
        if (!self2._initReady) {
          self2._initReady = self2.ready;
          self2.ready = _fullyReady;
        }
        var initPromises = [];
        function ignoreErrors() {
          return Promise$1.resolve();
        }
        for (var j = 0; j < dbContext.forages.length; j++) {
          var forage = dbContext.forages[j];
          if (forage !== self2) {
            initPromises.push(forage._initReady()["catch"](ignoreErrors));
          }
        }
        var forages = dbContext.forages.slice(0);
        return Promise$1.all(initPromises).then(function() {
          dbInfo.db = dbContext.db;
          return _getOriginalConnection(dbInfo);
        }).then(function(db) {
          dbInfo.db = db;
          if (_isUpgradeNeeded(dbInfo, self2._defaultConfig.version)) {
            return _getUpgradedConnection(dbInfo);
          }
          return db;
        }).then(function(db) {
          dbInfo.db = dbContext.db = db;
          self2._dbInfo = dbInfo;
          for (var k = 0; k < forages.length; k++) {
            var forage2 = forages[k];
            if (forage2 !== self2) {
              forage2._dbInfo.db = dbInfo.db;
              forage2._dbInfo.version = dbInfo.version;
            }
          }
        });
      }
      function getItem(key2, callback) {
        var self2 = this;
        key2 = normalizeKey(key2);
        var promise = new Promise$1(function(resolve, reject) {
          self2.ready().then(function() {
            createTransaction(self2._dbInfo, READ_ONLY, function(err, transaction) {
              if (err) {
                return reject(err);
              }
              try {
                var store2 = transaction.objectStore(self2._dbInfo.storeName);
                var req = store2.get(key2);
                req.onsuccess = function() {
                  var value = req.result;
                  if (value === void 0) {
                    value = null;
                  }
                  if (_isEncodedBlob(value)) {
                    value = _decodeBlob(value);
                  }
                  resolve(value);
                };
                req.onerror = function() {
                  reject(req.error);
                };
              } catch (e2) {
                reject(e2);
              }
            });
          })["catch"](reject);
        });
        executeCallback(promise, callback);
        return promise;
      }
      function iterate(iterator, callback) {
        var self2 = this;
        var promise = new Promise$1(function(resolve, reject) {
          self2.ready().then(function() {
            createTransaction(self2._dbInfo, READ_ONLY, function(err, transaction) {
              if (err) {
                return reject(err);
              }
              try {
                var store2 = transaction.objectStore(self2._dbInfo.storeName);
                var req = store2.openCursor();
                var iterationNumber = 1;
                req.onsuccess = function() {
                  var cursor = req.result;
                  if (cursor) {
                    var value = cursor.value;
                    if (_isEncodedBlob(value)) {
                      value = _decodeBlob(value);
                    }
                    var result = iterator(value, cursor.key, iterationNumber++);
                    if (result !== void 0) {
                      resolve(result);
                    } else {
                      cursor["continue"]();
                    }
                  } else {
                    resolve();
                  }
                };
                req.onerror = function() {
                  reject(req.error);
                };
              } catch (e2) {
                reject(e2);
              }
            });
          })["catch"](reject);
        });
        executeCallback(promise, callback);
        return promise;
      }
      function setItem(key2, value, callback) {
        var self2 = this;
        key2 = normalizeKey(key2);
        var promise = new Promise$1(function(resolve, reject) {
          var dbInfo;
          self2.ready().then(function() {
            dbInfo = self2._dbInfo;
            if (toString.call(value) === "[object Blob]") {
              return _checkBlobSupport(dbInfo.db).then(function(blobSupport) {
                if (blobSupport) {
                  return value;
                }
                return _encodeBlob(value);
              });
            }
            return value;
          }).then(function(value2) {
            createTransaction(self2._dbInfo, READ_WRITE, function(err, transaction) {
              if (err) {
                return reject(err);
              }
              try {
                var store2 = transaction.objectStore(self2._dbInfo.storeName);
                if (value2 === null) {
                  value2 = void 0;
                }
                var req = store2.put(value2, key2);
                transaction.oncomplete = function() {
                  if (value2 === void 0) {
                    value2 = null;
                  }
                  resolve(value2);
                };
                transaction.onabort = transaction.onerror = function() {
                  var err2 = req.error ? req.error : req.transaction.error;
                  reject(err2);
                };
              } catch (e2) {
                reject(e2);
              }
            });
          })["catch"](reject);
        });
        executeCallback(promise, callback);
        return promise;
      }
      function removeItem(key2, callback) {
        var self2 = this;
        key2 = normalizeKey(key2);
        var promise = new Promise$1(function(resolve, reject) {
          self2.ready().then(function() {
            createTransaction(self2._dbInfo, READ_WRITE, function(err, transaction) {
              if (err) {
                return reject(err);
              }
              try {
                var store2 = transaction.objectStore(self2._dbInfo.storeName);
                var req = store2["delete"](key2);
                transaction.oncomplete = function() {
                  resolve();
                };
                transaction.onerror = function() {
                  reject(req.error);
                };
                transaction.onabort = function() {
                  var err2 = req.error ? req.error : req.transaction.error;
                  reject(err2);
                };
              } catch (e2) {
                reject(e2);
              }
            });
          })["catch"](reject);
        });
        executeCallback(promise, callback);
        return promise;
      }
      function clear(callback) {
        var self2 = this;
        var promise = new Promise$1(function(resolve, reject) {
          self2.ready().then(function() {
            createTransaction(self2._dbInfo, READ_WRITE, function(err, transaction) {
              if (err) {
                return reject(err);
              }
              try {
                var store2 = transaction.objectStore(self2._dbInfo.storeName);
                var req = store2.clear();
                transaction.oncomplete = function() {
                  resolve();
                };
                transaction.onabort = transaction.onerror = function() {
                  var err2 = req.error ? req.error : req.transaction.error;
                  reject(err2);
                };
              } catch (e2) {
                reject(e2);
              }
            });
          })["catch"](reject);
        });
        executeCallback(promise, callback);
        return promise;
      }
      function length(callback) {
        var self2 = this;
        var promise = new Promise$1(function(resolve, reject) {
          self2.ready().then(function() {
            createTransaction(self2._dbInfo, READ_ONLY, function(err, transaction) {
              if (err) {
                return reject(err);
              }
              try {
                var store2 = transaction.objectStore(self2._dbInfo.storeName);
                var req = store2.count();
                req.onsuccess = function() {
                  resolve(req.result);
                };
                req.onerror = function() {
                  reject(req.error);
                };
              } catch (e2) {
                reject(e2);
              }
            });
          })["catch"](reject);
        });
        executeCallback(promise, callback);
        return promise;
      }
      function key(n, callback) {
        var self2 = this;
        var promise = new Promise$1(function(resolve, reject) {
          if (n < 0) {
            resolve(null);
            return;
          }
          self2.ready().then(function() {
            createTransaction(self2._dbInfo, READ_ONLY, function(err, transaction) {
              if (err) {
                return reject(err);
              }
              try {
                var store2 = transaction.objectStore(self2._dbInfo.storeName);
                var advanced = false;
                var req = store2.openKeyCursor();
                req.onsuccess = function() {
                  var cursor = req.result;
                  if (!cursor) {
                    resolve(null);
                    return;
                  }
                  if (n === 0) {
                    resolve(cursor.key);
                  } else {
                    if (!advanced) {
                      advanced = true;
                      cursor.advance(n);
                    } else {
                      resolve(cursor.key);
                    }
                  }
                };
                req.onerror = function() {
                  reject(req.error);
                };
              } catch (e2) {
                reject(e2);
              }
            });
          })["catch"](reject);
        });
        executeCallback(promise, callback);
        return promise;
      }
      function keys(callback) {
        var self2 = this;
        var promise = new Promise$1(function(resolve, reject) {
          self2.ready().then(function() {
            createTransaction(self2._dbInfo, READ_ONLY, function(err, transaction) {
              if (err) {
                return reject(err);
              }
              try {
                var store2 = transaction.objectStore(self2._dbInfo.storeName);
                var req = store2.openKeyCursor();
                var keys2 = [];
                req.onsuccess = function() {
                  var cursor = req.result;
                  if (!cursor) {
                    resolve(keys2);
                    return;
                  }
                  keys2.push(cursor.key);
                  cursor["continue"]();
                };
                req.onerror = function() {
                  reject(req.error);
                };
              } catch (e2) {
                reject(e2);
              }
            });
          })["catch"](reject);
        });
        executeCallback(promise, callback);
        return promise;
      }
      function dropInstance(options, callback) {
        callback = getCallback.apply(this, arguments);
        var currentConfig = this.config();
        options = typeof options !== "function" && options || {};
        if (!options.name) {
          options.name = options.name || currentConfig.name;
          options.storeName = options.storeName || currentConfig.storeName;
        }
        var self2 = this;
        var promise;
        if (!options.name) {
          promise = Promise$1.reject("Invalid arguments");
        } else {
          var isCurrentDb = options.name === currentConfig.name && self2._dbInfo.db;
          var dbPromise = isCurrentDb ? Promise$1.resolve(self2._dbInfo.db) : _getOriginalConnection(options).then(function(db) {
            var dbContext = dbContexts[options.name];
            var forages = dbContext.forages;
            dbContext.db = db;
            for (var i = 0; i < forages.length; i++) {
              forages[i]._dbInfo.db = db;
            }
            return db;
          });
          if (!options.storeName) {
            promise = dbPromise.then(function(db) {
              _deferReadiness(options);
              var dbContext = dbContexts[options.name];
              var forages = dbContext.forages;
              db.close();
              for (var i = 0; i < forages.length; i++) {
                var forage = forages[i];
                forage._dbInfo.db = null;
              }
              var dropDBPromise = new Promise$1(function(resolve, reject) {
                var req = idb.deleteDatabase(options.name);
                req.onerror = function() {
                  var db2 = req.result;
                  if (db2) {
                    db2.close();
                  }
                  reject(req.error);
                };
                req.onblocked = function() {
                  console.warn('dropInstance blocked for database "' + options.name + '" until all open connections are closed');
                };
                req.onsuccess = function() {
                  var db2 = req.result;
                  if (db2) {
                    db2.close();
                  }
                  resolve(db2);
                };
              });
              return dropDBPromise.then(function(db2) {
                dbContext.db = db2;
                for (var i2 = 0; i2 < forages.length; i2++) {
                  var _forage = forages[i2];
                  _advanceReadiness(_forage._dbInfo);
                }
              })["catch"](function(err) {
                (_rejectReadiness(options, err) || Promise$1.resolve())["catch"](function() {
                });
                throw err;
              });
            });
          } else {
            promise = dbPromise.then(function(db) {
              if (!db.objectStoreNames.contains(options.storeName)) {
                return;
              }
              var newVersion = db.version + 1;
              _deferReadiness(options);
              var dbContext = dbContexts[options.name];
              var forages = dbContext.forages;
              db.close();
              for (var i = 0; i < forages.length; i++) {
                var forage = forages[i];
                forage._dbInfo.db = null;
                forage._dbInfo.version = newVersion;
              }
              var dropObjectPromise = new Promise$1(function(resolve, reject) {
                var req = idb.open(options.name, newVersion);
                req.onerror = function(err) {
                  var db2 = req.result;
                  db2.close();
                  reject(err);
                };
                req.onupgradeneeded = function() {
                  var db2 = req.result;
                  db2.deleteObjectStore(options.storeName);
                };
                req.onsuccess = function() {
                  var db2 = req.result;
                  db2.close();
                  resolve(db2);
                };
              });
              return dropObjectPromise.then(function(db2) {
                dbContext.db = db2;
                for (var j = 0; j < forages.length; j++) {
                  var _forage2 = forages[j];
                  _forage2._dbInfo.db = db2;
                  _advanceReadiness(_forage2._dbInfo);
                }
              })["catch"](function(err) {
                (_rejectReadiness(options, err) || Promise$1.resolve())["catch"](function() {
                });
                throw err;
              });
            });
          }
        }
        executeCallback(promise, callback);
        return promise;
      }
      var asyncStorage = {
        _driver: "asyncStorage",
        _initStorage,
        _support: isIndexedDBValid(),
        iterate,
        getItem,
        setItem,
        removeItem,
        clear,
        length,
        key,
        keys,
        dropInstance
      };
      function isWebSQLValid() {
        return typeof openDatabase === "function";
      }
      var BASE_CHARS = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
      var BLOB_TYPE_PREFIX = "~~local_forage_type~";
      var BLOB_TYPE_PREFIX_REGEX = /^~~local_forage_type~([^~]+)~/;
      var SERIALIZED_MARKER = "__lfsc__:";
      var SERIALIZED_MARKER_LENGTH = SERIALIZED_MARKER.length;
      var TYPE_ARRAYBUFFER = "arbf";
      var TYPE_BLOB = "blob";
      var TYPE_INT8ARRAY = "si08";
      var TYPE_UINT8ARRAY = "ui08";
      var TYPE_UINT8CLAMPEDARRAY = "uic8";
      var TYPE_INT16ARRAY = "si16";
      var TYPE_INT32ARRAY = "si32";
      var TYPE_UINT16ARRAY = "ur16";
      var TYPE_UINT32ARRAY = "ui32";
      var TYPE_FLOAT32ARRAY = "fl32";
      var TYPE_FLOAT64ARRAY = "fl64";
      var TYPE_SERIALIZED_MARKER_LENGTH = SERIALIZED_MARKER_LENGTH + TYPE_ARRAYBUFFER.length;
      var toString$1 = Object.prototype.toString;
      function stringToBuffer(serializedString) {
        var bufferLength = serializedString.length * 0.75;
        var len = serializedString.length;
        var i;
        var p = 0;
        var encoded1, encoded2, encoded3, encoded4;
        if (serializedString[serializedString.length - 1] === "=") {
          bufferLength--;
          if (serializedString[serializedString.length - 2] === "=") {
            bufferLength--;
          }
        }
        var buffer = new ArrayBuffer(bufferLength);
        var bytes = new Uint8Array(buffer);
        for (i = 0; i < len; i += 4) {
          encoded1 = BASE_CHARS.indexOf(serializedString[i]);
          encoded2 = BASE_CHARS.indexOf(serializedString[i + 1]);
          encoded3 = BASE_CHARS.indexOf(serializedString[i + 2]);
          encoded4 = BASE_CHARS.indexOf(serializedString[i + 3]);
          bytes[p++] = encoded1 << 2 | encoded2 >> 4;
          bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
          bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
        }
        return buffer;
      }
      function bufferToString(buffer) {
        var bytes = new Uint8Array(buffer);
        var base64String = "";
        var i;
        for (i = 0; i < bytes.length; i += 3) {
          base64String += BASE_CHARS[bytes[i] >> 2];
          base64String += BASE_CHARS[(bytes[i] & 3) << 4 | bytes[i + 1] >> 4];
          base64String += BASE_CHARS[(bytes[i + 1] & 15) << 2 | bytes[i + 2] >> 6];
          base64String += BASE_CHARS[bytes[i + 2] & 63];
        }
        if (bytes.length % 3 === 2) {
          base64String = base64String.substring(0, base64String.length - 1) + "=";
        } else if (bytes.length % 3 === 1) {
          base64String = base64String.substring(0, base64String.length - 2) + "==";
        }
        return base64String;
      }
      function serialize(value, callback) {
        var valueType = "";
        if (value) {
          valueType = toString$1.call(value);
        }
        if (value && (valueType === "[object ArrayBuffer]" || value.buffer && toString$1.call(value.buffer) === "[object ArrayBuffer]")) {
          var buffer;
          var marker = SERIALIZED_MARKER;
          if (value instanceof ArrayBuffer) {
            buffer = value;
            marker += TYPE_ARRAYBUFFER;
          } else {
            buffer = value.buffer;
            if (valueType === "[object Int8Array]") {
              marker += TYPE_INT8ARRAY;
            } else if (valueType === "[object Uint8Array]") {
              marker += TYPE_UINT8ARRAY;
            } else if (valueType === "[object Uint8ClampedArray]") {
              marker += TYPE_UINT8CLAMPEDARRAY;
            } else if (valueType === "[object Int16Array]") {
              marker += TYPE_INT16ARRAY;
            } else if (valueType === "[object Uint16Array]") {
              marker += TYPE_UINT16ARRAY;
            } else if (valueType === "[object Int32Array]") {
              marker += TYPE_INT32ARRAY;
            } else if (valueType === "[object Uint32Array]") {
              marker += TYPE_UINT32ARRAY;
            } else if (valueType === "[object Float32Array]") {
              marker += TYPE_FLOAT32ARRAY;
            } else if (valueType === "[object Float64Array]") {
              marker += TYPE_FLOAT64ARRAY;
            } else {
              callback(new Error("Failed to get type for BinaryArray"));
            }
          }
          callback(marker + bufferToString(buffer));
        } else if (valueType === "[object Blob]") {
          var fileReader = new FileReader();
          fileReader.onload = function() {
            var str = BLOB_TYPE_PREFIX + value.type + "~" + bufferToString(this.result);
            callback(SERIALIZED_MARKER + TYPE_BLOB + str);
          };
          fileReader.readAsArrayBuffer(value);
        } else {
          try {
            callback(JSON.stringify(value));
          } catch (e2) {
            console.error("Couldn't convert value into a JSON string: ", value);
            callback(null, e2);
          }
        }
      }
      function deserialize(value) {
        if (value.substring(0, SERIALIZED_MARKER_LENGTH) !== SERIALIZED_MARKER) {
          return JSON.parse(value);
        }
        var serializedString = value.substring(TYPE_SERIALIZED_MARKER_LENGTH);
        var type = value.substring(SERIALIZED_MARKER_LENGTH, TYPE_SERIALIZED_MARKER_LENGTH);
        var blobType;
        if (type === TYPE_BLOB && BLOB_TYPE_PREFIX_REGEX.test(serializedString)) {
          var matcher = serializedString.match(BLOB_TYPE_PREFIX_REGEX);
          blobType = matcher[1];
          serializedString = serializedString.substring(matcher[0].length);
        }
        var buffer = stringToBuffer(serializedString);
        switch (type) {
          case TYPE_ARRAYBUFFER:
            return buffer;
          case TYPE_BLOB:
            return createBlob([buffer], { type: blobType });
          case TYPE_INT8ARRAY:
            return new Int8Array(buffer);
          case TYPE_UINT8ARRAY:
            return new Uint8Array(buffer);
          case TYPE_UINT8CLAMPEDARRAY:
            return new Uint8ClampedArray(buffer);
          case TYPE_INT16ARRAY:
            return new Int16Array(buffer);
          case TYPE_UINT16ARRAY:
            return new Uint16Array(buffer);
          case TYPE_INT32ARRAY:
            return new Int32Array(buffer);
          case TYPE_UINT32ARRAY:
            return new Uint32Array(buffer);
          case TYPE_FLOAT32ARRAY:
            return new Float32Array(buffer);
          case TYPE_FLOAT64ARRAY:
            return new Float64Array(buffer);
          default:
            throw new Error("Unkown type: " + type);
        }
      }
      var localforageSerializer = {
        serialize,
        deserialize,
        stringToBuffer,
        bufferToString
      };
      function createDbTable(t, dbInfo, callback, errorCallback) {
        t.executeSql("CREATE TABLE IF NOT EXISTS " + dbInfo.storeName + " (id INTEGER PRIMARY KEY, key unique, value)", [], callback, errorCallback);
      }
      function _initStorage$1(options) {
        var self2 = this;
        var dbInfo = {
          db: null
        };
        if (options) {
          for (var i in options) {
            dbInfo[i] = typeof options[i] !== "string" ? options[i].toString() : options[i];
          }
        }
        var dbInfoPromise = new Promise$1(function(resolve, reject) {
          try {
            dbInfo.db = openDatabase(dbInfo.name, String(dbInfo.version), dbInfo.description, dbInfo.size);
          } catch (e2) {
            return reject(e2);
          }
          dbInfo.db.transaction(function(t) {
            createDbTable(t, dbInfo, function() {
              self2._dbInfo = dbInfo;
              resolve();
            }, function(t2, error2) {
              reject(error2);
            });
          }, reject);
        });
        dbInfo.serializer = localforageSerializer;
        return dbInfoPromise;
      }
      function tryExecuteSql(t, dbInfo, sqlStatement, args, callback, errorCallback) {
        t.executeSql(sqlStatement, args, callback, function(t2, error2) {
          if (error2.code === error2.SYNTAX_ERR) {
            t2.executeSql("SELECT name FROM sqlite_master WHERE type='table' AND name = ?", [dbInfo.storeName], function(t3, results) {
              if (!results.rows.length) {
                createDbTable(t3, dbInfo, function() {
                  t3.executeSql(sqlStatement, args, callback, errorCallback);
                }, errorCallback);
              } else {
                errorCallback(t3, error2);
              }
            }, errorCallback);
          } else {
            errorCallback(t2, error2);
          }
        }, errorCallback);
      }
      function getItem$1(key2, callback) {
        var self2 = this;
        key2 = normalizeKey(key2);
        var promise = new Promise$1(function(resolve, reject) {
          self2.ready().then(function() {
            var dbInfo = self2._dbInfo;
            dbInfo.db.transaction(function(t) {
              tryExecuteSql(t, dbInfo, "SELECT * FROM " + dbInfo.storeName + " WHERE key = ? LIMIT 1", [key2], function(t2, results) {
                var result = results.rows.length ? results.rows.item(0).value : null;
                if (result) {
                  result = dbInfo.serializer.deserialize(result);
                }
                resolve(result);
              }, function(t2, error2) {
                reject(error2);
              });
            });
          })["catch"](reject);
        });
        executeCallback(promise, callback);
        return promise;
      }
      function iterate$1(iterator, callback) {
        var self2 = this;
        var promise = new Promise$1(function(resolve, reject) {
          self2.ready().then(function() {
            var dbInfo = self2._dbInfo;
            dbInfo.db.transaction(function(t) {
              tryExecuteSql(t, dbInfo, "SELECT * FROM " + dbInfo.storeName, [], function(t2, results) {
                var rows = results.rows;
                var length2 = rows.length;
                for (var i = 0; i < length2; i++) {
                  var item = rows.item(i);
                  var result = item.value;
                  if (result) {
                    result = dbInfo.serializer.deserialize(result);
                  }
                  result = iterator(result, item.key, i + 1);
                  if (result !== void 0) {
                    resolve(result);
                    return;
                  }
                }
                resolve();
              }, function(t2, error2) {
                reject(error2);
              });
            });
          })["catch"](reject);
        });
        executeCallback(promise, callback);
        return promise;
      }
      function _setItem(key2, value, callback, retriesLeft) {
        var self2 = this;
        key2 = normalizeKey(key2);
        var promise = new Promise$1(function(resolve, reject) {
          self2.ready().then(function() {
            if (value === void 0) {
              value = null;
            }
            var originalValue = value;
            var dbInfo = self2._dbInfo;
            dbInfo.serializer.serialize(value, function(value2, error2) {
              if (error2) {
                reject(error2);
              } else {
                dbInfo.db.transaction(function(t) {
                  tryExecuteSql(t, dbInfo, "INSERT OR REPLACE INTO " + dbInfo.storeName + " (key, value) VALUES (?, ?)", [key2, value2], function() {
                    resolve(originalValue);
                  }, function(t2, error3) {
                    reject(error3);
                  });
                }, function(sqlError) {
                  if (sqlError.code === sqlError.QUOTA_ERR) {
                    if (retriesLeft > 0) {
                      resolve(_setItem.apply(self2, [key2, originalValue, callback, retriesLeft - 1]));
                      return;
                    }
                    reject(sqlError);
                  }
                });
              }
            });
          })["catch"](reject);
        });
        executeCallback(promise, callback);
        return promise;
      }
      function setItem$1(key2, value, callback) {
        return _setItem.apply(this, [key2, value, callback, 1]);
      }
      function removeItem$1(key2, callback) {
        var self2 = this;
        key2 = normalizeKey(key2);
        var promise = new Promise$1(function(resolve, reject) {
          self2.ready().then(function() {
            var dbInfo = self2._dbInfo;
            dbInfo.db.transaction(function(t) {
              tryExecuteSql(t, dbInfo, "DELETE FROM " + dbInfo.storeName + " WHERE key = ?", [key2], function() {
                resolve();
              }, function(t2, error2) {
                reject(error2);
              });
            });
          })["catch"](reject);
        });
        executeCallback(promise, callback);
        return promise;
      }
      function clear$1(callback) {
        var self2 = this;
        var promise = new Promise$1(function(resolve, reject) {
          self2.ready().then(function() {
            var dbInfo = self2._dbInfo;
            dbInfo.db.transaction(function(t) {
              tryExecuteSql(t, dbInfo, "DELETE FROM " + dbInfo.storeName, [], function() {
                resolve();
              }, function(t2, error2) {
                reject(error2);
              });
            });
          })["catch"](reject);
        });
        executeCallback(promise, callback);
        return promise;
      }
      function length$1(callback) {
        var self2 = this;
        var promise = new Promise$1(function(resolve, reject) {
          self2.ready().then(function() {
            var dbInfo = self2._dbInfo;
            dbInfo.db.transaction(function(t) {
              tryExecuteSql(t, dbInfo, "SELECT COUNT(key) as c FROM " + dbInfo.storeName, [], function(t2, results) {
                var result = results.rows.item(0).c;
                resolve(result);
              }, function(t2, error2) {
                reject(error2);
              });
            });
          })["catch"](reject);
        });
        executeCallback(promise, callback);
        return promise;
      }
      function key$1(n, callback) {
        var self2 = this;
        var promise = new Promise$1(function(resolve, reject) {
          self2.ready().then(function() {
            var dbInfo = self2._dbInfo;
            dbInfo.db.transaction(function(t) {
              tryExecuteSql(t, dbInfo, "SELECT key FROM " + dbInfo.storeName + " WHERE id = ? LIMIT 1", [n + 1], function(t2, results) {
                var result = results.rows.length ? results.rows.item(0).key : null;
                resolve(result);
              }, function(t2, error2) {
                reject(error2);
              });
            });
          })["catch"](reject);
        });
        executeCallback(promise, callback);
        return promise;
      }
      function keys$1(callback) {
        var self2 = this;
        var promise = new Promise$1(function(resolve, reject) {
          self2.ready().then(function() {
            var dbInfo = self2._dbInfo;
            dbInfo.db.transaction(function(t) {
              tryExecuteSql(t, dbInfo, "SELECT key FROM " + dbInfo.storeName, [], function(t2, results) {
                var keys2 = [];
                for (var i = 0; i < results.rows.length; i++) {
                  keys2.push(results.rows.item(i).key);
                }
                resolve(keys2);
              }, function(t2, error2) {
                reject(error2);
              });
            });
          })["catch"](reject);
        });
        executeCallback(promise, callback);
        return promise;
      }
      function getAllStoreNames(db) {
        return new Promise$1(function(resolve, reject) {
          db.transaction(function(t) {
            t.executeSql("SELECT name FROM sqlite_master WHERE type='table' AND name <> '__WebKitDatabaseInfoTable__'", [], function(t2, results) {
              var storeNames = [];
              for (var i = 0; i < results.rows.length; i++) {
                storeNames.push(results.rows.item(i).name);
              }
              resolve({
                db,
                storeNames
              });
            }, function(t2, error2) {
              reject(error2);
            });
          }, function(sqlError) {
            reject(sqlError);
          });
        });
      }
      function dropInstance$1(options, callback) {
        callback = getCallback.apply(this, arguments);
        var currentConfig = this.config();
        options = typeof options !== "function" && options || {};
        if (!options.name) {
          options.name = options.name || currentConfig.name;
          options.storeName = options.storeName || currentConfig.storeName;
        }
        var self2 = this;
        var promise;
        if (!options.name) {
          promise = Promise$1.reject("Invalid arguments");
        } else {
          promise = new Promise$1(function(resolve) {
            var db;
            if (options.name === currentConfig.name) {
              db = self2._dbInfo.db;
            } else {
              db = openDatabase(options.name, "", "", 0);
            }
            if (!options.storeName) {
              resolve(getAllStoreNames(db));
            } else {
              resolve({
                db,
                storeNames: [options.storeName]
              });
            }
          }).then(function(operationInfo) {
            return new Promise$1(function(resolve, reject) {
              operationInfo.db.transaction(function(t) {
                function dropTable(storeName) {
                  return new Promise$1(function(resolve2, reject2) {
                    t.executeSql("DROP TABLE IF EXISTS " + storeName, [], function() {
                      resolve2();
                    }, function(t2, error2) {
                      reject2(error2);
                    });
                  });
                }
                var operations = [];
                for (var i = 0, len = operationInfo.storeNames.length; i < len; i++) {
                  operations.push(dropTable(operationInfo.storeNames[i]));
                }
                Promise$1.all(operations).then(function() {
                  resolve();
                })["catch"](function(e2) {
                  reject(e2);
                });
              }, function(sqlError) {
                reject(sqlError);
              });
            });
          });
        }
        executeCallback(promise, callback);
        return promise;
      }
      var webSQLStorage = {
        _driver: "webSQLStorage",
        _initStorage: _initStorage$1,
        _support: isWebSQLValid(),
        iterate: iterate$1,
        getItem: getItem$1,
        setItem: setItem$1,
        removeItem: removeItem$1,
        clear: clear$1,
        length: length$1,
        key: key$1,
        keys: keys$1,
        dropInstance: dropInstance$1
      };
      function isLocalStorageValid() {
        try {
          return typeof localStorage !== "undefined" && "setItem" in localStorage && !!localStorage.setItem;
        } catch (e2) {
          return false;
        }
      }
      function _getKeyPrefix(options, defaultConfig) {
        var keyPrefix = options.name + "/";
        if (options.storeName !== defaultConfig.storeName) {
          keyPrefix += options.storeName + "/";
        }
        return keyPrefix;
      }
      function checkIfLocalStorageThrows() {
        var localStorageTestKey = "_localforage_support_test";
        try {
          localStorage.setItem(localStorageTestKey, true);
          localStorage.removeItem(localStorageTestKey);
          return false;
        } catch (e2) {
          return true;
        }
      }
      function _isLocalStorageUsable() {
        return !checkIfLocalStorageThrows() || localStorage.length > 0;
      }
      function _initStorage$2(options) {
        var self2 = this;
        var dbInfo = {};
        if (options) {
          for (var i in options) {
            dbInfo[i] = options[i];
          }
        }
        dbInfo.keyPrefix = _getKeyPrefix(options, self2._defaultConfig);
        if (!_isLocalStorageUsable()) {
          return Promise$1.reject();
        }
        self2._dbInfo = dbInfo;
        dbInfo.serializer = localforageSerializer;
        return Promise$1.resolve();
      }
      function clear$2(callback) {
        var self2 = this;
        var promise = self2.ready().then(function() {
          var keyPrefix = self2._dbInfo.keyPrefix;
          for (var i = localStorage.length - 1; i >= 0; i--) {
            var key2 = localStorage.key(i);
            if (key2.indexOf(keyPrefix) === 0) {
              localStorage.removeItem(key2);
            }
          }
        });
        executeCallback(promise, callback);
        return promise;
      }
      function getItem$2(key2, callback) {
        var self2 = this;
        key2 = normalizeKey(key2);
        var promise = self2.ready().then(function() {
          var dbInfo = self2._dbInfo;
          var result = localStorage.getItem(dbInfo.keyPrefix + key2);
          if (result) {
            result = dbInfo.serializer.deserialize(result);
          }
          return result;
        });
        executeCallback(promise, callback);
        return promise;
      }
      function iterate$2(iterator, callback) {
        var self2 = this;
        var promise = self2.ready().then(function() {
          var dbInfo = self2._dbInfo;
          var keyPrefix = dbInfo.keyPrefix;
          var keyPrefixLength = keyPrefix.length;
          var length2 = localStorage.length;
          var iterationNumber = 1;
          for (var i = 0; i < length2; i++) {
            var key2 = localStorage.key(i);
            if (key2.indexOf(keyPrefix) !== 0) {
              continue;
            }
            var value = localStorage.getItem(key2);
            if (value) {
              value = dbInfo.serializer.deserialize(value);
            }
            value = iterator(value, key2.substring(keyPrefixLength), iterationNumber++);
            if (value !== void 0) {
              return value;
            }
          }
        });
        executeCallback(promise, callback);
        return promise;
      }
      function key$2(n, callback) {
        var self2 = this;
        var promise = self2.ready().then(function() {
          var dbInfo = self2._dbInfo;
          var result;
          try {
            result = localStorage.key(n);
          } catch (error2) {
            result = null;
          }
          if (result) {
            result = result.substring(dbInfo.keyPrefix.length);
          }
          return result;
        });
        executeCallback(promise, callback);
        return promise;
      }
      function keys$2(callback) {
        var self2 = this;
        var promise = self2.ready().then(function() {
          var dbInfo = self2._dbInfo;
          var length2 = localStorage.length;
          var keys2 = [];
          for (var i = 0; i < length2; i++) {
            var itemKey = localStorage.key(i);
            if (itemKey.indexOf(dbInfo.keyPrefix) === 0) {
              keys2.push(itemKey.substring(dbInfo.keyPrefix.length));
            }
          }
          return keys2;
        });
        executeCallback(promise, callback);
        return promise;
      }
      function length$2(callback) {
        var self2 = this;
        var promise = self2.keys().then(function(keys2) {
          return keys2.length;
        });
        executeCallback(promise, callback);
        return promise;
      }
      function removeItem$2(key2, callback) {
        var self2 = this;
        key2 = normalizeKey(key2);
        var promise = self2.ready().then(function() {
          var dbInfo = self2._dbInfo;
          localStorage.removeItem(dbInfo.keyPrefix + key2);
        });
        executeCallback(promise, callback);
        return promise;
      }
      function setItem$2(key2, value, callback) {
        var self2 = this;
        key2 = normalizeKey(key2);
        var promise = self2.ready().then(function() {
          if (value === void 0) {
            value = null;
          }
          var originalValue = value;
          return new Promise$1(function(resolve, reject) {
            var dbInfo = self2._dbInfo;
            dbInfo.serializer.serialize(value, function(value2, error2) {
              if (error2) {
                reject(error2);
              } else {
                try {
                  localStorage.setItem(dbInfo.keyPrefix + key2, value2);
                  resolve(originalValue);
                } catch (e2) {
                  if (e2.name === "QuotaExceededError" || e2.name === "NS_ERROR_DOM_QUOTA_REACHED") {
                    reject(e2);
                  }
                  reject(e2);
                }
              }
            });
          });
        });
        executeCallback(promise, callback);
        return promise;
      }
      function dropInstance$2(options, callback) {
        callback = getCallback.apply(this, arguments);
        options = typeof options !== "function" && options || {};
        if (!options.name) {
          var currentConfig = this.config();
          options.name = options.name || currentConfig.name;
          options.storeName = options.storeName || currentConfig.storeName;
        }
        var self2 = this;
        var promise;
        if (!options.name) {
          promise = Promise$1.reject("Invalid arguments");
        } else {
          promise = new Promise$1(function(resolve) {
            if (!options.storeName) {
              resolve(options.name + "/");
            } else {
              resolve(_getKeyPrefix(options, self2._defaultConfig));
            }
          }).then(function(keyPrefix) {
            for (var i = localStorage.length - 1; i >= 0; i--) {
              var key2 = localStorage.key(i);
              if (key2.indexOf(keyPrefix) === 0) {
                localStorage.removeItem(key2);
              }
            }
          });
        }
        executeCallback(promise, callback);
        return promise;
      }
      var localStorageWrapper = {
        _driver: "localStorageWrapper",
        _initStorage: _initStorage$2,
        _support: isLocalStorageValid(),
        iterate: iterate$2,
        getItem: getItem$2,
        setItem: setItem$2,
        removeItem: removeItem$2,
        clear: clear$2,
        length: length$2,
        key: key$2,
        keys: keys$2,
        dropInstance: dropInstance$2
      };
      var sameValue = function sameValue2(x, y) {
        return x === y || typeof x === "number" && typeof y === "number" && isNaN(x) && isNaN(y);
      };
      var includes = function includes2(array, searchElement) {
        var len = array.length;
        var i = 0;
        while (i < len) {
          if (sameValue(array[i], searchElement)) {
            return true;
          }
          i++;
        }
        return false;
      };
      var isArray = Array.isArray || function(arg) {
        return Object.prototype.toString.call(arg) === "[object Array]";
      };
      var DefinedDrivers = {};
      var DriverSupport = {};
      var DefaultDrivers = {
        INDEXEDDB: asyncStorage,
        WEBSQL: webSQLStorage,
        LOCALSTORAGE: localStorageWrapper
      };
      var DefaultDriverOrder = [DefaultDrivers.INDEXEDDB._driver, DefaultDrivers.WEBSQL._driver, DefaultDrivers.LOCALSTORAGE._driver];
      var OptionalDriverMethods = ["dropInstance"];
      var LibraryMethods = ["clear", "getItem", "iterate", "key", "keys", "length", "removeItem", "setItem"].concat(OptionalDriverMethods);
      var DefaultConfig = {
        description: "",
        driver: DefaultDriverOrder.slice(),
        name: "localforage",
        size: 4980736,
        storeName: "keyvaluepairs",
        version: 1
      };
      function callWhenReady(localForageInstance, libraryMethod) {
        localForageInstance[libraryMethod] = function() {
          var _args = arguments;
          return localForageInstance.ready().then(function() {
            return localForageInstance[libraryMethod].apply(localForageInstance, _args);
          });
        };
      }
      function extend() {
        for (var i = 1; i < arguments.length; i++) {
          var arg = arguments[i];
          if (arg) {
            for (var _key in arg) {
              if (arg.hasOwnProperty(_key)) {
                if (isArray(arg[_key])) {
                  arguments[0][_key] = arg[_key].slice();
                } else {
                  arguments[0][_key] = arg[_key];
                }
              }
            }
          }
        }
        return arguments[0];
      }
      var LocalForage = function() {
        function LocalForage2(options) {
          _classCallCheck(this, LocalForage2);
          for (var driverTypeKey in DefaultDrivers) {
            if (DefaultDrivers.hasOwnProperty(driverTypeKey)) {
              var driver = DefaultDrivers[driverTypeKey];
              var driverName = driver._driver;
              this[driverTypeKey] = driverName;
              if (!DefinedDrivers[driverName]) {
                this.defineDriver(driver);
              }
            }
          }
          this._defaultConfig = extend({}, DefaultConfig);
          this._config = extend({}, this._defaultConfig, options);
          this._driverSet = null;
          this._initDriver = null;
          this._ready = false;
          this._dbInfo = null;
          this._wrapLibraryMethodsWithReady();
          this.setDriver(this._config.driver)["catch"](function() {
          });
        }
        LocalForage2.prototype.config = function config(options) {
          if ((typeof options === "undefined" ? "undefined" : _typeof2(options)) === "object") {
            if (this._ready) {
              return new Error("Can't call config() after localforage has been used.");
            }
            for (var i in options) {
              if (i === "storeName") {
                options[i] = options[i].replace(/\W/g, "_");
              }
              if (i === "version" && typeof options[i] !== "number") {
                return new Error("Database version must be a number.");
              }
              this._config[i] = options[i];
            }
            if ("driver" in options && options.driver) {
              return this.setDriver(this._config.driver);
            }
            return true;
          } else if (typeof options === "string") {
            return this._config[options];
          } else {
            return this._config;
          }
        };
        LocalForage2.prototype.defineDriver = function defineDriver(driverObject, callback, errorCallback) {
          var promise = new Promise$1(function(resolve, reject) {
            try {
              var driverName = driverObject._driver;
              var complianceError = new Error("Custom driver not compliant; see https://mozilla.github.io/localForage/#definedriver");
              if (!driverObject._driver) {
                reject(complianceError);
                return;
              }
              var driverMethods = LibraryMethods.concat("_initStorage");
              for (var i = 0, len = driverMethods.length; i < len; i++) {
                var driverMethodName = driverMethods[i];
                var isRequired = !includes(OptionalDriverMethods, driverMethodName);
                if ((isRequired || driverObject[driverMethodName]) && typeof driverObject[driverMethodName] !== "function") {
                  reject(complianceError);
                  return;
                }
              }
              var configureMissingMethods = function configureMissingMethods2() {
                var methodNotImplementedFactory = function methodNotImplementedFactory2(methodName) {
                  return function() {
                    var error2 = new Error("Method " + methodName + " is not implemented by the current driver");
                    var promise2 = Promise$1.reject(error2);
                    executeCallback(promise2, arguments[arguments.length - 1]);
                    return promise2;
                  };
                };
                for (var _i = 0, _len = OptionalDriverMethods.length; _i < _len; _i++) {
                  var optionalDriverMethod = OptionalDriverMethods[_i];
                  if (!driverObject[optionalDriverMethod]) {
                    driverObject[optionalDriverMethod] = methodNotImplementedFactory(optionalDriverMethod);
                  }
                }
              };
              configureMissingMethods();
              var setDriverSupport = function setDriverSupport2(support) {
                if (DefinedDrivers[driverName]) {
                  console.info("Redefining LocalForage driver: " + driverName);
                }
                DefinedDrivers[driverName] = driverObject;
                DriverSupport[driverName] = support;
                resolve();
              };
              if ("_support" in driverObject) {
                if (driverObject._support && typeof driverObject._support === "function") {
                  driverObject._support().then(setDriverSupport, reject);
                } else {
                  setDriverSupport(!!driverObject._support);
                }
              } else {
                setDriverSupport(true);
              }
            } catch (e2) {
              reject(e2);
            }
          });
          executeTwoCallbacks(promise, callback, errorCallback);
          return promise;
        };
        LocalForage2.prototype.driver = function driver() {
          return this._driver || null;
        };
        LocalForage2.prototype.getDriver = function getDriver(driverName, callback, errorCallback) {
          var getDriverPromise = DefinedDrivers[driverName] ? Promise$1.resolve(DefinedDrivers[driverName]) : Promise$1.reject(new Error("Driver not found."));
          executeTwoCallbacks(getDriverPromise, callback, errorCallback);
          return getDriverPromise;
        };
        LocalForage2.prototype.getSerializer = function getSerializer(callback) {
          var serializerPromise = Promise$1.resolve(localforageSerializer);
          executeTwoCallbacks(serializerPromise, callback);
          return serializerPromise;
        };
        LocalForage2.prototype.ready = function ready(callback) {
          var self2 = this;
          var promise = self2._driverSet.then(function() {
            if (self2._ready === null) {
              self2._ready = self2._initDriver();
            }
            return self2._ready;
          });
          executeTwoCallbacks(promise, callback, callback);
          return promise;
        };
        LocalForage2.prototype.setDriver = function setDriver(drivers, callback, errorCallback) {
          var self2 = this;
          if (!isArray(drivers)) {
            drivers = [drivers];
          }
          var supportedDrivers = this._getSupportedDrivers(drivers);
          function setDriverToConfig() {
            self2._config.driver = self2.driver();
          }
          function extendSelfWithDriver(driver) {
            self2._extend(driver);
            setDriverToConfig();
            self2._ready = self2._initStorage(self2._config);
            return self2._ready;
          }
          function initDriver(supportedDrivers2) {
            return function() {
              var currentDriverIndex = 0;
              function driverPromiseLoop() {
                while (currentDriverIndex < supportedDrivers2.length) {
                  var driverName = supportedDrivers2[currentDriverIndex];
                  currentDriverIndex++;
                  self2._dbInfo = null;
                  self2._ready = null;
                  return self2.getDriver(driverName).then(extendSelfWithDriver)["catch"](driverPromiseLoop);
                }
                setDriverToConfig();
                var error2 = new Error("No available storage method found.");
                self2._driverSet = Promise$1.reject(error2);
                return self2._driverSet;
              }
              return driverPromiseLoop();
            };
          }
          var oldDriverSetDone = this._driverSet !== null ? this._driverSet["catch"](function() {
            return Promise$1.resolve();
          }) : Promise$1.resolve();
          this._driverSet = oldDriverSetDone.then(function() {
            var driverName = supportedDrivers[0];
            self2._dbInfo = null;
            self2._ready = null;
            return self2.getDriver(driverName).then(function(driver) {
              self2._driver = driver._driver;
              setDriverToConfig();
              self2._wrapLibraryMethodsWithReady();
              self2._initDriver = initDriver(supportedDrivers);
            });
          })["catch"](function() {
            setDriverToConfig();
            var error2 = new Error("No available storage method found.");
            self2._driverSet = Promise$1.reject(error2);
            return self2._driverSet;
          });
          executeTwoCallbacks(this._driverSet, callback, errorCallback);
          return this._driverSet;
        };
        LocalForage2.prototype.supports = function supports(driverName) {
          return !!DriverSupport[driverName];
        };
        LocalForage2.prototype._extend = function _extend(libraryMethodsAndProperties) {
          extend(this, libraryMethodsAndProperties);
        };
        LocalForage2.prototype._getSupportedDrivers = function _getSupportedDrivers(drivers) {
          var supportedDrivers = [];
          for (var i = 0, len = drivers.length; i < len; i++) {
            var driverName = drivers[i];
            if (this.supports(driverName)) {
              supportedDrivers.push(driverName);
            }
          }
          return supportedDrivers;
        };
        LocalForage2.prototype._wrapLibraryMethodsWithReady = function _wrapLibraryMethodsWithReady() {
          for (var i = 0, len = LibraryMethods.length; i < len; i++) {
            callWhenReady(this, LibraryMethods[i]);
          }
        };
        LocalForage2.prototype.createInstance = function createInstance(options) {
          return new LocalForage2(options);
        };
        return LocalForage2;
      }();
      var localforage_js = new LocalForage();
      module3.exports = localforage_js;
    }, { "3": 3 }] }, {}, [4])(4);
  });
})(localforage);
var localForage = localforage.exports;
const e = { props: { src: { type: String, required: true }, srcPlaceholder: { type: String, default: "data:," }, srcset: { type: String }, intersectionOptions: { type: Object, default: () => ({}) }, usePicture: { type: Boolean, default: false } }, inheritAttrs: false, data: () => ({ observer: null, intersected: false, loaded: false }), computed: { srcImage() {
  return this.intersected && this.src ? this.src : this.srcPlaceholder;
}, srcsetImage() {
  return !(!this.intersected || !this.srcset) && this.srcset;
} }, methods: { load() {
  this.$el.getAttribute("src") !== this.srcPlaceholder && (this.loaded = true, this.$emit("load"));
}, error() {
  this.$emit("error", this.$el);
} }, render(e2) {
  let t = e2("img", { attrs: { src: this.srcImage, srcset: this.srcsetImage }, domProps: this.$attrs, class: { "v-lazy-image": true, "v-lazy-image-loaded": this.loaded }, on: { load: this.load, error: this.error } });
  return this.usePicture ? e2("picture", { on: { load: this.load } }, this.intersected ? [this.$slots.default, t] : [t]) : t;
}, mounted() {
  "IntersectionObserver" in window && (this.observer = new IntersectionObserver((e2) => {
    e2[0].isIntersecting && (this.intersected = true, this.observer.disconnect(), this.$emit("intersect"));
  }, this.intersectionOptions), this.observer.observe(this.$el));
}, destroyed() {
  "IntersectionObserver" in window && this.observer.disconnect();
} };
var __defProp$g = Object.defineProperty;
var __getOwnPropDesc$g = Object.getOwnPropertyDescriptor;
var __decorateClass$g = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$g(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$g(target, key, result);
  return result;
};
const ComponentProps$9 = Vue$1.extend({
  props: {
    message: {
      type: Object,
      default: () => {
      }
    },
    index: {
      type: [Number, String],
      default: 0
    }
  }
});
let AudioPlayer$1 = class extends ComponentProps$9 {
  constructor() {
    super(...arguments);
    this.isPlaying = false;
    this.isMouseDown = false;
    this.percentage = 0;
    this.pos = 0;
    this.duration = this.convertTimeMMSS(0);
    this.playedTime = this.convertTimeMMSS(0);
    this.player = null;
    this.progressTime = "- : -";
  }
  mounted() {
    this.player = document.getElementById(`audio-${this.index}`);
    this.player.addEventListener("ended", () => {
      this.isPlaying = false;
    });
    this.player.addEventListener("loadeddata", () => {
      this.resetProgress();
      this.duration = this.convertTimeMMSS(this.player.duration);
      this.updateProgressTime();
    });
    this.player.addEventListener("timeupdate", this.onTimeUpdate);
  }
  get currentAudioPlaying() {
    return store.state.currentAudioPlaying;
  }
  convertTimeMMSS(seconds) {
    return new Date(seconds * 1e3).toISOString().substr(14, 5);
  }
  playback() {
    if (this.isPlaying) {
      this.player.muted = true;
      this.player.pause();
    } else {
      setTimeout(() => {
        this.player.muted = false;
        this.player.play();
        this.pauseOtherAudio();
        store.setState("currentAudioPlaying", this.index);
      });
    }
    this.isPlaying = !this.isPlaying;
  }
  resetProgress() {
    if (this.isPlaying)
      this.player.pause();
    this.duration = this.convertTimeMMSS(0);
    this.playedTime = this.convertTimeMMSS(0);
    this.percentage = 0;
    this.isPlaying = false;
    this.updateProgressTime();
  }
  onTimeUpdate() {
    this.playedTime = this.convertTimeMMSS(this.player.currentTime);
    this.percentage = this.player.currentTime / this.player.duration * 100;
    this.updateProgressTime();
  }
  onUpdateProgress() {
    if (this.pos)
      this.player.currentTime = this.pos * this.player.duration;
  }
  updateProgressTime() {
    this.progressTime = this.percentage > 1 ? this.playedTime : this.duration;
  }
  onMouseDown(event) {
    this.isMouseDown = true;
    this.pos = this.calculateLineHeadPosition(event, this.$refs.progress);
    this.onUpdateProgress();
    document.addEventListener("mousemove", this.onMouseMove);
    document.addEventListener("mouseup", this.onMouseUp);
  }
  onMouseUp(event) {
    this.isMouseDown = false;
    document.removeEventListener("mouseup", this.onMouseUp);
    document.removeEventListener("mousemove", this.onMouseMove);
    this.pos = this.calculateLineHeadPosition(event, this.$refs.progress);
    this.onUpdateProgress();
  }
  onMouseMove(event) {
    this.pos = this.calculateLineHeadPosition(event, this.$refs.progress);
    this.onUpdateProgress();
  }
  calculateLineHeadPosition(event, element) {
    const progressWidth = element.getBoundingClientRect().width;
    const leftPosition = element.getBoundingClientRect().left;
    let pos = (event.clientX - leftPosition) / progressWidth;
    pos = pos < 0 ? 0 : pos;
    pos = pos > 1 ? 1 : pos;
    return pos;
  }
  pauseOtherAudio() {
    const audioElements = document.querySelectorAll("audio");
    audioElements.forEach((audio) => {
      if (this.player !== audio) {
        audio.muted = true;
        audio.pause();
      }
    });
  }
};
AudioPlayer$1 = __decorateClass$g([
  Component({
    name: "AudioPlayer",
    components: {
      Content
    },
    watch: {
      currentAudioPlaying: {
        handler(playingIndex) {
          if (playingIndex !== this.index) {
            this.isPlaying = false;
          }
        }
      }
    }
  })
], AudioPlayer$1);
var render$g = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "robin-ap robin-flex robin-flex-align-start" }, [!_vm.isPlaying ? _c("i", { staticClass: "robin-material-icon", attrs: { "role": "button" }, on: { "click": function($event) {
    return _vm.playback();
  } } }, [_vm._v("play_arrow")]) : _c("i", { staticClass: "robin-material-icon", attrs: { "role": "button" }, on: { "click": function($event) {
    return _vm.playback();
  } } }, [_vm._v("pause")]), _c("div", { staticClass: "robin-ap-bar-wrapper robin-flex robin-flex-column robin-flex-space-between" }, [_c("div", { ref: "progress", staticClass: "robin-ap-bar", on: { "mousedown": _vm.onMouseDown } }, [_c("div", { staticClass: "robin-ap-progress" }, [_c("div", { staticClass: "robin-ap-line-container" }, [_c("div", { staticClass: "robin-ap-line-progress", style: { width: (_vm.percentage > 10 ? _vm.percentage - 7 : _vm.percentage) + "%" } }), _c("div", { staticClass: "robin-ap-line-dot", class: { active: _vm.isMouseDown }, style: { left: (_vm.percentage > 10 ? _vm.percentage - 7 : _vm.percentage) + "%" }, attrs: { "role": "progress-dot" } })])])]), _c("span", { staticClass: "robin-ap-time" }, [_vm._v(" " + _vm._s(_vm.percentage > 1 ? _vm.playedTime : _vm.duration) + " ")])]), _c("audio", { attrs: { "data-testid": "audio-" + _vm.index, "id": "audio-" + _vm.index, "src": _vm.message.content.attachment } }, [_vm._v("Your browser does not support the")])]);
};
var staticRenderFns$g = [];
var AudioPlayer_vue_vue_type_style_index_0_scoped_true_lang = "";
const __cssModules$g = {};
var __component__$g = /* @__PURE__ */ normalizeComponent(AudioPlayer$1, render$g, staticRenderFns$g, false, injectStyles$g, "54d6454c", null, null);
function injectStyles$g(context2) {
  for (let o in __cssModules$g) {
    this[o] = __cssModules$g[o];
  }
}
var AudioPlayer = /* @__PURE__ */ function() {
  return __component__$g.exports;
}();
var __defProp$f = Object.defineProperty;
var __getOwnPropDesc$f = Object.getOwnPropertyDescriptor;
var __decorateClass$f = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$f(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$f(target, key, result);
  return result;
};
const ComponentProps$8 = Vue$1.extend({
  props: {
    messages: {
      type: Array,
      default: () => []
    },
    message: {
      type: Object,
      default: () => {
      }
    },
    sender: {
      type: Boolean,
      default: false
    },
    index: {
      type: Number,
      default: 0
    }
  }
});
let ReplyMessageBubble$1 = class extends ComponentProps$8 {
  constructor() {
    super(...arguments);
    this.props = {};
    this.imageRegex = /^image/;
    this.videoRegex = /^video/;
    this.documentRegex = /(csv|xlsx|xls|doc|docx|ppt|pptx|txt|pdf|ppt|rtf|rar|tar|odt|md|zip|7z|zip|mp3|html)$/;
    this.emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    this.websiteRegex = /[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)/;
  }
  get imageSelected() {
    return store.state.imageSelected;
  }
  get assets() {
    return assets;
  }
  checkAttachmentType(attachmentUrl) {
    const strArr = attachmentUrl.split(".");
    if (mime.getType(strArr[strArr.length - 1]) === "application/msword") {
      return "doc";
    }
    if (mime.getType(strArr[strArr.length - 1]) === "audio/mpeg") {
      return "mp3";
    }
    return `${mime.getType(strArr[strArr.length - 1])}`;
  }
  getFileDetails(attachmentUrl) {
    const fileName = attachmentUrl.substring(attachmentUrl.lastIndexOf("/") + 1);
    const strArr = fileName.split(".");
    return {
      name: strArr[strArr.length - 2],
      extension: strArr[strArr.length - 1]
    };
  }
  checkArrayReceiverUserToken(message) {
    return message.some((item) => item.content.sender_token === this.$user_token);
  }
  getContactName(sender_token) {
    const index = this.$robin_users.findIndex((user2) => user2.userToken === sender_token);
    const user = this.$robin_users[index];
    return user ? user.userName : "";
  }
  getReplyMessage(id) {
    const message = this.messages.find((element) => {
      if (Array.isArray(element)) {
        return element.find((item) => item._id === id);
      }
      if (!Array.isArray(element)) {
        if (element._id === id) {
          return element;
        }
      }
      return false;
    });
    if (Array.isArray(message)) {
      return message.find((element) => element._id === id);
    }
    return message;
  }
  validateLinkInMessage() {
    const texts = this.getReplyMessage(this.message.reply_to).content.msg.split(" ");
    return {
      containsWebsite: texts.some((text) => this.websiteRegex.test(text)),
      containsEmail: texts.some((text) => this.emailRegex.test(text))
    };
  }
  getTextsInMessage() {
    return {
      texts: this.getReplyMessage(this.message.reply_to).content.msg.split(" "),
      length: this.getReplyMessage(this.message.reply_to).content.msg.split(" ").length
    };
  }
  injectHtml() {
    let returnedMessage = "";
    for (const word of this.getReplyMessage(this.message.reply_to).content.msg.split(" ")) {
      if (this.emailRegex.test(word)) {
        returnedMessage += String.raw` <a target="_blank" href="mailto:${word}" > ${word} <a/>`;
      } else if (this.websiteRegex.test(word)) {
        if (word.includes("http://") || word.includes("https://")) {
          returnedMessage += String.raw` <a target="_blank" href="${word}" > ${word} <a/>`;
        } else {
          returnedMessage += String.raw` <a target="_blank" href="http://${word}"> ${word} <a/>`;
        }
      } else {
        returnedMessage += ` ${word}`;
      }
    }
    return returnedMessage;
  }
  scrollToRepliedMessage(id) {
    this.$emit("scroll-replied-message", id);
  }
};
ReplyMessageBubble$1 = __decorateClass$f([
  Component({
    name: "ReplyMessageBubble",
    components: {
      Content,
      VLazyImage: e,
      AudioPlayer
    }
  })
], ReplyMessageBubble$1);
var render$f = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _vm.getReplyMessage(_vm.message.reply_to) && !_vm.getReplyMessage(_vm.message.reply_to).content.is_attachment ? _c("div", { staticClass: "robin-reply-message-bubble robin-flex robin-flex-align-start", class: _vm.sender ? "robin-reply-sender" : "robin-reply-receiver", on: { "click": function($event) {
    return _vm.scrollToRepliedMessage(_vm.message.reply_to);
  } } }, [_c("div", [_c("Content", { staticClass: "robin-messager-name robin-mb-4", attrs: { "font-size": 14, "color": "#51545C", "as": "span", "line-height": 20 } }, [_vm._v(" " + _vm._s(_vm.getReplyMessage(_vm.message.reply_to).sender_token === _vm.$user_token ? "You" : _vm.getContactName(_vm.getReplyMessage(_vm.message.reply_to).content.sender_token)) + " ")]), !_vm.validateLinkInMessage().containsEmail && !_vm.validateLinkInMessage().containsWebsite ? _c("Content", { attrs: { "font-size": 14, "color": "#8D9091", "textWrap": "pre-line", "wordBreak": "break-word", "as": "span" } }, [_vm._v(" " + _vm._s(_vm.getReplyMessage(_vm.message.reply_to).content.msg) + " ")]) : _vm._e(), _vm.validateLinkInMessage().containsEmail && _vm.validateLinkInMessage().containsWebsite || _vm.validateLinkInMessage().containsEmail || _vm.validateLinkInMessage().containsWebsite ? _c("div", { staticClass: "robin-link-container", domProps: { "innerHTML": _vm._s(_vm.injectHtml()) } }) : _vm._e()], 1)]) : _vm.getReplyMessage(_vm.message.reply_to) && _vm.imageRegex.test(_vm.checkAttachmentType(_vm.getReplyMessage(_vm.message.reply_to).content.attachment)) ? _c("div", { staticClass: "robin-reply-message-bubble", class: _vm.sender ? "robin-reply-sender" : "robin-reply-receiver", on: { "click": function($event) {
    return _vm.scrollToRepliedMessage(_vm.message.reply_to);
  } } }, [_c("Content", { staticClass: "robin-messager-name robin-mb-4", attrs: { "font-size": 14, "color": "#51545C", "as": "span", "line-height": 20 } }, [_vm._v(" " + _vm._s(_vm.getReplyMessage(_vm.message.reply_to).sender_token === _vm.$user_token ? "You" : _vm.getContactName(_vm.getReplyMessage(_vm.message.reply_to).content.sender_token)) + " ")]), _c("v-lazy-image", { staticClass: "robin-uploaded-image", attrs: { "src": _vm.getReplyMessage(_vm.message.reply_to).content.attachment } }), !_vm.validateLinkInMessage().containsEmail && !_vm.validateLinkInMessage().containsWebsite && _vm.getReplyMessage(_vm.message.reply_to).content.msg && _vm.getReplyMessage(_vm.message.reply_to).content.msg != "undefined" ? _c("Content", { attrs: { "max-width": _vm.getReplyMessage(_vm.message.reply_to).content.msg.length < 120 ? "217" : "270", "textWrap": "pre-line", "wordBreak": "break-word", "as": "span" } }, [_vm._v(" " + _vm._s(_vm.getReplyMessage(_vm.message.reply_to).content.msg) + " ")]) : _vm._e(), _vm.validateLinkInMessage().containsEmail && _vm.validateLinkInMessage().containsWebsite || _vm.validateLinkInMessage().containsEmail || _vm.validateLinkInMessage().containsWebsite && _vm.getReplyMessage(_vm.message.reply_to).content.msg && _vm.getReplyMessage(_vm.message.reply_to).content.msg != "undefined" ? _c("div", { staticClass: "robin-link-container", domProps: { "innerHTML": _vm._s(_vm.injectHtml()) } }) : _vm._e()], 1) : _vm.getReplyMessage(_vm.message.reply_to) && _vm.videoRegex.test(_vm.checkAttachmentType(_vm.getReplyMessage(_vm.message.reply_to).content.attachment)) ? _c("div", { staticClass: "robin-reply-message-bubble", class: _vm.sender ? "robin-reply-sender" : "robin-reply-receiver", on: { "click": function($event) {
    return _vm.scrollToRepliedMessage(_vm.message.reply_to);
  } } }, [_c("Content", { staticClass: "robin-messager-name robin-mb-4", attrs: { "font-size": 14, "color": "#51545C", "as": "span", "line-height": 20 } }, [_vm._v(" " + _vm._s(_vm.getReplyMessage(_vm.message.reply_to).sender_token === _vm.$user_token ? "You" : _vm.getContactName(_vm.getReplyMessage(_vm.message.reply_to).content.sender_token)) + " ")]), _c("video", { attrs: { "controls": "" } }, [_c("source", { attrs: { "src": _vm.getReplyMessage(_vm.message.reply_to).content.attachment } }), _vm._v(" Your browser does not support the video tag. ")]), !_vm.validateLinkInMessage().containsEmail && !_vm.validateLinkInMessage().containsWebsite && _vm.getReplyMessage(_vm.message.reply_to).content.msg && _vm.getReplyMessage(_vm.message.reply_to).content.msg != "undefined" ? _c("Content", { attrs: { "max-width": _vm.getReplyMessage(_vm.message.reply_to).content.msg.length < 120 ? "217" : "270", "textWrap": "pre-line", "wordBreak": "break-word", "as": "span" } }, [_vm._v(" " + _vm._s(_vm.getReplyMessage(_vm.message.reply_to).content.msg) + " ")]) : _vm._e(), _vm.validateLinkInMessage().containsEmail && _vm.validateLinkInMessage().containsWebsite || _vm.validateLinkInMessage().containsEmail || _vm.validateLinkInMessage().containsWebsite && _vm.getReplyMessage(_vm.message.reply_to).content.msg && _vm.getReplyMessage(_vm.message.reply_to).content.msg != "undefined" ? _c("div", { staticClass: "robin-link-container", domProps: { "innerHTML": _vm._s(_vm.injectHtml()) } }) : _vm._e()], 1) : _vm.getReplyMessage(_vm.message.reply_to) && _vm.documentRegex.test(_vm.checkAttachmentType(_vm.getReplyMessage(_vm.message.reply_to).content.attachment)) ? _c("div", { staticClass: "robin-reply-message-bubble", class: _vm.sender ? "robin-reply-sender" : "robin-reply-receiver", on: { "click": function($event) {
    return _vm.scrollToRepliedMessage(_vm.message.reply_to);
  } } }, [_c("Content", { staticClass: "robin-messager-name robin-mb-4", attrs: { "font-size": 14, "color": "#51545C", "as": "span", "line-height": 20 } }, [_vm._v(" " + _vm._s(_vm.getReplyMessage(_vm.message.reply_to).sender_token === _vm.$user_token ? "You" : _vm.getContactName(_vm.getReplyMessage(_vm.message.reply_to).content.sender_token)) + " ")]), _vm.getFileDetails(_vm.getReplyMessage(_vm.message.reply_to).content.attachment).extension !== "mp3" ? _c("div", { staticClass: "robin-reply-document robin-flex robin-flex-align-center" }, [_vm.assets[_vm.getFileDetails(_vm.getReplyMessage(_vm.message.reply_to).content.attachment).extension] ? _c("img", { attrs: { "src": _vm.assets[_vm.getFileDetails(_vm.getReplyMessage(_vm.message.reply_to).content.attachment).extension], "alt": "document" } }) : _c("img", { attrs: { "src": _vm.assets["default"] } }), _c("div", { staticClass: "details robin-ml-5" }, [_c("Content", { attrs: { "as": "span", "fontSize": 14 } }, [_vm._v(" " + _vm._s(_vm.getFileDetails(_vm.getReplyMessage(_vm.message.reply_to).content.attachment).name.length > 9 ? _vm.getFileDetails(_vm.getReplyMessage(_vm.message.reply_to).content.attachment).name.substring(0, 9) + "...." + _vm.getFileDetails(_vm.getReplyMessage(_vm.message.reply_to).content.attachment).extension : _vm.getFileDetails(_vm.getReplyMessage(_vm.message.reply_to).content.attachment).name + "." + _vm.getFileDetails(_vm.getReplyMessage(_vm.message.reply_to).content.attachment).extension) + " ")])], 1)]) : _c("AudioPlayer", { attrs: { "message": _vm.getReplyMessage(_vm.message.reply_to), "index": "reply-" + _vm.index, "show-progress-time": false } }), !_vm.validateLinkInMessage().containsEmail && !_vm.validateLinkInMessage().containsWebsite && _vm.getReplyMessage(_vm.message.reply_to).content.msg && _vm.getReplyMessage(_vm.message.reply_to).content.msg != "undefined" ? _c("Content", { attrs: { "max-width": _vm.getReplyMessage(_vm.message.reply_to).content.msg.length < 120 ? "217" : "270", "textWrap": "pre-line", "wordBreak": "break-word", "as": "span" } }, [_vm._v(" " + _vm._s(_vm.getReplyMessage(_vm.message.reply_to).content.msg) + " ")]) : _vm._e(), _vm.validateLinkInMessage().containsEmail && _vm.validateLinkInMessage().containsWebsite || _vm.validateLinkInMessage().containsEmail || _vm.validateLinkInMessage().containsWebsite && _vm.getReplyMessage(_vm.message.reply_to).content.msg && _vm.getReplyMessage(_vm.message.reply_to).content.msg != "undefined" ? _c("div", { staticClass: "robin-link-container", domProps: { "innerHTML": _vm._s(_vm.injectHtml()) } }) : _vm._e()], 1) : _vm._e();
};
var staticRenderFns$f = [];
var ReplyMessageBubble_vue_vue_type_style_index_0_scoped_true_lang = "";
const __cssModules$f = {};
var __component__$f = /* @__PURE__ */ normalizeComponent(ReplyMessageBubble$1, render$f, staticRenderFns$f, false, injectStyles$f, "198cb87d", null, null);
function injectStyles$f(context2) {
  for (let o in __cssModules$f) {
    this[o] = __cssModules$f[o];
  }
}
var ReplyMessageBubble = /* @__PURE__ */ function() {
  return __component__$f.exports;
}();
var __defProp$e = Object.defineProperty;
var __getOwnPropDesc$e = Object.getOwnPropertyDescriptor;
var __decorateClass$e = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$e(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$e(target, key, result);
  return result;
};
const ComponentProps$7 = Vue$1.extend({
  props: {
    id: {
      type: String,
      default: ""
    },
    message: {
      type: [Object, Array],
      default: () => {
      }
    }
  }
});
let ReactionPopOver$1 = class extends ComponentProps$7 {
};
ReactionPopOver$1 = __decorateClass$e([
  Component({
    name: "ReactionPopOver",
    components: {
      Button
    }
  })
], ReactionPopOver$1);
var render$e = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { ref: "popup-body", staticClass: "robin-popup robin-zoomIn" }, [_c("div", { staticClass: "robin-reaction-container" }, [_c("Button", { attrs: { "font-size": 18, "emit": "click", "data-testid": "heart" }, on: { "click": function($event) {
    return _vm.$emit("reaction", "\u2764\uFE0F");
  } } }, [_vm._v("\u2764\uFE0F")]), _c("Button", { attrs: { "font-size": 18, "emit": "click", "data-testid": "thumbs-up" }, on: { "click": function($event) {
    return _vm.$emit("reaction", "\u{1F44D}");
  } } }, [_vm._v("\u{1F44D}")]), _c("Button", { attrs: { "font-size": 18, "emit": "click", "data-testid": "thumbs-down" }, on: { "click": function($event) {
    return _vm.$emit("reaction", "\u{1F44E}");
  } } }, [_vm._v("\u{1F44E}")]), _c("Button", { attrs: { "font-size": 18, "emit": "click", "data-testid": "laughter" }, on: { "click": function($event) {
    return _vm.$emit("reaction", "\u{1F602}");
  } } }, [_vm._v("\u{1F602}")]), _c("Button", { attrs: { "font-size": 18, "color": "initial", "emit": "click", "data-testid": "question" }, on: { "click": function($event) {
    return _vm.$emit("reaction", "\u2049\uFE0F");
  } } }, [_vm._v("\u2049\uFE0F")])], 1)]);
};
var staticRenderFns$e = [];
var ReactionPopOver_vue_vue_type_style_index_0_scoped_true_lang = "";
const __cssModules$e = {};
var __component__$e = /* @__PURE__ */ normalizeComponent(ReactionPopOver$1, render$e, staticRenderFns$e, false, injectStyles$e, "0ea9f1ce", null, null);
function injectStyles$e(context2) {
  for (let o in __cssModules$e) {
    this[o] = __cssModules$e[o];
  }
}
var ReactionPopOver = /* @__PURE__ */ function() {
  return __component__$e.exports;
}();
var __defProp$d = Object.defineProperty;
var __getOwnPropDesc$d = Object.getOwnPropertyDescriptor;
var __decorateClass$d = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$d(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$d(target, key, result);
  return result;
};
const ComponentProps$6 = Vue$1.extend({
  props: {
    groupnameColors: {
      type: Object,
      default: () => {
      }
    },
    message: {
      type: Array,
      default: () => []
    },
    messagePopup: {
      type: Object,
      default: () => {
      }
    },
    conversation: {
      type: Object,
      default: () => {
      }
    },
    readReceipts: {
      type: Array,
      default: () => []
    }
  }
});
let MessageGrid$1 = class extends ComponentProps$6 {
  constructor() {
    super(...arguments);
    this.images = [];
  }
  get getSizeOfGridClass() {
    if (this.message.length >= 4) {
      return "robin-grid-4-by-4";
    } else if (this.message.length === 3) {
      return "robin-grid-3-by-3";
    } else {
      return "robin-grid-2-by-2";
    }
  }
  get isMessageReactionViewEnabled() {
    return store.state.messageReactionViewEnabled;
  }
  closeModal() {
    this.$emit("close-modal");
  }
  openPreview(message) {
    this.$emit("open-preview", message);
    this.closeModal();
  }
  formatTimeStamp(value) {
    return moment(String(value)).format("h:mma").toUpperCase();
  }
  validateImageClass(index) {
    return this.message.some((item) => item.content && item.content.sender_token !== this.$user_token) ? `robin-image-sender robin-grid-${index}` : `robin-image-receiver robin-grid-${index}`;
  }
  validateMessageClass() {
    return this.message.some((item) => item.content && item.content.sender_token === this.$user_token);
  }
  getFileDetails(attachmentUrl) {
    const fileName = attachmentUrl.substring(attachmentUrl.lastIndexOf("/") + 1);
    const strArr = fileName.split(".");
    return {
      name: strArr[strArr.length - 2],
      extension: strArr[strArr.length - 1]
    };
  }
  async downloadImages(messages) {
    let intervalLevel = 0;
    const interval = setInterval(() => {
      if (intervalLevel === messages.length) {
        clearInterval(interval);
        return;
      }
      const element = document.createElement("a");
      const fileDetails = this.getFileDetails(messages[intervalLevel].content.attachment);
      element.setAttribute("href", messages[intervalLevel].content.attachment);
      element.setAttribute("download", fileDetails.name + " " + fileDetails.extension);
      document.body.appendChild(element);
      element.click();
      document.body.removeChild(element);
      intervalLevel += 1;
    }, 1e3);
  }
  getContactName(sender_token) {
    const index = this.$robin_users.findIndex((user2) => user2.userToken === sender_token);
    const user = this.$robin_users[index];
    return user ? user.userName : "";
  }
};
MessageGrid$1 = __decorateClass$d([
  Component({
    name: "MessageGrid",
    components: {
      Content,
      VLazyImage: e,
      ReactionPopOver,
      SvgIcon,
      IconButton
    },
    watch: {
      message: {
        handler(val) {
          this.images = [...val].slice(0, 4);
        },
        immediate: true
      }
    }
  })
], MessageGrid$1);
var render$d = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "robin-bubble", class: !_vm.validateMessageClass() ? "robin-grid-sender" : "robin-grid-receiver", attrs: { "data-testid": "bubble" }, on: { "click": function($event) {
    if ($event.target !== $event.currentTarget) {
      return null;
    }
    return _vm.$emit("open-modal");
  } } }, [_c("div", { ref: "popup-body", staticClass: "robin-popup-container reactions" }, [_c("ReactionPopOver", { directives: [{ name: "show", rawName: "v-show", value: _vm.messagePopup.opened && _vm.isMessageReactionViewEnabled, expression: "messagePopup.opened && isMessageReactionViewEnabled" }], attrs: { "id": _vm.message[0]._id, "message": _vm.message[0] }, on: { "close-modal": function($event) {
    return _vm.closeModal();
  }, "reaction": function($event) {
    return _vm.$emit("add-reaction", $event);
  } } })], 1), !_vm.validateMessageClass() && _vm.conversation.is_group ? _c("Content", { staticClass: "robin-messager-name robin-mb-4", attrs: { "font-size": 12, "as": "span", "color": _vm.groupnameColors[_vm.message[0].content.sender_token], "line-height": 20 } }, [_vm._v(" " + _vm._s(_vm.getContactName(_vm.message[0].content.sender_token)) + " ")]) : _vm._e(), _c("div", { staticClass: "robin-bubble-inner robin-grid-container", class: _vm.getSizeOfGridClass, attrs: { "data-testid": "bubble-inner" }, on: { "click": function($event) {
    return _vm.openPreview(_vm.message);
  } } }, [_vm._l(_vm.images, function(image, index) {
    return _c("div", { key: image._id, staticClass: "robin-message-bubble-image", class: _vm.validateImageClass(index) }, [_c("v-lazy-image", { staticClass: "robin-uploaded-image", attrs: { "src": image.content.attachment } })], 1);
  }), _c("span", { staticClass: "robin-drop-shadow robin-flex", class: _vm.message.length > 4 ? "back-drop robin-flex-column robin-flex-space-between" : "robin-flex-end" }, [_c("Content", { directives: [{ name: "show", rawName: "v-show", value: _vm.message.length > 4, expression: "message.length > 4" }], staticClass: "robin-message-count", attrs: { "font-size": 26, "color": "#fff", "as": "p" } }, [_vm._v(" " + _vm._s(_vm.message.length - 4) + "+ ")])], 1)], 2), _c("Content", { staticClass: "robin-side-text", attrs: { "font-size": 10, "font-weight": "300", "color": "#7a7a7a", "as": "p" } }, [_vm._v(" " + _vm._s(_vm.formatTimeStamp(_vm.message[0].content.timestamp)) + " "), _vm.message[0].is_read ? _c("SvgIcon", { attrs: { "name": "read" } }) : _vm._e(), !_vm.message[0].is_read ? _c("SvgIcon", { attrs: { "name": "not-read" } }) : _vm._e()], 1), _c("IconButton", { staticClass: "download-btn", attrs: { "name": "downloadImage", "to-emit": true, "to-click-away": false }, on: { "clicked": function($event) {
    return _vm.downloadImages(_vm.message);
  } } })], 1);
};
var staticRenderFns$d = [];
var MessageGrid_vue_vue_type_style_index_0_scoped_true_lang = "";
const __cssModules$d = {};
var __component__$d = /* @__PURE__ */ normalizeComponent(MessageGrid$1, render$d, staticRenderFns$d, false, injectStyles$d, "cbca5516", null, null);
function injectStyles$d(context2) {
  for (let o in __cssModules$d) {
    this[o] = __cssModules$d[o];
  }
}
var MessageGrid = /* @__PURE__ */ function() {
  return __component__$d.exports;
}();
var __defProp$c = Object.defineProperty;
var __getOwnPropDesc$c = Object.getOwnPropertyDescriptor;
var __decorateClass$c = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$c(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$c(target, key, result);
  return result;
};
const ComponentProps$5 = Vue$1.extend({
  props: {
    id: {
      type: String,
      default: ""
    },
    message: {
      type: [Object, Array],
      default: () => {
      }
    }
  }
});
let MessagePopOver$1 = class extends ComponentProps$5 {
  get isDeleteMessagesEnabled() {
    return store.state.deleteMessagesEnabled;
  }
  get isForwardMessagesEnabled() {
    return store.state.forwardMessagesEnabled;
  }
  get isReplyMessagesEnabled() {
    return store.state.replyMessagesEnabled;
  }
  async deleteMessage() {
    this.$emit("close-modal");
    const res = await this.$robin.deleteMessages([this.id], this.$user_token);
    if (res && !res.error) {
      EventBus.$emit("message-deleted", this.message);
      this.$toast.open({
        message: "Message Deleted.",
        type: "success",
        position: "bottom-left"
      });
    } else {
      this.$toast.open({
        message: "Check your connection.",
        type: "error",
        position: "bottom-left"
      });
    }
  }
  selectMessage() {
    store.setState("selectMessagesOpen", true);
    this.$emit("select-message");
  }
  forwardMessage() {
    store.setState("selectMessagesOpen", true);
    this.$emit("select-message");
    this.$emit("forward-message");
  }
};
MessagePopOver$1 = __decorateClass$c([
  Component({
    name: "MessagePopOver",
    components: {
      Content,
      IconButton
    }
  })
], MessagePopOver$1);
var render$c = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { ref: "popup-body", staticClass: "robin-popup robin-zoomIn" }, [_vm.isReplyMessagesEnabled ? _c("div", { staticClass: "robin-wrapper robin-w-100", attrs: { "data-testid": "reply-button" }, on: { "click": function($event) {
    return _vm.$emit("reply-message");
  } } }, [_c("Content", { attrs: { "font-size": 14, "color": "#51545C" } }, [_vm._v("Reply Message")]), _c("IconButton", { attrs: { "name": "reply", "to-emit": false, "to-click-away": false } })], 1) : _vm._e(), _vm.isForwardMessagesEnabled ? _c("div", { staticClass: "robin-wrapper robin-w-100", attrs: { "data-testid": "forward-button" }, on: { "click": function($event) {
    return _vm.forwardMessage();
  } } }, [_c("Content", { attrs: { "font-size": 14, "color": "#51545C" } }, [_vm._v("Forward")]), _c("IconButton", { attrs: { "name": "forward", "to-emit": false, "to-click-away": false } })], 1) : _vm._e(), _vm.isForwardMessagesEnabled || _vm.isDeleteMessagesEnabled || _vm.isForwardMessagesEnabled && _vm.isDeleteMessagesEnabled ? _c("div", { staticClass: "robin-wrapper robin-w-100", attrs: { "data-testid": "select-button" }, on: { "click": function($event) {
    return _vm.selectMessage();
  } } }, [_c("Content", { attrs: { "font-size": 14, "color": "#51545C" } }, [_vm._v("Select Message")]), _c("IconButton", { attrs: { "name": "select", "to-emit": false, "to-click-away": false } })], 1) : _vm._e(), _vm.isDeleteMessagesEnabled ? _c("div", { staticClass: "robin-wrapper robin-w-100", attrs: { "data-testid": "delete-button" }, on: { "click": function($event) {
    return _vm.deleteMessage();
  } } }, [_c("Content", { attrs: { "font-size": 14, "color": "#51545C" } }, [_vm._v("Delete Message")]), _c("IconButton", { attrs: { "name": "delete", "to-emit": false, "to-click-away": false } })], 1) : _vm._e()]);
};
var staticRenderFns$c = [];
var MessagePopOver_vue_vue_type_style_index_0_scoped_true_lang = "";
const __cssModules$c = {};
var __component__$c = /* @__PURE__ */ normalizeComponent(MessagePopOver$1, render$c, staticRenderFns$c, false, injectStyles$c, "08178d59", null, null);
function injectStyles$c(context2) {
  for (let o in __cssModules$c) {
    this[o] = __cssModules$c[o];
  }
}
var MessagePopOver = /* @__PURE__ */ function() {
  return __component__$c.exports;
}();
var __defProp$b = Object.defineProperty;
var __getOwnPropDesc$b = Object.getOwnPropertyDescriptor;
var __decorateClass$b = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$b(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$b(target, key, result);
  return result;
};
const ComponentProps$4 = Vue$1.extend({
  props: {
    message: {
      type: [Object, Array],
      default: () => {
      }
    },
    index: {
      type: Number,
      default: 0
    },
    groupnameColors: {
      type: Object,
      default: () => {
      }
    },
    messages: {
      type: Array,
      default: () => []
    },
    storedMessages: {
      type: Array,
      default: () => []
    },
    conversation: {
      type: Object,
      default: () => {
      }
    },
    messagePopup: {
      type: Object,
      default: () => ({
        opened: false,
        _id: ""
      })
    },
    lastId: {
      type: String,
      default: ""
    },
    scroll: {
      type: Boolean,
      default: false
    },
    readReceipts: {
      type: Array,
      default: () => []
    },
    uncheck: {
      type: Boolean,
      default: false
    }
  }
});
let MessageContent$1 = class extends ComponentProps$4 {
  constructor() {
    super(...arguments);
    this.props = {};
    this.caretOpen = false;
    this.screenWidth = 0;
    this.imageRegex = /^image/;
    this.videoRegex = /^video/;
    this.documentRegex = /^application\/(csv|pdf|msword|(vnd\.(ms-|openxmlformats-).*))$|^text\/plain$|^audio\/mpeg$/i;
    this.emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    this.websiteRegex = /[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)/;
    this.files = [];
    this.leaveGroupActivity = [];
    this.reactions = { "\u2764\uFE0F": [], "\u{1F44D}": [], "\u{1F44E}": [], "\u{1F602}": [], "\u2049\uFE0F": [] };
    this.videoPlayer = null;
  }
  get selectMessagesOpen() {
    return store.state.selectMessagesOpen;
  }
  get isReplyMessagesEnabled() {
    return store.state.replyMessagesEnabled;
  }
  get isDeleteMessagesEnabled() {
    return store.state.deleteMessagesEnabled;
  }
  get isForwardMessagesEnabled() {
    return store.state.forwardMessagesEnabled;
  }
  get isMessageReactionViewEnabled() {
    return store.state.messageReactionViewEnabled;
  }
  get isMessageReactionDeleteEnabled() {
    return store.state.messageReactionDeleteEnabled;
  }
  get assets() {
    return assets;
  }
  created() {
    this.onNewReaction();
    this.onReactionDelete();
    this.handleLeaveGroup();
  }
  mounted() {
    this.$nextTick(function() {
      this.onResize();
    });
    window.addEventListener("resize", this.onResize);
    this.injectHtml(this.message.content ? this.message.content.msg : null);
    this.videoPlayer = document.getElementById(`video-${this.index}`);
    if (this.videoPlayer) {
      this.videoPlayer.addEventListener("play", (event) => {
        this.pauseOtherVideo();
      });
    }
  }
  getMessageIndex() {
    const message = this.messages[this.index];
    if (Array.isArray(message)) {
      return this.storedMessages.findIndex((item) => {
        if (Array.isArray(item)) {
          return item[0]._id === message[0]._id;
        }
        return false;
      });
    }
    return this.storedMessages.findIndex((item) => item._id === message._id);
  }
  showDate() {
    if (this.index - 1 > -1) {
      const dateA = this.messages[this.index];
      const dateB = this.messages[this.index - 1];
      if (Array.isArray(dateA) && !Array.isArray(dateB)) {
        return moment(dateA[0].created_at).format("YYYY-MM-DD") !== moment(dateB.created_at).format("YYYY-MM-DD");
      }
      if (!Array.isArray(dateA) && Array.isArray(dateB)) {
        return moment(dateA.created_at).format("YYYY-MM-DD") !== moment(dateB[0].created_at).format("YYYY-MM-DD");
      }
      if (Array.isArray(dateA) && Array.isArray(dateB)) {
        return moment(dateA[0].created_at).format("YYYY-MM-DD") !== moment(dateB[0].created_at).format("YYYY-MM-DD");
      }
      return moment(dateA.created_at).format("YYYY-MM-DD") !== moment(dateB.created_at).format("YYYY-MM-DD");
    }
    return false;
  }
  formatTimeStamp(value) {
    return moment(value).format("h:mma").toUpperCase();
  }
  formatDate(value) {
    const today = moment().format("MMM DD YYYY");
    const formattedValue = moment(value).format("MMM DD YYYY");
    if (today === formattedValue)
      return "Today";
    return moment(value).format("MMM DD YYYY");
  }
  checkAttachmentType(attachmentUrl) {
    const strArr = attachmentUrl.split(".");
    return `${mime.getType(strArr[strArr.length - 1])}`;
  }
  getFileDetails(attachmentUrl) {
    const fileName = attachmentUrl.substring(attachmentUrl.lastIndexOf("/") + 1);
    const strArr = fileName.split(".");
    return {
      name: strArr[strArr.length - 2],
      extension: strArr[strArr.length - 1]
    };
  }
  downloadFile(attachmentUrl) {
    const fileDetails = this.getFileDetails(attachmentUrl);
    const element = document.createElement("a");
    element.setAttribute("href", attachmentUrl);
    element.setAttribute("download", fileDetails.name + " " + fileDetails.extension);
    element.click();
  }
  openModal() {
    if (!this.selectMessagesOpen) {
      this.messagePopup.opened = true;
    }
  }
  closeModal() {
    const popup = this.$refs;
    for (const ref in popup) {
      if (ref !== "checkbox" && popup[ref] && popup[ref].$refs) {
        popup[ref].$refs["popup-body"].classList.remove("robin-zoomIn");
        popup[ref].$refs["popup-body"].classList.add("robin-zoomOut");
      }
    }
    window.setTimeout(() => {
      for (const ref in popup) {
        if (ref !== "checkbox" && popup[ref] && popup[ref].$refs) {
          popup[ref].$refs["popup-body"].classList.add("robin-zoomIn");
          popup[ref].$refs["popup-body"].classList.remove("robin-zoomOut");
        }
      }
      this.messagePopup.opened = false;
    }, 300);
  }
  openPreview(event) {
    this.$emit("open-preview", event);
  }
  checkArrayReceiverUserToken(message) {
    return message.some((item) => item.content.sender_token === this.$user_token);
  }
  validateMessages(message) {
    const nextMessage = this.messages[this.index + 1];
    if (Array.isArray(message) && this.checkArrayReceiverUserToken(message) && nextMessage && nextMessage.content.sender_token !== this.$user_token) {
      return "robin-message-receiver robin-w-100 robin-flex-align-end prev";
    }
    if (message.content && message.content.sender_token === this.$user_token && Array.isArray(nextMessage) && !this.checkArrayReceiverUserToken(nextMessage)) {
      return "robin-message-receiver robin-w-100 robin-flex-align-end prev";
    }
    if (Array.isArray(message) && this.checkArrayReceiverUserToken(message)) {
      return "robin-message-receiver robin-w-100 robin-flex-align-end";
    }
    if (message.content && message.content.sender_token === this.$user_token) {
      return "robin-message-receiver robin-w-100 robin-flex-align-end";
    }
    if (Array.isArray(message) && !this.checkArrayReceiverUserToken(message) && nextMessage && nextMessage.content.sender_token === this.$user_token) {
      return "robin-message-sender prev";
    }
    if (message.content && message.content.sender_token !== this.$user_token && Array.isArray(nextMessage) && this.checkArrayReceiverUserToken(nextMessage)) {
      return "robin-message-sender prev";
    }
    return "robin-message-sender";
  }
  toggleCheckAction(val) {
    this.$emit("toggle-check-action", val);
  }
  getContactName(sender_token) {
    const index = this.$robin_users.findIndex((user2) => user2.userToken === sender_token);
    const user = this.$robin_users[index];
    return user ? user.userName : "";
  }
  getReplyMessage(id) {
    const message = this.messages.find((element) => {
      if (Array.isArray(element)) {
        return element.find((item) => item._id === id);
      }
      if (!Array.isArray(element)) {
        if (element._id === id) {
          return element;
        }
      }
      return false;
    });
    return message;
  }
  async addReaction(emoji) {
    const robin = this.$robin;
    const message = Array.isArray(this.message) ? this.message[0] : this.message;
    await robin.reactToMessage(emoji, this.conversation._id, message._id, this.$user_token);
    this.closeModal();
  }
  async removeReaction(reaction) {
    const robin = this.$robin;
    const message = Array.isArray(this.message) ? this.message[0] : this.message;
    if (this.isMessageReactionDeleteEnabled) {
      await robin.RemoveReaction(reaction._id, message._id);
    }
  }
  onNewReaction() {
    EventBus.$on("message.reaction", (message) => {
      if (!Array.isArray(this.message)) {
        if (!this.message.reactions)
          this.message.reactions = [];
        if (this.message._id === message.message_id) {
          this.message.reactions.push(message);
          this.increaseMessageReaction(message.reaction, message);
        }
      } else {
        const messageArray = this.message;
        if (!messageArray[0].reactions)
          messageArray[0].reactions = [];
        if (this.message[0]._id === message.message_id) {
          this.message[0].reactions.push(message);
          this.increaseMessageReaction(message.reaction, message);
        }
      }
      this.$forceUpdate();
    });
  }
  getMessageReactions() {
    const reactions = Array.isArray(this.message) ? this.message[0].reactions : this.message.reactions;
    if (reactions) {
      reactions.forEach((message) => {
        this.increaseMessageReaction(message.reaction, message);
      });
    }
  }
  increaseMessageReaction(reaction, message) {
    const reactionExists = this.reactions[reaction].some((item) => item._id === message._id);
    if (!reactionExists)
      this.reactions[reaction].push(message);
  }
  reduceMessageReaction(reaction) {
    this.reactions[reaction].pop();
  }
  onReactionDelete() {
    EventBus.$on("message.remove.reaction", (message) => {
      if (message.message_id === this.message._id) {
        const reactions = this.message.reactions;
        const reactionIndex = reactions.findIndex((item) => item._id === message._id);
        if (reactionIndex > -1) {
          this.reduceMessageReaction(reactions[reactionIndex].reaction);
          reactions.splice(reactionIndex, 1);
          this.$forceUpdate();
        }
      }
      if (this.message[0] && message.message_id === this.message[0]._id) {
        const reactions = this.message[0].reactions;
        const reactionIndex = reactions.findIndex((item) => item._id === message._id);
        if (reactionIndex > -1) {
          this.reduceMessageReaction(reactions[reactionIndex].reaction);
          reactions.splice(reactionIndex, 1);
          this.$forceUpdate();
        }
      }
    });
  }
  validateLinkInMessage() {
    const texts = this.message.content.msg.split(" ");
    return {
      containsWebsite: texts.some((text) => this.websiteRegex.test(text)),
      containsEmail: texts.some((text) => this.emailRegex.test(text))
    };
  }
  getTextsInMessage() {
    return {
      texts: this.message.content.msg.split(" "),
      length: this.message.content.msg.split(" ").length
    };
  }
  injectHtml(message) {
    let returnedMessage = "";
    if (message) {
      for (const word of message.split(" ")) {
        if (this.emailRegex.test(word)) {
          returnedMessage += String.raw` <a target="_blank" href="mailto:${word}">${word}<a/>`;
        } else if (this.websiteRegex.test(word)) {
          if (word.includes("http://") || word.includes("https://")) {
            returnedMessage += String.raw` <a target="_blank" href="${word}">${word}<a/>`;
          } else {
            returnedMessage += String.raw` <a target="_blank" href="http://${word}">${word}<a/>`;
          }
        } else {
          returnedMessage += ` ${word}`;
        }
      }
    }
    const newMessage = this.$refs.message;
    if (newMessage) {
      newMessage.innerHTML = returnedMessage;
    }
  }
  onResize() {
    this.screenWidth = window.innerWidth;
    if (this.screenWidth <= 1024) {
      this.caretOpen = true;
    } else {
      this.caretOpen = false;
    }
  }
  onMouseOver() {
    if (!this.selectMessagesOpen) {
      this.caretOpen = true;
    } else {
      this.caretOpen = false;
    }
  }
  onMouseLeave() {
    if (this.screenWidth > 1024) {
      this.caretOpen = false;
    }
  }
  selectMessage() {
    const checkbox = this.$refs.checkbox;
    checkbox.checked = true;
    this.toggleCheckAction(false);
  }
  forwardMessage() {
    const checkbox = this.$refs.checkbox;
    checkbox.checked = true;
    this.toggleCheckAction(false);
  }
  scrollToRepliedMessage(id) {
    this.$emit("scroll-replied-message", id);
  }
  handleLeaveGroup() {
    EventBus.$on("remove.group.participant", (value) => {
      if (value.participant.user_token === this.$user_token) {
        this.leaveGroupActivity.push("You left the group.");
      }
      if (value.participant.user_token !== this.$user_token) {
        const userName = this.getContactName(value.participant.user_token) !== "" ? this.getContactName(value.participant.user_token) : "Participant";
        this.leaveGroupActivity.push(userName + " was removed from the group by moderator.");
      }
    });
  }
  pauseOtherVideo() {
    const videoElements = document.querySelectorAll("video");
    videoElements.forEach((video) => {
      if (this.videoPlayer !== video) {
        video.pause();
      }
    });
  }
};
MessageContent$1 = __decorateClass$b([
  Component({
    name: "MessageContent",
    components: {
      Content,
      VLazyImage: e,
      MessageGrid,
      MessagePopOver,
      ReactionPopOver,
      CheckBox,
      IconButton,
      ReplyMessageBubble,
      SvgIcon,
      AudioPlayer
    },
    mixins: [mixin],
    watch: {
      uncheck: {
        handler(val) {
          if (this.uncheck) {
            const checkbox = this.$refs.checkbox;
            checkbox.checked = false;
          }
        }
      },
      messages: {
        handler(val) {
          this.leaveGroupActivity = [];
          this.reactions = { "\u2764\uFE0F": [], "\u{1F44D}": [], "\u{1F44E}": [], "\u{1F602}": [], "\u2049\uFE0F": [] };
          this.getMessageReactions();
        }
      }
    }
  })
], MessageContent$1);
var render$b = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "robin-flex robin-flex-column", class: _vm.validateMessages(_vm.message) }, [_vm.getMessageIndex() == 0 && _vm.conversation.is_group ? _c("div", { staticClass: "robin-conversation-date" }, [_vm._v("This group was created by " + _vm._s(_vm.$user_token == _vm.conversation.moderator.user_token ? "You" : _vm.conversation.moderator.meta_data.display_name) + " " + _vm._s(_vm.formatDate(_vm.message.created_at || _vm.message[0].created_at) == "Today" ? "today." : "on " + _vm.formatDate(_vm.message.created_at || _vm.message[0].created_at) + "."))]) : _vm._e(), _vm.getMessageIndex() == 0 && !_vm.conversation.is_group ? _c("div", { staticClass: "robin-conversation-date" }, [_vm._v("This conversation was created " + _vm._s(_vm.formatDate(_vm.message.created_at || _vm.message[0].created_at) == "Today" ? "today." : "on " + _vm.formatDate(_vm.message.created_at || _vm.message[0].created_at) + "."))]) : _vm._e(), _vm.showDate() && _vm.getMessageIndex() != 0 ? _c("div", { staticClass: "robin-activity" }, [_vm._v(_vm._s(_vm.formatDate(_vm.message.created_at || _vm.message[0].created_at)))]) : _vm._e(), _c("div", { staticClass: "robin-message-bubble robin-flex robin-flex-align-center" }, [_c("CheckBox", { directives: [{ name: "show", rawName: "v-show", value: _vm.selectMessagesOpen, expression: "selectMessagesOpen" }], ref: "checkbox", on: { "clicked": function($event) {
    return _vm.toggleCheckAction($event);
  } } }), !Array.isArray(_vm.message) ? _c("div", { directives: [{ name: "on-clickaway", rawName: "v-on-clickaway", value: _vm.closeModal, expression: "closeModal" }], staticClass: "robin-bubble", class: _vm.validateMessages(_vm.message).includes("message-sender") ? "robin-ml-5" : "robin-mr-5", attrs: { "data-testid": "bubble" }, on: { "mouseover": function($event) {
    return _vm.onMouseOver();
  }, "mouseleave": function($event) {
    return _vm.onMouseLeave();
  } } }, [_c("div", { staticClass: "robin-popup-container reactions" }, [_c("ReactionPopOver", { directives: [{ name: "show", rawName: "v-show", value: _vm.messagePopup.opened && _vm.validateMessages(_vm.message) && _vm.isMessageReactionViewEnabled, expression: "messagePopup.opened && validateMessages(message) && isMessageReactionViewEnabled" }], ref: "popup-1", attrs: { "id": _vm.message._id, "message": _vm.message, "data-testid": "reaction-popover" }, on: { "close-modal": function($event) {
    return _vm.closeModal();
  }, "reaction": _vm.addReaction } })], 1), _vm.message && _vm.message.reactions && _vm.message.reactions.length > 0 && _vm.isMessageReactionViewEnabled ? _c("div", { staticClass: "robin-reactions" }, _vm._l(_vm.reactions, function(value, key, index) {
    return _c("div", { directives: [{ name: "show", rawName: "v-show", value: value.length > 0, expression: "value.length > 0" }], key: index, staticClass: "robin-reaction", class: { "delete-enabled": _vm.isMessageReactionDeleteEnabled }, on: { "click": function($event) {
      return _vm.removeReaction(value[value.length - 1]);
    } } }, [_vm._v(_vm._s(key + " " + value.length))]);
  }), 0) : _vm._e(), !_vm.message.has_attachment ? _c("div", { staticClass: "robin-message-bubble-inner", class: { "robin-non-clickable": _vm.selectMessagesOpen, "robin-non-clickable": !_vm.isMessageReactionViewEnabled && !_vm.isReplyMessagesEnabled && !_vm.isDeleteMessagesEnabled && !_vm.isForwardMessagesEnabled } }, [_vm.validateMessages(_vm.message).includes("message-sender") && _vm.conversation.is_group ? _c("Content", { staticClass: "robin-messager-name robin-mb-4", attrs: { "font-size": 12, "color": _vm.groupnameColors[_vm.message.content.sender_token], "as": "span", "line-height": 20 } }, [_vm._v(" " + _vm._s(_vm.getContactName(_vm.message.content.sender_token)) + " ")]) : _vm._e(), _c("div", { directives: [{ name: "show", rawName: "v-show", value: (_vm.caretOpen || _vm.messagePopup.opened && _vm.validateMessages(_vm.message)) && (_vm.isMessageReactionViewEnabled || _vm.isReplyMessagesEnabled || _vm.isDeleteMessagesEnabled || _vm.isForwardMessagesEnabled || _vm.isMessageReactionViewEnabled && _vm.isReplyMessagesEnabled && _vm.isDeleteMessagesEnabled && _vm.isForwardMessagesEnabled), expression: "(caretOpen || (messagePopup.opened && validateMessages(message))) && (isMessageReactionViewEnabled || isReplyMessagesEnabled || isDeleteMessagesEnabled || isForwardMessagesEnabled || (isMessageReactionViewEnabled && isReplyMessagesEnabled && isDeleteMessagesEnabled && isForwardMessagesEnabled))" }], staticClass: "robin-caret-container", attrs: { "data-testid": "popup-caret" }, on: { "click": function($event) {
    return _vm.openModal();
  } } }, [_c("IconButton", { attrs: { "name": "messagePopupCaret", "to-emit": false, "to-click-away": false } })], 1), _c("SvgIcon", { directives: [{ name: "show", rawName: "v-show", value: _vm.message.is_forwarded, expression: "message.is_forwarded" }], staticClass: "robin-forwarded", attrs: { "name": "forwarded" } }), _vm.message.is_reply && _vm.isReplyMessagesEnabled ? _c("ReplyMessageBubble", { attrs: { "messages": _vm.messages, "message": _vm.message, "sender": _vm.validateMessages(_vm.message).includes("message-sender") }, on: { "scroll-replied-message": _vm.scrollToRepliedMessage } }) : _vm._e(), _c("div", { staticClass: "message-inner", class: { "robin-flex-column": _vm.validateLinkInMessage().containsEmail && _vm.validateLinkInMessage().containsWebsite || _vm.validateLinkInMessage().containsEmail || _vm.validateLinkInMessage().containsWebsite } }, [!_vm.validateLinkInMessage().containsEmail && !_vm.validateLinkInMessage().containsWebsite ? _c("Content", { attrs: { "max-width": _vm.message.content.msg.length < 120 ? "217" : "270", "font-size": 17, "textWrap": "pre-line", "wordBreak": "break-word", "as": "span" } }, [_vm._v(" " + _vm._s(_vm.message.content.msg) + " ")]) : _vm._e(), _vm.validateLinkInMessage().containsEmail && _vm.validateLinkInMessage().containsWebsite || _vm.validateLinkInMessage().containsEmail || _vm.validateLinkInMessage().containsWebsite ? _c("div", { ref: "message", staticClass: "robin-link-container" }) : _vm._e(), _c("span", { staticClass: "robin-side-text robin-flex robin-flex-align-end robin-ml-auto" }, [_c("Content", { staticClass: "robin-flex", attrs: { "font-weight": "300", "font-size": 10, "color": "#7a7a7a", "as": "p" }, nativeOn: { "click": function($event) {
    return _vm.openModal();
  } } }, [_vm._v(" " + _vm._s(_vm.formatTimeStamp(_vm.message.content.timestamp)) + " "), !_vm.validateMessages(_vm.message).includes("message-sender") && _vm.message.is_read ? _c("SvgIcon", { attrs: { "name": "read" } }) : _vm._e(), !_vm.validateMessages(_vm.message).includes("message-sender") && !_vm.message.is_read ? _c("SvgIcon", { attrs: { "name": "not-read" } }) : _vm._e()], 1)], 1)], 1)], 1) : _vm._e(), _vm.message.content.is_attachment && _vm.imageRegex.test(_vm.checkAttachmentType(_vm.message.content.attachment)) ? _c("div", { staticClass: "robin-message-bubble-image", class: { "robin-non-clickable": _vm.selectMessagesOpen, "robin-non-clickable": !_vm.isMessageReactionViewEnabled && !_vm.isReplyMessagesEnabled && !_vm.isDeleteMessagesEnabled && !_vm.isForwardMessagesEnabled } }, [_vm.validateMessages(_vm.message).includes("message-sender") && _vm.conversation.is_group ? _c("Content", { staticClass: "robin-messager-name robin-mb-4", attrs: { "font-size": 12, "color": _vm.groupnameColors[_vm.message.content.sender_token], "as": "span", "line-height": 20 } }, [_vm._v(" " + _vm._s(_vm.getContactName(_vm.message.content.sender_token)) + " ")]) : _vm._e(), _c("div", { directives: [{ name: "show", rawName: "v-show", value: (_vm.caretOpen || _vm.messagePopup.opened && _vm.validateMessages(_vm.message)) && (_vm.isMessageReactionViewEnabled || _vm.isReplyMessagesEnabled || _vm.isDeleteMessagesEnabled || _vm.isForwardMessagesEnabled || _vm.isMessageReactionViewEnabled && _vm.isReplyMessagesEnabled && _vm.isDeleteMessagesEnabled && _vm.isForwardMessagesEnabled), expression: "(caretOpen || (messagePopup.opened && validateMessages(message))) && (isMessageReactionViewEnabled || isReplyMessagesEnabled || isDeleteMessagesEnabled || isForwardMessagesEnabled || (isMessageReactionViewEnabled && isReplyMessagesEnabled && isDeleteMessagesEnabled && isForwardMessagesEnabled))" }], staticClass: "robin-caret-container", on: { "click": function($event) {
    return _vm.openModal();
  } } }, [_c("IconButton", { attrs: { "name": "messagePopupCaret", "to-emit": false, "to-click-away": false } })], 1), _c("SvgIcon", { directives: [{ name: "show", rawName: "v-show", value: _vm.message.is_forwarded, expression: "message.is_forwarded" }], staticClass: "robin-forwarded", attrs: { "name": "forwarded" } }), _vm.message.is_reply && _vm.isReplyMessagesEnabled ? _c("ReplyMessageBubble", { attrs: { "messages": _vm.messages, "message": _vm.message, "sender": _vm.validateMessages(_vm.message).includes("message-sender") }, on: { "scroll-replied-message": _vm.scrollToRepliedMessage } }) : _vm._e(), _c("v-lazy-image", { staticClass: "robin-uploaded-image", attrs: { "src": _vm.message.content.attachment }, nativeOn: { "click": function($event) {
    return _vm.$emit("open-preview", [_vm.message]);
  } } }), !_vm.validateLinkInMessage().containsEmail && !_vm.validateLinkInMessage().containsWebsite && _vm.message.content.msg && _vm.message.content.msg != "undefined" ? _c("Content", { attrs: { "max-width": _vm.message.content.msg.length < 120 ? "217" : "270", "textWrap": "pre-line", "wordBreak": "break-word", "as": "span" } }, [_vm._v(" " + _vm._s(_vm.message.content.msg) + " ")]) : _vm._e(), _vm.validateLinkInMessage().containsEmail && _vm.validateLinkInMessage().containsWebsite || _vm.validateLinkInMessage().containsEmail || _vm.validateLinkInMessage().containsWebsite && _vm.message.content.msg && _vm.message.content.msg != "undefined" ? _c("div", { ref: "message", staticClass: "robin-link-container" }) : _vm._e(), _c("span", { staticClass: "robin-side-text robin-flex robin-flex-align-end robin-ml-auto" }, [_c("Content", { staticClass: "robin-flex", attrs: { "font-weight": "300", "font-size": 10, "color": "#7a7a7a", "as": "p" }, nativeOn: { "click": function($event) {
    return _vm.openModal();
  } } }, [_vm._v(" " + _vm._s(_vm.formatTimeStamp(_vm.message.content.timestamp)) + " "), !_vm.validateMessages(_vm.message).includes("message-sender") && _vm.message.is_read ? _c("SvgIcon", { attrs: { "name": "read" } }) : _vm._e(), !_vm.validateMessages(_vm.message).includes("message-sender") && !_vm.message.is_read ? _c("SvgIcon", { attrs: { "name": "not-read" } }) : _vm._e()], 1)], 1)], 1) : _vm._e(), _vm.message.content.is_attachment && _vm.videoRegex.test(_vm.checkAttachmentType(_vm.message.content.attachment)) ? _c("div", { staticClass: "robin-message-bubble-video", class: { "robin-non-clickable": _vm.selectMessagesOpen, "robin-non-clickable": !_vm.isMessageReactionViewEnabled && !_vm.isReplyMessagesEnabled && !_vm.isDeleteMessagesEnabled && !_vm.isForwardMessagesEnabled } }, [_vm.validateMessages(_vm.message).includes("message-sender") && _vm.conversation.is_group ? _c("Content", { staticClass: "robin-messager-name robin-mb-4", attrs: { "font-size": 12, "color": _vm.groupnameColors[_vm.message.content.sender_token], "as": "span", "line-height": 20 } }, [_vm._v(" " + _vm._s(_vm.getContactName(_vm.message.content.sender_token)) + " ")]) : _vm._e(), _c("div", { directives: [{ name: "show", rawName: "v-show", value: (_vm.caretOpen || _vm.messagePopup.opened && _vm.validateMessages(_vm.message)) && (_vm.isMessageReactionViewEnabled || _vm.isReplyMessagesEnabled || _vm.isDeleteMessagesEnabled || _vm.isForwardMessagesEnabled || _vm.isMessageReactionViewEnabled && _vm.isReplyMessagesEnabled && _vm.isDeleteMessagesEnabled && _vm.isForwardMessagesEnabled), expression: "(caretOpen || (messagePopup.opened && validateMessages(message))) && (isMessageReactionViewEnabled || isReplyMessagesEnabled || isDeleteMessagesEnabled || isForwardMessagesEnabled || (isMessageReactionViewEnabled && isReplyMessagesEnabled && isDeleteMessagesEnabled && isForwardMessagesEnabled))" }], staticClass: "robin-caret-container", on: { "click": function($event) {
    return _vm.openModal();
  } } }, [_c("IconButton", { attrs: { "name": "messagePopupCaret", "to-emit": false, "to-click-away": false } })], 1), _c("SvgIcon", { directives: [{ name: "show", rawName: "v-show", value: _vm.message.is_forwarded, expression: "message.is_forwarded" }], staticClass: "robin-forwarded", attrs: { "name": "forwarded" } }), _vm.message.is_reply && _vm.isReplyMessagesEnabled ? _c("ReplyMessageBubble", { attrs: { "messages": _vm.messages, "message": _vm.message, "sender": _vm.validateMessages(_vm.message).includes("message-sender") }, on: { "scroll-replied-message": _vm.scrollToRepliedMessage } }) : _vm._e(), _c("video", { class: _vm.message.is_reply ? "video-reply" : "", attrs: { "controls": "", "id": "video-" + _vm.index } }, [_c("source", { attrs: { "src": _vm.message.content.attachment } }), _vm._v(" Your browser does not support the video tag. ")]), !_vm.validateLinkInMessage().containsEmail && !_vm.validateLinkInMessage().containsWebsite && _vm.message.content.msg && _vm.message.content.msg != "undefined" ? _c("Content", { attrs: { "max-width": _vm.message.content.msg.length < 120 ? "217" : "270", "textWrap": "pre-line", "wordBreak": "break-word", "as": "span" } }, [_vm._v(" " + _vm._s(_vm.message.content.msg) + " ")]) : _vm._e(), _vm.validateLinkInMessage().containsEmail && _vm.validateLinkInMessage().containsWebsite || _vm.validateLinkInMessage().containsEmail || _vm.validateLinkInMessage().containsWebsite && _vm.message.content.msg && _vm.message.content.msg != "undefined" ? _c("div", { ref: "message", staticClass: "robin-link-container" }) : _vm._e(), _c("span", { staticClass: "robin-side-text robin-flex robin-flex-align-end robin-ml-auto" }, [_c("Content", { staticClass: "robin-flex", attrs: { "font-weight": "300", "font-size": 10, "color": "#7a7a7a", "as": "p" }, nativeOn: { "click": function($event) {
    return _vm.openModal();
  } } }, [_vm._v(" " + _vm._s(_vm.formatTimeStamp(_vm.message.content.timestamp)) + " "), !_vm.validateMessages(_vm.message).includes("message-sender") && _vm.message.is_read ? _c("SvgIcon", { attrs: { "name": "read" } }) : _vm._e(), !_vm.validateMessages(_vm.message).includes("message-sender") && !_vm.message.is_read ? _c("SvgIcon", { attrs: { "name": "not-read" } }) : _vm._e()], 1)], 1)], 1) : _vm._e(), _vm.message.content.is_attachment && _vm.documentRegex.test(_vm.checkAttachmentType(_vm.message.content.attachment)) ? _c("div", { staticClass: "robin-message-bubble-document", class: { "robin-non-clickable": _vm.selectMessagesOpen, "robin-non-clickable": !_vm.isMessageReactionViewEnabled && !_vm.isReplyMessagesEnabled && !_vm.isDeleteMessagesEnabled && !_vm.isForwardMessagesEnabled } }, [_vm.validateMessages(_vm.message).includes("message-sender") && _vm.conversation.is_group ? _c("Content", { staticClass: "robin-messager-name robin-mb-4", attrs: { "font-size": 12, "color": _vm.groupnameColors[_vm.message.content.sender_token], "as": "span", "line-height": 20 } }, [_vm._v(" " + _vm._s(_vm.getContactName(_vm.message.content.sender_token)) + " ")]) : _vm._e(), _c("div", { directives: [{ name: "show", rawName: "v-show", value: (_vm.caretOpen || _vm.messagePopup.opened && _vm.validateMessages(_vm.message)) && (_vm.isMessageReactionViewEnabled || _vm.isReplyMessagesEnabled || _vm.isDeleteMessagesEnabled || _vm.isForwardMessagesEnabled || _vm.isMessageReactionViewEnabled && _vm.isReplyMessagesEnabled && _vm.isDeleteMessagesEnabled && _vm.isForwardMessagesEnabled), expression: "(caretOpen || (messagePopup.opened && validateMessages(message))) && (isMessageReactionViewEnabled || isReplyMessagesEnabled || isDeleteMessagesEnabled || isForwardMessagesEnabled || (isMessageReactionViewEnabled && isReplyMessagesEnabled && isDeleteMessagesEnabled && isForwardMessagesEnabled))" }], staticClass: "robin-caret-container", on: { "click": function($event) {
    return _vm.openModal();
  } } }, [_c("IconButton", { attrs: { "name": "messagePopupCaret", "to-emit": false, "to-click-away": false } })], 1), _c("SvgIcon", { directives: [{ name: "show", rawName: "v-show", value: _vm.message.is_forwarded, expression: "message.is_forwarded" }], staticClass: "robin-forwarded", attrs: { "name": "forwarded" } }), _vm.message.is_reply && _vm.isReplyMessagesEnabled ? _c("ReplyMessageBubble", { staticClass: "robin-mb-8", attrs: { "messages": _vm.messages, "message": _vm.message, "index": _vm.index, "sender": _vm.validateMessages(_vm.message).includes("message-sender") } }) : _vm._e(), _vm.getFileDetails(_vm.message.content.attachment).extension !== "mp3" ? _c("div", { staticClass: "robin-uploaded-document" }, [_vm.assets[_vm.getFileDetails(_vm.message.content.attachment).extension] ? _c("img", { attrs: { "src": _vm.assets[_vm.getFileDetails(_vm.message.content.attachment).extension], "alt": "document" } }) : _c("img", { attrs: { "src": _vm.assets["default"] } }), _c("div", { staticClass: "details robin-flex robin-h-100 robin-flex-align-center" }, [_c("Content", { attrs: { "as": "span", "fontSize": 14 } }, [_vm._v(" " + _vm._s(_vm.getFileDetails(_vm.message.content.attachment).name.length > 9 ? _vm.getFileDetails(_vm.message.content.attachment).name.substring(0, 9) + "...." + _vm.getFileDetails(_vm.message.content.attachment).extension : _vm.getFileDetails(_vm.message.content.attachment).name + "." + _vm.getFileDetails(_vm.message.content.attachment).extension) + " ")])], 1), _c("IconButton", { attrs: { "name": "download", "color": "#15AE73", "to-emit": true, "to-click-away": false }, on: { "clicked": function($event) {
    return _vm.downloadFile(_vm.message.content.attachment);
  } } })], 1) : _c("AudioPlayer", { attrs: { "message": _vm.message, "index": _vm.index } }), !_vm.validateLinkInMessage().containsEmail && !_vm.validateLinkInMessage().containsWebsite && _vm.message.content.msg && _vm.message.content.msg != "undefined" ? _c("Content", { attrs: { "max-width": _vm.message.content.msg.length < 120 ? "217" : "270", "textWrap": "pre-line", "wordBreak": "break-word", "as": "span" } }, [_vm._v(" " + _vm._s(_vm.message.content.msg) + " ")]) : _vm._e(), _vm.validateLinkInMessage().containsEmail && _vm.validateLinkInMessage().containsWebsite || _vm.validateLinkInMessage().containsEmail || _vm.validateLinkInMessage().containsWebsite && _vm.message.content.msg && _vm.message.content.msg != "undefined" ? _c("div", { ref: "message", staticClass: "robin-link-container" }) : _vm._e(), _c("span", { staticClass: "robin-side-text robin-flex robin-flex-align-end robin-ml-auto" }, [_c("Content", { staticClass: "robin-flex", attrs: { "font-weight": "300", "font-size": 10, "color": "#7a7a7a", "as": "p" }, nativeOn: { "click": function($event) {
    return _vm.openModal();
  } } }, [_vm._v(" " + _vm._s(_vm.formatTimeStamp(_vm.message.content.timestamp)) + " "), !_vm.validateMessages(_vm.message).includes("message-sender") && _vm.message.is_read ? _c("SvgIcon", { attrs: { "name": "read" } }) : _vm._e(), !_vm.validateMessages(_vm.message).includes("message-sender") && !_vm.message.is_read ? _c("SvgIcon", { attrs: { "name": "not-read" } }) : _vm._e()], 1)], 1)], 1) : _vm._e()]) : _vm._e(), Array.isArray(_vm.message) && _vm.message.filter(function(image) {
    return !image.is_deleted;
  }).length === 1 ? _c("div", { staticClass: "robin-bubble", class: _vm.validateMessages(_vm.message).includes("message-sender") ? "robin-ml-5" : "robin-mr-5" }, [_vm.message[0].reactions && _vm.message[0].reactions.length > 0 && _vm.isMessageReactionViewEnabled ? _c("div", { staticClass: "robin-reactions" }, _vm._l(_vm.reactions, function(value, key, index) {
    return _c("div", { directives: [{ name: "show", rawName: "v-show", value: value.length > 0, expression: "value.length > 0" }], key: index, staticClass: "robin-reaction", class: { "delete-enabled": _vm.isMessageReactionDeleteEnabled }, on: { "click": function($event) {
      return _vm.removeReaction(value[value.length - 1]);
    } } }, [_vm._v(_vm._s(key + " " + value.length))]);
  }), 0) : _vm._e(), _vm.message[0].content.is_attachment && _vm.imageRegex.test(_vm.checkAttachmentType(_vm.message[0].content.attachment)) ? _c("div", { staticClass: "robin-message-bubble-image" }, [_vm.validateMessages(_vm.message).includes("message-sender") && _vm.conversation.is_group ? _c("Content", { staticClass: "robin-messager-name robin-mb-4", attrs: { "font-size": 12, "color": _vm.groupnameColors[_vm.message[0].content.sender_token], "as": "span", "line-height": 20 } }, [_vm._v(" " + _vm._s(_vm.getContactName(_vm.message[0].content.sender_token)) + " ")]) : _vm._e(), _vm.message[0].is_reply && _vm.isReplyMessagesEnabled ? _c("ReplyMessageBubble", { attrs: { "messages": _vm.messages, "message": _vm.message, "sender": _vm.validateMessages(_vm.message).includes("message-sender") }, on: { "scroll-replied-message": _vm.scrollToRepliedMessage } }) : _vm._e(), _c("v-lazy-image", { staticClass: "robin-uploaded-image", attrs: { "src": _vm.message[0].content.attachment }, nativeOn: { "click": function($event) {
    return _vm.$emit("open-preview", [_vm.message[0]]);
  } } }), _c("span", { staticClass: "robin-side-text robin-flex robin-flex-align-end robin-ml-auto" }, [_c("Content", { staticClass: "robin-flex", attrs: { "font-weight": "300", "font-size": 10, "color": "#7a7a7a", "as": "p" } }, [_vm._v(" " + _vm._s(_vm.formatTimeStamp(_vm.message[0].content.timestamp)) + " "), !_vm.validateMessages(_vm.message).includes("message-sender") && (_vm.message[0].is_read || _vm.readReceipts.some(function(item) {
    return item === _vm.message[0]._id;
  })) ? _c("SvgIcon", { attrs: { "name": "read" } }) : _vm._e(), !_vm.validateMessages(_vm.message).includes("message-sender") && (!_vm.message[0].is_read || !_vm.readReceipts.some(function(item) {
    return item === _vm.message[0]._id;
  })) ? _c("SvgIcon", { attrs: { "name": "not-read" } }) : _vm._e()], 1)], 1)], 1) : _vm._e()]) : _vm._e(), Array.isArray(_vm.message) && _vm.message[0].reactions && _vm.message[0].reactions.length > 0 && _vm.isMessageReactionViewEnabled ? _c("div", { staticClass: "robin-reactions" }, _vm._l(_vm.reactions, function(value, key, index) {
    return _c("div", { directives: [{ name: "show", rawName: "v-show", value: value.length > 0, expression: "value.length > 0" }], key: index, staticClass: "robin-reaction", class: { "delete-enabled": _vm.isMessageReactionDeleteEnabled }, on: { "click": function($event) {
      return _vm.removeReaction(value[value.length - 1]);
    } } }, [_vm._v(_vm._s(key + " " + value.length))]);
  }), 0) : _vm._e(), Array.isArray(_vm.message) && _vm.message.filter(function(image) {
    return !image.is_deleted;
  }).length > 1 ? _c("MessageGrid", { directives: [{ name: "on-clickaway", rawName: "v-on-clickaway", value: _vm.closeModal, expression: "closeModal" }], ref: "popup-2", class: !_vm.validateMessages(_vm.message) ? "robin-ml-5" : "robin-mr-5", attrs: { "message": _vm.message.filter(function(image) {
    return !image.is_deleted;
  }), "read-receipts": _vm.readReceipts, "conversation": _vm.conversation, "message-popup": _vm.messagePopup, "groupname-colors": _vm.groupnameColors }, on: { "open-preview": function($event) {
    return _vm.openPreview($event);
  }, "open-modal": function($event) {
    return _vm.openModal();
  }, "close-modal": function($event) {
    return _vm.closeModal();
  }, "add-reaction": _vm.addReaction } }) : _vm._e(), _c("div", { staticClass: "robin-popup-container message", class: { top: (_vm.lastId === _vm.message._id || _vm.messages.length - 3 === _vm.index) && _vm.scroll } }, [_c("MessagePopOver", { directives: [{ name: "show", rawName: "v-show", value: _vm.messagePopup.opened && _vm.validateMessages(_vm.message) && !Array.isArray(_vm.message) && (_vm.isReplyMessagesEnabled || _vm.isDeleteMessagesEnabled || _vm.isForwardMessagesEnabled || _vm.isReplyMessagesEnabled && _vm.isDeleteMessagesEnabled && _vm.isForwardMessagesEnabled), expression: "messagePopup.opened && validateMessages(message) && !Array.isArray(message) && (isReplyMessagesEnabled || isDeleteMessagesEnabled || isForwardMessagesEnabled || (isReplyMessagesEnabled && isDeleteMessagesEnabled && isForwardMessagesEnabled))" }], ref: "popup-3", attrs: { "id": _vm.message._id, "message": _vm.message, "data-testid": "message-popover" }, on: { "close-modal": function($event) {
    return _vm.closeModal();
  }, "select-message": function($event) {
    return _vm.selectMessage();
  }, "forward-message": function($event) {
    return _vm.$emit("forward-message");
  }, "reply-message": function($event) {
    return _vm.$emit("reply-message", _vm.message);
  } } })], 1)], 1), _vm._l(_vm.leaveGroupActivity, function(activity, index) {
    return _c("div", { directives: [{ name: "show", rawName: "v-show", value: _vm.getMessageIndex() === _vm.messages.length - 1, expression: "getMessageIndex() === messages.length - 1" }], key: "activity-" + index, staticClass: "robin-activity" }, [_vm._v(" " + _vm._s(activity.length > 35 ? activity.substring(0, 35) + ".." : activity) + " ")]);
  })], 2);
};
var staticRenderFns$b = [];
var MessageContent_vue_vue_type_style_index_0_scoped_true_lang = "";
const __cssModules$b = {};
var __component__$b = /* @__PURE__ */ normalizeComponent(MessageContent$1, render$b, staticRenderFns$b, false, injectStyles$b, "2ada2b67", null, null);
function injectStyles$b(context2) {
  for (let o in __cssModules$b) {
    this[o] = __cssModules$b[o];
  }
}
var MessageContent = /* @__PURE__ */ function() {
  return __component__$b.exports;
}();
var __defProp$a = Object.defineProperty;
var __getOwnPropDesc$a = Object.getOwnPropertyDescriptor;
var __decorateClass$a = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$a(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$a(target, key, result);
  return result;
};
const ComponentProps$3 = Vue$1.extend({
  props: {
    selectedMessages: {
      type: Array,
      default: () => []
    }
  }
});
let ForwardMessage$1 = class extends ComponentProps$3 {
  constructor() {
    super(...arguments);
    this.conversations = {};
    this.isLoading = false;
    this.isSending = false;
    this.selectedConversations = [];
    this.checkBoxKeyState = 0;
    this.searchData = [];
    this.screenWidth = 0;
  }
  created() {
    this.getConversations("");
  }
  mounted() {
    this.$nextTick(function() {
      this.onResize();
    });
    window.addEventListener("resize", this.onResize);
  }
  getConversations(searchText) {
    this.conversations = {};
    if (searchText.trim() === "") {
      for (const conversation of this.getRegularConversations(this.$conversations)) {
        this.conversations[conversation.name[0] ? this.getContactKey(conversation.name) : this.getContactKey(conversation.sender_token !== this.$user_token ? conversation.sender_name : conversation.receiver_name)] = this.getRegularConversations(this.$conversations).filter((item) => {
          const conversationName = conversation.is_group ? conversation.name : conversation.sender_token !== this.$user_token ? conversation.sender_name : conversation.receiver_name;
          const itemName = item.is_group ? item.name : item.sender_token !== this.$user_token ? item.sender_name : item.receiver_name;
          return this.validateContact(itemName, conversationName);
        });
      }
      this.sortConversations();
    } else {
      for (const conversation of this.searchData) {
        this.conversations[conversation.name[0] ? this.getContactKey(conversation.name) : this.getContactKey(conversation.sender_token !== this.$user_token ? conversation.sender_name : conversation.receiver_name)] = this.searchData.filter((item) => {
          const conversationName = conversation.is_group ? conversation.name : conversation.sender_token !== this.$user_token ? conversation.sender_name : conversation.receiver_name;
          const itemName = item.is_group ? item.name : item.sender_token !== this.$user_token ? item.sender_name : item.receiver_name;
          return this.validateContact(itemName, conversationName);
        });
      }
      this.sortConversations();
    }
  }
  getRegularConversations(data) {
    return data.filter((user) => {
      if (!user.archived_for || user.archived_for.length === 0)
        return true;
      return false;
    });
  }
  searchConversation(searchText) {
    this.isLoading = true;
    const data = this.getRegularConversations(this.$conversations).filter((obj) => {
      let stopSearch = false;
      Object.values(obj).forEach((val) => {
        const filter = String(val).toLowerCase().includes(searchText.toLowerCase());
        if (filter) {
          stopSearch = true;
        }
      });
      if (stopSearch) {
        return obj;
      }
    });
    this.searchData = [...data];
    this.getConversations(searchText);
    setTimeout(() => {
      this.isLoading = false;
    }, 300);
  }
  toggleSelectAllCheckAction(val) {
    const checkboxComponents = this.$refs["checkbox-comp"];
    if (!val) {
      this.selectedConversations = [...this.getRegularConversations(this.$conversations)];
      for (let i = 0; i < checkboxComponents.length; i += 1) {
        checkboxComponents[i].checked = true;
      }
    } else {
      this.selectedConversations = [];
      for (let i = 0; i < checkboxComponents.length; i += 1) {
        checkboxComponents[i].checked = false;
      }
    }
  }
  toggleCheckAction(val, item) {
    if (!val) {
      this.addConversation(item);
    } else {
      this.removeConversation(item);
    }
  }
  addConversation(item) {
    this.selectedConversations.push(item);
  }
  removeConversation(item) {
    const index = this.selectedConversations.findIndex((conversation) => conversation._id === item._id);
    this.selectedConversations.splice(index, 1);
  }
  addIndexToCheckBoxState(index, checkBoxKeyState) {
    return parseInt(index) + checkBoxKeyState;
  }
  handleForwardMessages() {
    const messageIds = [];
    const conversationIds = [];
    for (const message of this.selectedMessages) {
      message.is_read = false;
      messageIds.push(message._id);
    }
    for (const conversation of this.selectedConversations) {
      conversationIds.push(conversation._id);
    }
    this.forwardMessages(messageIds, conversationIds);
  }
  async forwardMessages(messageIds, conversationIds) {
    this.isSending = true;
    const res = await this.$robin.forwardMessages(this.$user_token, messageIds, conversationIds);
    if (res && !res.error) {
      const conversation = this.$conversations.find((conversation2) => conversation2._id === conversationIds[0]);
      this.isSending = false;
      this.$toast.open({
        message: "Forwarded messages.",
        type: "success",
        position: "bottom-left"
      });
      EventBus.$emit("conversation-opened", conversation);
      this.closeModal();
      return new Promise((resolve) => resolve);
    } else {
      this.isSending = false;
      this.$toast.open({
        message: "Check your connection.",
        type: "error",
        position: "bottom-left"
      });
      return new Promise((resolve, reject) => reject);
    }
  }
  closeModal() {
    const popup = this.$refs["popup-1"];
    popup.classList.remove("robin-fadeIn");
    popup.classList.add("robin-fadeOut");
    window.setTimeout(() => {
      const popup2 = this.$refs["popup-1"];
      popup2.classList.remove("robin-fadeOut");
      popup2.classList.add("robin-fadeIn");
      this.$emit("closemodal");
    }, 100);
  }
  sortConversations() {
    this.conversations = Object.keys(this.conversations).sort().reduce((result, key) => {
      result[key] = this.conversations[key];
      return result;
    }, {});
  }
  getContactKey(username) {
    return username.trim() !== "" && isNaN(parseInt(username[0])) ? username[0].toUpperCase() : "*";
  }
  validateContact(usernameVal, username) {
    if (!usernameVal[0] && !username[0]) {
      return usernameVal.trim() === username.trim();
    }
    if (usernameVal[0] && username[0]) {
      return usernameVal[0].toUpperCase() === username[0].toUpperCase();
    }
    return false;
  }
  onResize() {
    this.screenWidth = window.innerWidth;
  }
};
ForwardMessage$1 = __decorateClass$a([
  Component({
    name: "ForwardMessage",
    components: {
      Content,
      IconButton,
      Avatar,
      GroupAvatar,
      AlphabetBlock,
      SearchBar,
      CheckBox,
      Button
    }
  })
], ForwardMessage$1);
var render$a = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { ref: "popup-1", staticClass: "robin-shim robin-fadeIn", on: { "click": function($event) {
    if ($event.target !== $event.currentTarget) {
      return null;
    }
    return _vm.closeModal.apply(null, arguments);
  } } }, [_c("div", { staticClass: "robin-modal-container robin-flex" }, [_c("div", { staticClass: "robin-inner-container robin-flex robin-flex-column" }, [_c("header", { staticClass: "robin-wrapper robin-mb-7" }, [_c("IconButton", { attrs: { "name": "remove", "emit": "close", "to-emit": true, "to-click-away": false }, on: { "close": function($event) {
    return _vm.closeModal();
  } } }), _c("Content", { staticClass: "robin-ml-8" }, [_vm._v("Forward Message")])], 1), _c("div", { staticClass: "robin-search" }, [_c("SearchBar", { attrs: { "placeholder": "Search people...", "loading": _vm.isLoading }, on: { "user-typing": function($event) {
    return _vm.searchConversation($event);
  } } })], 1), _c("div", { staticClass: "robin-select robin-flex robin-flex-align-center robin-flex-justify-end robin-w-100 robin-pl-16 robin-pr-16 robin-pt-17 robin-pb-17" }, [_c("Content", { attrs: { "color": "#9999BC" } }, [_vm._v(" Select All ")]), _c("CheckBox", { staticClass: "robin-ml-8", on: { "clicked": function($event) {
    return _vm.toggleSelectAllCheckAction($event);
  } } })], 1), _c("div", { staticClass: "robin-conversation-container" }, _vm._l(_vm.conversations, function(conversation, key, index) {
    return _c("div", { key: "conversation-" + index, staticClass: "robin-contact-container" }, [_c("div", { directives: [{ name: "show", rawName: "v-show", value: key.toString() != "*", expression: "key.toString() != '*'" }], staticClass: "robin-w-100 robin-alphabet-block" }, [_c("AlphabetBlock", { attrs: { "text": key } })], 1), _c("div", { staticClass: "robin-card-container robin-flex robin-flex-column" }, _vm._l(conversation, function(item, conversationIndex) {
      return _c("div", { key: item._id, staticClass: "robin-card robin-flex robin-flex-align-center", attrs: { "data-testid": "conversation-" + item._id } }, [_c("div", { staticClass: "robin-card-info robin-mr-12" }, [item.is_group ? _c("GroupAvatar") : _c("Avatar", { attrs: { "robin-users": _vm.$robin_users, "sender-token": item.sender_token === _vm.$user_token ? item.receiver_token : item.sender_token } })], 1), _c("div", { staticClass: "robin-card-info robin-h-100 robin-h-100 robin-flex robin-flex-align-center robin-pt-4 robin-pb-4 robin-flex-1" }, [_c("div", { staticClass: "robin-flex" }, [!item.is_group ? _c("Content", { attrs: { "font-size": 14, "line-height": 18 } }, [_vm._v(_vm._s(item.sender_token != _vm.$user_token ? item.sender_name : item.receiver_name))]) : _c("Content", { attrs: { "font-size": 14, "line-height": 18 } }, [_vm._v(_vm._s(item.name))])], 1), _c("div", { staticClass: "robin-ml-auto" }, [_c("CheckBox", { key: _vm.addIndexToCheckBoxState(conversationIndex, _vm.checkBoxKeyState), ref: "checkbox-comp", refInFor: true, on: { "clicked": function($event) {
        return _vm.toggleCheckAction($event, item);
      } } })], 1)])]);
    }), 0)]);
  }), 0), _c("button", { directives: [{ name: "show", rawName: "v-show", value: _vm.selectedConversations.length > 0 && !_vm.isSending, expression: "selectedConversations.length > 0 && !isSending" }], staticClass: "robin-primary-button robin-come-up", on: { "click": function($event) {
    return _vm.handleForwardMessages();
  } } }, [_vm._v("Forward")]), _c("button", { directives: [{ name: "show", rawName: "v-show", value: _vm.isSending, expression: "isSending" }], staticClass: "robin-primary-button" }, [_c("div", { staticClass: "robin-spinner2" })])])])]);
};
var staticRenderFns$a = [];
var ForwardMessage_vue_vue_type_style_index_0_scoped_true_lang = "";
const __cssModules$a = {};
var __component__$a = /* @__PURE__ */ normalizeComponent(ForwardMessage$1, render$a, staticRenderFns$a, false, injectStyles$a, "3b08ab68", null, null);
function injectStyles$a(context2) {
  for (let o in __cssModules$a) {
    this[o] = __cssModules$a[o];
  }
}
var ForwardMessage = /* @__PURE__ */ function() {
  return __component__$a.exports;
}();
var __defProp$9 = Object.defineProperty;
var __getOwnPropDesc$9 = Object.getOwnPropertyDescriptor;
var __decorateClass$9 = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$9(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$9(target, key, result);
  return result;
};
const ComponentProps$2 = Vue$1.extend({
  props: {
    status: {
      type: String,
      default: ""
    }
  }
});
let Prompt$1 = class extends ComponentProps$2 {
  closeModal() {
    const popup = this.$refs["popup-2"];
    popup.classList.remove("robin-fadeIn");
    popup.classList.add("robin-fadeOut");
    window.setTimeout(() => {
      const popup2 = this.$refs["popup-2"];
      popup2.classList.remove("robin-fadeOut");
      popup2.classList.add("robin-fadeIn");
      this.$emit("closemodal");
    }, 100);
  }
  getHeaderDialog() {
    if (this.status === "delete message") {
      return "Delete Message";
    } else if (this.status === "exit group") {
      return "Exit Group";
    } else if (this.status === "clear messages") {
      return "Clear Messages";
    } else {
      return "Remove Participant";
    }
  }
};
Prompt$1 = __decorateClass$9([
  Component({
    name: "Prompt",
    components: {
      Content,
      IconButton
    }
  })
], Prompt$1);
var render$9 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { ref: "popup-2", staticClass: "robin-shim robin-fadeIn", on: { "click": function($event) {
    if ($event.target !== $event.currentTarget) {
      return null;
    }
    return _vm.closeModal();
  } } }, [_c("div", { staticClass: "robin-card" }, [_c("div", { staticClass: "robin-wrapper" }, [_c("Content", { staticClass: "robin-mb-11", attrs: { "font-size": 17, "font-weight": "500" } }, [_vm._v(" " + _vm._s(_vm.getHeaderDialog()) + " ")]), _c("Content", { attrs: { "color": "#51545C", "text-wrap": "normal", "text-align": "center" } }, [_vm._v(" Are you sure you want to proceed? ")])], 1), _c("div", { staticClass: "robin-button-container" }, [_c("button", { staticClass: "robin-button cancel", attrs: { "data-testid": "cancel-button" }, on: { "click": function($event) {
    return _vm.$emit("closemodal");
  } } }, [_c("Content", { attrs: { "color": "#D53120" } }, [_vm._v("Cancel")])], 1), _c("button", { staticClass: "robin-button proceed", attrs: { "data-testid": "proceed-button" }, on: { "click": function($event) {
    return _vm.$emit("proceed");
  } } }, [_c("Content", { attrs: { "color": "#15AE73" } }, [_vm._v("Proceed")])], 1)])])]);
};
var staticRenderFns$9 = [];
var Prompt_vue_vue_type_style_index_0_scoped_true_lang = "";
const __cssModules$9 = {};
var __component__$9 = /* @__PURE__ */ normalizeComponent(Prompt$1, render$9, staticRenderFns$9, false, injectStyles$9, "c1e36372", null, null);
function injectStyles$9(context2) {
  for (let o in __cssModules$9) {
    this[o] = __cssModules$9[o];
  }
}
var Prompt = /* @__PURE__ */ function() {
  return __component__$9.exports;
}();
var __defProp$8 = Object.defineProperty;
var __getOwnPropDesc$8 = Object.getOwnPropertyDescriptor;
var __decorateClass$8 = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$8(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$8(target, key, result);
  return result;
};
let MessageContainer$1 = class extends Vue$1 {
  constructor() {
    super(...arguments);
    this.promptOpen = false;
    this.promptStatus = "";
    this.uncheck = false;
    this.windowHeight = 0;
    this.readReceipts = [];
    this.selectedMessages = [];
    this.forwardMessage = false;
    this.conversation = {};
    this.messages = [];
    this.promise = null;
    this.capturedImage = null;
    this.scroll = false;
    this.scrollUp = false;
    this.lastScroll = 0;
    this.popUpState = {
      cameraOpened: false,
      messagePopUp: []
    };
    this.offlineMessages = { messages: {} };
    this.messageReply = {};
    this.messageError = false;
    this.isMessagesLoading = true;
    this.messagePopUpIndex = 0;
    this.key = 0;
    this.newConversationOpenCount = 0;
    this.observer = null;
    this.currentPage = 0;
    this.totalPages = 0;
    this.imageRegex = /^image/;
    this.videoRegex = /^video/;
    this.documentRegex = /(csv|xlsx|xls|doc|docx|ppt|pptx|txt|pdf|ppt|rtf|rar|tar|odt|md|zip|7z|zip|html)$/;
    this.emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    this.websiteRegex = /[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)/;
  }
  created() {
    this.handleConversationOpen();
    this.onNewMessage();
    this.onMessageDelete();
    this.onImageDelete();
    this.handleUserConnect();
    this.handleUserDisconnect();
    this.getReadReceipts();
  }
  mounted() {
    this.$nextTick(function() {
      this.onResize();
    });
    window.addEventListener("resize", this.onResize);
  }
  get groupnameColors() {
    const colors = ["#F8863D", "#18C583", "#FF0000", "#0F0FFE", "#9B2226", "#AE2012", "#BB3E03", "#CA6702", "#7F5539", "#606C38", "#283618", "#03045E", "#370617", "#6A040F", "#EE9B00", "#0A9396", "#005F73", "#0AFF99", "#9D4EDD", "#7400B8", "#6B705C", "#CB997E", "#A4133C", "#38B000", "#14213D", "#007200", "#7209B7", "#3D405B", "#8338EC", "#3A86FF", "#5A189A", "#3C096C", "#BBC4DF"];
    const userColors = {};
    for (const user of this.$robin_users) {
      userColors[user.userToken] = colors[Math.floor(Math.random() * colors.length)];
    }
    return userColors;
  }
  get currentConversation() {
    return store.state.currentConversation;
  }
  get selectMessagesOpen() {
    return store.state.selectMessagesOpen;
  }
  get isForwardMessagesEnabled() {
    return store.state.forwardMessagesEnabled;
  }
  get clearMessages() {
    return store.state.clearMessages;
  }
  get exitGroup() {
    return store.state.exitGroup;
  }
  get imagePreviewOpen() {
    return store.state.imagePreviewOpen;
  }
  get imagesToPreview() {
    return store.state.imagesToPreview;
  }
  get imageSelected() {
    return store.state.imageSelected;
  }
  get isImageReplying() {
    return store.state.isImageReplying;
  }
  get participantToken() {
    return store.state.participantToken;
  }
  get removeParticipant() {
    return store.state.removeParticipant;
  }
  handleConversationOpen() {
    EventBus.$on("conversation-opened", (conversation) => {
      this.getOfflineMessages();
      this.messageReply = {};
      this.messages = [];
      this.currentPage = 0;
      this.totalPages = 0;
      this.newConversationOpenCount += 1;
      this.conversation = conversation || {};
      store.setState("currentConversation", conversation);
      this.scroll = false;
      this.scrollUp = false;
      this.isMessagesLoading = true;
      EventBus.$emit("mark-as-read", conversation);
      store.setState("messageViewProfileOpen", false);
      this.getConversationMessages().then(() => {
        if (!this.messageError) {
          this.isMessagesLoading = false;
        }
      });
    });
  }
  async initializeReadReceipts(messageIds) {
    const res = await this.$robin.sendReadReceipts(messageIds, this.conversation._id);
    if (!res.error)
      ;
    if (res.error) {
      this.$toast.open({
        message: "Check your connection.",
        type: "error",
        position: "bottom-left"
      });
    }
  }
  getReadReceipts() {
    EventBus.$on("read.reciept", (message) => {
      this.readReceipts.push(...message.message_ids);
    });
  }
  handleUserConnect() {
    EventBus.$on("user.connect", (conversation) => {
      this.refresh();
    });
  }
  handleUserDisconnect() {
    EventBus.$on("user.disconnect", (conversation) => {
      this.refresh();
    });
  }
  refresh() {
    this.key += 1;
  }
  onNewMessage() {
    EventBus.$on("new-message", (message) => {
      if (message.conversation_id === this.conversation._id) {
        this.messages.push(message);
        if (this.offlineMessages.messages[message.conversation_id]) {
          this.offlineMessages.messages[message.conversation_id].push(message);
        }
        this.scrollToBottom();
        if (message.sender_token !== this.$user_token) {
          const messageIds = [this.messages[this.messages.length - 1]._id];
          this.initializeReadReceipts(messageIds);
        }
      }
      if (message.conversation_id !== this.currentConversation._id) {
        const index = this.$regularConversations.findIndex((item) => item._id === message.conversation_id);
        EventBus.$emit("mark-as-unread", this.$regularConversations[index]);
      }
      this.$conversations.forEach((conversation, index) => {
        if (conversation._id === message.conversation_id) {
          this.$conversations[index].updated_at = message.content.timestamp;
          this.$conversations[index].last_message = message.content;
          const newConv = this.$conversations[index];
          if (!newConv.archived_for || newConv.archived_for.length === 0) {
            EventBus.$emit("search-text.reset");
            EventBus.$emit("regular-conversation.delete", newConv);
            EventBus.$emit("regular-conversation.add", newConv);
          } else {
            EventBus.$emit("archived-conversation.delete", newConv);
            EventBus.$emit("archived-conversation.add", newConv);
          }
        }
      });
    });
  }
  onMessageDelete() {
    EventBus.$on("message-deleted", (message) => {
      const index = this.messages.findIndex((item) => item._id === message._id);
      const offlineMessageIndex = this.offlineMessages.messages[this.conversation._id].findIndex((item) => item._id === message._id);
      this.messages[index].is_deleted = true;
      this.offlineMessages.messages[this.conversation._id][offlineMessageIndex].is_deleted = true;
      this.$forceUpdate();
    });
  }
  onImageDelete() {
    EventBus.$on("image-deleted", (message) => {
      const messageIndex = this.messages.findIndex((item) => {
        if (Array.isArray(item))
          return item.some((image) => image._id === message._id);
        return false;
      });
      const offlineMessageIndex = this.offlineMessages.messages[this.conversation._id].findIndex((item) => {
        if (Array.isArray(item))
          return item.some((image) => image._id === message._id);
        return false;
      });
      if (messageIndex >= 0) {
        const index = this.messages[messageIndex].findIndex((item) => item._id === message._id);
        this.messages[messageIndex][index].is_deleted = true;
        this.$forceUpdate();
      }
      if (messageIndex === -1) {
        EventBus.$emit("message-deleted", message);
      }
      if (offlineMessageIndex >= 0) {
        const index = this.offlineMessages.messages[this.conversation._id][offlineMessageIndex].findIndex((item) => item._id === message._id);
        this.offlineMessages.messages[this.conversation._id][offlineMessageIndex][index].is_deleted = true;
        this.$forceUpdate();
      }
      if (offlineMessageIndex === -1) {
        EventBus.$emit("message-deleted", message);
      }
      EventBus.$emit("messages.get", this.messages);
    });
  }
  handleReadReceipts(data) {
    const filterMessage = data ? data.filter((item) => !item.is_read && item.sender_token !== this.$user_token) : [];
    const messageIds = filterMessage.map((item) => item._id);
    if (messageIds.length > 0) {
      this.initializeReadReceipts(messageIds);
    }
  }
  async getConversationMessages() {
    const res = await this.$robin.getConversationMessages(this.conversation._id, this.$user_token);
    if (res && !res.error) {
      this.messageError = false;
      this.testMessages(res.data ? res.data : []);
      this.currentPage = this.messages.length > 20 ? this.messages.length - 20 : 0;
      if (!this.offlineMessages.messages[this.conversation._id]) {
        this.offlineMessages.messages[this.conversation._id] = [...this.messages.slice(this.currentPage, this.messages.length)];
      }
      if (this.messages.length > 19) {
        this.setOfflineMessages(this.messages.slice(this.currentPage, this.messages.length));
      } else {
        this.setOfflineMessages(this.messages.slice(0, this.messages.length));
      }
      this.handleReadReceipts(res.data);
    } else {
      this.messageError = true;
      this.$toast.open({
        message: "Check your connection.",
        type: "error",
        position: "bottom-left"
      });
    }
    this.scrollToBottom();
  }
  loadMoreMessages() {
    const message = this.$refs.message;
    this.isMessagesLoading = true;
    setTimeout(() => {
      this.isMessagesLoading = false;
      this.currentPage -= 20;
      const lastPage = this.messages.length - (this.messages.length - this.currentPage) + 20;
      const messages = this.messages.slice(this.currentPage < 20 ? 0 : this.currentPage, lastPage);
      for (let i = messages.length - 1; i >= 0; i--) {
        this.offlineMessages.messages[this.conversation._id].unshift(messages[i]);
      }
      message.scrollTop = 160;
    }, 500);
  }
  scrollToBottom() {
    window.setTimeout(() => {
      const message = this.$refs.message;
      if (message) {
        message.scrollTop = message.scrollHeight;
        this.scrollUp = false;
      }
    }, 100);
  }
  openCamera() {
    this.popUpState.cameraOpened = true;
  }
  closeCamera() {
    const popup = this.$refs["popup-1"];
    popup.$refs["popup-body"].classList.remove("robin-squeezeOut");
    popup.$refs["popup-body"].classList.add("robin-squeezeIn");
    window.setTimeout(() => {
      popup.$refs["popup-body"].classList.remove("robin-squeezeIn");
      popup.$refs["popup-body"].classList.add("robin-squeezeOut");
      this.popUpState.cameraOpened = false;
    }, 100);
  }
  openImagePreview($event) {
    store.setState("imagePreviewOpen", true);
    store.setState("imagesToPreview", $event);
  }
  openMessagePopup(val) {
    this.messagePopUpIndex = val;
    this.popUpState.messagePopUp[this.messagePopUpIndex].opened = true;
  }
  closeMessagePopup(event) {
    this.popUpState.messagePopUp[this.messagePopUpIndex].opened = false;
    this.messagePopUpIndex = 0;
  }
  getMessagePopup(index) {
    return this.popUpState.messagePopUp[parseInt(index)];
  }
  handleCapturedImage(val) {
    this.capturedImage = val;
  }
  checkAttachmentType(attachmentUrl) {
    const strArr = attachmentUrl.split(".");
    return `${mime.getType(strArr[strArr.length - 1])}`;
  }
  testMessages(messages) {
    const newMessages = [];
    let temp = [];
    for (let index = 0; index < messages.length; index += 1) {
      const fileMimeType = this.checkAttachmentType(messages[index].content.attachment || "");
      const isImage = this.imageRegex.test(fileMimeType && (!messages[index].content.msg || messages[index].content.msg === "undefined") ? fileMimeType : "");
      const nextFileMimeType = this.checkAttachmentType(messages[index + 1] ? messages[index + 1].content.attachment || "" : "");
      const isImageNext = this.imageRegex.test(messages[index + 1] ? nextFileMimeType && (!messages[index + 1].content.msg || messages[index + 1].content.msg === "undefined") ? nextFileMimeType : "" : "");
      if (isImage) {
        temp.push(messages[index]);
      }
      if (temp.length > 1) {
        if (!Array.isArray(newMessages[newMessages.length - 1])) {
          newMessages[newMessages.length] = temp;
        }
      }
      if (!isImageNext || !isImage) {
        if (Array.isArray(newMessages[newMessages.length - 1]) && isImage)
          ;
        else {
          temp = [];
          newMessages.push(messages[index]);
        }
      }
    }
    this.messages = newMessages;
  }
  async clearAllMessages() {
    const id = [];
    for (let i = 0; i < this.messages.length; i += 1) {
      if (Array.isArray(this.messages[i])) {
        this.messages[i].forEach((item) => {
          id.push(item._id);
        });
      }
      if (!Array.isArray(this.messages[i])) {
        id.push(this.messages[i]._id);
      }
    }
    const res = await this.$robin.deleteMessages([...id], this.$user_token);
    if (res && !res.error) {
      this.$toast.open({
        message: "Messages Deleted.",
        type: "success",
        position: "bottom-left"
      });
      this.promptOpen = false;
      this.promise = this.getConversationMessages();
      this.promise.then(() => {
        this.scrollToBottom();
      });
    } else {
      this.$toast.open({
        message: "Check your connection.",
        type: "error",
        position: "bottom-left"
      });
    }
    store.setState("clearMessages", false);
  }
  onScroll() {
    this.handleScrollUp();
    this.scroll = true;
  }
  handleScrollUp() {
    const message = this.$refs.message;
    const endOfScroll = Math.floor(message.scrollTop) > Math.floor(message.scrollHeight - message.clientHeight - 20);
    if (endOfScroll) {
      this.scrollUp = false;
    }
    if (message.scrollTop <= this.lastScroll) {
      if (!this.isMessagesLoading) {
        this.scrollUp = true;
      }
    }
    if (message.scrollTop === 0 && this.offlineMessages.length !== this.messages.length && this.currentPage > 19) {
      this.loadMoreMessages();
    }
    this.lastScroll = message.scrollTop <= 0 ? 0 : message.scrollTop;
  }
  toggleCheckAction(val, message) {
    if (!val) {
      this.selectMessage(message);
    } else {
      this.removeSelectedMessage(message);
    }
  }
  selectMessage(message) {
    if (Array.isArray(message)) {
      message.forEach((item) => {
        this.selectedMessages.push(item);
      });
    } else {
      this.selectedMessages.push(message);
    }
  }
  removeSelectedMessage(message) {
    const index = this.selectedMessages.findIndex((item) => item._id === message._id);
    this.selectedMessages.splice(index, 1);
  }
  onChatClickAway() {
    store.setState("selectMessagesOpen", false);
  }
  onCloseForwardMessagePopup() {
    this.forwardMessage = false;
    store.setState("selectMessagesOpen", false);
    this.uncheck = true;
  }
  replyMessage(message) {
    this.messageReply = message;
  }
  onCloseReply() {
    this.messageReply = {};
  }
  async deleteSelectedMessages() {
    const res = await this.$robin.deleteMessages(this.selectedMessages.map((message) => message._id), this.$user_token);
    if (res && !res.error) {
      this.selectedMessages.forEach((message) => EventBus.$emit("message-deleted", message));
      this.selectedMessages = [];
      store.setState("selectMessagesOpen", false);
      this.uncheck = true;
      this.promptOpen = false;
      this.refresh();
      this.$toast.open({
        message: this.selectedMessages.length > 0 ? "Messages Deleted." : "Message Deleted.",
        type: "success",
        position: "bottom-left"
      });
    } else {
      this.$toast.open({
        message: "Check your connection.",
        type: "error",
        position: "bottom-left"
      });
    }
  }
  async handleRemoveParticipant() {
    const res = await this.$robin.removeGroupParticipant(this.currentConversation._id, this.participantToken);
    if (res && !res.error)
      ;
    else {
      this.$toast.open({
        message: "Check your connection.",
        type: "error",
        position: "bottom-left"
      });
    }
  }
  openPrompt(status) {
    this.promptOpen = true;
    this.promptStatus = status;
  }
  closePrompt() {
    this.promptOpen = false;
    store.setState("selectMessagesOpen", false);
    store.setState("clearMessages", false);
    store.setState("exitGroup", false);
    store.setState("removeParticipant", false);
  }
  scrollToRepliedMessage(id) {
    const messageIndex = this.offlineMessages.messages[this.conversation._id].findIndex((element) => {
      if (Array.isArray(element)) {
        return element.find((item) => item._id === id);
      }
      if (!Array.isArray(element)) {
        if (element._id === id) {
          return element;
        }
      }
      return false;
    });
    const messageRef = this.$refs[`message-${messageIndex}`];
    messageRef[0].$el.scrollIntoView({ behavior: "smooth", block: "end" });
  }
  onResize() {
    this.scrollUp = false;
    this.windowHeight = window.innerHeight;
  }
  async handleLeaveGroup() {
    const res = await this.$robin.removeGroupParticipant(this.conversation._id, this.$user_token);
    if (res && !res.error) {
      this.$toast.open({
        message: "You left group",
        type: "success",
        position: "bottom-left"
      });
      EventBus.$emit("regular-conversation.delete", this.conversation);
      EventBus.$emit("close-conversation");
      store.setState("exitGroup", false);
    } else {
      this.$toast.open({
        message: "Check your connection.",
        type: "error",
        position: "bottom-left"
      });
    }
  }
  proceed() {
    if (this.promptStatus === "delete select" && this.selectMessagesOpen) {
      this.deleteSelectedMessages();
    }
    if (this.promptStatus === "clear messages" && this.clearMessages) {
      this.clearAllMessages();
    }
    if (this.promptStatus === "exit group" && this.exitGroup) {
      this.handleLeaveGroup();
    }
    if (this.promptStatus === "remove participant" && this.removeParticipant) {
      this.handleRemoveParticipant();
    }
  }
  async getOfflineMessages() {
    try {
      const value = await localForage.getItem("messages");
      this.offlineMessages = value ? __spreadValues({}, value) : { messages: {} };
    } catch (error2) {
      console.error(error2);
    }
  }
  async setOfflineMessages(messages) {
    try {
      const data = { messages: { [this.conversation._id]: messages } };
      for (const item in this.offlineMessages.messages) {
        if (!data.messages[item]) {
          data.messages[item] = this.offlineMessages.messages[item];
        }
      }
      await localForage.setItem("messages", data);
      this.getOfflineMessages();
    } catch (error2) {
      console.error(error2);
    }
  }
};
MessageContainer$1 = __decorateClass$8([
  Component({
    name: "MessageContainer",
    components: {
      ChatHeader,
      Content,
      MessageInputBar,
      Camera,
      MessageContent,
      ForwardMessage,
      Button,
      Prompt
    },
    mixins: [mixin],
    watch: {
      messages: {
        handler(val) {
          this.popUpState.messagePopUp = [];
          [...val].forEach((val2) => {
            this.popUpState.messagePopUp.push({
              opened: false,
              _id: val2._id
            });
          });
          EventBus.$emit("messages.get", [...val]);
        },
        immediate: true
      },
      offlineMessages: {
        handler(val) {
          this.popUpState.messagePopUp = [];
          const messages = this.offlineMessages.messages[this.conversation._id];
          if (messages) {
            messages.forEach((val2) => {
              this.popUpState.messagePopUp.push({
                opened: false,
                _id: val2._id
              });
            });
            EventBus.$emit("messages.get", [...messages]);
          }
        },
        immediate: true
      },
      selectMessagesOpen: {
        handler(val) {
          if (!val) {
            this.selectedMessages = [];
            this.uncheck = true;
            this.closePrompt();
          }
          if (val) {
            this.uncheck = false;
          }
        }
      },
      clearMessages: {
        handler(val) {
          if (this.clearMessages) {
            this.openPrompt("clear messages");
          } else {
            this.closePrompt();
          }
        }
      },
      exitGroup: {
        handler(val) {
          if (this.exitGroup) {
            this.openPrompt("exit group");
          } else {
            this.closePrompt();
          }
        }
      },
      removeParticipant: {
        handler(val) {
          if (this.removeParticipant) {
            this.openPrompt("remove participant");
          } else {
            this.closePrompt();
          }
        }
      },
      isImageReplying: {
        handler(val) {
          this.messageReply = this.imagesToPreview[this.imageSelected];
        }
      }
    }
  })
], MessageContainer$1);
var render$8 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { directives: [{ name: "on-clickaway", rawName: "v-on-clickaway", value: _vm.onChatClickAway, expression: "onChatClickAway" }], staticClass: "robin-message-container" }, [_c("ChatHeader", { key: _vm.key, attrs: { "conversation": _vm.conversation, "selected-messages": _vm.selectedMessages }, on: { "delete-selected-messages": function($event) {
    return _vm.openPrompt("delete select");
  } } }), _c("div", { ref: "message", staticClass: "robin-wrapper robin-flex robin-flex-column robin-flex-space-between", attrs: { "id": "message-container", "data-testid": "message" }, on: { "scroll": function($event) {
    return _vm.onScroll();
  } } }, [_vm.isMessagesLoading && _vm.currentPage > 0 || !_vm.offlineMessages.messages[_vm.conversation._id] && _vm.isMessagesLoading ? _c("div", { staticClass: "robin-inner-wrapper-loader robin-flex robin-flex-align-center", attrs: { "id": "infinite-loader" } }, [_c("div", { staticClass: "robin-spinner" })]) : _vm._e(), _vm.offlineMessages.messages[_vm.conversation._id] ? _c("div", { staticClass: "robin-inner-wrapper-offline" }, _vm._l(_vm.offlineMessages.messages[_vm.conversation._id], function(message, index) {
    return _c("MessageContent", { directives: [{ name: "show", rawName: "v-show", value: !message.is_deleted, expression: "!message.is_deleted" }], key: "message-" + String(index + _vm.key), ref: "message-" + String(index), refInFor: true, attrs: { "groupname-colors": _vm.groupnameColors, "uncheck": _vm.uncheck, "message": message, "conversation": _vm.conversation, "message-popup": _vm.getMessagePopup(index), "messages": _vm.offlineMessages.messages[_vm.conversation._id], "stored-messages": _vm.messages, "index": index, "scroll": _vm.scroll, "last-id": !Array.isArray(message) && _vm.messages.length - 3 < parseInt(String(index)) ? message._id : "", "read-receipts": _vm.readReceipts }, on: { "open-preview": function($event) {
      return _vm.openImagePreview($event);
    }, "toggle-check-action": function($event) {
      return _vm.toggleCheckAction($event, message);
    }, "reply-message": function($event) {
      return _vm.replyMessage($event);
    }, "forward-message": function($event) {
      _vm.forwardMessage = true;
    }, "scroll-replied-message": _vm.scrollToRepliedMessage } });
  }), 1) : _vm._e(), _vm.scrollUp && _vm.scroll ? _c("div", { staticClass: "robin-scroll-to-bottom robin-bounceIn", attrs: { "data-testid": "scroll-bottom-button" }, on: { "click": function($event) {
    return _vm.scrollToBottom();
  } } }, [_c("i", { staticClass: "robin-material-icon" }, [_vm._v(" arrow_downward ")])]) : _vm._e()]), _c("MessageInputBar", { directives: [{ name: "show", rawName: "v-show", value: !_vm.selectMessagesOpen || !_vm.isForwardMessagesEnabled, expression: "!selectMessagesOpen || !isForwardMessagesEnabled" }], key: "input-" + _vm.newConversationOpenCount, attrs: { "conversation": _vm.conversation, "message-reply": _vm.messageReply, "captured-image": _vm.capturedImage }, on: { "open-camera": function($event) {
    return _vm.openCamera();
  }, "on-close-reply": function($event) {
    return _vm.onCloseReply();
  } } }), _vm.selectMessagesOpen && _vm.isForwardMessagesEnabled ? _c("div", { staticClass: "robin-forward-tab" }, [_c("Content", { attrs: { "color": "#51545C" } }, [_vm._v(" " + _vm._s(_vm.selectedMessages.length) + " Messages Selected ")]), _c("Button", { directives: [{ name: "show", rawName: "v-show", value: _vm.selectedMessages.length > 0, expression: "selectedMessages.length > 0" }], attrs: { "emit": "forward-message" }, on: { "forward-message": function($event) {
    _vm.forwardMessage = true;
  } } }, [_vm._v(" Forward Messages ")])], 1) : _vm._e(), _c("Camera", { directives: [{ name: "show", rawName: "v-show", value: _vm.popUpState.cameraOpened, expression: "popUpState.cameraOpened" }], ref: "popup-1", attrs: { "camera-opened": _vm.popUpState.cameraOpened }, on: { "close": function($event) {
    return _vm.closeCamera();
  }, "captured-image": _vm.handleCapturedImage } }), _vm.forwardMessage == true ? _c("ForwardMessage", { attrs: { "selected-messages": _vm.selectedMessages }, on: { "closemodal": function($event) {
    return _vm.onCloseForwardMessagePopup();
  } } }) : _vm._e(), _c("Prompt", { directives: [{ name: "show", rawName: "v-show", value: _vm.promptOpen, expression: "promptOpen" }], attrs: { "status": _vm.promptStatus }, on: { "proceed": function($event) {
    return _vm.proceed();
  }, "closemodal": function($event) {
    return _vm.closePrompt();
  } } })], 1);
};
var staticRenderFns$8 = [];
var MessageContainer_vue_vue_type_style_index_0_scoped_true_lang = "";
const __cssModules$8 = {};
var __component__$8 = /* @__PURE__ */ normalizeComponent(MessageContainer$1, render$8, staticRenderFns$8, false, injectStyles$8, "1ea680e9", null, null);
function injectStyles$8(context2) {
  for (let o in __cssModules$8) {
    this[o] = __cssModules$8[o];
  }
}
var MessageContainer = /* @__PURE__ */ function() {
  return __component__$8.exports;
}();
var __defProp$7 = Object.defineProperty;
var __getOwnPropDesc$7 = Object.getOwnPropertyDescriptor;
var __decorateClass$7 = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$7(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$7(target, key, result);
  return result;
};
let NoMessageSelected$1 = class extends Vue$1 {
};
NoMessageSelected$1 = __decorateClass$7([
  Component({
    name: "NoMessageSelected"
  })
], NoMessageSelected$1);
var render$7 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "robin-no-message-container" });
};
var staticRenderFns$7 = [];
var NoMessageSelected_vue_vue_type_style_index_0_scoped_true_lang = "";
const __cssModules$7 = {};
var __component__$7 = /* @__PURE__ */ normalizeComponent(NoMessageSelected$1, render$7, staticRenderFns$7, false, injectStyles$7, "4c7e7d71", null, null);
function injectStyles$7(context2) {
  for (let o in __cssModules$7) {
    this[o] = __cssModules$7[o];
  }
}
var NoMessageSelected = /* @__PURE__ */ function() {
  return __component__$7.exports;
}();
var __defProp$6 = Object.defineProperty;
var __getOwnPropDesc$6 = Object.getOwnPropertyDescriptor;
var __decorateClass$6 = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$6(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$6(target, key, result);
  return result;
};
let PageLoader$1 = class extends Vue$1 {
  get assets() {
    return assets;
  }
};
PageLoader$1 = __decorateClass$6([
  Component({
    name: "PageLoader",
    components: {
      Content
    }
  })
], PageLoader$1);
var render$6 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "robin-shim" }, [_c("div", { staticClass: "robin-inner-shim" }, [_c("div", { staticClass: "robin-loader-ctn" }, [_c("div", { staticClass: "robin-loader" }), _c("img", { staticClass: "robin-pulse-1", attrs: { "src": _vm.assets["robin_icon"], "alt": "logo" } })]), _c("div", { staticClass: "robin-come-up robin-mt-18" }, [_c("Content", { attrs: { "as": "h2", "color": "#fff", "font-weight": "'bold'", "font-size": 24 } }, [_vm._v(" Getting messages... ")])], 1)])]);
};
var staticRenderFns$6 = [];
var PageLoader_vue_vue_type_style_index_0_scoped_true_lang = "";
const __cssModules$6 = {};
var __component__$6 = /* @__PURE__ */ normalizeComponent(PageLoader$1, render$6, staticRenderFns$6, false, injectStyles$6, "269477a4", null, null);
function injectStyles$6(context2) {
  for (let o in __cssModules$6) {
    this[o] = __cssModules$6[o];
  }
}
var PageLoader = /* @__PURE__ */ function() {
  return __component__$6.exports;
}();
var __defProp$5 = Object.defineProperty;
var __getOwnPropDesc$5 = Object.getOwnPropertyDescriptor;
var __decorateClass$5 = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$5(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$5(target, key, result);
  return result;
};
let MessagePreviewPopOver$1 = class extends Vue$1 {
  get isDeleteMessagesEnabled() {
    return store.state.deleteMessagesEnabled;
  }
  get isForwardMessagesEnabled() {
    return store.state.forwardMessagesEnabled;
  }
  get isReplyMessagesEnabled() {
    return store.state.replyMessagesEnabled;
  }
};
MessagePreviewPopOver$1 = __decorateClass$5([
  Component({
    name: "MessagePreviewPopOver",
    components: {
      Content,
      IconButton
    }
  })
], MessagePreviewPopOver$1);
var render$5 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { ref: "popup-body", staticClass: "robin-popup robin-zoomIn" }, [_c("div", { staticClass: "robin-wrapper robin-w-100", attrs: { "data-testid": "download-button" }, on: { "click": function($event) {
    return _vm.$emit("download");
  } } }, [_c("Content", { attrs: { "font-size": 14, "color": "#101010" } }, [_vm._v("Save Image")]), _c("IconButton", { attrs: { "name": "imageDownload", "to-emit": false, "to-click-away": false } })], 1), _vm.isReplyMessagesEnabled ? _c("div", { staticClass: "robin-wrapper robin-w-100", attrs: { "data-testid": "reply-button" }, on: { "click": function($event) {
    return _vm.$emit("reply");
  } } }, [_c("Content", { attrs: { "font-size": 14, "color": "#101010" } }, [_vm._v("Reply Message")]), _c("IconButton", { attrs: { "name": "reply", "to-emit": false, "to-click-away": false } })], 1) : _vm._e(), _vm.isForwardMessagesEnabled ? _c("div", { staticClass: "robin-wrapper robin-w-100", attrs: { "data-testid": "forward-button" }, on: { "click": function($event) {
    return _vm.$emit("forward");
  } } }, [_c("Content", { attrs: { "font-size": 14, "color": "#101010" } }, [_vm._v("Forward")]), _c("IconButton", { attrs: { "name": "forward", "to-emit": false, "to-click-away": false } })], 1) : _vm._e(), _vm.isDeleteMessagesEnabled ? _c("div", { staticClass: "robin-wrapper robin-w-100", attrs: { "data-testid": "delete-button" }, on: { "click": function($event) {
    return _vm.$emit("delete");
  } } }, [_c("Content", { attrs: { "font-size": 14, "color": "#101010" } }, [_vm._v("Delete Message")]), _c("IconButton", { attrs: { "name": "delete", "to-emit": false, "to-click-away": false } })], 1) : _vm._e()]);
};
var staticRenderFns$5 = [];
var MessagePreviewPopOver_vue_vue_type_style_index_0_scoped_true_lang = "";
const __cssModules$5 = {};
var __component__$5 = /* @__PURE__ */ normalizeComponent(MessagePreviewPopOver$1, render$5, staticRenderFns$5, false, injectStyles$5, "63aeb6b7", null, null);
function injectStyles$5(context2) {
  for (let o in __cssModules$5) {
    this[o] = __cssModules$5[o];
  }
}
var MessagePreviewPopOver = /* @__PURE__ */ function() {
  return __component__$5.exports;
}();
var __defProp$4 = Object.defineProperty;
var __getOwnPropDesc$4 = Object.getOwnPropertyDescriptor;
var __decorateClass$4 = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$4(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$4(target, key, result);
  return result;
};
const ComponentProps$1 = Vue$1.extend({
  props: {
    imagesToPreview: {
      type: Array,
      default: () => []
    },
    conversation: {
      type: Object,
      default: () => ({})
    }
  }
});
let MessageImagePreviewer$1 = class extends ComponentProps$1 {
  constructor() {
    super(...arguments);
    this.viewerOptions = {
      toolbar: false,
      title: false,
      navbar: false
    };
    this.imageSelected = 0;
    this.selectedMessages = [];
    this.forwardMessage = false;
    this.images = [];
    this.id = 0;
    this.settings = {
      dots: true,
      infinite: true,
      slidesToScroll: 1,
      rtl: true
    };
    this.popUpState = {
      opened: false
    };
  }
  get imagePreview() {
    return this.images[this.imageSelected] ? this.images[this.imageSelected].content.attachment : "";
  }
  get isDeleteMessagesEnabled() {
    return store.state.deleteMessagesEnabled;
  }
  get isForwardMessagesEnabled() {
    return store.state.forwardMessagesEnabled;
  }
  get isReplyMessagesEnabled() {
    return store.state.replyMessagesEnabled;
  }
  handleOpenPopUp() {
    const popup = this.$refs["popup-1"];
    popup.$refs["popup-body"].classList.remove("robin-zoomOut");
    this.popUpState.opened = true;
  }
  handleClosePopUp() {
    const popup = this.$refs["popup-1"];
    popup.$refs["popup-body"].classList.remove("robin-zoomIn");
    popup.$refs["popup-body"].classList.add("robin-zoomOut");
    window.setTimeout(() => {
      const popup2 = this.$refs["popup-1"];
      popup2.$refs["popup-body"].classList.add("robin-zoomIn");
      popup2.$refs["popup-body"].classList.remove("robin-zoomOut");
      this.popUpState.opened = false;
    }, 300);
  }
  closeImagePreview() {
    this.$emit("close");
  }
  getFileDetails(attachmentUrl) {
    const fileName = attachmentUrl.substring(attachmentUrl.lastIndexOf("/") + 1);
    const strArr = fileName.split(".");
    return {
      name: strArr[strArr.length - 2],
      extension: strArr[strArr.length - 1]
    };
  }
  getProfileImage(conversation) {
    const index = this.$robin_users.findIndex((user) => user.userToken === conversation.sender_token);
    return this.$robin_users[index] ? this.$robin_users[index].profileImage : null;
  }
  onSelectChange(index) {
    this.imageSelected = index;
  }
  downloadImage() {
    const fileDetails = this.getFileDetails(this.imagePreview);
    const element = document.createElement("a");
    element.setAttribute("href", this.imagePreview);
    element.setAttribute("download", fileDetails.name + " " + fileDetails.extension);
    element.click();
  }
  async deleteImage() {
    const res = await this.$robin.deleteMessages([this.images[this.imageSelected]._id], this.$user_token);
    if (res && !res.error) {
      if (this.images.length < 2)
        this.closeImagePreview();
      EventBus.$emit("image-deleted", this.images[this.imageSelected]);
      window.setTimeout(() => {
        this.images.splice(this.imageSelected, 1);
      }, 300);
    } else {
      this.$toast.open({
        message: "Check your connection.",
        type: "error",
        position: "bottom-left"
      });
    }
  }
  openForwardMessage() {
    this.forwardMessage = true;
    this.selectedMessages = [this.imagesToPreview[0]];
    store.setState("messageViewProfileOpen", false);
  }
  replyImageMessage() {
    store.setState("imageSelected", this.imageSelected);
    store.setState("isImageReplying", true);
    store.setState("messageViewProfileOpen", false);
    this.closeImagePreview();
  }
  onCloseForwardMessagePopup() {
    this.forwardMessage = false;
    store.setState("selectMessagesOpen", false);
  }
};
MessageImagePreviewer$1 = __decorateClass$4([
  Component({
    name: "MessageImagePreviewer",
    components: {
      Content,
      IconButton,
      GroupAvatar,
      OptionButton,
      Avatar,
      MessagePreviewPopOver,
      VLazyImage: e,
      ForwardMessage
    },
    watch: {
      imagesToPreview: {
        handler(val) {
          this.images = [...val];
        },
        immediate: true
      }
    }
  })
], MessageImagePreviewer$1);
var render$4 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { ref: "popup-body", staticClass: "robin-image-box robin-squeezeOut" }, [_c("header", { staticClass: "robin-head" }, [_c("div", { staticClass: "robin-card-container robin-flex robin-flex-align-center" }, [_c("div", { staticClass: "robin-wrapper robin-mr-27", on: { "click": function($event) {
    return _vm.closeImagePreview();
  } } }, [_c("IconButton", { attrs: { "name": "remove", "to-emit": false, "to-click-away": false } })], 1), _c("div", { staticClass: "robin-card-info robin-mr-16" }, [_vm.conversation.is_group ? _c("GroupAvatar", { attrs: { "img-url": _vm.conversation.group_icon } }) : _c("Avatar", { attrs: { "robin-users": _vm.$robin_users, "img-url": _vm.getProfileImage(_vm.conversation) || _vm.conversation.display_photo, "sender-token": _vm.conversation.sender_token === _vm.$user_token ? _vm.conversation.receiver_token : _vm.conversation.sender_token } })], 1), _c("div", { staticClass: "robin-card-info robin-h-100 robin-flex robin-flex-column robin-flex-space-between robin-flex-1" }, [_c("div", { staticClass: "robin-mt-6" }, [!_vm.conversation.is_group ? _c("Content", { attrs: { "font-weight": "normal", "color": "#000000", "font-size": 16, "line-height": 20 } }, [_vm._v(" " + _vm._s(_vm.conversation.sender_token != _vm.$user_token ? _vm.conversation.sender_name : _vm.conversation.receiver_name) + " ")]) : _c("Content", { attrs: { "font-weight": "normal", "color": "#000000", "font-size": 16, "line-height": 20 } }, [_vm._v(" " + _vm._s(_vm.conversation.name) + " ")])], 1)])]), _vm.isReplyMessagesEnabled || _vm.isDeleteMessagesEnabled || _vm.isForwardMessagesEnabled || _vm.isReplyMessagesEnabled && _vm.isDeleteMessagesEnabled && _vm.isForwardMessagesEnabled ? _c("div", { staticClass: "robin-options robin-ml-auto", attrs: { "data-testid": "options" }, on: { "click": function($event) {
    return _vm.handleOpenPopUp();
  } } }, [_c("IconButton", { attrs: { "name": "openModalDot", "to-emit": false, "to-click-away": true }, on: { "clickoutside": function($event) {
    return _vm.handleClosePopUp();
  } } }), _c("div", { directives: [{ name: "show", rawName: "v-show", value: _vm.popUpState.opened, expression: "popUpState.opened" }], staticClass: "robin-popup-container" }, [_c("MessagePreviewPopOver", { ref: "popup-1", attrs: { "data-testid": "message-preview-popover" }, on: { "delete": function($event) {
    return _vm.deleteImage();
  }, "download": function($event) {
    return _vm.downloadImage();
  }, "forward": function($event) {
    return _vm.openForwardMessage();
  }, "reply": function($event) {
    return _vm.replyImageMessage();
  } } })], 1)], 1) : _vm._e()]), _c("div", { staticClass: "robin-body" }, [_c("div", { staticClass: "robin-wrapper robin-w-100 robin-h-100 robin-flex robin-flex-column robin-flex-align-center robin-flex-space-between" }, [_c("div", { staticClass: "robin-image-preview" }, [_c("v-lazy-image", { staticClass: "robin-uploaded-image", attrs: { "src": _vm.imagePreview } })], 1), _c("div", { staticClass: "robin-image-row robin-overflow-x-auto robin-flex robin-flex-align-center robin-mt-16" }, _vm._l(_vm.images, function(image, index) {
    return _c("v-lazy-image", { key: index, staticClass: "robin-uploaded-image", class: [index === _vm.imageSelected && _vm.images.length > 1 ? "selected" : "", _vm.images.length === 1 && "not-selected"], attrs: { "src": image.content.attachment }, nativeOn: { "click": function($event) {
      return _vm.onSelectChange(index);
    } } });
  }), 1)])]), _vm.forwardMessage ? _c("ForwardMessage", { attrs: { "selected-messages": _vm.selectedMessages }, on: { "closemodal": function($event) {
    return _vm.onCloseForwardMessagePopup();
  } } }) : _vm._e()], 1);
};
var staticRenderFns$4 = [];
var MessageImagePreviewer_vue_vue_type_style_index_0_scoped_true_lang = "";
const __cssModules$4 = {};
var __component__$4 = /* @__PURE__ */ normalizeComponent(MessageImagePreviewer$1, render$4, staticRenderFns$4, false, injectStyles$4, "58e74922", null, null);
function injectStyles$4(context2) {
  for (let o in __cssModules$4) {
    this[o] = __cssModules$4[o];
  }
}
var MessageImagePreviewer = /* @__PURE__ */ function() {
  return __component__$4.exports;
}();
var __defProp$3 = Object.defineProperty;
var __getOwnPropDesc$3 = Object.getOwnPropertyDescriptor;
var __decorateClass$3 = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$3(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$3(target, key, result);
  return result;
};
let ViewProfile$1 = class extends Vue$1 {
  constructor() {
    super(...arguments);
    this.nav = "Media";
    this.isProfileLoading = false;
    this.messages = [];
    this.media = [];
    this.links = [];
    this.documents = [];
    this.participantsToShow = 4;
    this.mediaStop = 6;
    this.linkStop = 6;
    this.documentStop = 6;
    this.imageRegex = /^image/;
    this.videoRegex = /^video/;
    this.documentRegex = /(xls|doc|ppt|txt|pdf|csv|ppt|zip|html|avi|psd|svg|ai|gif|ai|mkv)$/;
    this.emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    this.websiteRegex = /[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)/;
  }
  get currentConversation() {
    return store.state.currentConversation;
  }
  get groupParticipants() {
    if (Object.keys(this.currentConversation).length > 0 && this.currentConversation.is_group) {
      return this.currentConversation.participants;
    }
    return [];
  }
  get isSignedInUserModerator() {
    if (Object.keys(this.currentConversation).length > 0 && this.currentConversation.is_group) {
      return this.currentConversation.participants.some((user) => user.user_token === this.$user_token && user.is_moderator);
    }
    return false;
  }
  get assets() {
    return assets;
  }
  get profileOpen() {
    return store.state.profileOpen;
  }
  get isDeleteMessagesEnabled() {
    return store.state.deleteMessagesEnabled;
  }
  created() {
    this.handleConversationMessages();
    this.handleRemoveGroupParticipant();
    this.handleAssignedGroupModerator();
    this.onAddGroupParticipants();
  }
  closeModal() {
    this.participantsToShow = 4;
    this.mediaStop = 6;
    this.linkStop = 6;
    this.documentStop = 6;
    this.$emit("close");
  }
  formatRecentMessageTime(time) {
    const datetime = moment(time);
    return datetime.calendar(null, {
      sameDay: "hh:mm a",
      lastDay: "[Yesterday]",
      lastWeek: "DD/MM/YYYY",
      sameElse: "DD/MM/YYYY"
    });
  }
  openImagePreview(media) {
    store.setState("imagePreviewOpen", true);
    store.setState("imagesToPreview", media);
    this.closePrompt();
  }
  async getProfile() {
    this.isProfileLoading = true;
    const res = await this.$robin.getConversationDetails(this.currentConversation._id, this.$user_token);
    if (res && !res.error) {
      this.isProfileLoading = false;
      this.media = res.data.photos ? [...res.data.photos] : [];
      this.links = res.data.links ? [...res.data.links] : [];
      this.documents = res.data.documents ? [...res.data.documents.filter((doc2) => this.documentRegex.test(this.checkAttachmentType(doc2.content.attachment)))] : [];
    }
  }
  getProfileImage(conversation) {
    const index = this.$robin_users.findIndex((user) => user.userToken === conversation.sender_token);
    return this.$robin_users[index] ? this.$robin_users[index].profileImage : null;
  }
  handleConversationMessages() {
    EventBus.$on("messages.get", (messages) => {
      this.messages = [...messages];
    });
  }
  getFileDetails(attachmentUrl) {
    const fileName = attachmentUrl.substring(attachmentUrl.lastIndexOf("/") + 1);
    const strArr = fileName.split(".");
    return {
      name: strArr[strArr.length - 2],
      extension: strArr[strArr.length - 1]
    };
  }
  downloadFile(attachmentUrl) {
    const fileDetails = this.getFileDetails(attachmentUrl);
    const element = document.createElement("a");
    element.setAttribute("href", attachmentUrl);
    element.setAttribute("download", fileDetails.name + " " + fileDetails.extension);
    element.click();
  }
  checkAttachmentType(attachmentUrl) {
    const strArr = attachmentUrl.split(".");
    if (mime.getType(strArr[strArr.length - 1]) === "application/msword") {
      return "doc";
    }
    return `${mime.getType(strArr[strArr.length - 1])}`;
  }
  validateLinkInMessage(message) {
    const texts = message.content.msg.split(" ");
    return {
      containsWebsite: texts.some((text) => this.websiteRegex.test(text)),
      containsEmail: texts.some((text) => this.emailRegex.test(text))
    };
  }
  getTextsInMessage(message) {
    return {
      texts: message.content.msg.split(" "),
      length: message.content.msg.split(" ").length
    };
  }
  handleClearMessages() {
    store.setState("clearMessages", true);
  }
  async handleLeaveGroup() {
    store.setState("exitGroup", true);
  }
  async handleRemoveParticipant(userToken) {
    store.setState("participantToken", userToken);
    store.setState("removeParticipant", true);
  }
  getUser(userToken) {
    const index = this.$robin_users.findIndex((user) => user.userToken === userToken);
    return this.$robin_users[index];
  }
  handleRemoveGroupParticipant() {
    EventBus.$on("remove.group.participant", (value) => {
      if (value.participant.user_token !== this.$user_token) {
        const index = this.currentConversation.participants.findIndex((participant) => participant.user_token === value.participant.user_token);
        if (index > -1) {
          this.currentConversation.participants.splice(index, 1);
          this.closePrompt();
          this.participantsToShow = 4;
        }
      }
    });
  }
  handleAssignedGroupModerator() {
    EventBus.$on("participant.assigned.moderator", (conversation) => {
      store.setState("currentConversation", conversation);
      this.$forceUpdate();
    });
  }
  addGroupParticipant() {
    EventBus.$emit("show.new.group");
    EventBus.$emit("edit.participants.group", {
      conversation_id: this.currentConversation._id
    });
  }
  onAddGroupParticipants() {
    EventBus.$on("update.group.conversation", (conversation) => {
      store.setState("currentConversation", conversation);
    });
  }
  openGroupPrompt(token, isModerator) {
    if (this.currentConversation.is_group && token !== this.$user_token) {
      store.setState("groupPromptOpen", true);
      store.setState("currentParticipantToken", token);
      store.setState("isParticipantModerator", isModerator);
    }
  }
  showEncriptionDetails() {
    store.setState("encryptionDetailsOpen", true);
    this.closePrompt();
  }
  closePrompt() {
    store.setState("selectMessagesOpen", false);
    store.setState("clearMessages", false);
    store.setState("exitGroup", false);
    store.setState("removeParticipant", false);
  }
};
ViewProfile$1 = __decorateClass$3([
  Component({
    name: "ViewProfile",
    components: {
      IconButton,
      SvgIcon,
      Button,
      Content,
      Avatar,
      GroupAvatar,
      VLazyImage: e
    },
    watch: {
      profileOpen() {
        this.getProfile();
      }
    }
  })
], ViewProfile$1);
var render$3 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { ref: "popup-body", staticClass: "robin-modal-container robin-flex robin-flex-column robin-slideInRight" }, [_c("header", { staticClass: "robin-header" }, [_c("IconButton", { attrs: { "name": "remove", "emit": "close", "to-emit": true, "to-click-away": false }, on: { "close": function($event) {
    return _vm.closeModal();
  } } }), _c("Content", { staticClass: "robin-ml-12", attrs: { "font-weight": "400", "font-size": 16 } }, [_vm._v(_vm._s(!_vm.currentConversation.is_group ? "Chat" : "Group") + " Info")])], 1), !_vm.isProfileLoading ? _c("div", { staticClass: "robin-wrapper robin-fadeIn" }, [_c("div", { staticClass: "robin-profile" }, [!_vm.currentConversation.is_group ? _c("Avatar", { staticClass: "robin-mb-8", attrs: { "robin-users": _vm.$robin_users, "img-url": _vm.getProfileImage(_vm.currentConversation) || _vm.currentConversation.display_photo, "sender-token": _vm.currentConversation.sender_token === _vm.$user_token ? _vm.currentConversation.receiver_token : _vm.currentConversation.sender_token } }) : _c("GroupAvatar", { staticClass: "robin-mb-8", attrs: { "img-url": _vm.currentConversation.group_icon } }), _c("Content", { staticClass: "robin-mb-8", attrs: { "fontWeight": "500", "as": "h3" } }, [_vm._v(_vm._s(!_vm.currentConversation.is_group ? _vm.currentConversation.sender_token != _vm.$user_token ? _vm.currentConversation.sender_name : _vm.currentConversation.receiver_name : _vm.currentConversation.name))]), _c("Content", { directives: [{ name: "show", rawName: "v-show", value: _vm.currentConversation.is_group, expression: "currentConversation.is_group" }], staticClass: "robin-mb-8", attrs: { "color": "#51545C", "fontSize": 12, "text-align": "center", "as": "p" } }, [_vm._v(_vm._s(_vm.groupParticipants.length > 1 ? _vm.groupParticipants.length + " Members" : _vm.groupParticipants.length + " Member"))]), _vm.currentConversation.is_group ? _c("Content", { staticClass: "robin-flex", attrs: { "color": "#51545C", "fontSize": 12, "text-align": "center", "as": "p" } }, [_vm._v("Created at " + _vm._s(_vm.formatRecentMessageTime(_vm.currentConversation.created_at)) + ", By "), _c("Content", { attrs: { "fontSize": 12 } }, [_vm._v(_vm._s(_vm.currentConversation.moderator.meta_data.display_name))])], 1) : _vm._e()], 1), _c("div", { staticClass: "robin-nav-container" }, [_c("div", { class: { active: _vm.nav == "Media" }, attrs: { "data-testid": "media-nav-button" }, on: { "click": function($event) {
    _vm.nav = "Media";
  } } }, [_vm._v("Media")]), _c("div", { class: { active: _vm.nav == "Links" }, attrs: { "data-testid": "link-nav-button" }, on: { "click": function($event) {
    _vm.nav = "Links";
  } } }, [_vm._v("Links")]), _c("div", { class: { active: _vm.nav == "Docs" }, attrs: { "data-testid": "doc-nav-button" }, on: { "click": function($event) {
    _vm.nav = "Docs";
  } } }, [_vm._v("Docs")])]), _c("div", { directives: [{ name: "show", rawName: "v-show", value: _vm.nav === "Media", expression: "nav === 'Media'" }], staticClass: "robin-media-grids" }, _vm._l(_vm.media.slice(0, _vm.mediaStop), function(media, mediaIndex) {
    return _c("div", { key: mediaIndex, staticClass: "robin-media-grid" }, [_vm.imageRegex.test(_vm.checkAttachmentType(media.content.attachment)) ? _c("v-lazy-image", { staticClass: "robin-uploaded-image", attrs: { "src": media.content.attachment }, nativeOn: { "click": function($event) {
      return _vm.openImagePreview([media]);
    } } }) : _vm._e(), _vm.videoRegex.test(_vm.checkAttachmentType(media.content.attachment)) ? _c("video", { attrs: { "controls": "" } }, [_c("source", { attrs: { "src": media.content.attachment } }), _vm._v(" Your browser does not support the video tag. ")]) : _vm._e()], 1);
  }), 0), _c("div", { directives: [{ name: "show", rawName: "v-show", value: _vm.nav === "Links", expression: "nav === 'Links'" }], staticClass: "robin-link-container" }, _vm._l(_vm.links.slice(0, _vm.linkStop), function(message, messageIndex) {
    return _c("a", { key: messageIndex, staticClass: "robin-link-preview", attrs: { "href": _vm.getTextsInMessage(message).texts[_vm.getTextsInMessage(message).length - 1].includes("http") || _vm.getTextsInMessage(message).texts[_vm.getTextsInMessage(message).length - 1].includes("https") ? _vm.getTextsInMessage(message).texts[_vm.getTextsInMessage(message).length - 1] : "https://" + _vm.getTextsInMessage(message).texts[_vm.getTextsInMessage(message).length - 1] } }, [_vm._m(0, true), _vm._v(" " + _vm._s(_vm.getTextsInMessage(message).texts[_vm.getTextsInMessage(message).length - 1].includes("http") || _vm.getTextsInMessage(message).texts[_vm.getTextsInMessage(message).length - 1].includes("https") ? _vm.getTextsInMessage(message).texts[_vm.getTextsInMessage(message).length - 1] : "https://" + _vm.getTextsInMessage(message).texts[_vm.getTextsInMessage(message).length - 1]) + " ")]);
  }), 0), _c("div", { directives: [{ name: "show", rawName: "v-show", value: _vm.nav === "Docs", expression: "nav === 'Docs'" }], staticClass: "robin-document-grids" }, _vm._l(_vm.documents, function(document2, documentIndex) {
    return _c("div", { key: documentIndex, staticClass: "robin-uploaded-documents" }, [_vm.assets[_vm.getFileDetails(document2.content.attachment).extension] ? _c("img", { attrs: { "src": _vm.assets[_vm.getFileDetails(document2.content.attachment).extension], "alt": "document" } }) : _c("img", { attrs: { "src": _vm.assets["default"] } }), _c("div", { staticClass: "detail robin-flex robin-h-100 robin-flex-align-center" }, [_c("Content", { attrs: { "as": "span", "fontSize": 14 } }, [_vm._v(" " + _vm._s(_vm.getFileDetails(document2.content.attachment).name && _vm.getFileDetails(document2.content.attachment).name.length > 9 ? _vm.getFileDetails(document2.content.attachment).name.substring(0, 9) + "...." + _vm.getFileDetails(document2.content.attachment).extension : _vm.getFileDetails(document2.content.attachment).name + "." + _vm.getFileDetails(document2.content.attachment).extension) + " ")])], 1), _c("IconButton", { staticClass: "robin-ml-auto", attrs: { "name": "download", "color": "#15AE73", "to-emit": true, "to-click-away": false }, on: { "clicked": function($event) {
      return _vm.downloadFile(document2.content.attachment);
    } } })], 1);
  }), 0), _c("Button", { directives: [{ name: "show", rawName: "v-show", value: _vm.nav == "Media" && _vm.media.length > 6 && _vm.mediaStop != _vm.media.length - 1, expression: "nav == 'Media' && media.length > 6 && mediaStop != media.length - 1" }], staticClass: "robin-mt-8 robin-mb-11 robin-ml-auto robin-mr-auto", attrs: { "font-size": 12, "emit": "click" }, on: { "click": function($event) {
    _vm.mediaStop = _vm.media.length - 1;
  } } }, [_vm._v("See All Media")]), _c("Button", { directives: [{ name: "show", rawName: "v-show", value: _vm.nav === "Links" && _vm.links.length > 6 && _vm.linkStop != _vm.links.length - 1, expression: "nav === 'Links' && links.length > 6 && linkStop != links.length - 1" }], staticClass: "robin-mt-8 robin-mb-11 robin-ml-auto robin-mr-auto", attrs: { "font-size": 12, "emit": "click" }, on: { "click": function($event) {
    _vm.linkStop = _vm.links.length - 1;
  } } }, [_vm._v("See All Links")]), _c("Button", { directives: [{ name: "show", rawName: "v-show", value: _vm.nav === "Docs" && _vm.documents.length > 6 && _vm.documentStop != _vm.documents.length - 1, expression: "nav === 'Docs' && documents.length > 6 && documentStop != documents.length - 1" }], staticClass: "robin-mt-8 robin-mb-11 robin-ml-auto robin-mr-auto", attrs: { "font-size": 12, "emit": "click" }, on: { "click": function($event) {
    _vm.documentStop = _vm.documents.length - 1;
  } } }, [_vm._v("See All Docs")]), _c("Content", { directives: [{ name: "show", rawName: "v-show", value: _vm.nav == "Media" && _vm.media.length == 0, expression: "nav == 'Media' && media.length == 0" }], staticClass: "robin-mt-8 robin-mb-11 robin-ml-auto robin-mr-auto", attrs: { "font-size": 12, "color": "#15AE73" } }, [_vm._v("No Media")]), _c("Content", { directives: [{ name: "show", rawName: "v-show", value: _vm.nav === "Links" && _vm.links.length == 0, expression: "nav === 'Links' && links.length == 0" }], staticClass: "robin-mt-8 robin-mb-11 robin-ml-auto robin-mr-auto", attrs: { "font-size": 12, "color": "#15AE73" } }, [_vm._v("No Links")]), _c("Content", { directives: [{ name: "show", rawName: "v-show", value: _vm.nav === "Docs" && _vm.documents.length == 0, expression: "nav === 'Docs' && documents.length == 0" }], staticClass: "robin-mt-8 robin-mb-11 robin-ml-auto robin-mr-auto", attrs: { "font-size": 12, "color": "#15AE73" } }, [_vm._v("No Docs")]), _c("div", { staticClass: "robin-wrapper robin-mb-12" }, [_c("Button", { staticClass: "robin-tab", attrs: { "color": "#51545C", "emit": "clicked" }, on: { "clicked": function($event) {
    return _vm.showEncriptionDetails();
  } } }, [_c("SvgIcon", { staticClass: "robin-mr-8", attrs: { "name": "encryption" } }), _vm._v(" Encryption Details ")], 1)], 1), _c("div", { directives: [{ name: "show", rawName: "v-show", value: _vm.currentConversation.is_group, expression: "currentConversation.is_group" }], staticClass: "robin-group-container" }, [_c("Button", { staticClass: "robin-tab", attrs: { "color": "#000", "emit": "clicked" }, on: { "clicked": function($event) {
    return _vm.addGroupParticipant();
  } } }, [_c("SvgIcon", { staticClass: "robin-mr-8", attrs: { "name": "addParticipant" } }), _vm._v(" Add Group Participant ")], 1), !_vm.isSignedInUserModerator ? _c("div", { staticClass: "robin-card-container" }, _vm._l(_vm.groupParticipants.slice(0, _vm.participantsToShow), function(participant, participantIndex) {
    return _c("div", { key: participantIndex, staticClass: "robin-card robin-flex robin-flex-align-center" }, [_c("div", { staticClass: "robin-card-info robin-mr-12" }, [_c("Avatar", { attrs: { "robin-users": _vm.$robin_users, "sender-token": participant.user_token } })], 1), _c("div", { staticClass: "robin-card-info robin-h-100 robin-h-100 robin-flex robin-flex-align-center robin-pt-4 robin-pb-4 robin-flex-1" }, [_c("div", { staticClass: "robin-flex" }, [_c("Content", { attrs: { "font-size": 14, "line-height": 18 } }, [_vm._v(_vm._s(participant.user_token === _vm.$user_token ? "You" : participant.meta_data.display_name))])], 1), _c("div", { directives: [{ name: "show", rawName: "v-show", value: participant.is_moderator, expression: "participant.is_moderator" }], staticClass: "robin-moderator-text" }, [_vm._v("Moderator")])])]);
  }), 0) : _c("div", { staticClass: "robin-card-container" }, _vm._l(_vm.groupParticipants.slice(0, _vm.participantsToShow), function(participant, participantIndex) {
    return _c("div", { key: participantIndex, staticClass: "robin-card robin-flex robin-flex-align-center", class: { "robin-clickable": _vm.currentConversation.is_group && participant.user_token !== _vm.$user_token }, on: { "click": function($event) {
      if ($event.target !== $event.currentTarget) {
        return null;
      }
      return _vm.openGroupPrompt(participant.user_token, participant.is_moderator);
    } } }, [_c("div", { staticClass: "robin-card-info robin-mr-12", on: { "click": function($event) {
      return _vm.openGroupPrompt(participant.user_token, participant.is_moderator);
    } } }, [_c("Avatar", { attrs: { "robin-users": _vm.$robin_users, "sender-token": participant.user_token == _vm.$user_token ? "" : participant.user_token } })], 1), _c("div", { staticClass: "robin-card-info robin-h-100 robin-h-100 robin-flex robin-flex-align-center robin-pt-4 robin-pb-4 robin-flex-1", on: { "click": function($event) {
      if ($event.target !== $event.currentTarget) {
        return null;
      }
      return _vm.openGroupPrompt(participant.user_token, participant.is_moderator);
    } } }, [_c("div", { staticClass: "robin-flex", on: { "click": function($event) {
      return _vm.openGroupPrompt(participant.user_token, participant.is_moderator);
    } } }, [_c("Content", { attrs: { "font-size": 14, "line-height": 18 } }, [_vm._v(_vm._s(participant.user_token === _vm.$user_token ? "You" : participant.meta_data.display_name))])], 1), _c("div", { directives: [{ name: "show", rawName: "v-show", value: !participant.is_moderator, expression: "!participant.is_moderator" }], staticClass: "robin-ml-auto", on: { "click": function($event) {
      return _vm.handleRemoveParticipant(participant.user_token);
    } } }, [_c("IconButton", { attrs: { "name": "remove2", "to-emit": false, "to-click-away": false } })], 1), _c("div", { directives: [{ name: "show", rawName: "v-show", value: participant.is_moderator, expression: "participant.is_moderator" }], staticClass: "robin-moderator-text" }, [_vm._v("Moderator")])])]);
  }), 0), _c("div", { directives: [{ name: "show", rawName: "v-show", value: _vm.participantsToShow !== _vm.groupParticipants.length - 1 && _vm.groupParticipants.length > 4, expression: "participantsToShow !== groupParticipants.length - 1 && groupParticipants.length > 4" }], staticClass: "robin-see-all", on: { "click": function($event) {
    _vm.participantsToShow = _vm.groupParticipants.length - 1;
  } } }, [_c("Button", { attrs: { "fontSize": 14 } }, [_vm._v(" See All Participants ")])], 1)], 1), _c("div", { staticClass: "robin-actions robin-mt-14" }, [_vm.isDeleteMessagesEnabled ? _c("Button", { attrs: { "color": "#D53120", "emit": "click" }, on: { "click": function($event) {
    return _vm.handleClearMessages();
  } } }, [_vm._v(" Clear Chat ")]) : _vm._e(), _c("Button", { directives: [{ name: "show", rawName: "v-show", value: _vm.currentConversation.is_group, expression: "currentConversation.is_group" }], attrs: { "color": "#D53120", "emit": "click" }, on: { "click": function($event) {
    return _vm.handleLeaveGroup();
  } } }, [_vm._v(" Exit Group ")])], 1)], 1) : _c("div", { staticClass: "robin-wrapper" }, [_c("div", { staticClass: "robin-spinner" })])]);
};
var staticRenderFns$3 = [function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", [_c("i", { staticClass: "robin-material-icon" }, [_vm._v(" link ")])]);
}];
var ViewProfile_vue_vue_type_style_index_0_scoped_true_lang = "";
const __cssModules$3 = {};
var __component__$3 = /* @__PURE__ */ normalizeComponent(ViewProfile$1, render$3, staticRenderFns$3, false, injectStyles$3, "ef45c1f0", null, null);
function injectStyles$3(context2) {
  for (let o in __cssModules$3) {
    this[o] = __cssModules$3[o];
  }
}
var ViewProfile = /* @__PURE__ */ function() {
  return __component__$3.exports;
}();
var __defProp$2 = Object.defineProperty;
var __getOwnPropDesc$2 = Object.getOwnPropertyDescriptor;
var __decorateClass$2 = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$2(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$2(target, key, result);
  return result;
};
let GroupPrompt$2 = class extends Vue$1 {
  get currentConversation() {
    return store.state.currentConversation;
  }
  get currentParticipantToken() {
    return store.state.currentParticipantToken;
  }
  get isParticipantModerator() {
    return store.state.isParticipantModerator;
  }
  closeModal() {
    store.setState("groupPromptOpen", false);
  }
  async assignModerator() {
    const res = await this.$robin.assignGroupModerator(this.currentConversation._id, this.currentParticipantToken);
    if (res && !res.error) {
      EventBus.$emit("participant.assigned.moderator", res.data);
      this.closeModal();
    } else {
      this.$toast.open({
        message: "Check your connection.",
        type: "error",
        position: "bottom-left"
      });
    }
  }
  async removeGroupParticipant() {
    const res = await this.$robin.removeGroupParticipant(this.currentConversation._id, this.currentParticipantToken);
    if (res && !res.error) {
      this.closeModal();
    } else {
      this.$toast.open({
        message: "Check your connection.",
        type: "error",
        position: "bottom-left"
      });
    }
  }
};
GroupPrompt$2 = __decorateClass$2([
  Component({
    name: "GroupPrompt",
    components: {
      Content
    }
  })
], GroupPrompt$2);
var render$2 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "robin-shim robin-fadeIn", on: { "click": function($event) {
    if ($event.target !== $event.currentTarget) {
      return null;
    }
    return _vm.closeModal();
  } } }, [_c("div", { staticClass: "robin-card" }, [!_vm.isParticipantModerator ? _c("div", { staticClass: "robin-wrapper robin-clickable", on: { "click": function($event) {
    return _vm.assignModerator();
  } } }, [_c("Content", { attrs: { "font-size": 18, "color": "#15AE73" } }, [_vm._v(_vm._s(!_vm.isParticipantModerator ? "Assign moderator" : "Dismiss as moderator"))])], 1) : _vm._e(), _c("div", { staticClass: "robin-wrapper robin-clickable", on: { "click": function($event) {
    return _vm.removeGroupParticipant();
  } } }, [_c("Content", { attrs: { "font-size": 18, "color": "#D53120" } }, [_vm._v("Remove participant")])], 1)])]);
};
var staticRenderFns$2 = [];
var GroupPrompt_vue_vue_type_style_index_0_scoped_true_lang = "";
const __cssModules$2 = {};
var __component__$2 = /* @__PURE__ */ normalizeComponent(GroupPrompt$2, render$2, staticRenderFns$2, false, injectStyles$2, "30057789", null, null);
function injectStyles$2(context2) {
  for (let o in __cssModules$2) {
    this[o] = __cssModules$2[o];
  }
}
var GroupPrompt$1 = /* @__PURE__ */ function() {
  return __component__$2.exports;
}();
var __defProp$1 = Object.defineProperty;
var __getOwnPropDesc$1 = Object.getOwnPropertyDescriptor;
var __decorateClass$1 = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$1(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$1(target, key, result);
  return result;
};
let GroupPrompt = class extends Vue$1 {
  closeModal() {
    store.setState("encryptionDetailsOpen", false);
  }
};
GroupPrompt = __decorateClass$1([
  Component({
    name: "EncryptionDetails",
    components: {
      Content,
      IconButton,
      SvgIcon
    }
  })
], GroupPrompt);
var render$1 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "robin-shim robin-fadeIn", on: { "click": function($event) {
    if ($event.target !== $event.currentTarget) {
      return null;
    }
    return _vm.closeModal();
  } } }, [_c("div", { staticClass: "robin-card" }, [_c("div", { staticClass: "robin-head" }, [_c("IconButton", { attrs: { "name": "remove", "emit": "close", "to-emit": true, "to-click-away": false }, on: { "close": function($event) {
    return _vm.closeModal();
  } } }), _c("Content", { staticClass: "robin-ml-12" }, [_vm._v(" Encryption Details")])], 1), _c("div", { staticClass: "robin-details" }, [_c("SvgIcon", { attrs: { "name": "largeEncryption" } }), _c("Content", { staticClass: "robin-mt-27", attrs: { "text-align": "center", "as": "span" } }, [_vm._v(" Your chat is fully encrypted ")])], 1)])]);
};
var staticRenderFns$1 = [];
var EncryptionDetails_vue_vue_type_style_index_0_scoped_true_lang = "";
const __cssModules$1 = {};
var __component__$1 = /* @__PURE__ */ normalizeComponent(GroupPrompt, render$1, staticRenderFns$1, false, injectStyles$1, "1328fa8f", null, null);
function injectStyles$1(context2) {
  for (let o in __cssModules$1) {
    this[o] = __cssModules$1[o];
  }
}
var EncryptionDetails = /* @__PURE__ */ function() {
  return __component__$1.exports;
}();
var __defProp2 = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp2(target, key, result);
  return result;
};
const ComponentProps = Vue$1.extend({
  props: {
    userToken: {
      type: String,
      default: "clpYwBMnDGdynSarEBZOuPWZ"
    },
    apiKey: {
      type: String,
      default: "NT-XmIzEmWUlsrQYypZOFRlogDFvQUsaEuxMfZf"
    },
    pageLoader: {
      type: Boolean,
      default: false
    },
    channel: {
      type: String,
      default: "private_chat"
    },
    userName: {
      type: String,
      default: "Enoch Chejieh"
    },
    users: {
      type: Array,
      default: () => [
        {
          _id: "621436282dc9a4e040d741bb",
          created_at: "2022-02-22T01:02:32.517Z",
          updated_at: "2022-02-22T01:02:32.517Z",
          fullname: "Testing Tester",
          user_token: "GmStKZeaAzsYzxsdIlFvoJSa",
          password: "$2a$14$ynUAMEo0StZa7FnbipS6l.qgAObpZJL.SkvXXVKjRalPKTK0Y51ce",
          profile_image: "",
          email: "testingtester@gmail.com"
        }
      ]
    },
    logo: {
      type: String,
      default: ""
    },
    features: {
      type: Array,
      default: () => ["create-chat", "voice-recorder"]
    },
    useDefaultProfileDetails: {
      type: Boolean,
      default: true
    },
    keys: {
      type: Object,
      default: () => {
        return {
          userToken: "user_token",
          userName: "fullname",
          profileImage: "profile_image"
        };
      }
    },
    imageUrl: {
      type: String,
      default: ""
    }
  }
});
let App$1 = class extends ComponentProps {
  constructor() {
    super(...arguments);
    this.robin = null;
    this.conn = null;
    this.key = 0;
    this.screenWidth = 0;
    this.messageEvent = null;
    this.time = 0;
  }
  created() {
    this.filterUsers();
    this.initiateRobin();
    this.openConversation();
    this.onGroupConversationCreated();
    this.onExitGroup();
    this.onExitMessage();
    this.onConversationDelete();
    this.openProfile();
    store.setState("forwardMessagesEnabled", this.features.includes("forward-messages"));
    store.setState("deleteMessagesEnabled", this.features.includes("delete-messages"));
    store.setState("archiveChatEnabled", this.features.includes("archive-chat"));
    store.setState("createChatEnabled", this.features.includes("create-chat"));
    store.setState("replyMessagesEnabled", this.features.includes("reply-messages"));
    store.setState("voiceRecorderEnabled", this.features.includes("voice-recorder"));
    store.setState("messageReactionViewEnabled", this.features.includes("message-reaction.view"));
    store.setState("messageReactionDeleteEnabled", this.features.includes("message-reaction.delete"));
    store.setState("useDefaultProfileDetails", this.useDefaultProfileDetails);
    if (this.conn) {
      this.conn.onopen = () => {
        var _a;
        (_a = this.robin) == null ? void 0 : _a.subscribe(this.channel, this.conn);
      };
      this.conn.onclose = () => {
        this.connect();
      };
    }
  }
  mounted() {
    this.$nextTick(function() {
      this.onResize();
    });
    window.addEventListener("resize", this.onResize);
    setInterval(() => {
      this.time += 1;
    }, 6e4);
  }
  get conversationOpened() {
    return store.state.conversationOpened;
  }
  get isPageLoading() {
    return store.state.isPageLoading;
  }
  get assets() {
    return assets;
  }
  get currentConversation() {
    return store.state.currentConversation;
  }
  get encryptionDetailsOpen() {
    return store.state.encryptionDetailsOpen;
  }
  get imagesToPreview() {
    return store.state.imagesToPreview;
  }
  get imagePreviewOpen() {
    return store.state.imagePreviewOpen;
  }
  get profileOpen() {
    return store.state.profileOpen;
  }
  get groupPromptOpen() {
    return store.state.groupPromptOpen;
  }
  get showDefaultProfileDetails() {
    return store.state.useDefaultProfileDetails;
  }
  initiateRobin() {
    this.robin = new Robin(this.apiKey, true);
    this.connect();
    this.setPrototypes();
  }
  filterUsers() {
    const filteredUsers = [];
    this.users.forEach((user) => {
      var _a, _b, _c;
      const newUser = {
        userToken: user[(_a = this.keys) == null ? void 0 : _a.userToken],
        profileImage: user[(_b = this.keys) == null ? void 0 : _b.profileImage],
        userName: user[(_c = this.keys) == null ? void 0 : _c.userName]
      };
      filteredUsers.push(newUser);
    });
    Vue$1.prototype.$robin_users = [...filteredUsers];
  }
  setPrototypes() {
    Vue$1.prototype.$robin = this.robin;
    Vue$1.prototype.$apiKey = this.apiKey;
    Vue$1.prototype.$user_token = this.userToken;
    Vue$1.prototype.$channel = this.channel;
    Vue$1.prototype.$conversations = [];
    Vue$1.prototype.$regularConversations = [];
    Vue$1.prototype.$archivedConversations = [];
    Vue$1.prototype.$senderName = this.userName;
    Vue$1.prototype.$logo = this.logo;
  }
  connect() {
    var _a;
    this.conn = (_a = this.robin) == null ? void 0 : _a.connect(this.userToken);
    this.conn.onmessage = (evt) => {
      const notification2 = this.$refs.notification;
      const message = JSON.parse(evt.data);
      if (message.is_event !== true) {
        EventBus.$emit("new-message", message);
        this.messageEvent = message;
        if (notification2) {
          notification2.click();
        }
      } else {
        this.handleEvents(message);
      }
      this.resetStopWatch();
    };
    const WebSocket = this.conn;
    window.onbeforeunload = function() {
      WebSocket.close();
    };
    Vue$1.prototype.$conn = this.conn;
  }
  openConversation() {
    EventBus.$on("open-conversation", () => {
      store.setState("conversationOpened", true);
    });
  }
  onGroupConversationCreated() {
    EventBus.$on("new-group.conversation", (conversation) => {
    });
  }
  handleEvents(message) {
    switch (message.name) {
      case "user.connect":
        EventBus.$emit("user.connect", message.value);
        break;
      case "user.disconnect":
        EventBus.$emit("user.disconnect", message.value);
        break;
      case "new.conversation":
        if (message.value.is_group) {
          EventBus.$emit("new-group.conversation", message.value);
        } else {
          EventBus.$emit("new.conversation", message.value);
        }
        break;
      case "message.forward":
        EventBus.$emit("message.forward", message.value);
        break;
      case "message.reaction":
        EventBus.$emit("message.reaction", message.value);
        break;
      case "message.remove.reaction":
        EventBus.$emit("message.remove.reaction", message.value);
        break;
      case "remove.group.participant":
        EventBus.$emit("remove.group.participant", message.value);
        break;
      case "read.reciept":
        EventBus.$emit("read.reciept", message.value);
        break;
      case "group.icon.update":
        EventBus.$emit("group.icon.update", message.value);
        break;
    }
  }
  onExitGroup() {
    EventBus.$on("left.group", () => {
      this.key += 1;
      store.setState("conversationOpened", false);
      store.setState("profileOpen", false);
    });
  }
  onConversationDelete() {
    EventBus.$on("close-conversation", () => {
      store.setState("conversationOpened", false);
      store.setState("profileOpen", false);
    });
  }
  onExitMessage() {
    EventBus.$on("left.message", () => {
      store.setState("conversationOpened", false);
      store.setState("profileOpen", false);
    });
  }
  onResize() {
    this.screenWidth = window.innerWidth;
  }
  openProfile() {
    EventBus.$on("open-profile", () => {
      this.$emit("open-profile");
    });
  }
  closeImagePreview() {
    const popup = this.$refs["popup-1"];
    popup.$refs["popup-body"].classList.remove("robin-squeezeOut");
    popup.$refs["popup-body"].classList.add("robin-squeezeIn");
    window.setTimeout(() => {
      popup.$refs["popup-body"].classList.remove("robin-squeezeIn");
      popup.$refs["popup-body"].classList.add("robin-squeezeOut");
      store.setState("imagePreviewOpen", false);
      store.setState("imagesToPreview", []);
    }, 100);
  }
  closeMessageViewProfile() {
    const popup = this.$refs["popup-2"];
    popup.$refs["popup-body"].classList.remove("robin-slideInRight");
    popup.$refs["popup-body"].classList.add("robin-slideOutRight");
    window.setTimeout(() => {
      popup.$refs["popup-body"].classList.remove("robin-slideOutRight");
      popup.$refs["popup-body"].classList.add("robin-slideInRight");
      store.setState("profileOpen", false);
    }, 100);
  }
  playAudio(event) {
    if (this.messageEvent) {
      if (this.messageEvent.content.receiver_token === this.$user_token) {
        event.target.play();
      }
    }
  }
  resetStopWatch() {
    this.time = 0;
  }
};
App$1 = __decorateClass([
  Component({
    name: "RobinChatContainer",
    components: {
      SideContainer,
      MessageContainer,
      PageLoader,
      NoMessageSelected,
      MessageImagePreviewer,
      ViewProfile,
      GroupPrompt: GroupPrompt$1,
      EncryptionDetails
    },
    watch: {
      users: {
        handler(val) {
          this.filterUsers();
        },
        immediate: true
      },
      currentConversation: {
        handler() {
          this.closeMessageViewProfile();
        }
      },
      time: {
        handler(val) {
          if (this.time === 9) {
            this.connect();
            this.resetStopWatch();
          }
        }
      }
    }
  })
], App$1);
var render = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "robin-container" }, [_c("transition", { attrs: { "name": "robin-fadeIn" } }, [_c("SideContainer", { directives: [{ name: "show", rawName: "v-show", value: !_vm.conversationOpened && _vm.screenWidth <= 1200 || _vm.conversationOpened && _vm.screenWidth > 1200 || !_vm.conversationOpened && _vm.screenWidth > 1200, expression: "(!conversationOpened && screenWidth <= 1200) || (conversationOpened && screenWidth > 1200) || (!conversationOpened && screenWidth > 1200)" }], key: _vm.key, scopedSlots: _vm._u([{ key: "chat-list-header", fn: function() {
    return [_vm._t("chat-list-header")];
  }, proxy: true }], null, true) })], 1), _c("transition", { attrs: { "name": "robin-fadeIn" } }, [_c("MessageContainer", { directives: [{ name: "show", rawName: "v-show", value: !_vm.isPageLoading && _vm.conversationOpened && _vm.screenWidth > 1200 && !_vm.profileOpen || !_vm.isPageLoading && _vm.conversationOpened && _vm.screenWidth <= 1200 && !_vm.profileOpen || !_vm.isPageLoading && _vm.conversationOpened && _vm.screenWidth > 1200 && _vm.profileOpen, expression: "(!isPageLoading && conversationOpened && screenWidth > 1200 && !profileOpen) || (!isPageLoading && conversationOpened && screenWidth <= 1200 && !profileOpen) || (!isPageLoading && conversationOpened && screenWidth > 1200 && profileOpen)" }], key: _vm.key + 1 })], 1), !_vm.isPageLoading && !_vm.conversationOpened ? _c("NoMessageSelected") : _vm._e(), _vm.isPageLoading && _vm.pageLoader ? _c("PageLoader") : _vm._e(), _c("MessageImagePreviewer", { directives: [{ name: "show", rawName: "v-show", value: _vm.imagePreviewOpen, expression: "imagePreviewOpen" }], ref: "popup-1", attrs: { "conversation": _vm.currentConversation, "images-to-preview": _vm.imagesToPreview }, on: { "close": function($event) {
    return _vm.closeImagePreview();
  } } }), _c("ViewProfile", { directives: [{ name: "show", rawName: "v-show", value: _vm.profileOpen && _vm.showDefaultProfileDetails, expression: "profileOpen && showDefaultProfileDetails" }], ref: "popup-2", on: { "close": function($event) {
    return _vm.closeMessageViewProfile();
  } } }), !_vm.showDefaultProfileDetails ? _vm._t("profile-details", null, { "currentConversation": _vm.currentConversation }) : _vm._e(), _vm.groupPromptOpen ? _c("GroupPrompt") : _vm._e(), _vm.encryptionDetailsOpen ? _c("EncryptionDetails") : _vm._e(), _c("audio", { ref: "notification", attrs: { "src": _vm.assets["notification"] }, on: { "click": function($event) {
    return _vm.playAudio($event);
  } } }, [_vm._v("Your browser does not support the audio feature")])], 2);
};
var staticRenderFns = [];
var App_vue_vue_type_style_index_0_lang = "";
const __cssModules = {};
var __component__ = /* @__PURE__ */ normalizeComponent(App$1, render, staticRenderFns, false, injectStyles, null, null, null);
function injectStyles(context2) {
  for (let o in __cssModules) {
    this[o] = __cssModules[o];
  }
}
var App = /* @__PURE__ */ function() {
  return __component__.exports;
}();
var RobinChat = {
  install(Vue2, options) {
    Vue2.component("RobinChat", App);
  }
};
function _typeof(o) {
  return (_typeof = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && typeof Symbol == "function" && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  })(o);
}
function plugin(o, e2) {
  if (!plugin.installed)
    if (e2) {
      if (plugin.installed = true, o.version && o.version.split(".")[0] < 3)
        Object.defineProperties(o.prototype, { axios: { get: function() {
          return e2;
        } }, $http: { get: function() {
          return e2;
        } } });
      else {
        if (!(o.version && o.version.split(".")[0] >= 3))
          return void console.error("Unknown Vue version");
        o.config.globalProperties.axios = e2, o.config.globalProperties.$http = e2;
      }
      o.axios = e2, o.$http = e2;
    } else
      console.error("You have to install axios");
}
(typeof exports == "undefined" ? "undefined" : _typeof(exports)) == "object" ? module.exports = plugin : typeof define == "function" && define.amd ? define([], function() {
  return plugin;
}) : window.Vue && window.axios && window.Vue.use && Vue.use(plugin, window.axios);
var themeSugar = "";
var main = "";
Vue$1.use(plugin, axios);
Vue$1.use(VueToast);
export { RobinChat as default };
